import React, { useEffect, useState, useMemo, ChangeEvent, useRef } from 'react';
import { ThemeProvider, CheckboxField, Accordion,Text, View, Flex, Card, Link, Button, SelectField, useTheme, Divider, TextField, Table, TableHead, TableRow, TableCell, TableBody,Image,Message, IconsProvider, Pagination,RadioGroupField, Radio, Alert, useBreakpointValue, Collection, Grid } from '@aws-amplify/ui-react';
import { Tooltip } from 'react-tooltip'
import { Cache } from 'aws-amplify/utils';
import { Helmet } from "react-helmet-async";
import { MdCancelPresentation, MdEdit,MdExpandLess, MdExpandMore,MdSave, MdRestore,MdSearch,MdKeyboardDoubleArrowRight,MdKeyboardDoubleArrowLeft } from "react-icons/md";
import IcoSearchTitle from '../image/ico_search_title.svg'
import IcoResultTitle from '../image/ico_result_title.svg'
import { ImArrowUp, ImArrowDown } from "react-icons/im";
import { PiNewspaperClippingFill, PiBuildingOfficeFill } from "react-icons/pi";
import { FaAngleDown } from "react-icons/fa6";
import { ReactComponent as IcoCsvTable } from '../image/ico_csv_table.svg'
import { ReactComponent as IcoCsvTableHover } from '../image/ico_csv_table_hover.svg'
import { ReactComponent as IcoKigyou } from '../image/ico_kigyou.svg'
import { ReactComponent as IcoSinbun } from '../image/ico_sinbun.svg'
import { ReactComponent as IcoPaginationBack } from '../image/ico_pagination_back.svg'
import { ReactComponent as IcoPaginationNext } from '../image/ico_pagination_next.svg'
import { GrCircleInformation } from "react-icons/gr";
import { useNavigate } from 'react-router-dom';
import { useTokens } from './AuthPage'; // AuthPageからuseTokensをインポート
import { SaveSearchFilter } from './SaveSearchFilter';
import { CallSearchFilter } from './CallSearchFilter';
import CsvDLConfirm, { SearchFilter } from './CsvDLConfirm';
import { SearchFilterCheckboxInput,DataNode } from './SearchFilterCheckboxInput';
import { FilterFacetsCheckboxInput,FacetsDataNode,RegionItemNumType } from './FilterFacetsCheckboxInput';
import { industryData } from '../data/industryData';
import { industryFacetsData } from '../data/industryFacetsData';
import { regionData } from '../data/regionData';
import { regionClassificationData } from '../data/regionClassificationData';
import { regionFacetsData } from '../data/regionFacetsData';
import { regionHierarchyMap } from '../data/regionHierarchyMap';
import SearchConditionModal from './SearchConditionModal';
import Header from '../commons/Header';
import Footer from '../commons/Footer';
import '../css/HomeScreen.css';
import { BsFunnel } from "react-icons/bs";
import { IoMdArrowDropdown } from "react-icons/io";
import { MdNavigateNext } from "react-icons/md";
import IcoFilterOff from '../image/ico_filter_off.svg'
import IcoFilterOn from '../image/ico_filter_on.svg'
import IcoFilterFacets from '../image/ico_filter_facets.svg'
import IcoInfo from '../image/ico_info.svg'
import IcoSearchSave from '../image/ico_search_save.svg';
import IcoSearchLoad from '../image/ico_search_load.svg';
import IcoMinus from '../image/ico_minus.svg';
import IcoPlus from '../image/ico_plus.svg';
import IcoNewly from '../image/ico_flag_newly.png';
import IcoDx from '../image/ico_flag_dx.png';
import IcoLeaders from '../image/ico_flag_leaders.png';
import IcoWomen from '../image/ico_flag_women.png';
import IcoSupport from '../image/ico_flag_support.png';
import IcoInfoTags from '../image/ico_info_tags.svg'
import IcoFilterTags from '../image/ico_filter_tags.svg'
import IcoYouth from '../image/ico_flag_youth.png';
import IcoTagKey from '../image/ico_tag_key.svg';
import IcoTagCheckOn from '../image/ico_tag_check_on.svg';
import IcoTagCheckOff from '../image/ico_tag_check_off.svg';
import {ReactComponent as IcoComplianceCheck} from '../image/ico_compliance_check.svg';
import HomeScreenPagination from './HomeScreenPagination'
import IcoLoading from '../image/loading.svg';
import '../css/searching_dots.css';
import LoadingSpinner from './LoadingSpinner';


//企業検索
interface SearchHomeType {
    outputDate:string,
    industorialClass_code:string,
    address_code:string,
    corporateName:string,
    freeWord:string,
    detailParameter:string
    sortOrder: string,
    ascending_DescendingOrder: string,
    displayCount: string,
    currentPageNumber: string
}
interface SearchConditions {
  outputDate:string,
  corporateName:string
  freeWord:string
  freeWord1: string,
  freeWord2: string,
  freeWord3: string,
  freeWord4: string,
  freeWord5: string,
  freeWord6: string,
  industorialClass_code:string,
  address_code:string,
  detailParameter:string,
  flag:string,
  sortOrder:string,
  ascending_DescendingOrder: string,
  displayCount: string,
  currentPageNumber: string,
  businessKeywords: string,
  businessKeyword1: string,
  businessKeyword2: string,
  businessKeyword3: string,
  businessKeyword4: string,
  businessKeyword5: string,
  businessKeyword6: string,
  salesFrom:string,
  salesTo:string,
  numberOfEmployeesFrom:string,
  numberOfEmployeesTo:string,
  establishmentDateFrom:string,
  establishmentDateTo:string,
  captalStockFrom:string,
  captalStockTo:string,
  shareholders:string,
  partners:string,
  endOfFY:string,
  corporateGroupIsBelong:string,
  officeIsExist:string,
  tags: string,
}
interface ResponseDataItem {
  max_search_data_limit:number
  cnt_corporateNumber:number
  cnt_corporateNumber_limitplus1:number
  corporateName: string;
  corporateNumber: string;
  headquarterAddress: string;
  industorialClass_large: string;
  captalStock: number;
  numberOfEmployees: number;
  flag1: boolean,
  flag2: boolean,
  flag3: boolean,
  flag4: boolean,
  flag5: boolean,
  flag6: boolean,
}
//桁数チェック
interface CheckDegitResult {
  checkResult: boolean;
  message: string;
}
interface CheckDegitInput {
itemName: string;
inputText: string;
limitNumberOfDigit: number;
}

interface CheckDegitRecordType {
  inputInfo: CheckDegitInput[];
}

//検索条件保存
//tb_searchfilter_cnaviに合わせて地域=address
interface SearchData {
  savedAt: Date | null;
  userName: string;
  industry: string;
  industryCode: string;
  businessSummary: string;
  address: string;
  addressCode: string;
  corporateName: string;
  Keyword: string;
  detailCondition: string;
  flag: string;
  comments: string;
}

//関数に渡す型
interface eventArgsType {
  searchConditionRecordInfo: SearchData;
  saveDate: string | null;
  created_at: string | null;
  updated_at: string | null;
}

//G-Search連携
interface GsearchServiceType {
  corporateName: string;
  dbid: string;
  T: string;
}

//フィルタファセット - 決算月
interface filterFinancialEndofFYFacetListType {
  endOfFY: string | null,
  hitcount: number,
}
//フィルタファセット - 企業グループ
interface filterCorpGroupFacetsListType {
  corporateGroupIsBelong: boolean,
  hitcount: number,
}
//フィルタファセット - 事業所
interface filterOfficeIsExistFacetListType {
  officeIsExist: string,
  hitcount: number,
}
//フィルタファセット - 企業URL
interface filterCorporateUrlFacetListType {
  corporateUrlFlag: boolean,
  hitcount: number,
}

export default function HomeScreen() {
  // ヘッダ読み込み時処理完了フラグ
  const [isLoadedHeader, setIsLoadedHeader] = React.useState(false);
  const { tokens } = useTheme();
  // 2025/10/30 ダウンロード件数再読み込み処理の追加 START
  // ヘッダ 詳細表示・ダウンロード件数再読み込みフラグ
  const [doReloadOutputCountFlag, setDoReloadOutputCountFlag] = React.useState(false);
  // 2025/10/30 ダウンロード件数再読み込み処理の追加 END

  // ■■エラーメッセージの定義
  const ERROR_MESSAGE_PROCESSING_ERROR = "処理中にエラーが発生しました。もう一度お試し下さい。";

  // ■■トークン関連
  const { getTokens } = useTokens(); // useTokensフックを使用
  const [tokenInfo, setTokenInfo] = useState<any>(null);

  // ■■エラー関連
  const [errorMessage1, setErrorMessage1] = useState<string | null>(null); // エラーメッセージ用のstate
  const error1Ref = useRef<HTMLDivElement | null>(null);
  const [errorMessage2, setErrorMessage2] = useState<string | null>(null); // エラーメッセージ用のstate
  const error2Ref = useRef<HTMLDivElement | null>(null);
  const [errorMessage3, setErrorMessage3] = useState<string | null>(null); // エラーメッセージ用のstate
  const error3Ref = useRef<HTMLDivElement | null>(null);
  const [successMessage, setSuccessMessage] = useState<string | null>(null); // 成功メッセージ用のstate
  const successRef = useRef<HTMLDivElement | null>(null);
  const [isNeedChangePlan, setIsNeedChangePlan] = useState(false);
  const [isNeedAddPurchase, setIsNeedAddPurchase] = useState(false);
  const [isNeedChangePlan2, setIsNeedChangePlan2] = useState(false);

  const [isSpNoticeOpen, setIsSpNoticeOpen] = useState(false);
  const [isSpDataUpdateOpen, setIsSpDataUpdateOpen] = useState(false);

  // ■■ 検索結果表示
  const [tableData, setTableData] = useState<ResponseDataItem[]>([]);
  const [tagList, setTagList] = useState<string[]>([]);
  const [corporateNumList, setCorporateNumList] = useState<string[]>([]);
  const [dataCount, setDataCount] = useState(0);
  const [facetCount, setFacetCount] = useState(0);
  const [isViewFacet, setIsViewFacet] = useState(false);
  const [isSearchClicked, setIsSearchClicked] = useState(false);
  const [isSearchFacetClicked, setIsSearchFacetClicked] = useState(false);
  const [isSearchTagFilterClicked, setIsSearchTagFilterClicked] = useState(false);
  const [isSearchTagNewClicked, setIsSearchTagNewClicked] = useState(false);
  const [hoveredIndex, setHoveredIndex] = useState<{ [key: number]: { addressHovered: boolean; industryHovered: boolean; capitalHovered: boolean; membersHovered: boolean } }>({});
  const searchConditionRef = useRef<HTMLDivElement>(null);

  //表示件数
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [currentPage, setCurrentPage] = useState(1);
  //並び替え
  const [sortKey, setSortKey] = useState<keyof ResponseDataItem>("headquarterAddress");
  const [ascDesc, setAscDesc] = useState("ASC");
  const [isAscendingPush, setIsAscendingPush] = useState(true);

  //検索条件表示
  const [searchConditionModalIsOpen, setSearchConditionModalIsOpen] = useState(false);

  //検索条件保存
  const [saveSearchData, setSaveSearchData] = useState<SearchData | null>(null);
  const [saveSearchModalIsOpen, setSaveSearchModalIsOpen] = useState(false);
  const [returnedSaveSearchData, setReturnedSaveSearchData] = useState<SearchData | null>(null);

  //検索条件呼び出し
  const [callSearchData, setCallSearchData] = useState<SearchData[]>([]);
  const [callSearchModalIsOpen, setCallSearchModalIsOpen] = useState(false);
  const [returnedCallSearchData, setReturnedCallSearchData] = useState<SearchData | null>(null);

  const [currentResultSearchConditions,setCurrentResultSearchConditions] = useState<SearchConditions | null>(null);

   // 各業種の企業数レコード保持用
  const [eachIndustrialCompanyNum,setEachIndustrialCompanyNum] = useState<{[key: string]:number}>({});

  // 各地域の企業数レコード保持用
  const [eachRegionCompanyNum,setEachRegionCompanyNum] = useState<{[key: string]:number}>({});

  //セレクトテーマレコード保持用
  const [eachTrendThemeList,setEachTrendThemeList] = useState<any[]>([]);

  // データ更新表示データ取得済み判定
  const [isFetchedUpdatedData,setIsFetchedUpdatedData] = useState<boolean>(false);

  // 各業種の企業数取得済み判定
  const [isFetchedEachIndustrialCompanyNum, setIsFetchedEachIndustrialCompanyNum] = useState<boolean>(false);

  // 各地域の企業数取得済み判定
  const [isFetchedEachRegionCompanyNum,setIsFetchedEachRegionCompanyNum] = useState<boolean>(false);

  // セレクトテーマ取得済み判定
  const [isFetchedEachTrendThemeList,setIsFetchedEachTrendThemeList] = useState<boolean>(false);

  // 詳細条件入力許可判定
  const [allowDetailConditionInput,setAllowDetailConditionInput] = useState<boolean>(false);

  // アコーディオン開閉管理
  const [accordionOpenManage,setAccordionOpenManage] = useState<string[] | undefined>([]);

  //画面遷移
  const navigate = useNavigate();
  const isReturning = useRef(false);
  // 入力フィールドの状態
  const [dummy, setDummy] = useState("");
  const [corporateName, setCorporateName] = useState("");
  const [freeWordFirst, setFreeWordFirst] = useState("");
  const [freeWordSecond, setFreeWordSecond] = useState("");
  const [freeWordThird, setFreeWordThird] = useState("");
  const [freeWordFourth, setFreeWordFourth] = useState("");
  const [freeWordFifth, setFreeWordFifth] = useState("");
  const [freeWordSixth, setFreeWordSixth] = useState("");
  const [businessContentsFirst, setBusinessContentsFirst] = useState("");
  const [businessContentsSecond, setBusinessContentsSecond] = useState("");
  const [businessContentsThird, setBusinessContentsThird] = useState("");
  const [businessContentsFourth, setBusinessContentsFourth] = useState("");
  const [businessContentsFifth, setBusinessContentsFifth] = useState("");
  const [businessContentsSixth, setBusinessContentsSixth] = useState("");
  const [salesFrom, setSalesFrom] = useState("");
  const [salesTo, setSalesTo] = useState("");
  const [employeesNumFrom,setEmployeesNumFrom] = useState("");
  const [employeesNumTo, setEmployeesNumTo] = useState("");
  const [establishedFrom, setEstablishedFrom] = useState("");
  const [establishedTo, setEstablishedTo] = useState("");
  const [capitalFrom, setCapitalFrom] = useState("");
  const [capitalTo, setCapitalTo] = useState("");
  const [shareholders, setShareholders] = useState("");
  const [partners, setPartners] = useState("");
  // 検索結果
  const [searchResults, setSearchResults] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const totalDots = 10;

  // 処理中フラグ tokenの読み込み済みか
  const [isLoadingToken, setIsLoadingToken] = React.useState(true);

  // 処理中フラグ モーダルの多重クリック防止
  const [isProcessing, setIsProcessing] = React.useState(false);

  // 処理中フラグ 検索中の多重クリック防止
  const [isSearching, setIsSearching] = React.useState(false);
  const [isGeneratingTags, setIsGeneratingTags] = React.useState(false);
  const [isSearchTagNewSearching, setIsSearchTagNewSearching] = React.useState(false);
  const [isSearchTagFilterSearching, setIsSearchTagFilterSearching] = React.useState(false);
  const [isSearchFacetSearching, setIsSearchFacetSearching] = React.useState(false);
  const [isGetFacetCountSearching, setIsGetFacetCountSearching] = React.useState(false);
  const queueCountFacet: boolean[] = [];

  // ■■業種・地域・企業名・詳細条件の入力エリア＞業種　関連
  // 大分類、中分類の開閉状態を管理するステート
  const [openCategories, setOpenCategories] = useState<string[]>([]);
  // トグルで開閉を管理
  const handleToggle = (category: string) => {
    setOpenCategories((prev) => {
      if (prev.includes(category)) {
        // オフにする場合
        let newCategories = prev.filter((item) => item !== category);

        // 大分類がオフになる場合、中分類もオフにする
        const [mainCategory, subCategory] = category.split(',').slice(0, 2);
        if (subCategory === '00') {
          // 大分類の場合
          newCategories = newCategories.filter((item) => {
            const [itemMainCategory, itemSubCategory] = item.split(',').slice(0, 2);
            // 同じグループで、かつ中分類（サブカテゴリーが '00' ではない）を除外
            return !(itemMainCategory === mainCategory && itemSubCategory !== '00');
          });
        }

        return newCategories;
      } else {
        // オンにする場合
        return [...prev, category];
      }
    });
  };

  // CSVダウンロードモーダル表示フラグ
  const [csvDLModalIsOpen, setCsvDLModalIsOpen] = useState(false);
  // 出力企業リスト CSVダウンロードモーダル　
  const [selectedCorporateNumberList, setSelectedCorporateNumberList] = useState<string[]>([]);
  // 検索条件　CSVダウンロードモーダル　　デフォルト値（null許容のPGではないので）
  const deafaultSearchFilter : SearchFilter = 
  {
    industorialClass:'',
    address:'',
    businessKeywords:'',
    corporateName:'',
    freeWord:'',
    detailParameter:'',
    flag:'',
    numberOfCorporate:0,
    comments:'',
  };
  // 検索条件　CSVダウンロードモーダル　
  const [searchFilterRecord, setSearchFilterRecord] = useState<SearchFilter>(deafaultSearchFilter);
  // CSVダウンロードフラグ
  const [isDownload, setIsDownload] = useState<boolean>(false);
  // 2025/10/30 ダウンロード件数再読み込み処理の追加 START
  // CSVダウンロード完了フラグ
  const [isDownloaded, setIsDownloaded] = useState<boolean>(false);
  // 2025/10/30 ダウンロード件数再読み込み処理の追加 END

  // 検索結果チェックボックスの状態
  const [masterChecked, setMasterChecked] = useState(true);
  const [otherChecked, setOtherChecked] = useState<boolean[]>(new Array(corporateNumList.length).fill(true));

  // セッションによる変更かどうかの判定
  const [isNoSession, setIsNoSession] = useState<boolean>(false);
  const [isSessionLoading, setIsSessionLoading] = useState<boolean>(false);

  useEffect(() => {
    const loadState = async () => {
      try {
        // セッションからの呼び出し
        setIsSessionLoading(true);
        // 検索条件
        const savedCheckedIndustryItems = JSON.parse(sessionStorage.getItem('checkedIndustryItems') ?? '{}');
        const savedCheckedRegionItems = JSON.parse(sessionStorage.getItem('checkedRegionItems') ?? '{}');
        const savedForNotationRegionItems = JSON.parse(sessionStorage.getItem('forNotationRegionItems') ?? '{}');
        const savedForNotationIndustryItems = JSON.parse(sessionStorage.getItem('forNotationIndustryItems') ?? '{}');
        const savedCorporateName = sessionStorage.getItem('corporateName') ?? "";
        const savedFreeWordSearchMethod = sessionStorage.getItem('freeWordSearchMethod') ?? "AND";
        const savedFreeWordFirst = sessionStorage.getItem('freeWordFirst') ?? "";
        const savedFreeWordSecond = sessionStorage.getItem('freeWordSecond') ?? "";
        const savedFreeWordThird =  sessionStorage.getItem('freeWordThird') ?? "";
        const savedFreeWordFourth =  sessionStorage.getItem('freeWordFourth') ?? "";
        const savedFreeWordFifth =  sessionStorage.getItem('freeWordFifth') ?? "";
        const savedFreeWordSixth =  sessionStorage.getItem('freeWordSixth') ?? "";
        const savedBusinessContentsSearchMethod = sessionStorage.getItem('businessContentsSearchMethod') ?? "AND";
        const savedBusinessContentsFirst = sessionStorage.getItem('businessContentsFirst') ?? "";
        const savedBusinessContentsSecond = sessionStorage.getItem('businessContentsSecond') ?? "";
        const savedBusinessContentsThird =  sessionStorage.getItem('businessContentsThird') ?? "";
        const savedBusinessContentsFourth =  sessionStorage.getItem('businessContentsFourth') ?? "";
        const savedBusinessContentsFifth =  sessionStorage.getItem('businessContentsFifth') ?? "";
        const savedBusinessContentsSixth =  sessionStorage.getItem('businessContentsSixth') ?? "";
        const savedSalesFrom =  sessionStorage.getItem('salesFrom') ?? "";
        const savedSalesTo =  sessionStorage.getItem('salesTo') ?? "";
        const savedEmployeesNumFrom =  sessionStorage.getItem('employeesNumFrom') ?? "";
        const savedEmployeesNumTo =  sessionStorage.getItem('employeesNumTo') ?? "";
        const savedEstablishedFrom =  sessionStorage.getItem('establishedFrom') ?? "";
        const savedEstablishedTo =  sessionStorage.getItem('establishedTo') ?? "";
        const savedCapitalFrom =  sessionStorage.getItem('capitalFrom') ?? "";
        const savedCapitalTo =  sessionStorage.getItem('capitalTo') ?? "";
        const savedShareholders =  sessionStorage.getItem('shareholders') ?? "";
        const savedPartners =  sessionStorage.getItem('partners') ?? "";
        const savedCheckedHaveOrNotHaveHomePage = JSON.parse(sessionStorage.getItem('checkedHaveOrNotHaveHomePage') ?? '[true, false]');
        const savedCheckedHaveOrNotHaveContactPage = JSON.parse(sessionStorage.getItem('checkedHaveOrNotHaveContactPage') ?? '[true, true]');
        const savedCheckedListedOrUnListedCompany = JSON.parse(sessionStorage.getItem('checkedListedOrUnListedCompany') ?? '[true, true]');
        const savedCheckedCloseOrOpenCompany = JSON.parse(sessionStorage.getItem('checkedCloseOrOpenCompany') ?? '[false, true]');
        const savedCheckedNotificationCertification = JSON.parse(sessionStorage.getItem('checkedNotificationCertification') ?? '[false,false]');
        const savedCheckedAwardName = JSON.parse(sessionStorage.getItem('checkedAwardName') ?? '[false,false]');
        const savedCheckedQualificationLevel = JSON.parse(sessionStorage.getItem('checkedQualificationLevel') ?? '[false,false]');
        const savedCheckedProcurementInformation = JSON.parse(sessionStorage.getItem('checkedProcurementInformation') ?? '[false,false]');
        const savedCheckedOutputOrNotOutputCompany = JSON.parse(sessionStorage.getItem('checkedOutputOrNotOutputCompany') ?? '[true, true]');

        const savedCheckedNewlyEstablished = JSON.parse(sessionStorage.getItem('checkedNewlyEstablished') ?? 'false');
        const savedCheckedDXCertified = JSON.parse(sessionStorage.getItem('checkedDXCertified') ?? 'false');
        const savedCheckedRegionalEconomicLeaders = JSON.parse(sessionStorage.getItem('checkedRegionalEconomicLeaders') ?? 'false');
        const savedCheckedPromotionWomenSuccess = JSON.parse(sessionStorage.getItem('checkedPromotionWomenSuccess') ?? 'false');
        const savedCheckedLifeAndWorkSupport = JSON.parse(sessionStorage.getItem('checkedLifeAndWorkSupport') ?? 'false');
        const savedCheckedPromotingYouthDevelopment = JSON.parse(sessionStorage.getItem('checkedPromotingYouthDevelopment') ?? 'false');

        // セッションに保存済み検索条件があれば取得（上書き）
        const savedCurrentResultSearchConditions = JSON.parse(sessionStorage.getItem('currentResultSearchConditions') ?? 'null');

        // ページネーション・並び替え情報
        const savedCurrentPage = JSON.parse(sessionStorage.getItem('currentPage') ?? '1');
        const savedRowsPerPage = JSON.parse(sessionStorage.getItem('rowsPerPage') ?? '20');
        const savedSortKey = sessionStorage.getItem('sortKey') ?? "headquarterAddress";
        const savedAscDesc = sessionStorage.getItem('ascDesc') ?? "ASC";
        const savedIsAscendingPush = JSON.parse(sessionStorage.getItem('isAscendingPush') ?? 'true');
        // 検索結果の表示内容
        const savedDataCount = JSON.parse(sessionStorage.getItem('dataCount') ?? '0');
        const savedTableData = JSON.parse(sessionStorage.getItem('tableData') ?? '[]');
        const savedFacetCount = JSON.parse(sessionStorage.getItem('facetCount') ?? '0');
        const savedIsViewFacet = JSON.parse(sessionStorage.getItem('isViewFacet') ?? 'false');

        const savedTagList = JSON.parse(sessionStorage.getItem('tagList') ?? '[]');
        const savedTagSearchList = JSON.parse(sessionStorage.getItem('tagSearchList') ?? '[]');
        const savedTagSearchCondList = JSON.parse(sessionStorage.getItem('tagSearchCondList') ?? '[]');
        const savedIsTagButtonOn = JSON.parse(sessionStorage.getItem('isTagButtonOn') ?? '{}');
        const savedIsSearchClicked = JSON.parse(sessionStorage.getItem('isSearchClicked') ?? 'false');
        const savedIsSearchFacetClicked = JSON.parse(sessionStorage.getItem('isSearchFacetClicked') ?? 'false');
        const savedIsSearchTagFilterClicked = JSON.parse(sessionStorage.getItem('isSearchTagFilterClicked') ?? 'false');
        const savedIsSearchTagNewClicked = JSON.parse(sessionStorage.getItem('isSearchTagNewClicked') ?? 'false');

        const savedCorporateNumList = JSON.parse(sessionStorage.getItem('corporateNumList') ?? '[]');
        // フィルタファセットの項目
        const savedFilterIndustryFacetsData = JSON.parse(sessionStorage.getItem('filterIndustryFacetsData') ?? '[]');
        const savedFilterFinancialEndofFYFacetList = JSON.parse(sessionStorage.getItem('filterFinancialEndofFYFacetList') ?? '[]');
        const savedFilterCorpGroupFacetsHitcount = JSON.parse(sessionStorage.getItem('filterCorpGroupFacetsHitcount') ?? '[]');
        const savedFilterLocalGovernmentFacetList = JSON.parse(sessionStorage.getItem('filterLocalGovernmentFacetList') ?? '[]');
        const savedFilterOfficeIsExistFacetHitcount = JSON.parse(sessionStorage.getItem('filterOfficeIsExistFacetHitcount') ?? '[]');
        const savedFilterCorporateUrlFacetHitCount = JSON.parse(sessionStorage.getItem('filterCorporateUrlFacetHitCount') ?? '[]');
        // フィルタファセットの条件
        const savedCheckedEndOfFY = JSON.parse(sessionStorage.getItem('checkedEndOfFY') ?? '[]');
        const savedCheckedGroup = JSON.parse(sessionStorage.getItem('checkedGroup') ?? '[false]');
        const savedCheckedOffice = JSON.parse(sessionStorage.getItem('checkedOffice') ?? '[]');
        // CSVDL条件　チェックボックス
        const savedSearchFilterRecord = JSON.parse(sessionStorage.getItem('searchFilterRecord') ?? 'null');
        const savedMasterChecked = JSON.parse(sessionStorage.getItem('masterChecked') ?? 'false');
        const savedOtherChecked = JSON.parse(sessionStorage.getItem('otherChecked') ?? '[]');

        // セッションの値のセット
        // 検索条件・検索条件保存モーダル
        setCheckedIndustryItems(savedCheckedIndustryItems);
        setForNotationIndustryItems(savedForNotationIndustryItems);
        setCheckedRegionItems(savedCheckedRegionItems);
        setForNotationRegionItems(savedForNotationRegionItems);
        setCorporateName(savedCorporateName);
        if (corporateNameRef.current) corporateNameRef.current.value = savedCorporateName;
        setFreeWordSearchMethod(savedFreeWordSearchMethod);
        setFreeWordFirst(savedFreeWordFirst);
        if (freeWordFirstRef.current) freeWordFirstRef.current.value = savedFreeWordFirst;
        setFreeWordSecond(savedFreeWordSecond);
        if (freeWordSecondRef.current) freeWordSecondRef.current.value = savedFreeWordSecond;
        setFreeWordThird(savedFreeWordThird);
        if (freeWordThirdRef.current) freeWordThirdRef.current.value = savedFreeWordThird;
        setFreeWordFourth(savedFreeWordFourth);
        if (freeWordFourthRef.current) freeWordFourthRef.current.value = savedFreeWordFourth;
        setFreeWordFifth(savedFreeWordFifth);
        if (freeWordFifthRef.current) freeWordFifthRef.current.value = savedFreeWordFifth;
        setFreeWordSixth(savedFreeWordSixth);
        if (freeWordSixthRef.current) freeWordSixthRef.current.value = savedBusinessContentsSixth;
        setBusinessContentsSearchMethod(savedBusinessContentsSearchMethod);
        setBusinessContentsFirst(savedBusinessContentsFirst);
        if (businessContentsFirstRef.current) businessContentsFirstRef.current.value = savedBusinessContentsFirst;
        setBusinessContentsSecond(savedBusinessContentsSecond);
        if (businessContentsSecondRef.current) businessContentsSecondRef.current.value = savedBusinessContentsSecond;
        setBusinessContentsThird(savedBusinessContentsThird);
        if (businessContentsThirdRef.current) businessContentsThirdRef.current.value = savedBusinessContentsThird;
        setBusinessContentsFourth(savedBusinessContentsFourth);
        if (businessContentsFourthRef.current) businessContentsFourthRef.current.value = savedBusinessContentsFourth;
        setBusinessContentsFifth(savedBusinessContentsFifth);
        if (businessContentsFifthRef.current) businessContentsFifthRef.current.value = savedBusinessContentsFifth;
        setBusinessContentsSixth(savedBusinessContentsSixth);
        if (businessContentsSixthRef.current) businessContentsSixthRef.current.value = savedBusinessContentsSixth;
        setSalesFrom(savedSalesFrom);
        if (salesFromRef.current) salesFromRef.current.value = savedSalesFrom;
        setSalesTo(savedSalesTo);
        if (salesToRef.current) salesToRef.current.value = savedSalesTo;
        setEmployeesNumFrom(savedEmployeesNumFrom);
        if (employeesNumFromRef.current) employeesNumFromRef.current.value = savedEmployeesNumFrom;
        setEmployeesNumTo(savedEmployeesNumTo);
        if (employeesNumToRef.current) employeesNumToRef.current.value = savedEmployeesNumTo;
        setEstablishedFrom(savedEstablishedFrom);
        if (establishedFromRef.current) establishedFromRef.current.value = savedEstablishedFrom;
        setEstablishedTo(savedEstablishedTo);
        if (establishedToRef.current) establishedToRef.current.value = savedEstablishedTo;
        setCapitalFrom(savedCapitalFrom);
        if (capitalFromRef.current) capitalFromRef.current.value = savedCapitalFrom;
        setCapitalTo(savedCapitalTo);
        if (capitalToRef.current) capitalToRef.current.value = savedCapitalTo;
        setShareholders(savedShareholders);
        if (shareholdersRef.current) shareholdersRef.current.value = savedShareholders;
        setPartners(savedPartners);
        if (partnersRef.current) partnersRef.current.value = savedPartners;
        setCheckedHaveOrNotHaveHomePage(savedCheckedHaveOrNotHaveHomePage);
        setCheckedHaveOrNotHaveContactPage(savedCheckedHaveOrNotHaveContactPage);
        setCheckedListedOrUnListedCompany(savedCheckedListedOrUnListedCompany);
        setCheckedCloseOrOpenCompany(savedCheckedCloseOrOpenCompany);
        setCheckedNotificationCertification(savedCheckedNotificationCertification);
        setCheckedAwardName(savedCheckedAwardName);
        setCheckedQualificationLevel(savedCheckedQualificationLevel);
        setCheckedProcurementInformation(savedCheckedProcurementInformation);
        setCheckedOutputOrNotOutputCompany(savedCheckedOutputOrNotOutputCompany);
        setCheckedNewlyEstablished(savedCheckedNewlyEstablished);
        setCheckedDXCertified(savedCheckedDXCertified);
        setCheckedRegionalEconomicLeaders(savedCheckedRegionalEconomicLeaders);
        setCheckedPromotionWomenSuccess(savedCheckedPromotionWomenSuccess);
        setCheckedLifeAndWorkSupport(savedCheckedLifeAndWorkSupport);
        setCheckedPromotingYouthDevelopment(savedCheckedPromotingYouthDevelopment);
        // 読み込み時のチェック状態がデフォルト状態と異なる場合、isBusinessKeywordsCheckboxDifferentFromDefaultStateをtrueにする
        if (savedBusinessContentsFirst != "" || savedBusinessContentsSecond != "" || savedBusinessContentsThird != "" || savedBusinessContentsFourth != "" || savedBusinessContentsFifth != "" || savedBusinessContentsSixth != "") {
          isBusinessKeywordsCheckboxDifferentFromDefaultState.current = true;
        }
        // 読み込み時のチェック状態がデフォルト状態と異なる場合、isFreeWordCheckboxDifferentFromDefaultStateをtrueにする
        if (savedFreeWordFirst != "" || savedFreeWordSecond != "" || savedFreeWordThird != "" || savedFreeWordFourth != "" || savedFreeWordFifth != "" || savedFreeWordSixth != "") {
          isFreeWordCheckboxDifferentFromDefaultState.current = true;
        }
        // 読み込み時のチェック状態がデフォルト状態と異なる場合、isDetailConditionsCheckboxDifferentFromDefaultStateをtrueにする
        if (
          !(savedCheckedHaveOrNotHaveHomePage[0] && !savedCheckedHaveOrNotHaveHomePage[1]) ||
          !(savedCheckedHaveOrNotHaveContactPage[0] && savedCheckedHaveOrNotHaveContactPage[1]) ||
          !(savedCheckedListedOrUnListedCompany[0] && savedCheckedListedOrUnListedCompany[1]) ||
          !(!savedCheckedCloseOrOpenCompany[0] && savedCheckedCloseOrOpenCompany[1]) ||
          !(!savedCheckedNotificationCertification[0] && !savedCheckedNotificationCertification[1]) ||
          !(!savedCheckedAwardName[0] && !savedCheckedAwardName[1]) ||
          !(!savedCheckedQualificationLevel[0] && !savedCheckedQualificationLevel[1]) ||
          !(!savedCheckedProcurementInformation[0] && !savedCheckedProcurementInformation[1]) ||
          !(savedCheckedOutputOrNotOutputCompany[0] && savedCheckedOutputOrNotOutputCompany[1])
        ) {
          isDetailConditionsCheckboxDifferentFromDefaultState.current = true;
        }
        // 読み込み時のチェック状態がデフォルト状態と異なる場合、isFlagCheckboxDifferentFromDefaultStateをtrueにする
        if (savedCheckedNewlyEstablished || savedCheckedDXCertified || savedCheckedRegionalEconomicLeaders || savedCheckedPromotionWomenSuccess || savedCheckedLifeAndWorkSupport || savedCheckedPromotingYouthDevelopment) {
          isFlagCheckboxDifferentFromDefaultState.current = true;
        }
        setCurrentResultSearchConditions(savedCurrentResultSearchConditions);
        // ページネーション・並び替え情報
        setCurrentPage(Number(savedCurrentPage));
        setRowsPerPage(Number(savedRowsPerPage));
        setSortKey(savedSortKey as keyof ResponseDataItem);
        setAscDesc(savedAscDesc);
        setIsAscendingPush(savedIsAscendingPush);
        // 検索結果の表示内容
        setDataCount(savedDataCount);
        setFacetCount(Number(savedFacetCount));
        setIsViewFacet(savedIsViewFacet);
        setTableData(savedTableData);
        setTagList(savedTagList);
        setTagSearchList(savedTagSearchList);
        setTagSearchCondList(savedTagSearchCondList);
        setIsTagButtonOn(savedIsTagButtonOn);
        setIsSearchClicked(savedIsSearchClicked);
        setIsSearchFacetClicked(savedIsSearchFacetClicked);
        setIsSearchTagFilterClicked(savedIsSearchTagFilterClicked);
        setIsSearchTagNewClicked(savedIsSearchTagNewClicked);
        confirmBusinessKeywordsIsEnterd(false);
        confirmFreeWordIsEnterd(false);
        confirmDetailConditionsIsEnterd(false);
        confirmFlagIsEnterd(false);
        setCorporateNumList(savedCorporateNumList);
        // フィルタファセットの項目
        setFilterIndustryFacetsData(savedFilterIndustryFacetsData);
        setFilterFinancialEndofFYFacetList(savedFilterFinancialEndofFYFacetList);     // 決算月
        const monthLength = Object.keys(savedFilterFinancialEndofFYFacetList).length;
        setMonthLength(monthLength);
        const monthLimit = (monthLength > 3) ? 3 : monthLength;
        setMonthLimit(monthLimit);
        setHasShowMoreMonthList(monthLength > 3);
        setFilterCorpGroupFacetsHitcount(savedFilterCorpGroupFacetsHitcount);         // 企業グループ
        setFilterLocalGovernmentFacetList(savedFilterLocalGovernmentFacetList);
        setFilterOfficeIsExistFacetHitcount(savedFilterOfficeIsExistFacetHitcount);   // 事業所
        setFilterCorporateUrlFacetHitCount(savedFilterCorporateUrlFacetHitCount);     // 企業URL
        // フィルタファセットの条件
        setCheckedEndOfFY(savedCheckedEndOfFY);
        setCheckedGroup(savedCheckedGroup);
        setCheckedOffice(savedCheckedOffice);
        // フィルタファセットの該当社数更新ローディングを停止
        queueCountFacet.length = 0;
        setIsGetFacetCountSearching(false);
        // CSVDL条件　チェックボックス
        if (savedSearchFilterRecord) setSearchFilterRecord(savedSearchFilterRecord);
        setMasterChecked(savedMasterChecked);
        setOtherChecked(savedOtherChecked);

        setIsSessionLoading(false);
      } catch (error) {
        // エラーハンドリング
        console.error("エラーが発生しました:", error);
      }
    };

    loadState();
  }, []);

  // ■■画面読み込み時
  React.useEffect(() => {

    const handleLoadHeader = async () => {
      // 最新のトークンを取得する
      try {
        // 最新のトークンを取得する
        setIsLoadingToken(true);
        const { decodedAccessTokenInfo, idToken } = await getTokens(); // トークンを取得
        setTokenInfo(decodedAccessTokenInfo); // 取得したdecodedAccessTokenInfoをセット
        setIsLoadingToken(false);
        // 「【ホーム画面】表示内容の取得」の呼び出しと画面値の設定
        fetchEachIndustrialCompanyNumAndSetting();
        fetchEachRegionCompanyNumAndSetting();
        /* 2025/10/21 V2.0 セレクトテーマ非表示対応
        fetchEachTrendThemeSetting();
         */
      } catch (error) {
        console.error("画面読み込み時エラー:", error);
        setErrorMessage1(ERROR_MESSAGE_PROCESSING_ERROR);
      }

    }

    if (isLoadedHeader) {
      handleLoadHeader();
      setIsLoadedHeader(false);
    }

  },[isLoadedHeader]);

  // ■■画面読み込み時 「【ホーム画面】表示内容の取得」完了時
  React.useEffect(() => {

    const handleSetAllowDetailConditionInput = () => {
      try {
        if(tokenInfo.plan == "basic" || tokenInfo.plan == "freePlus"){
          // 詳細条件を入力可に設定
          setAllowDetailConditionInput(true);
        }
      } catch (error) {
        console.error("画面読み込み時エラー:", error);
        setErrorMessage1(ERROR_MESSAGE_PROCESSING_ERROR);
      }
    };

    /* 2025/10/21 V2.0 セレクトテーマ非表示対応 start */
    // if (/*isFetchedUpdatedData && */isFetchedEachIndustrialCompanyNum && isFetchedEachRegionCompanyNum && isFetchedEachTrendThemeList) {
    //   handleSetAllowDetailConditionInput();
    // }
    if (/*isFetchedUpdatedData && */isFetchedEachIndustrialCompanyNum && isFetchedEachRegionCompanyNum /* && isFetchedEachTrendThemeList */) {
      handleSetAllowDetailConditionInput();
    }
    /* 2025/10/21 V2.0 セレクトテーマ非表示対応 end */

  },[isFetchedUpdatedData, isFetchedEachIndustrialCompanyNum, isFetchedEachRegionCompanyNum, isFetchedEachTrendThemeList]);

  // ■■「【ホーム画面】表示内容の取得」の呼び出しと画面値の設定
  // 1. 企業数(産業分類単位)
  const fetchEachIndustrialCompanyNumAndSetting = async () => {
    const responseData = await callShowHomeAndSetting('numindustorialclass');
    const newEachIndustrialCompanyNum:{[key:string]:number} = JSON.parse(responseData.numindustorialclass.replace(/\n/g,"").replace(/\s+/g,""));
    setEachIndustrialCompanyNum(newEachIndustrialCompanyNum);
    setIsFetchedEachIndustrialCompanyNum(true);

    const newEachIndustrialSortList = Object.entries(newEachIndustrialCompanyNum).sort((a,b) => b[1] - a[1]).map(([key]) => key);
    setIndustryFacetsSortDataDict(newEachIndustrialSortList);
  };
  // 2. 企業数(地域単位)
  const fetchEachRegionCompanyNumAndSetting = async () => {
    const responseData = await callShowHomeAndSetting('numlocalgovernment');
    const newEachRegionCompanyNum:{[key:string]:number} = JSON.parse(responseData.numlocalgovernment.replace(/\n/g,"").replace(/\s+/g,""));
    setEachRegionCompanyNum(newEachRegionCompanyNum);
    setIsFetchedEachRegionCompanyNum(true);
  };
  // 4. セレクトテーマ
  const fetchEachTrendThemeSetting = async () => {
    const responseData = await callShowHomeAndSetting('trendtheme');
    const newEachTrendThemeList:any[] = responseData.trendtheme;
    setEachTrendThemeList(newEachTrendThemeList);
    setIsFetchedEachTrendThemeList(true);
  };

  // ■■「【ホーム画面】表示内容の取得」の呼び出し
  const callShowHomeAndSetting = async (fetchType:string) => {
    try {
      // idTokenを取得
      const { idToken } = await getTokens();

      // API Gatewayを呼び出す
      const baseUrl:string = process.env.REACT_APP_API_BASE_URL || '';
      const path:string = '/event/showhome';
      const apipath = baseUrl.concat(path);
      const response = await fetch(apipath,{
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${idToken}`, // IDトークンをヘッダーに設定
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({'fetchType': fetchType})
      });
      // ステータスコードの確認
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      // レスポンスのJSONデータをパース
      const responseData = await response.json();
      return responseData;
    } catch (error) {
      console.error('callShowHomeAndSettingエラー:', error);
      throw error;
    }
  };

  // ■■「保存上限チェック」の呼び出し
  const callCheckLimitSave = async () => {
    try {
      // idTokenを取得
      const { idToken } = await getTokens();

      // API Gatewayを呼び出す
      const baseUrl:string = process.env.REACT_APP_API_BASE_URL || '';
      const path:string = '/common/checklimitsave';
      const apipath = baseUrl.concat(path);
      const response = await fetch(apipath,{
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${idToken}`, // IDトークンをヘッダーに設定
          'Content-Type': 'application/json'
        },
      });
      // ステータスコードの確認
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      // レスポンスのJSONデータをパース
      const responseData = await response.json();
      // レスポンスのbodyから必要なデータを取得
      const { saveFlag, message } = responseData;
      // 保存数の制限が超えた場合の処理
      if (!saveFlag) {
        setErrorMessage2(message); // エラーメッセージを表示
      } else {
        setErrorMessage2(""); // エラーメッセージをクリア
      }
      return saveFlag;
    } catch (error) {
      throw Error;
    }
  };

  // ■■「桁数チェック」の呼び出し
  const callCheckDegit = async (record:CheckDegitRecordType): Promise<CheckDegitResult[]> => {
    try {
      // idTokenを取得
      const { idToken } = await getTokens();

      // API Gatewayを呼び出す
      const baseUrl:string = process.env.REACT_APP_API_BASE_URL || '';
      const path:string = '/common/checkdegit';
      const apipath = baseUrl.concat(path);
      const response = await fetch(apipath,{
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${idToken}`, // IDトークンをヘッダーに設定
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(record)
      });
      // ステータスコードの確認
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      // レスポンスのJSONデータをパース
      const responseData: CheckDegitResult[] = await response.json();
      return responseData;
    } catch (error) {
      setIsSearching(false); // 検索中フラグOFF
      console.error("エラー:", error);
      setErrorMessage3("処理中にエラーが発生しました。もう一度お試し下さい。");
      throw Error;
    }
  };

  // ハンドラー関数 (検索ボタン押下時)
  const handleSearchWithClick = async () => {
    // 検索中は多重検索・クリックを防止
    if (isSearching) {
        return;
    }
    setIsSearching(true); // 検索中フラグOFF
    setCurrentPage(1);
    resetTagList();                 // タグクリア
    clearTagSearchRequirements();   // タグ条件クリア
    clearFacetSearchRequirements(); // ファセット条件クリア
    await handleSearch(true);
    //検索条件をキャッシュに保存
    handleConditionSet();
    saveState();
  };

  // 検索処理
  const handleSearch = async (isFromButtonClick: boolean) => {
    const industrialClass_code = Object.keys(forNotationIndustryItems).join(";");

    const newForNotationregionItems:string[] = [];
    const regionItems = Object.keys(forNotationRegionItems);
    regionItems.map((item:string) => {
      if (item.endsWith("tokyoSpecialWards")) {
        regionHierarchyMap["tokyoSpecialWards"].map((code:string)=> {
          newForNotationregionItems.push(item + ">" + code);
        });
      } else if (item.endsWith("tokyoNonSpecialWards")) {
        regionHierarchyMap["tokyoNonSpecialWards"].map((code:string)=> {
          newForNotationregionItems.push(item + ">" + code);
        });
      } else {
        newForNotationregionItems.push(item);
      }
    });
    const address_code = Array.from(new Set(newForNotationregionItems)).join(";");

    const getCurrentDateFormatted = (): string => {
      const date = new Date();
      const year = date.getFullYear();
      const month = ('0' + (date.getMonth() + 1)).slice(-2); // 月は0が1月なので+1
      return `${year}/${month}`;
    };
    let searchConditions:SearchConditions;

    if (isFromButtonClick || !currentResultSearchConditions) {
      searchConditions = {
        outputDate:getCurrentDateFormatted(),
        corporateName:corporateNameRef.current?.value ? corporateNameRef.current?.value : "",
        freeWord: formatFreeWordRequirementsForSaveSearchData(),
        freeWord1:freeWordFirstRef.current?.value ? freeWordFirstRef.current?.value: "",
        freeWord2:freeWordSecondRef.current?.value ? freeWordSecondRef.current?.value: "",
        freeWord3:freeWordThirdRef.current?.value ? freeWordThirdRef.current?.value: "",
        freeWord4:freeWordFourthRef.current?.value ? freeWordFourthRef.current?.value: "",
        freeWord5:freeWordFifthRef.current?.value ? freeWordFifthRef.current?.value: "",
        freeWord6:freeWordSixthRef.current?.value ? freeWordSixthRef.current?.value: "",
        industorialClass_code:industrialClass_code,
        address_code:address_code,
        detailParameter:formatDetailRequirementsForSaveSearchData(),
        flag:formatFlagRequirementsForSaveSearchData(),
        sortOrder: sortKey,
        ascending_DescendingOrder: ascDesc,
        displayCount: rowsPerPage.toString(),
        currentPageNumber: "1",
        businessKeywords:formatBusinessKeywordsRequirementsForSaveSearchData(),
        businessKeyword1:businessContentsFirstRef.current?.value ? businessContentsFirstRef.current?.value: "",
        businessKeyword2:businessContentsSecondRef.current?.value ? businessContentsSecondRef.current?.value: "",
        businessKeyword3:businessContentsThirdRef.current?.value ? businessContentsThirdRef.current?.value: "",
        businessKeyword4:businessContentsFourthRef.current?.value ? businessContentsFourthRef.current?.value: "",
        businessKeyword5:businessContentsFifthRef.current?.value ? businessContentsFifthRef.current?.value: "",
        businessKeyword6:businessContentsSixthRef.current?.value ? businessContentsSixthRef.current?.value: "",
        salesFrom:salesFromRef.current?.value ? salesFromRef.current?.value : "",
        salesTo:salesToRef.current?.value ? salesToRef.current?.value : "",
        numberOfEmployeesFrom:employeesNumFromRef.current?.value ? employeesNumFromRef.current?.value : "",
        numberOfEmployeesTo:employeesNumToRef.current?.value ? employeesNumToRef.current?.value : "",
        establishmentDateFrom:establishedFromRef.current?.value ? establishedFromRef.current?.value : "",
        establishmentDateTo:establishedToRef.current?.value ? establishedToRef.current?.value : "",
        captalStockFrom:capitalFromRef.current?.value ? capitalFromRef.current?.value : "",
        captalStockTo:capitalToRef.current?.value ? capitalToRef.current?.value : "",
        shareholders:shareholdersRef.current?.value ? shareholdersRef.current?.value : "",
        partners:partnersRef.current?.value ? partnersRef.current?.value : "",
        endOfFY: "",
        corporateGroupIsBelong: "",
        officeIsExist: "",
        tags: "",
      };
    } else {
      searchConditions = {
        outputDate:currentResultSearchConditions.outputDate,
        corporateName:currentResultSearchConditions.corporateName,
        freeWord:currentResultSearchConditions.freeWord,
        freeWord1:currentResultSearchConditions.freeWord1,
        freeWord2:currentResultSearchConditions.freeWord2,
        freeWord3:currentResultSearchConditions.freeWord3,
        freeWord4:currentResultSearchConditions.freeWord4,
        freeWord5:currentResultSearchConditions.freeWord5,
        freeWord6:currentResultSearchConditions.freeWord6,
        industorialClass_code:currentResultSearchConditions.industorialClass_code,
        address_code:currentResultSearchConditions.address_code,
        detailParameter:currentResultSearchConditions.detailParameter,
        flag:currentResultSearchConditions.flag,
        sortOrder: sortKey,
        ascending_DescendingOrder: ascDesc,
        displayCount: rowsPerPage.toString(),
        currentPageNumber: currentPage.toString(),
        businessKeywords:currentResultSearchConditions.businessKeywords,
        businessKeyword1:currentResultSearchConditions.businessKeyword1,
        businessKeyword2:currentResultSearchConditions.businessKeyword2,
        businessKeyword3:currentResultSearchConditions.businessKeyword3,
        businessKeyword4:currentResultSearchConditions.businessKeyword4,
        businessKeyword5:currentResultSearchConditions.businessKeyword5,
        businessKeyword6:currentResultSearchConditions.businessKeyword6,
        salesFrom:currentResultSearchConditions.salesFrom,
        salesTo:currentResultSearchConditions.salesTo,
        numberOfEmployeesFrom:currentResultSearchConditions.numberOfEmployeesFrom,
        numberOfEmployeesTo:currentResultSearchConditions.numberOfEmployeesTo,
        establishmentDateFrom:currentResultSearchConditions.establishmentDateFrom,
        establishmentDateTo:currentResultSearchConditions.establishmentDateTo,
        captalStockFrom:currentResultSearchConditions.captalStockFrom,
        captalStockTo:currentResultSearchConditions.captalStockTo,
        shareholders:currentResultSearchConditions.shareholders,
        partners:currentResultSearchConditions.partners,
        endOfFY:currentResultSearchConditions.endOfFY,
        corporateGroupIsBelong:currentResultSearchConditions.corporateGroupIsBelong,
        officeIsExist:currentResultSearchConditions.officeIsExist,
        tags: "",
      };
    }

    // トークンが読み込めていない時は処理を中断
    if (!tokenInfo) {
      setIsSearching(false); // 検索中フラグOFF
      return;
    }

    // 検索処理開始時すべてのエラーメッセージ、成功メッセージをリセットする
    setSuccessMessage("");
    setErrorMessage1("");
    setErrorMessage2("");
    setErrorMessage3("");

    //検索するボタン押下時の検索の場合入力チェックを行う(ページ遷移の際の検索では入力チェック済みの同じ条件を使うためチェックは行わない)
    if (isFromButtonClick) {
      //桁数チェックのための整形
      const  inputInfo: CheckDegitRecordType = {
        inputInfo: [
          { itemName: "corporateName", inputText: searchConditions.corporateName, limitNumberOfDigit: 150 },
          { itemName: "freeWord1", inputText: searchConditions.freeWord1, limitNumberOfDigit: 200 },
          { itemName: "freeWord2", inputText: searchConditions.freeWord2, limitNumberOfDigit: 200 },
          { itemName: "freeWord3", inputText: searchConditions.freeWord3, limitNumberOfDigit: 200 },
          { itemName: "freeWord4", inputText: searchConditions.freeWord4, limitNumberOfDigit: 200 },
          { itemName: "freeWord5", inputText: searchConditions.freeWord5, limitNumberOfDigit: 200 },
          { itemName: "freeWord6", inputText: searchConditions.freeWord6, limitNumberOfDigit: 200 },
          { itemName: "businessKeyword1", inputText: searchConditions.businessKeyword1, limitNumberOfDigit: 200 },
          { itemName: "businessKeyword2", inputText: searchConditions.businessKeyword2, limitNumberOfDigit: 200 },
          { itemName: "businessKeyword3", inputText: searchConditions.businessKeyword3, limitNumberOfDigit: 200 },
          { itemName: "businessKeyword4", inputText: searchConditions.businessKeyword4, limitNumberOfDigit: 200 },
          { itemName: "businessKeyword5", inputText: searchConditions.businessKeyword5, limitNumberOfDigit: 200 },
          { itemName: "businessKeyword6", inputText: searchConditions.businessKeyword6, limitNumberOfDigit: 200 },
          { itemName: "salesFrom", inputText: searchConditions.salesFrom.toString(), limitNumberOfDigit: 150 },
          { itemName: "salesTo", inputText: searchConditions.salesTo.toString(), limitNumberOfDigit: 150 },
          { itemName: "numberOfEmployeesFrom", inputText: searchConditions.numberOfEmployeesFrom.toString(), limitNumberOfDigit: 8 },
          { itemName: "numberOfEmployeesTo", inputText: searchConditions.numberOfEmployeesTo.toString(), limitNumberOfDigit: 8 },
          { itemName: "establishmentDateFrom", inputText: searchConditions.establishmentDateFrom.toString(), limitNumberOfDigit: 4 },
          { itemName: "establishmentDateTo", inputText: searchConditions.establishmentDateTo.toString(), limitNumberOfDigit: 4 },
          { itemName: "captalStockFrom", inputText: searchConditions.captalStockFrom.toString(), limitNumberOfDigit: 15 },
          { itemName: "captalStockTo", inputText: searchConditions.captalStockTo.toString(), limitNumberOfDigit: 15 },
          { itemName: "shareholders", inputText: searchConditions.shareholders.toString(), limitNumberOfDigit: 150 },
          { itemName: "partners", inputText: searchConditions.partners.toString(), limitNumberOfDigit: 150 },
        ]
      };
      //入力桁数チェック
      const degitResult: CheckDegitResult[] = await callCheckDegit(inputInfo);
      const errorMessages = degitResult
      .filter(result => !result.checkResult)
      .map(result => result.message);
      if (errorMessages.length > 0) {
        setIsSearching(false); // 検索中フラグOFF
        // 一番目のエラーメッセージを表示
        setErrorMessage2(errorMessages[0]);
        return;
      }

      //属性(数値)チェック
      if (!validateSearchConditions(searchConditions)) {
        setIsSearching(false); // 検索中フラグOFF
        // エラーメッセージを設定し、処理を中断
        return;
      }

      //範囲チェックFROM,TO
      const sales = validateRange(searchConditions.salesFrom, searchConditions.salesTo);
      if (!sales) {
        setIsSearching(false); // 検索中フラグOFF
        return;
      }
      const employees = validateRange(searchConditions.numberOfEmployeesFrom, searchConditions.numberOfEmployeesTo);
      if (!employees) {
        setIsSearching(false); // 検索中フラグOFF
        return;
      }
      const establishment = validateRange(searchConditions.establishmentDateFrom, searchConditions.establishmentDateTo);
      if (!establishment) {
        setIsSearching(false); // 検索中フラグOFF
        return;
      }
      const captalStock = validateRange(searchConditions.captalStockFrom, searchConditions.captalStockTo);
      if (!captalStock) {
        setIsSearching(false); // 検索中フラグOFF
        return;
      }
    }
    // エラーがある場合はここで処理を中断
    await callSearchHome(searchConditions,isFromButtonClick);
    // CSVダウンロード用検索条件保存
    getSearchFilter()

    if (isFromButtonClick || !currentResultSearchConditions) {
      setCurrentResultSearchConditions(searchConditions);
    }
  };

  // ハンドラー関数 (セレクトテーマボタン押下時)
  const handleTrendThemeWithClick = async (trendTheme:any) => {
    
    // 検索条件をセット
    const returnedCallSearchData = {
      savedAt: new Date(trendTheme.saveDate),
      userName: trendTheme.userName,
      industry: trendTheme.industorialClass,
      industryCode: trendTheme.industorialClass_code,
      businessSummary: trendTheme.businessSummary,
      address: trendTheme.address,
      addressCode: trendTheme.address_code,
      corporateName: trendTheme.corporateName,
      Keyword: trendTheme.Keyword,
      detailCondition: trendTheme.detailParameter,
      flag: trendTheme.flag,
      comments: ''
    };
    clearSearchRequirements();
    clearTagSearchRequirements();
    clearFacetSearchRequirements();
    resetTagList();
    mappingNamesToCodes(returnedCallSearchData);
    inputDataBasedOnCallSearchRequirment(returnedCallSearchData);
    setCorporateNameRefValue(returnedCallSearchData.corporateName);
    distributeDetailRequirementsForSaveSearchData(returnedCallSearchData.detailCondition);
    confirmBusinessKeywordsIsEnterd(true);
    setBusinessKeywordsRefValue(returnedCallSearchData.businessSummary);
    confirmFreeWordIsEnterd(true);
    setFreeWordRefValue(returnedCallSearchData.Keyword);
    confirmDetailConditionsIsEnterd(true);
    confirmFlagIsEnterd(true);

    // 検索中は多重検索・クリックを防止
    if (isSearching) {
        return;
    }
    setIsSearching(true); // 検索中フラグOFF

    //
    const getCurrentDateFormatted = (): string => {
      const date = new Date();
      const year = date.getFullYear();
      const month = ('0' + (date.getMonth() + 1)).slice(-2); // 月は0が1月なので+1
      return `${year}/${month}`;
    };
    const searchConditions = {
      outputDate:getCurrentDateFormatted(),
      corporateName:trendTheme.corporateName,
      freeWord:trendTheme.Keyword,
      freeWord1:freeWordFirstRef.current?.value ? freeWordFirstRef.current?.value: "",
      freeWord2:freeWordSecondRef.current?.value ? freeWordSecondRef.current?.value: "",
      freeWord3:freeWordThirdRef.current?.value ? freeWordThirdRef.current?.value: "",
      freeWord4:freeWordFourthRef.current?.value ? freeWordFourthRef.current?.value: "",
      freeWord5:freeWordFifthRef.current?.value ? freeWordFifthRef.current?.value: "",
      freeWord6:freeWordSixthRef.current?.value ? freeWordSixthRef.current?.value: "",
      industorialClass_code:trendTheme.industorialClass_code,
      address_code:trendTheme.address_code,
      detailParameter:trendTheme.detailParameter,
      flag:trendTheme.flag,
      businessKeywords:trendTheme.businessSummary,
      businessKeyword1:businessContentsFirstRef.current?.value ? businessContentsFirstRef.current?.value: "",
      businessKeyword2:businessContentsSecondRef.current?.value ? businessContentsSecondRef.current?.value: "",
      businessKeyword3:businessContentsThirdRef.current?.value ? businessContentsThirdRef.current?.value: "",
      businessKeyword4:businessContentsFourthRef.current?.value ? businessContentsFourthRef.current?.value: "",
      businessKeyword5:businessContentsFifthRef.current?.value ? businessContentsFifthRef.current?.value: "",
      businessKeyword6:businessContentsSixthRef.current?.value ? businessContentsSixthRef.current?.value: "",
      sortOrder: sortKey,
      ascending_DescendingOrder: ascDesc,
      displayCount: rowsPerPage.toString(),
      currentPageNumber: "1",
      salesFrom:salesFromRef.current?.value ? salesFromRef.current?.value : "",
      salesTo:salesToRef.current?.value ? salesToRef.current?.value : "",
      numberOfEmployeesFrom:employeesNumFromRef.current?.value ? employeesNumFromRef.current?.value : "",
      numberOfEmployeesTo:employeesNumToRef.current?.value ? employeesNumToRef.current?.value : "",
      establishmentDateFrom:establishedFromRef.current?.value ? establishedFromRef.current?.value : "",
      establishmentDateTo:establishedToRef.current?.value ? establishedToRef.current?.value : "",
      captalStockFrom:capitalFromRef.current?.value ? capitalFromRef.current?.value : "",
      captalStockTo:capitalToRef.current?.value ? capitalToRef.current?.value : "",
      shareholders:shareholdersRef.current?.value ? shareholdersRef.current?.value : "",
      partners:partnersRef.current?.value ? partnersRef.current?.value : "",
      endOfFY: "",
      corporateGroupIsBelong: "",
      officeIsExist: "",
      tags: "",
    };
    //検索
    await callSearchHome(searchConditions, true);

    // CSVダウンロード用検索条件保存（即時反映させるためgetSearchFilterは使用しない）
    const newForNotationIndustryItems:{[key:string]:string} = {};
    if (trendTheme.industorialClass_code) {
      const industryCodeList = trendTheme.industorialClass_code.split(";");
      const industryNameList = trendTheme.industorialClass.split(";");

      if (industryCodeList.length > 0 && industryCodeList.length === industryNameList.length) {
        for(let i = 0; i < industryCodeList.length; i++) {
          newForNotationIndustryItems[industryCodeList[i]] = industryNameList[i];
        }
      }
    }

    const newForNotationRegionItems:{[key:string]:string} = {};
    if (trendTheme.address_code) {
      const regionCodeList = trendTheme.address_code.split(";");
      const regionNameList = trendTheme.address.split(";");

      if (regionCodeList.length > 0 && regionCodeList.length === regionNameList.length) {
        for(let i = 0; i < regionCodeList.length; i++) {
          newForNotationRegionItems[regionCodeList[i]] = regionNameList[i];
        }
      }
    }

    const csvDlSearchFilterRecord : SearchFilter  = {
      corporateName:trendTheme.corporateName,
      freeWord:trendTheme.Keyword,
      industorialClass:Object.values(newForNotationIndustryItems).join(';'),
      address:Object.values(newForNotationRegionItems).join(';'),
      businessKeywords:trendTheme.businessSummary,
      detailParameter:trendTheme.detailParameter,
      flag:trendTheme.flag,
      numberOfCorporate:dataCount,
      comments:'',
    }
    setSearchFilterRecord(csvDlSearchFilterRecord)

    setCurrentResultSearchConditions(searchConditions);

    //検索条件をキャッシュに保存
    handleConditionSet();
    saveState();

    // 検索結果へスクロール
    if (searchConditionRef.current) {
      const top = searchConditionRef.current.getBoundingClientRect().top + window.scrollY - 120;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  const callSearchHome = async (record:SearchHomeType, isFromButtonClick:boolean) => {
    try {
      const { idToken } = await getTokens();
      const baseUrl = process.env.REACT_APP_API_BASE_URL || '';
      const path = '/event/search';
      const apipath = baseUrl.concat(path);
      const response = await fetch(apipath, {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${idToken}`, // IDトークンをヘッダーに設定
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(record)
      });

      if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
      }
      const responseData = await response.json();
      // レスポンスから表示用データと企業番号一覧を取得
      const searchedData = responseData['bodyVsearch'];
      const corporateNumData = responseData['corporateNumberList'];
      if (searchedData.length === 0) {
        setErrorMessage3("指定された検索条件に一致する結果がありませんでした。");
        // 検索結果に空のリストをセット
        setTableData([]);
        // 検索結果数は0件をセット
        setDataCount(0);
        setFacetCount(0);
        setIsViewFacet(false);

        setCorporateNumList([]);
      } else {

        const formattedData = searchedData.map((item:ResponseDataItem) => ({
            max_search_data_limit: item.max_search_data_limit,
            cnt_corporateNumber: item.cnt_corporateNumber,
            cnt_corporateNumber_limitplus1: item.cnt_corporateNumber_limitplus1,
            corporateName: item.corporateName,
            corporateNumber: item.corporateNumber,
            headquarterAddress: item.headquarterAddress,
            industorialClass_large: item.industorialClass_large,
            captalStock: item.captalStock,
            numberOfEmployees: item.numberOfEmployees,
            flag1: item.flag1,
            flag2: item.flag2,
            flag3: item.flag3,
            flag4: item.flag4,
            flag5: item.flag5,
            flag6: item.flag6,
        }));

        // 検索結果の表示範囲のセット
        setTableData(formattedData);
        setDataCount(formattedData[0].cnt_corporateNumber);
        setFacetCount(formattedData[0].cnt_corporateNumber);
        setIsViewFacet(formattedData[0].cnt_corporateNumber > 0);
        // タグ選択解除
        setTagSearchList([]);
        setTagSearchCondList([]);
        setIsTagButtonOn({});
        // 検索結果の企業番号一覧のセット
        if(!isEqualArray(corporateNumData, corporateNumList)){
          setCorporateNumList(corporateNumData);
        }
        // タグ生成APIの呼び出し
        if (isFromButtonClick) {
          callGenerateTags(searchedData);
          setIsGeneratingTags(true); // タグ生成中フラグON
        }
        // 検索が成功すればエラーメッセージは非表示にする
        setErrorMessage1("");
        setErrorMessage2("");
        setErrorMessage3("");
        // 件数が3000件の場合はメッセージを表示(中断はしない)
        const maxSearchDataLimit = formattedData[0].max_search_data_limit;
        if(formattedData[0].cnt_corporateNumber_limitplus1 > maxSearchDataLimit){
          setErrorMessage3(`検索結果が${maxSearchDataLimit}件を超えました。先頭の${maxSearchDataLimit}件までを表示します。`);
        }

        // フィルタファセット用項目データ
        const facetConditionsData = responseData['facetConditions'];
        settingFilterFacetData(facetConditionsData);
      }
      if (isFromButtonClick) {
          setIsSearchClicked(true);
          setIsSearchFacetClicked(false);
          setIsSearchTagFilterClicked(false);
          setIsSearchTagNewClicked(false);
      }
    } catch (error) {
      setIsSearching(false); // 検索中フラグOFF
      console.error("エラー:", error);
      setErrorMessage3("処理中にエラーが発生しました。もう一度お試し下さい。");
    }
    // 多重検索・クリックを防止解除
    setIsSearching(false); // 検索中フラグOFF
  };

  // フィルタファセット用項目データ設定
  const settingFilterFacetData = (facetConditionsData: any, isFilterFacetsSearch?: boolean) => {
    if (Object.keys(facetConditionsData).length > 0) {
      if (!isFilterFacetsSearch) {
        // 業種
        setFilterIndustryFacetsData(facetConditionsData["industryFacetList"]);
        if (Object.keys(facetConditionsData["industryFacetList"]).length > 5) {
          setLimit(5);
          setIsShowMore(false);
        } else {
          setLimit(Object.keys(facetConditionsData["industryFacetList"]).length);
          setIsShowMore(true);
        }
        setIndustryFacetsSortDataDict(facetConditionsData["industrycodelist"]);
        
        // 決算月
        setFilterFinancialEndofFYFacetList(facetConditionsData["financialEndofFYFacetList"]);
        const monthLength = Object.keys(facetConditionsData["financialEndofFYFacetList"]).length;
        setMonthLength(monthLength);
        const monthLimit = (monthLength > 3) ? 3 : monthLength;
        setMonthLimit(monthLimit);
        setHasShowMoreMonthList(monthLength > 3);

        // 事業所
        setFilterOfficeIsExistFacetHitcount({});
        if (facetConditionsData["officeIsExistFacetList"]) {
          facetConditionsData["officeIsExistFacetList"].map((item:filterOfficeIsExistFacetListType) => {
            setFilterOfficeIsExistFacetHitcount(prev => ({
              ...prev,
              [item.officeIsExist]: item.hitcount ? item.hitcount : 0,
            }));
          });
        }

        // 企業URL
        setFilterCorporateUrlFacetHitCount({});
        if (facetConditionsData["corporateUrlFacetList"]) {
          facetConditionsData["corporateUrlFacetList"].map((item:filterCorporateUrlFacetListType) => {
            setFilterCorporateUrlFacetHitCount(prev => ({
              ...prev,
              [item.corporateUrlFlag ? "true" : "false"]: item.hitcount ? item.hitcount : 0,
            }));
          });
        }
      } else {
        // 業種
        const tmpFilterIndustryFacetsData:{[key: string]: FacetsDataNode} = facetConditionsData["industryFacetList"];
        // 大分類
        Object.entries(filterIndustryFacetsData).map(([key, value]) => {
          if (tmpFilterIndustryFacetsData[key]?.hitcount !== undefined) {
            filterIndustryFacetsData[key].hitcount = tmpFilterIndustryFacetsData[key].hitcount;

            // 中分類
            Object.entries(filterIndustryFacetsData[key].childDataDict).map(([childKey, childValue]) => {
              if (tmpFilterIndustryFacetsData[key].childDataDict[childKey]?.hitcount !== undefined) {     
                filterIndustryFacetsData[key].childDataDict[childKey].hitcount = tmpFilterIndustryFacetsData[key].childDataDict[childKey].hitcount;
                
                // 小分類
                Object.entries(filterIndustryFacetsData[key].childDataDict[childKey].childDataDict).map(([grandChildKey, grandChildValue]) => {
                  if (tmpFilterIndustryFacetsData[key].childDataDict[childKey].childDataDict[grandChildKey]?.hitcount !== undefined) {
                    filterIndustryFacetsData[key].childDataDict[childKey].childDataDict[grandChildKey].hitcount = tmpFilterIndustryFacetsData[key].childDataDict[childKey].childDataDict[grandChildKey].hitcount;
                  } else {
                    filterIndustryFacetsData[key].childDataDict[childKey].childDataDict[grandChildKey].hitcount = 0;
                  }
                })
              } else {
                filterIndustryFacetsData[key].childDataDict[childKey].hitcount = 0;
                Object.entries(filterIndustryFacetsData[key].childDataDict[childKey].childDataDict).map(([grandChildKey, grandChildValue]) => {
                  filterIndustryFacetsData[key].childDataDict[childKey].childDataDict[grandChildKey].hitcount = 0;
                })
              }
            })
          } else {
            filterIndustryFacetsData[key].hitcount = 0;
            Object.entries(filterIndustryFacetsData[key].childDataDict).map(([childKey, childValue]) => {
              filterIndustryFacetsData[key].childDataDict[childKey].hitcount = 0;
              Object.entries(filterIndustryFacetsData[key].childDataDict[childKey].childDataDict).map(([grandChildKey, grandChildValue]) => {
                filterIndustryFacetsData[key].childDataDict[childKey].childDataDict[grandChildKey].hitcount = 0;
              })
            })
          }
        })

        // 決算月
        const tmpFinancialEndofFYFacetList:{[key: string]: filterFinancialEndofFYFacetListType} = facetConditionsData["financialEndofFYFacetList"];
        if (filterFinancialEndofFYFacetList) {
          Object.entries(filterFinancialEndofFYFacetList).map(([key, value]) => {
            const target = Object.values(tmpFinancialEndofFYFacetList).find(item => item.endOfFY == value.endOfFY);
            if (target) {
              filterFinancialEndofFYFacetList[key].hitcount = target.hitcount;
            } else {
              filterFinancialEndofFYFacetList[key].hitcount = 0;
            }
          })
        } else {
          setFilterFinancialEndofFYFacetList(facetConditionsData["financialEndofFYFacetList"]);
          const monthLength = Object.keys(facetConditionsData["financialEndofFYFacetList"]).length;
          setMonthLength(monthLength);
          const monthLimit = (monthLength > 3) ? 3 : monthLength;
          setMonthLimit(monthLimit);
          setHasShowMoreMonthList(monthLength > 3);
        }

        // 事業所
        const tmpFilterOfficeIsExistFacetHitcount:{[key: string]: filterOfficeIsExistFacetListType} = facetConditionsData["officeIsExistFacetList"];
        if (filterOfficeIsExistFacetHitcount) {
          Object.entries(filterOfficeIsExistFacetHitcount).map(([key, value]) => {
            const target = Object.values(tmpFilterOfficeIsExistFacetHitcount).find(item => item.officeIsExist == key);
            if (target) {
              filterOfficeIsExistFacetHitcount[key] = target.hitcount ? target.hitcount : 0;
            } else {
              filterOfficeIsExistFacetHitcount[key] = 0;
            }
          })
        } else {
          facetConditionsData["officeIsExistFacetList"].map((item:filterOfficeIsExistFacetListType) => {
            setFilterOfficeIsExistFacetHitcount(prev => ({
              ...prev,
              [item.officeIsExist]: item.hitcount ? item.hitcount : 0,
            }));
          });
        }

        // 企業URL
        const tmpFilterCorporateUrlFacetHitCount:{[key: string]: filterCorporateUrlFacetListType} = facetConditionsData["corporateUrlFacetList"];
        if (filterCorporateUrlFacetHitCount) {
          Object.entries(filterCorporateUrlFacetHitCount).map(([key, value]) => {
            if (tmpFilterCorporateUrlFacetHitCount) {
              const target = Object.values(tmpFilterCorporateUrlFacetHitCount).find(item => item.corporateUrlFlag == (key == "true"));
              if (target) {
                filterCorporateUrlFacetHitCount[key] = target.hitcount ? target.hitcount : 0;
              } else {
                filterCorporateUrlFacetHitCount[key] = 0;
              }
            } else {
              filterCorporateUrlFacetHitCount[key] = 0;
            }
          })
        } else {
          facetConditionsData["corporateUrlFacetList"].map((item:filterCorporateUrlFacetListType) => {
            setFilterCorporateUrlFacetHitCount(prev => ({
              ...prev,
              [item.corporateUrlFlag ? "true" : "false"]: item.hitcount ? item.hitcount : 0,
            }));
          });
        }
      }
      // 都道府県の件数
      setFilterLocalGovernmentFacetList(facetConditionsData["localGovernmentFacetList"]);

      // 企業グループ
      if (facetConditionsData["corpGroupFacetList"]) {
        const corpGroupFacetsHitcount = facetConditionsData["corpGroupFacetList"].filter((item:filterCorpGroupFacetsListType) => item.corporateGroupIsBelong).map((item:filterCorpGroupFacetsListType) => item.hitcount);
        setFilterCorpGroupFacetsHitcount(corpGroupFacetsHitcount);
      } else {
        setFilterCorpGroupFacetsHitcount(0);
      }
    }
  };

  const [monthLimit, setMonthLimit] = useState<number>(3);
  const [hasShowMoreMonthList, setHasShowMoreMonthList] = useState<boolean>(true);
  const [monthLength, setMonthLength] = useState<number>();
  function changeMonthLimit() {
    if (hasShowMoreMonthList && monthLength) {
      setMonthLimit(monthLength);
      setHasShowMoreMonthList(false);
    }
  }

  const callGenerateTags = async (bodyVsearch:[]) => {
    try {
      const { idToken } = await getTokens();
      const baseUrl = process.env.REACT_APP_API_BASE_URL || '';
      const path = '/event/generatetags';
      const apipath = baseUrl.concat(path);
      const response = await fetch(apipath, {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${idToken}`, // IDトークンをヘッダーに設定
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({'bodyVsearch': bodyVsearch })
      });

      if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
      }
      const responseData = await response.json();
      // レスポンスから表示用データと企業番号一覧を取得
      const responceTagList = responseData['tags'];
      if (responceTagList) {
        setTagList(responceTagList);
      }
    } catch (error) {
      setIsGeneratingTags(false); // タグ生成中フラグON
      console.error("エラー:", error);
      setErrorMessage3("処理中にエラーが発生しました。もう一度お試し下さい。");
    }
    // 多重検索・クリックを防止解除
    setIsGeneratingTags(false); // タグ生成中フラグON
  };


  //属性(数値)チェック
  function isNumber(value:any) {
    if (typeof value === 'string') {
      value = value.trim();
    }
    return !isNaN(value) && value !== '';
  }

  function isEqualArray (array1:string[], array2:string[]) {
      var i = array1.length;
      if (i != array2.length) return false;

      while (i--) {
        if (array1[i] !== array2[i]) return false;
      }
      return true;
  };

  function validateSearchConditions(conditions:any) {
    if (conditions.salesFrom && !isNumber(conditions.salesFrom)) {
      setErrorMessage2("売上は数字、150桁以内で入力してください。");
      return false;
    }
    if (conditions.salesTo && !isNumber(conditions.salesTo)) {
      setErrorMessage2("売上は数字、150桁以内で入力してください。");
      return false;
    }
    if (conditions.numberOfEmployeesFrom && !isNumber(conditions.numberOfEmployeesFrom)) {
      setErrorMessage2("従業員数は数字、8桁以内で入力してください。");
      return false;
    }
    if (conditions.numberOfEmployeesTo && !isNumber(conditions.numberOfEmployeesTo)) {
      setErrorMessage2("従業員数は数字、8桁以内で入力してください。");
      return false;
    }
    if (conditions.establishmentDateFrom && !isNumber(conditions.establishmentDateFrom)) {
      setErrorMessage2("設立年は数字、4桁以内で入力してください。");
      return false;
    }
    if (conditions.establishmentDateTo && !isNumber(conditions.establishmentDateTo)) {
      setErrorMessage2("設立年は数字、4桁以内で入力してください。");
      return false;
    }
    if (conditions.captalStockFrom && !isNumber(conditions.captalStockFrom)) {
      setErrorMessage2("資本金は数字、15桁以内で入力してください。");
      return false;
    }
    if (conditions.captalStockTo && !isNumber(conditions.captalStockTo)) {
      setErrorMessage2("資本金は数字、15桁以内で入力してください。");
      return false;
    }
    return true;
  }
  //範囲チェック
  function validateRange(from:any, to:any) {
    try{
      const fromNumber = Number(from);
      const toNumber = Number(to);
      if (fromNumber && toNumber && fromNumber > toNumber) {
        setErrorMessage2(`指定した値に矛盾があります。範囲を正しく指定してください。`);
        return false;
      }
      return true;
    }
    catch(error){
      console.error("エラー:", error);
      setErrorMessage2(`指定した値に矛盾があります。範囲を正しく指定してください。`);
      return false;
    }
  }

  // ホバー時処理
  const handleAddressMouseEnter = (index: number) => {
    setHoveredIndex(prevState => ({ ...prevState, [index]: { ...prevState[index], addressHovered: true } }));
  };

  const handleAddressMouseLeave = (index: number) => {
    setHoveredIndex(prevState => ({ ...prevState, [index]: { ...prevState[index], addressHovered: false } }));
  };

  const handleIndustryMouseEnter = (index: number) => {
    setHoveredIndex(prevState => ({ ...prevState, [index]: { ...prevState[index], industryHovered: true } }));
  };

  const handleIndustryMouseLeave = (index: number) => {
    setHoveredIndex(prevState => ({ ...prevState, [index]: { ...prevState[index], industryHovered: false } }));
  };

  const handleMembersMouseEnter = (index: number) => {
    setHoveredIndex(prevState => ({ ...prevState, [index]: { ...prevState[index], membersHovered: true } }));
  };

  const handleMembersMouseLeave = (index: number) => {
    setHoveredIndex(prevState => ({ ...prevState, [index]: { ...prevState[index], membersHovered: false } }));
  };

  const handleCapitalMouseEnter = (index: number) => {
    setHoveredIndex(prevState => ({ ...prevState, [index]: { ...prevState[index], capitalHovered: true } }));
  };

  const handleCapitalMouseLeave = (index: number) => {
    setHoveredIndex(prevState => ({ ...prevState, [index]: { ...prevState[index], capitalHovered: false } }));
  };

  //表示件数切替
  const handleRowsPerPageChange = async (event: React.ChangeEvent<HTMLSelectElement>) => {
    setIsNoSession(true); // セッション外の操作フラグＯＮ
    setRowsPerPage(Number(event.target.value));
    setCurrentPage(1); // ページ番号初期化
  };

  const indexOfLastItem = currentPage * rowsPerPage;
  const indexOfFirstItem = indexOfLastItem - rowsPerPage;
  const totalPages = Math.ceil(dataCount / rowsPerPage);

  // 並び替え項目の切替
  const handleSortChange = async (event: ChangeEvent<HTMLSelectElement>) => {
    setIsNoSession(true); // セッション外の操作フラグＯＮ
    const value = event.target.value as keyof ResponseDataItem;
    if (["corporateName", "headquarterAddress", "industorialClass_large", "captalStock", "numberOfEmployees"].includes(value)) {
      setSortKey(value);
      setCurrentPage(1); // ページ番号初期化
    } else {
      console.error('Invalid sort key:', value);
    }
  };

  const handleOrderChange = async (ascDesc: string, isAscending:boolean) => {
    setIsNoSession(true); // セッション外の操作フラグＯＮ
    setAscDesc(ascDesc)
    setIsAscendingPush(isAscending)
    setCurrentPage(1); // ページ番号初期化
  };

  // ページネーション押下時処理
  const handleNextPage = async () => {
      setIsNoSession(true); // セッション外の操作フラグON
      setCurrentPage(totalPages);
  };
  const handlePreviousPage = async () => {
      setIsNoSession(true); // セッション外の操作フラグON
      setCurrentPage(1);
  };
  const handleChangePage = async (newPageIndex?:number, prevPageIndex?:number) => {
      if (newPageIndex) {
          setIsNoSession(true); // セッション外の操作フラグON
          setCurrentPage(newPageIndex);
      }
  };


  // 並び替え、表示件数切替、ページ番号切替時に再読み込み
  useEffect(() => {
    // 検索方法を切り替える
    if (isSearchFacetClicked && !isSearching && isNoSession) {
      setIsSearching(true); // 検索中フラグON
      handleSearchFacet(false); // 再読み込み
      setIsNoSession(false); // セッション外の操作フラグOFF
    }
    else if (isSearchTagNewClicked && !isSearching && isNoSession) {
      setIsSearching(true); // 検索中フラグON
      setIsSearchTagNewSearching(true); // タグ検索中フラグON
      handleSearchTagNew(false); // 再読み込み
      setIsNoSession(false); // セッション外の操作フラグOFF
    }
    else if (isSearchTagFilterClicked && !isSearching && isNoSession) {
      setIsSearching(true); // 検索中フラグON
      setIsSearchTagFilterSearching(true); // タグ検索中フラグON
      handleSearchTagFilter(false); // 再読み込み
      setIsNoSession(false); // セッション外の操作フラグOFF
    }
    else if (isSearchClicked && !isSearching && isNoSession) {
      setIsSearching(true); // 検索中フラグON
      handleSearch(false); // 再読み込み
      setIsNoSession(false); // セッション外の操作フラグOFF
    }
  }, [currentPage, ascDesc, sortKey, rowsPerPage]);

  // 検索完了時に検索結果セクションへスクロール
  useEffect(() => {
    if ((isSearchClicked || isSearchFacetClicked || isSearchTagFilterClicked || isSearchTagNewClicked) && !isSearching && searchConditionRef.current) {
      const top = searchConditionRef.current.getBoundingClientRect().top + window.scrollY - 120;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  }, [isSearchClicked, isSearchFacetClicked, isSearchTagFilterClicked, isSearchTagNewClicked, isSearching]);

  //検索条件表示
  const openSearchConditionModal = () => {
    setSearchConditionModalIsOpen(true);
  };
  const closeSearchConditionModal = () => {
    setSearchConditionModalIsOpen(false);
  };

  //検索条件保存
  useEffect(() => {
    if (!saveSearchModalIsOpen && saveSearchData) {
      setReturnedSaveSearchData(saveSearchData);
    }
  }, [saveSearchModalIsOpen]);

  // ローディング画面用のドットインデックス切り替え
  useEffect(() => {
    const timer = setInterval(() => {
    setActiveIndex((prev) => (prev + 1) % 10);
    }, 300);
    return () => clearInterval(timer);
  }, []);

  async function openSaveSearchModal() {
    const saveSearchData:SearchData = {
      savedAt: new Date(),
      userName: "",
      industry:  Object.values(forNotationIndustryItems).join(";"),
      industryCode: Object.keys(forNotationIndustryItems).join(";"),
      address: Object.values(forNotationRegionItems).join(";"),
      addressCode:  Object.keys(forNotationRegionItems).join(";"),
      businessSummary: formatBusinessKeywordsRequirementsForSaveSearchData(),
      corporateName: corporateNameRef.current?.value ? corporateNameRef.current?.value : "",
      Keyword: formatFreeWordRequirementsForSaveSearchData(),
      detailCondition: formatDetailRequirementsForSaveSearchData(),
      flag: formatFlagRequirementsForSaveSearchData(),
      comments: ""
    };

    if (isProcessing) {
          return;
      }
      setIsProcessing(true);

      // 検索条件保存モーダル表示処理開始時すべてのエラーメッセージ、成功メッセージをリセットする
      setSuccessMessage("");
      setErrorMessage1("");
      setErrorMessage2("");
      setErrorMessage3("");

      if(tokenInfo.plan == "basic"){
      setSaveSearchData(saveSearchData);

      try {
          const saveFlag = await callCheckLimitSave();
          if (saveFlag === true) {
            setSaveSearchModalIsOpen(true);
          }else{
            // saveFlagがfalseの場合処理を中断
            return;
          }
        } catch (error) {
          console.error("保存上限チェックでエラーが発生しました:", error);
          setErrorMessage2(ERROR_MESSAGE_PROCESSING_ERROR);
        } finally {
          setIsProcessing(false);
        }
      } else {
        setErrorMessage2("現在のプランでは検索条件を保存できません。ベーシックプランへのアップグレードが必要です。")
        setIsNeedChangePlan(true);
        setIsProcessing(false);
      }
  }

  // コールバック関数
  const handleSaveSearchData = async (saveData:eventArgsType) => {
      if (isProcessing) {
          return;
      }
      setIsProcessing(true);

      try {
          const { idToken } = await getTokens(); // 最新のトークンを取得

          //保存上限値チェック
          const CheckLimitSaveResult = await callCheckLimitSave();
          if (!CheckLimitSaveResult) {
              setErrorMessage1(ERROR_MESSAGE_PROCESSING_ERROR);
              setSuccessMessage("")
              return;
          }

          // 検索条件保存
          const SaveSearchFilterResult = await callSaveSearchFilter(saveData);
          if(SaveSearchFilterResult.errFlag == "TRUE"){
              setErrorMessage2(SaveSearchFilterResult.err_message);
              setSuccessMessage("")
          } else {
              setSuccessMessage("検索条件の保存が完了しました");
              setErrorMessage1("");
              setErrorMessage2("");
              setErrorMessage3("");
              setIsNeedChangePlan(false);
              setIsNeedAddPurchase(false);
              setIsNeedChangePlan2(false);
          }
      } catch (error) {
          console.error("Error saving search filter:", error);
          setErrorMessage1(ERROR_MESSAGE_PROCESSING_ERROR);
          setSuccessMessage("")
      } finally {
          setIsProcessing(false);
          setSaveSearchModalIsOpen(false); // モーダルを閉じる
      }
  }

  // 検索条件保存APIの呼び出し
  const callSaveSearchFilter = async (record:eventArgsType) => {
    try {
      // idTokenを取得
      const { idToken } = await getTokens();

      // API Gatewayを呼び出す
      const baseUrl:string = process.env.REACT_APP_API_BASE_URL || '';
      const path:string = '/event/savesearchfilter';
      const apipath = baseUrl.concat(path);
      const response = await fetch(apipath,{
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${idToken}`, // IDトークンをヘッダーに設定
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(record)

      });
      // ステータスコードの確認
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      // レスポンスのJSONデータをパース
      const responseData = await response.json();
      // レスポンスのbodyから必要なデータを取得
      const { err_message, body, errFlag } = responseData;
      // 保存数の制限が超えた場合の処理
      if (errFlag) {
        setErrorMessage1(err_message); // エラーメッセージを表示
        setSuccessMessage("")
      } else {
        setErrorMessage1(""); // エラーメッセージをクリア
      }
      return errFlag;
    } catch (error) {
      console.error("callSaveSearchFilter:", error);
      throw Error;
    }
  };

  function closeSaveSearchModal(data: null | string) {
    setSaveSearchModalIsOpen(false);
  }

  const industryDataRef = useRef<HTMLInputElement>(null);

  // 業種：キーワードから絞り込まれたIndustryDataの辞書データ
  const [filterIndustryData, setFilterIndustryData] = useState<{[key: string]: DataNode}>(industryData);
  // 業種：キーワードから絞り込まれたindustryFacetsDataの辞書データ
  const [filterIndustryFacetsData, setFilterIndustryFacetsData] = useState<{[key: string]: FacetsDataNode}>(industryFacetsData);
  // 業種：チェックされたチェックボックスの状態管理用辞書型データ
  const [checkedIndustryItems,setCheckedIndustryItems] = useState<{[key: string]: boolean}>({});
  // 業種：チェックされたdataDictのコードを「>」で連結して状態管理する用の辞書型データ
  const [forNotationIndustryItems,setForNotationIndustryItems] = useState<{[key: string]: string}>({});
  // 業種:フィルタファセット用項目順序リスト
  const [industryFacetsSortDataDict, setIndustryFacetsSortDataDict] = useState<string[]>([]);

  const handleIndustryFilter:(keyword:string) => void = (keyword) => {
    // 再帰的にchildDataDictから一致する
    const checkDataNode:(data:DataNode) => DataNode|undefined = (data) => {
      // 子要素にヒットするものが無いか再帰的にチェックする
      const tempDict:{[key: string]: DataNode} = {}
      Object.entries(data.childDataDict).map(([key, value]) => {
        const v = checkDataNode(value);
        if (v) {
          tempDict[key] = v;
        }
      });
      const tempNode = {
        'name': data.name,
        'childDataDict': tempDict
      };

      // 子要素にヒットするものがあればそのまま返却
      if (Object.keys(tempDict).length > 0) {
        return tempNode
      }
      // 子要素が無い場合は親要素の名前がヒットするか確認する
      else if (data.name.indexOf(keyword) > -1) {
        return data;
      }
      // 存在しない場合はundefined
      else {
        return undefined;
      }
    };
    // キーワードに従って絞り込みを行う
    const filteringData:{[key: string]: DataNode} = {};
    Object.entries(industryData).map(([key, value]) => {
      const temp = checkDataNode(value);
      if (temp) {
        filteringData[key] = temp;
      }
    });
    setFilterIndustryData(filteringData);
  }

  // 地域：チェックされたチェックボックスの状態管理用辞書型データ
  const [checkedRegionItems,setCheckedRegionItems] = useState<{[key: string]: boolean}>({});
  // 地域：キーワードから絞り込まれたregionFacetsDataの辞書データ
  const [filterRegionFacetsData, setFilterRegionFacetsData] = useState<{[key: string]: FacetsDataNode}>(regionFacetsData);
  // 地域：チェックされたdataDictのコードを「>」で連結して状態管理する用の辞書型データ
  const [forNotationRegionItems,setForNotationRegionItems] = useState<{[key: string]: string}>({});

  // 地域分類(地方分類用):チェックされたチェックボックスの状態管理用辞書型データ
  const [openRegionClassificationItems,setOpenRegionClassificationItems] = useState<{[key: string]: boolean}>({});

  // 地域分類(地方分類用):データを使用しやすいように地域分類用データの型を合わせる
  const regionClassificationDataDict:{[key: string]: string[]} = regionClassificationData;

  // 地域分類の地方チェックボックス押下時に下位階層の都道府県分類チェックボックスを表示・非表示するための処理
  const handleClassificationCheck:(itemName:string,dataDict:{[key: string]: DataNode}) => void = (itemName,dataDict) => {
    // 処理終了前にcheckedItemsにセットするための更新後データを入れる辞書型データ
    const newOpenRegionClassificationItems:{[key: string]: boolean} = {...openRegionClassificationItems};

    // チェックボックスのチェックをつけた場合はtrue,外した場合はfalse
    const isChecked = !openRegionClassificationItems[itemName];
    if (isChecked) {
      newOpenRegionClassificationItems[itemName] = isChecked;
    } else {
      delete newOpenRegionClassificationItems[itemName];
    }

    // 更新後データをcheckedItemsにセットする
    setOpenRegionClassificationItems(newOpenRegionClassificationItems);
  }
  // フィルタファセット（地域）のチェックボックス
  const [topRegionCheckbox, setTopRegionCheckbox] = useState<{[key: string]: boolean}>({});
  function handleTopRegionCheckbox(key: string) {
    setTopRegionCheckbox(prev => ({
      ...prev,
      [key]: !prev[key],
    }));

    if (!topRegionCheckbox[key] && !openRegionClassificationItems[key]) {
      setOpenRegionClassificationItems(prev => ({
        ...prev,
        [key]: !prev[key],
      }));
    }
  }
  // フィルタファセット - 企業
  const [filterLocalGovernmentFacetList, setFilterLocalGovernmentFacetList] = useState<{[key: string]: RegionItemNumType}>();

  // フィルタファセット - 決算月
  const [filterFinancialEndofFYFacetList, setFilterFinancialEndofFYFacetList] = useState<{[key: string]: filterFinancialEndofFYFacetListType}>();
  // フィルタファセット - 企業グループ ヒット数
  const [filterCorpGroupFacetsHitcount, setFilterCorpGroupFacetsHitcount] = useState<number>();
  // フィルタファセット - 事業所 ヒット数
  const [filterOfficeIsExistFacetHitcount, setFilterOfficeIsExistFacetHitcount] = useState<{[key: string]: number}>();
  // フィルタファセット - 企業URL ヒット数
  const [filterCorporateUrlFacetHitCount, setFilterCorporateUrlFacetHitCount] = useState<{[key: string]: number}>();

  const [isBusinessContentsPushed, setIsBusinessContentsPushed] = useState<boolean>(false);
  function handleBusinessContentsTextFieldChange() {
    if (isBusinessContentsPushed) {
      setIsBusinessContentsPushed(false);
    } else {
      setIsBusinessContentsPushed(true);
    }
  }

  const [isFreeWordPushed, setIsFreeWordPushed] = useState<boolean>(false);
  function handleFreeWordTextFieldChange() {
    if (isFreeWordPushed) {
      setIsFreeWordPushed(false);
    } else {
      setIsFreeWordPushed(true);
    }
  }


  const corporateNameRef = useRef<HTMLInputElement>(null);

  const [freeWordSearchMethod,setFreeWordSearchMethod] = useState<string>("AND");
  const freeWordFirstRef = useRef<HTMLInputElement>(null);
  const freeWordSecondRef = useRef<HTMLInputElement>(null);
  const freeWordThirdRef = useRef<HTMLInputElement>(null);
  const freeWordFourthRef = useRef<HTMLInputElement>(null);
  const freeWordFifthRef = useRef<HTMLInputElement>(null);
  const freeWordSixthRef = useRef<HTMLInputElement>(null);

  const [businessContentsSearchMethod,setBusinessContentsSearchMethod] = useState<string>("AND");
  const businessContentsFirstRef = useRef<HTMLInputElement>(null);
  const businessContentsSecondRef = useRef<HTMLInputElement>(null);
  const businessContentsThirdRef = useRef<HTMLInputElement>(null);
  const businessContentsFourthRef = useRef<HTMLInputElement>(null);
  const businessContentsFifthRef = useRef<HTMLInputElement>(null);
  const businessContentsSixthRef = useRef<HTMLInputElement>(null);

  // 詳細条件エリアの入力管理
  const salesFromRef = useRef<HTMLInputElement>(null);
  const salesToRef = useRef<HTMLInputElement>(null);

  const employeesNumFromRef = useRef<HTMLInputElement>(null);
  const employeesNumToRef = useRef<HTMLInputElement>(null);

  const establishedFromRef = useRef<HTMLInputElement>(null);
  const establishedToRef = useRef<HTMLInputElement>(null);

  const capitalFromRef = useRef<HTMLInputElement>(null);
  const capitalToRef = useRef<HTMLInputElement>(null);

  const shareholdersRef = useRef<HTMLInputElement>(null);
  const partnersRef = useRef<HTMLInputElement>(null);

  const [checkedHaveOrNotHaveHomePage,setCheckedHaveOrNotHaveHomePage] = useState<boolean[]>([true,false]);
  const [checkedHaveOrNotHaveContactPage,setCheckedHaveOrNotHaveContactPage] = useState<boolean[]>([true,true]);
  const [checkedListedOrUnListedCompany,setCheckedListedOrUnListedCompany] = useState<boolean[]>([true,true]);
  const [checkedCloseOrOpenCompany,setCheckedCloseOrOpenCompany] = useState<boolean[]>([false,true]);
  const [checkedNotificationCertification,setCheckedNotificationCertification] = useState<boolean[]>([false,false]);
  const [checkedAwardName,setCheckedAwardName] = useState<boolean[]>([false,false]);
  const [checkedQualificationLevel,setCheckedQualificationLevel] = useState<boolean[]>([false,false]);
  const [checkedProcurementInformation,setCheckedProcurementInformation] = useState<boolean[]>([false,false]);
  const [checkedOutputOrNotOutputCompany,setCheckedOutputOrNotOutputCompany] = useState<boolean[]>([true,true]);

  // フラグ
  const newlyEstablishedRef = useRef<HTMLInputElement>(null);
  const dxCertifiedRef = useRef<HTMLInputElement>(null);
  const regionalEconomicLeadersRef = useRef<HTMLInputElement>(null);
  const promotionWomenSuccessRef = useRef<HTMLInputElement>(null);
  const lifeAndWorkSupportRef = useRef<HTMLInputElement>(null);
  const promotingYouthDevelopmentRef = useRef<HTMLInputElement>(null);

  const [checkedNewlyEstablished,setCheckedNewlyEstablished] = useState<boolean>(false);
  const [checkedDXCertified,setCheckedDXCertified] = useState<boolean>(false);
  const [checkedRegionalEconomicLeaders,setCheckedRegionalEconomicLeaders] = useState<boolean>(false);
  const [checkedPromotionWomenSuccess,setCheckedPromotionWomenSuccess] = useState<boolean>(false);
  const [checkedLifeAndWorkSupport,setCheckedLifeAndWorkSupport] = useState<boolean>(false);
  const [checkedPromotingYouthDevelopment,setCheckedPromotingYouthDevelopment] = useState<boolean>(false);

  const [isEnteredBusinessKeywords,setIsEnteredBusinessKeywords] = useState<boolean>(false);
  const [isEnteredFreeWord,setIsEnteredFreeWord] = useState<boolean>(false);
  const [isEnteredDetailConditions,setIsEnteredDetailConditions] = useState<boolean>(false);
  const [isEnteredFlag,setIsEnteredFlag] = useState<boolean>(false);

  const isBusinessKeywordsCheckboxDifferentFromDefaultState = useRef<boolean>(false);
  const isFreeWordCheckboxDifferentFromDefaultState = useRef<boolean>(false);
  const isDetailConditionsCheckboxDifferentFromDefaultState = useRef<boolean>(false);
  const isFlagCheckboxDifferentFromDefaultState = useRef<boolean>(false);

  const [checkedEndOfFY,setCheckedEndOfFY] = useState<string[]>([]);
  const [checkedGroup,setCheckedGroup] = useState<boolean[]>([]);
  const [checkedOffice,setCheckedOffice] = useState<string[]>([]);

  function handleDetailRequirementsChecked(checkedItemState:boolean[],setCheckedItemState:(checkedItemState:boolean[]) => void,checkedItemIndex:number) {
    const newCheckedItemState:boolean[] = [...checkedItemState];
    newCheckedItemState[checkedItemIndex] = !checkedItemState[checkedItemIndex];
    setCheckedItemState(newCheckedItemState);
  }

  // 決算月
  function handleEndOfFYChecked(month:string | null) {
    if (month) {
      if (!checkedEndOfFY.includes(month)) {
        setCheckedEndOfFY(prev => [...prev, month]);
      } else {
        setCheckedEndOfFY(checkedEndOfFY.filter(value => value !== month));
      }
    }
  }

  // 事業所有無
  function handleOfficeChecked(officeType:string | null) {
    if (officeType) {
      if (!checkedOffice.includes(officeType)) {
        setCheckedOffice(prev => [...prev, officeType]);
      } else {
        setCheckedOffice(checkedOffice.filter(value => value !== officeType));
      }
    }
  }

  function handleFlagRequirementsChecked(checkedItemState:boolean,setCheckedItemState:(checkedItemState:boolean) => void) {
    const newCheckedItemState:boolean = !checkedItemState;
    setCheckedItemState(newCheckedItemState);
  }

  function setCorporateNameRefValue(corporateName:string) {
    if (corporateNameRef.current) {
      corporateNameRef.current.value = corporateName;
    }
  }

  function setBusinessKeywordsRefValue(businessKeywords:string) {
    if (!businessKeywords) return;
    const splitBussinessKeywords:string[] = businessKeywords.split(",");

    let tempIsBusinessContentsPushed = false;
    splitBussinessKeywords.forEach((bussinessKeywordsString:string, index:number) => {
      if (bussinessKeywordsString) {
        switch (index) {
          case 0:
            if (bussinessKeywordsString == "AND" || bussinessKeywordsString == "OR") {
              setBusinessContentsSearchMethod(bussinessKeywordsString);
              if (bussinessKeywordsString != "AND") isBusinessKeywordsCheckboxDifferentFromDefaultState.current = true;
            }
            return;
          case 1:
            setBusinessContentsFirst(bussinessKeywordsString);
            isBusinessKeywordsCheckboxDifferentFromDefaultState.current = true;
            return;
          case 2:
            setBusinessContentsSecond(bussinessKeywordsString);
            isBusinessKeywordsCheckboxDifferentFromDefaultState.current = true;
            return;
          case 3:
            setBusinessContentsThird(bussinessKeywordsString);
            isBusinessKeywordsCheckboxDifferentFromDefaultState.current = true;
            return;
          case 4:
            setBusinessContentsFourth(bussinessKeywordsString);
            isBusinessKeywordsCheckboxDifferentFromDefaultState.current = true;
            tempIsBusinessContentsPushed = true;
            return;
          case 5:
            setBusinessContentsFifth(bussinessKeywordsString);
            isBusinessKeywordsCheckboxDifferentFromDefaultState.current = true;
            tempIsBusinessContentsPushed = true;
            return;
          case 6:
            setBusinessContentsSixth(bussinessKeywordsString);
            isBusinessKeywordsCheckboxDifferentFromDefaultState.current = true;
            tempIsBusinessContentsPushed = true;
            return;
        }
      }
    });
    // businessKeywords4～businessKeywords6が設定される場合、表示
    setIsBusinessContentsPushed(tempIsBusinessContentsPushed);
  }
  
  function setFreeWordRefValue(freeWord:string) {
    if (!freeWord) return;
    const splitFreeWords:string[] = freeWord.split(",");

    let tempIsFreeWordPushed = false;
    splitFreeWords.forEach((freeWordsString:string,index:number) => {
      switch (index) {
        case 0:
          if (freeWordsString == "AND" || freeWordsString == "OR") {
            setFreeWordSearchMethod(freeWordsString);
            if (freeWordsString != "AND") isFreeWordCheckboxDifferentFromDefaultState.current = true;
          }
          return;
        case 1:
          setFreeWordFirst(freeWordsString);
          isFreeWordCheckboxDifferentFromDefaultState.current = true;
          return;
        case 2:
          setFreeWordSecond(freeWordsString);
          isFreeWordCheckboxDifferentFromDefaultState.current = true;
          return;
        case 3:
          setFreeWordThird(freeWordsString);
          isFreeWordCheckboxDifferentFromDefaultState.current = true;
          return;
        case 4:
          setFreeWordFourth(freeWordsString);
          isFreeWordCheckboxDifferentFromDefaultState.current = true;
          tempIsFreeWordPushed = true;
          return;
        case 5:
          setFreeWordFifth(freeWordsString);
          isFreeWordCheckboxDifferentFromDefaultState.current = true;
          tempIsFreeWordPushed = true;
          return;
        case 6:
          setFreeWordSixth(freeWordsString);
          isFreeWordCheckboxDifferentFromDefaultState.current = true;
          tempIsFreeWordPushed = true;
          return;
      }
    });
    // freeWord4～freeWord6が設定される場合、表示
    setIsFreeWordPushed(tempIsFreeWordPushed);
  }

  function formatFreeWordRequirementsForSaveSearchData() {
    let resultString:string = "";

    if ((freeWordFirstRef.current?.value ? freeWordFirstRef.current?.value : "").length > 0 ||
        (freeWordSecondRef.current?.value ? freeWordSecondRef.current?.value : "").length > 0 ||
        (freeWordThirdRef.current?.value ? freeWordThirdRef.current?.value : "").length > 0 ||
        (freeWordFourthRef.current?.value ? freeWordFourthRef.current?.value : "").length > 0 ||
        (freeWordFifthRef.current?.value ? freeWordFifthRef.current?.value : "").length > 0 ||
        (freeWordSixthRef.current?.value ? freeWordSixthRef.current?.value : "").length > 0
    ) {
      resultString += freeWordSearchMethod + ","
    }
    resultString += [freeWordFirstRef.current?.value,freeWordSecondRef.current?.value,freeWordThirdRef.current?.value,freeWordFourthRef.current?.value,freeWordFifthRef.current?.value,freeWordSixthRef.current?.value]
      .filter((freeWordRefValue) => freeWordRefValue !== undefined && freeWordRefValue.length > 0)
      .join(",");

    return resultString;
  }

  function formatFreeWordRequirementsForSearchFilter() {
    let resultString:string = "";
    
    let resultStringArray:string[] = [];
    if (freeWordFirstRef.current?.value) {
      resultStringArray.push("項目１：" + freeWordFirstRef.current?.value);
    }
    if (freeWordSecondRef.current?.value) {
      resultStringArray.push("項目２：" + freeWordSecondRef.current?.value);
    }
    if (freeWordThirdRef.current?.value) {
      resultStringArray.push("項目３：" + freeWordThirdRef.current?.value);
    }
    if (freeWordFourthRef.current?.value) {
      resultStringArray.push("項目４：" + freeWordFourthRef.current?.value);
    }
    if (freeWordFifthRef.current?.value) {
      resultStringArray.push("項目５：" + freeWordFifthRef.current?.value);
    }
    if (freeWordSixthRef.current?.value) {
      resultStringArray.push("項目６：" + freeWordSixthRef.current?.value);
    }

    resultString = resultStringArray.join("、");
    return resultString;
  }

  function formatBusinessKeywordsRequirementsForSaveSearchData() {
    let resultString:string = "";

    if ((businessContentsFirstRef.current?.value ? businessContentsFirstRef.current?.value : "").length > 0 ||
        (businessContentsSecondRef.current?.value ? businessContentsSecondRef.current?.value : "").length > 0 ||
        (businessContentsThirdRef.current?.value ? businessContentsThirdRef.current?.value : "").length > 0 ||
        (businessContentsFourthRef.current?.value ? businessContentsFourthRef.current?.value : "").length > 0 ||
        (businessContentsFifthRef.current?.value ? businessContentsFifthRef.current?.value : "").length > 0 ||
        (businessContentsSixthRef.current?.value ? businessContentsSixthRef.current?.value : "").length > 0
    ) {
      resultString += businessContentsSearchMethod + ","
    }
    resultString += [businessContentsFirstRef.current?.value,businessContentsSecondRef.current?.value,businessContentsThirdRef.current?.value,businessContentsFourthRef.current?.value,businessContentsFifthRef.current?.value,businessContentsSixthRef.current?.value]
      .filter((businessContentsRefValue) => businessContentsRefValue !== undefined && businessContentsRefValue.length > 0)
      .join(",");

    return resultString;
  }

  function formatBusinessKeywordsRequirementsForSearchFilter() {
    let resultString:string = "";

    let resultStringArray:string[] = [];
    if (businessContentsFirstRef.current?.value) {
      resultStringArray.push("項目１：" + businessContentsFirstRef.current?.value);
    }
    if (businessContentsSecondRef.current?.value) {
      resultStringArray.push("項目２：" + businessContentsSecondRef.current?.value);
    }
    if (businessContentsThirdRef.current?.value) {
      resultStringArray.push("項目３：" + businessContentsThirdRef.current?.value);
    }
    if (businessContentsFourthRef.current?.value) {
      resultStringArray.push("項目４：" + businessContentsFourthRef.current?.value);
    }
    if (businessContentsFifthRef.current?.value) {
      resultStringArray.push("項目５：" + businessContentsFifthRef.current?.value);
    }
    if (businessContentsSixthRef.current?.value) {
      resultStringArray.push("項目６：" + businessContentsSixthRef.current?.value);
    }

    resultString = resultStringArray.join("、");
    return resultString;
  }

  function formatDetailRequirementsForSaveSearchData() {
    let resultString:string = "";

    resultString += "【売上】" + salesFromRef.current?.value + ((salesFromRef.current?.value ? salesFromRef.current?.value : "").length > 0 ? "万円" : "") + (((salesFromRef.current?.value ? salesFromRef.current?.value : "").length > 0 || (salesToRef.current?.value ? salesToRef.current?.value : "").length > 0) ? "～" : "") + salesToRef.current?.value + ((salesToRef.current?.value ? salesToRef.current?.value : "").length > 0 ? "万円" : "") + ";";
    resultString += "【従業員数】" + employeesNumFromRef.current?.value + ((employeesNumFromRef.current?.value ? employeesNumFromRef.current?.value : "").length > 0 ? "人" : "") + (((employeesNumFromRef.current?.value ? employeesNumFromRef.current?.value : "").length > 0 || (employeesNumToRef.current?.value ? employeesNumToRef.current?.value : "").length > 0) ? "～" : "") + employeesNumToRef.current?.value + ((employeesNumToRef.current?.value ? employeesNumToRef.current?.value : "").length > 0 ? "人" : "") + ";";
    resultString += "【設立年】" + establishedFromRef.current?.value + ((establishedFromRef.current?.value ? establishedFromRef.current?.value : "").length > 0 ? "年" : "") + (((establishedFromRef.current?.value ? establishedFromRef.current?.value : "").length > 0 || (establishedToRef.current?.value ? establishedToRef.current?.value : "").length > 0) ? "～" : "") + establishedToRef.current?.value + ((establishedToRef.current?.value ? establishedToRef.current?.value : "").length > 0 ? "年" : "") + ";";
    resultString += "【資本金】" + capitalFromRef.current?.value + ((capitalFromRef.current?.value ? capitalFromRef.current?.value : "").length > 0 ? "万円" : "" ) + (((capitalFromRef.current?.value ? capitalFromRef.current?.value : "").length > 0 || (capitalToRef.current?.value ? capitalToRef.current?.value : "").length > 0) ? "～" : "") + capitalToRef.current?.value + ((capitalToRef.current?.value ? capitalToRef.current?.value : "").length > 0 ? "万円" : "" ) + ";";
    resultString += "【株主】" + shareholdersRef.current?.value + ";";
    resultString += "【取引先】" + partnersRef.current?.value + ";";
    resultString += "【URL】" + (checkedHaveOrNotHaveHomePage[0] ? "有" : "") + (checkedHaveOrNotHaveHomePage[0] && checkedHaveOrNotHaveHomePage[1] ? "," : "") + (checkedHaveOrNotHaveHomePage[1] ? "無" : "") + ";";
    resultString += "【問合せURL】" + (checkedHaveOrNotHaveContactPage[0] ? "有" : "") + (checkedHaveOrNotHaveContactPage[0] && checkedHaveOrNotHaveContactPage[1] ? "," : "") + (checkedHaveOrNotHaveContactPage[1] ? "無" : "") + ";";
    resultString += "【上場・非上場】" + (checkedListedOrUnListedCompany[0] ? "上場" : "") + (checkedListedOrUnListedCompany[0] && checkedListedOrUnListedCompany[1] ? "," : "") + (checkedListedOrUnListedCompany[1] ? "非上場" : "") + ";";
    resultString += "【閉鎖企業】" + (checkedCloseOrOpenCompany[0] ? "有" : "") + (checkedCloseOrOpenCompany[0] && checkedCloseOrOpenCompany[1] ? "," : "") + (checkedCloseOrOpenCompany[1] ? "無" : "") + ";";
    resultString += "【届出認定】" + (checkedNotificationCertification[0] ? "有" : "") + (checkedNotificationCertification[0] && checkedNotificationCertification[1] ? "," : "") + (checkedNotificationCertification[1] ? "無" : "") + ";";
    resultString += "【表彰名】" + (checkedAwardName[0] ? "有" : "") + (checkedAwardName[0] && checkedAwardName[1] ? "," : "") + (checkedAwardName[1] ? "無" : "") + ";";
    resultString += "【資格等級】" + (checkedQualificationLevel[0] ? "有" : "") + (checkedQualificationLevel[0] && checkedQualificationLevel[1] ? "," : "") + (checkedQualificationLevel[1] ? "無" : "") + ";";
    resultString += "【調達情報】" + (checkedProcurementInformation[0] ? "有" : "") + (checkedProcurementInformation[0] && checkedProcurementInformation[1] ? "," : "") + (checkedProcurementInformation[1] ? "無" : "") + ";";
    resultString += "【出力済み企業】" + (checkedOutputOrNotOutputCompany[0] ? "有" : "") + (checkedOutputOrNotOutputCompany[0] && checkedOutputOrNotOutputCompany[1] ? "," : "") + (checkedOutputOrNotOutputCompany[1] ? "無" : "") + ";";

    return resultString;
  }

  function formatFlagRequirementsForSaveSearchData() {
    let flagNameList:Array<string> = [];

    if (checkedNewlyEstablished) {
      flagNameList.push("新設")
    }
    if (checkedDXCertified) {
      flagNameList.push("DX認定")
    }
    if (checkedRegionalEconomicLeaders) {
      flagNameList.push("地域経済担い手")
    }
    if (checkedPromotionWomenSuccess) {
      flagNameList.push("女性活躍推進")
    }
    if (checkedLifeAndWorkSupport) {
      flagNameList.push("子育て・家庭と仕事の両立支援")
    }
    if (checkedPromotingYouthDevelopment) {
      flagNameList.push("若者採用・育成推進")
    }

    return flagNameList.join(",")
  }

  function distributeDetailRequirementsForSaveSearchData(detailCondition:string) {
    const splitDetailCondition:string[] = detailCondition.split(";");
    splitDetailCondition.forEach((detailConditionItemString:string,index:number) => {
      if (detailConditionItemString.slice(1,detailConditionItemString.indexOf("】")) === "売上") {
        const excludeSalesTitleString = detailConditionItemString.slice(detailConditionItemString.indexOf("】")+1);
        if (excludeSalesTitleString.length > 0) {
          const salesItems: string[] = excludeSalesTitleString.split("～");
          if (salesFromRef.current) {
            let numMatch = salesItems[0].match(/\d+/);
            salesFromRef.current.value = (salesItems[0] !== "" && numMatch !== null) ? numMatch[0] : "";
            setSalesFrom(salesFromRef.current.value);
            if (salesFromRef.current.value !== "") isDetailConditionsCheckboxDifferentFromDefaultState.current = true;
          }
          if (salesToRef.current) {
            let numMatch = salesItems[1].match(/\d+/);
            salesToRef.current.value = (salesItems[1] !== "" && numMatch !== null) ? numMatch[0] : "";
            setSalesTo(salesToRef.current.value);
            if (salesToRef.current.value !== "") isDetailConditionsCheckboxDifferentFromDefaultState.current = true;
          }
        }
      }
      else if (detailConditionItemString.slice(1,detailConditionItemString.indexOf("】")) === "従業員数") {
        const excludeEmployeesNumTitleString = detailConditionItemString.slice(detailConditionItemString.indexOf("】")+1);
        if (excludeEmployeesNumTitleString.length > 0) {
          const employeesNumItems: string[] = excludeEmployeesNumTitleString.split("～");
          if (employeesNumFromRef.current) {
            let numMatch = employeesNumItems[0].match(/\d+/);
            employeesNumFromRef.current.value = (employeesNumItems[0] !== "" && numMatch !== null) ? numMatch[0] : "";
            setEmployeesNumFrom(employeesNumFromRef.current.value);
            if (employeesNumFromRef.current.value !== "") isDetailConditionsCheckboxDifferentFromDefaultState.current = true;
          }
          if (employeesNumToRef.current) {
            let numMatch = employeesNumItems[1].match(/\d+/);
            employeesNumToRef.current.value = (employeesNumItems[1] !== "" && numMatch !== null) ? numMatch[0] : "";
            setEmployeesNumTo(employeesNumToRef.current.value);
            if (employeesNumToRef.current.value !== "") isDetailConditionsCheckboxDifferentFromDefaultState.current = true;
          }
        }
      }
      else if (detailConditionItemString.slice(1,detailConditionItemString.indexOf("】")) === "設立年") {
        const excludeEstablishedTitleString = detailConditionItemString.slice(detailConditionItemString.indexOf("】")+1);
        if (excludeEstablishedTitleString.length > 0) {
          const establishedItems: string[] = excludeEstablishedTitleString.split("～");
          if (establishedFromRef.current) {
            let numMatch = establishedItems[0].match(/\d+/);
            establishedFromRef.current.value = (establishedItems[0] !== "" && numMatch !== null) ? numMatch[0] : "";
            setEstablishedFrom(establishedFromRef.current.value);
            if (establishedFromRef.current.value !== "") isDetailConditionsCheckboxDifferentFromDefaultState.current = true;
          }
          if (establishedToRef.current) {
            let numMatch = establishedItems[1].match(/\d+/);
            establishedToRef.current.value = (establishedItems[1] !== "" && numMatch !== null) ? numMatch[0] : "";
            setEstablishedTo(establishedToRef.current.value);
            if (establishedToRef.current.value !== "") isDetailConditionsCheckboxDifferentFromDefaultState.current = true;
          }
        }
      }
      else if (detailConditionItemString.slice(1,detailConditionItemString.indexOf("】")) === "資本金") {
        const excludeCapitalTitleString = detailConditionItemString.slice(detailConditionItemString.indexOf("】")+1);
        if (excludeCapitalTitleString.length > 0) {
          const capitalItems: string[] = excludeCapitalTitleString.split("～");
          if (capitalFromRef.current) {
            let numMatch = capitalItems[0].match(/\d+/);
            capitalFromRef.current.value = (capitalItems[0] !== "" && numMatch !== null) ? numMatch[0] : "";
            setCapitalFrom(capitalFromRef.current.value);
            if (capitalFromRef.current.value !== "") isDetailConditionsCheckboxDifferentFromDefaultState.current = true;
          }
          if (capitalToRef.current) {
            let numMatch = capitalItems[1].match(/\d+/);
            capitalToRef.current.value = (capitalItems[1] !== "" && numMatch !== null) ? numMatch[0] : "";
            setCapitalTo(capitalToRef.current.value);
            if (capitalToRef.current.value !== "") isDetailConditionsCheckboxDifferentFromDefaultState.current = true;
          }
        }
      }
      else if (detailConditionItemString.slice(1,detailConditionItemString.indexOf("】")) === "株主") {
        const excludeShareholdersTitleString = detailConditionItemString.slice(detailConditionItemString.indexOf("】")+1);
        if (excludeShareholdersTitleString.length > 0) {
          const shareholdersItems: string = excludeShareholdersTitleString;
          if (shareholdersRef.current) {
            shareholdersRef.current.value = (shareholdersItems !== "") ? shareholdersItems : "";
            if (shareholdersRef.current.value !== "") isDetailConditionsCheckboxDifferentFromDefaultState.current = true;
          }
        }
      }
      else if (detailConditionItemString.slice(1,detailConditionItemString.indexOf("】")) === "取引先") {
        const excludePartnersTitleString = detailConditionItemString.slice(detailConditionItemString.indexOf("】")+1);
        if (excludePartnersTitleString.length > 0) {
          const partnersItems: string = excludePartnersTitleString;
          if (partnersRef.current) {
            partnersRef.current.value = (partnersItems !== "") ? partnersItems : "";
            if (partnersRef.current.value !== "") isDetailConditionsCheckboxDifferentFromDefaultState.current = true;
          }
        }
      }
      else if (detailConditionItemString.slice(1,detailConditionItemString.indexOf("】")) === "URL") {
        const excludeHaveHomePageTitleString = detailConditionItemString.slice(detailConditionItemString.indexOf("】")+1);
        const newCheckedHaveOrNotHaveHomePage:boolean[] = [false,false];
        if (excludeHaveHomePageTitleString.length > 0) {
          const haveHomePageItems: string[] = excludeHaveHomePageTitleString.split(",");

          if (haveHomePageItems[0] === "有") {
            newCheckedHaveOrNotHaveHomePage[0] = true;
            if (haveHomePageItems.length > 1) {
              newCheckedHaveOrNotHaveHomePage[1] = true;
            }
          } else if (haveHomePageItems[0] === "無") {
            newCheckedHaveOrNotHaveHomePage[1] = true;
          }
        }
        setCheckedHaveOrNotHaveHomePage(newCheckedHaveOrNotHaveHomePage);

        // 更新後のチェック状態がデフォルト状態と異なる場合、isDetailConditionsCheckboxDifferentFromDefaultStateをtrueにする
        if (!(newCheckedHaveOrNotHaveHomePage[0] && !newCheckedHaveOrNotHaveHomePage[1])) {
          isDetailConditionsCheckboxDifferentFromDefaultState.current = true
        }
      }
      else if (detailConditionItemString.slice(1,detailConditionItemString.indexOf("】")) === "問合せURL") {
        const excludeHaveContactPageTitleString = detailConditionItemString.slice(detailConditionItemString.indexOf("】")+1);
        const newCheckedHaveOrNotHaveContactPage = [false,false];
        if (excludeHaveContactPageTitleString.length > 0) {
          const haveContactPageItems: string[] = excludeHaveContactPageTitleString.split(",");
          if (haveContactPageItems[0] === "有") {
            newCheckedHaveOrNotHaveContactPage[0] = true;
            if (haveContactPageItems.length > 1) {
              newCheckedHaveOrNotHaveContactPage[1] = true;
            }
          } else if (haveContactPageItems[0] === "無") {
            newCheckedHaveOrNotHaveContactPage[1] = true;
          }
        }
        setCheckedHaveOrNotHaveContactPage(newCheckedHaveOrNotHaveContactPage);

        // 更新後のチェック状態がデフォルト状態と異なる場合、isDetailConditionsCheckboxDifferentFromDefaultStateをtrueにする
        if (!(newCheckedHaveOrNotHaveContactPage[0] && newCheckedHaveOrNotHaveContactPage[1])) {
          isDetailConditionsCheckboxDifferentFromDefaultState.current = true
        }
      }
      else if (detailConditionItemString.slice(1,detailConditionItemString.indexOf("】")) === "上場・非上場") {
        const excludeListedCompanyTitleString = detailConditionItemString.slice(detailConditionItemString.indexOf("】")+1);
        const newCheckedListedOrUnListedCompany = [false,false];
        if (excludeListedCompanyTitleString.length > 0) {
          const haveListedCompanyItems: string[] = excludeListedCompanyTitleString.split(",");
          if (haveListedCompanyItems[0] === "上場") {
            newCheckedListedOrUnListedCompany[0] = true;
            if (haveListedCompanyItems.length > 1) {
              newCheckedListedOrUnListedCompany[1] = true;
            }
          } else if (haveListedCompanyItems[0] === "非上場") {
            newCheckedListedOrUnListedCompany[1] = true;
          }
        }
        setCheckedListedOrUnListedCompany(newCheckedListedOrUnListedCompany);

        // 更新後のチェック状態がデフォルト状態と異なる場合、isDetailConditionsCheckboxDifferentFromDefaultStateをtrueにする
        if (!(newCheckedListedOrUnListedCompany[0] && newCheckedListedOrUnListedCompany[1])) {
          isDetailConditionsCheckboxDifferentFromDefaultState.current = true
        }
      }
      else if (detailConditionItemString.slice(1,detailConditionItemString.indexOf("】")) === "閉鎖企業") {
        const excludeCloseCompanyTitleString = detailConditionItemString.slice(detailConditionItemString.indexOf("】")+1);
        const newCheckedCloseOrOpenCompany = [false,false];
        if (excludeCloseCompanyTitleString.length > 0) {
          const closeCompanyItems: string[] = excludeCloseCompanyTitleString.split(",");
          if (excludeCloseCompanyTitleString[0] === "有") {
            newCheckedCloseOrOpenCompany[0] = true;
            if (excludeCloseCompanyTitleString.length > 1) {
              newCheckedCloseOrOpenCompany[1] = true;
            }
          } else if (excludeCloseCompanyTitleString[0] === "無") {
            newCheckedCloseOrOpenCompany[1] = true;
          }
        }
        setCheckedCloseOrOpenCompany(newCheckedCloseOrOpenCompany);

        // 更新後のチェック状態がデフォルト状態と異なる場合、isDetailConditionsCheckboxDifferentFromDefaultStateをtrueにする
        if (!(!newCheckedCloseOrOpenCompany[0] && newCheckedCloseOrOpenCompany[1])) {
          isDetailConditionsCheckboxDifferentFromDefaultState.current = true
        }
      }
      else if (detailConditionItemString.slice(1,detailConditionItemString.indexOf("】")) === "届出認定") {
        const excludeCloseCompanyTitleString = detailConditionItemString.slice(detailConditionItemString.indexOf("】")+1);
        const newCheckedNotificationCertification = [false,false];
        if (excludeCloseCompanyTitleString.length > 0) {
          const closeCompanyItems: string[] = excludeCloseCompanyTitleString.split(",");
          if (excludeCloseCompanyTitleString[0] === "有") {
            newCheckedNotificationCertification[0] = true;
            if (excludeCloseCompanyTitleString.length > 1) {
              newCheckedNotificationCertification[1] = true;
            }
          } else if (excludeCloseCompanyTitleString[0] === "無") {
            newCheckedNotificationCertification[1] = true;
          }
        }
        setCheckedNotificationCertification(newCheckedNotificationCertification);

        // 更新後のチェック状態がデフォルト状態と異なる場合、isDetailConditionsCheckboxDifferentFromDefaultStateをtrueにする
        if (!(!newCheckedNotificationCertification[0] && !newCheckedNotificationCertification[1])) {
          isDetailConditionsCheckboxDifferentFromDefaultState.current = true
        }
      }
      else if (detailConditionItemString.slice(1,detailConditionItemString.indexOf("】")) === "表彰名") {
        const excludeCloseCompanyTitleString = detailConditionItemString.slice(detailConditionItemString.indexOf("】")+1);
        const newCheckedAwardName = [false,false];
        if (excludeCloseCompanyTitleString.length > 0) {
          const closeCompanyItems: string[] = excludeCloseCompanyTitleString.split(",");
          if (excludeCloseCompanyTitleString[0] === "有") {
            newCheckedAwardName[0] = true;
            if (excludeCloseCompanyTitleString.length > 1) {
              newCheckedAwardName[1] = true;
            }
          } else if (excludeCloseCompanyTitleString[0] === "無") {
            newCheckedAwardName[1] = true;
          }
        }
        setCheckedAwardName(newCheckedAwardName);

        // 更新後のチェック状態がデフォルト状態と異なる場合、isDetailConditionsCheckboxDifferentFromDefaultStateをtrueにする
        if (!(!newCheckedAwardName[0] && !newCheckedAwardName[1])) {
          isDetailConditionsCheckboxDifferentFromDefaultState.current = true
        }
      }
      else if (detailConditionItemString.slice(1,detailConditionItemString.indexOf("】")) === "資格等級") {
        const excludeCloseCompanyTitleString = detailConditionItemString.slice(detailConditionItemString.indexOf("】")+1);
        const newCheckedQualificationLevel = [false,false];
        if (excludeCloseCompanyTitleString.length > 0) {
          const closeCompanyItems: string[] = excludeCloseCompanyTitleString.split(",");
          if (excludeCloseCompanyTitleString[0] === "有") {
            newCheckedQualificationLevel[0] = true;
            if (excludeCloseCompanyTitleString.length > 1) {
              newCheckedQualificationLevel[1] = true;
            }
          } else if (excludeCloseCompanyTitleString[0] === "無") {
            newCheckedQualificationLevel[1] = true;
          }
        }
        setCheckedQualificationLevel(newCheckedQualificationLevel);

        // 更新後のチェック状態がデフォルト状態と異なる場合、isDetailConditionsCheckboxDifferentFromDefaultStateをtrueにする
        if (!(!newCheckedQualificationLevel[0] && !newCheckedQualificationLevel[1])) {
          isDetailConditionsCheckboxDifferentFromDefaultState.current = true
        }
      }
      else if (detailConditionItemString.slice(1,detailConditionItemString.indexOf("】")) === "調達情報") {
        const excludeCloseCompanyTitleString = detailConditionItemString.slice(detailConditionItemString.indexOf("】")+1);
        const newCheckedProcurementInformation = [false,false];
        if (excludeCloseCompanyTitleString.length > 0) {
          const closeCompanyItems: string[] = excludeCloseCompanyTitleString.split(",");
          if (excludeCloseCompanyTitleString[0] === "有") {
            newCheckedProcurementInformation[0] = true;
            if (excludeCloseCompanyTitleString.length > 1) {
              newCheckedProcurementInformation[1] = true;
            }
          } else if (excludeCloseCompanyTitleString[0] === "無") {
            newCheckedProcurementInformation[1] = true;
          }
        }
        setCheckedProcurementInformation(newCheckedProcurementInformation);

        // 更新後のチェック状態がデフォルト状態と異なる場合、isDetailConditionsCheckboxDifferentFromDefaultStateをtrueにする
        if (!(!newCheckedProcurementInformation[0] && !newCheckedProcurementInformation[1])) {
          isDetailConditionsCheckboxDifferentFromDefaultState.current = true
        }
      }
      else if (detailConditionItemString.slice(1,detailConditionItemString.indexOf("】")) === "出力済み企業") {
        const excludeOutputCompanyTitleString = detailConditionItemString.slice(detailConditionItemString.indexOf("】")+1);
        const newCheckedOutputOrNotOutputCompany = [false,false];
        if (excludeOutputCompanyTitleString.length > 0) {
          const outputCompanyItems: string[] = excludeOutputCompanyTitleString.split(",");
          if (outputCompanyItems[0] === "有") {
            newCheckedOutputOrNotOutputCompany[0] = true;
            if (excludeOutputCompanyTitleString.length > 1) {
              newCheckedOutputOrNotOutputCompany[1] = true;
            }
          } else if (outputCompanyItems[0] === "無") {
            newCheckedOutputOrNotOutputCompany[1] = true;
          }
        }
        setCheckedOutputOrNotOutputCompany(newCheckedOutputOrNotOutputCompany);

        // 更新後のチェック状態がデフォルト状態と異なる場合、isDetailConditionsCheckboxDifferentFromDefaultStateをtrueにする
        if (!(newCheckedOutputOrNotOutputCompany[0] && newCheckedOutputOrNotOutputCompany[1])) {
          isDetailConditionsCheckboxDifferentFromDefaultState.current = true
        }
      }
    })
  }

  // 事業内容が入力されているか確認し、入力されていればisEnteredBusinessKeywordsにtrueを入れる
  function confirmBusinessKeywordsIsEnterd(isCheckEvent:boolean) {
    if (isCheckEvent) {
      if (isBusinessKeywordsCheckboxDifferentFromDefaultState.current) {
        if (!isEnteredBusinessKeywords) {
          setIsEnteredBusinessKeywords(true);
        }
        return;
      } else {
        isBusinessKeywordsCheckboxDifferentFromDefaultState.current = true;
        setIsEnteredBusinessKeywords(true);
        return;
      }
    } else {
      if (isBusinessKeywordsCheckboxDifferentFromDefaultState.current) {
        if (!isEnteredBusinessKeywords) {
          setIsEnteredBusinessKeywords(true);
        }
        return;
      }
    }

    if (confirmBusinessKeywordsTextBoxIsEnterd()) {
      if (!isEnteredBusinessKeywords) {
        setIsEnteredBusinessKeywords(true);
      }
      return;
    }

    setIsEnteredBusinessKeywords(false);
  }

  function confirmBusinessKeywordsTextBoxIsEnterd():boolean {
    if ((businessContentsFirstRef.current && businessContentsFirstRef.current.value) ||
      (businessContentsSecondRef.current && businessContentsSecondRef.current.value) ||
      (businessContentsThirdRef.current && businessContentsThirdRef.current.value) ||
      (businessContentsFourthRef.current && businessContentsFourthRef.current.value) ||
      (businessContentsFifthRef.current && businessContentsFifthRef.current.value) ||
      (businessContentsSixthRef.current && businessContentsSixthRef.current.value)
    ) {
      return true;
    }

    return false;
  }

  // キーワードが入力されているか確認し、入力されていればisEnteredFreeWordにtrueを入れる
  function confirmFreeWordIsEnterd(isCheckEvent:boolean) {
    if (isCheckEvent) {
      if (isFreeWordCheckboxDifferentFromDefaultState.current) {
        if (!isEnteredFreeWord) {
          setIsEnteredFreeWord(true);
        }
        return;
      } else {
        isFreeWordCheckboxDifferentFromDefaultState.current = true;
        setIsEnteredFreeWord(true);
        return;
      }
    } else {
      if (isFreeWordCheckboxDifferentFromDefaultState.current) {
        if (!isEnteredFreeWord) {
          setIsEnteredFreeWord(true);
        }
        return;
      }
    }

    if (confirmFreeWordTextBoxIsEnterd()) {
      if (!isEnteredFreeWord) {
        setIsEnteredFreeWord(true);
      }
      return;
    }

    setIsEnteredFreeWord(false);
  }

  function confirmFreeWordTextBoxIsEnterd():boolean {
    if ((freeWordFirstRef.current && freeWordFirstRef.current.value) ||
      (freeWordSecondRef.current && freeWordSecondRef.current.value) ||
      (freeWordThirdRef.current && freeWordThirdRef.current.value) ||
      (freeWordFourthRef.current && freeWordFourthRef.current.value) ||
      (freeWordFifthRef.current && freeWordFifthRef.current.value) ||
      (freeWordSixthRef.current && freeWordSixthRef.current.value)
    ) {
      return true;
    }

    return false;
  }

  // 詳細条件が入力されているか確認し、入力されていればisEnteredDetailConditionsにtrueを入れる
  function confirmDetailConditionsIsEnterd(isCheckEvent:boolean) {
    if (isCheckEvent) {
      if (isDetailConditionsCheckboxDifferentFromDefaultState.current) {
        if (!isEnteredDetailConditions) {
          setIsEnteredDetailConditions(true);
        }
        return;
      } else {
        isDetailConditionsCheckboxDifferentFromDefaultState.current = true;
        setIsEnteredDetailConditions(true);
        return;
      }
    } else {
      if (isDetailConditionsCheckboxDifferentFromDefaultState.current) {
        if (!isEnteredDetailConditions) {
          setIsEnteredDetailConditions(true);
        }
        return;
      }
    }

    if (confirmDetailCoditionsTextBoxIsEnterd()) {
      if (!isEnteredDetailConditions) {
        setIsEnteredDetailConditions(true);
      }
      return;
    }

    setIsEnteredDetailConditions(false);
  }

  function confirmDetailCoditionsTextBoxIsEnterd():boolean {
    if ((salesFromRef.current && salesFromRef.current.value) ||
        (salesToRef.current && salesToRef.current.value)
    ) {
      return true;
    }

    if ((employeesNumFromRef.current && employeesNumFromRef.current.value) ||
        (employeesNumToRef.current && employeesNumToRef.current.value)
    ) {
      return true;
    }
    if ((establishedFromRef.current && establishedFromRef.current.value) ||
        (establishedToRef.current && establishedToRef.current.value)
    ) {
      return true;
    }
    if ((capitalFromRef.current && capitalFromRef.current.value) ||
      (capitalToRef.current && capitalToRef.current.value)
    ) {
      return true;
    }
    if (shareholdersRef.current && shareholdersRef.current.value) {
      return true;
    }
    if (partnersRef.current && partnersRef.current.value) {
      return true;
    }

    return false;
  }

  // フラグが入力されているか確認し、入力されていればisEnteredFlagにtrueを入れる
  function confirmFlagIsEnterd(isCheckEvent:boolean) {
    if (isCheckEvent) {
      if (isFlagCheckboxDifferentFromDefaultState.current) {
        if (!isEnteredFlag) {
          setIsEnteredFlag(true);
        }
        return;
      } else {
        isFlagCheckboxDifferentFromDefaultState.current = true;
        setIsEnteredFlag(true);
        return;
      }
    } else {
      if (isFlagCheckboxDifferentFromDefaultState.current) {
        if (!isEnteredFlag) {
          setIsEnteredFlag(true);
        }
        return;
      }
    }

    if (confirmFlagCheckBoxIsEnterd()) {
      if (!isEnteredFlag) {
        setIsEnteredFlag(true);
      }
      return;
    }

    setIsEnteredFlag(false);
  }

  function confirmFlagCheckBoxIsEnterd():boolean {
    if (newlyEstablishedRef.current && newlyEstablishedRef.current.checked) {
      return true;
    }

    if (dxCertifiedRef.current && dxCertifiedRef.current.checked) {
      return true;
    }

    if (regionalEconomicLeadersRef.current && regionalEconomicLeadersRef.current.checked) {
      return true;
    }

    if (promotionWomenSuccessRef.current && promotionWomenSuccessRef.current.checked) {
      return true;
    }

    if (lifeAndWorkSupportRef.current && lifeAndWorkSupportRef.current.checked) {
      return true;
    }

    if (promotingYouthDevelopmentRef.current && promotingYouthDevelopmentRef.current.checked) {
      return true;
    }

    return false;
  }

  // 地域の都道府県のチェックボックス一覧表示順を指定するための配列
  const prefectureSortingList:string[] =
    ["010006","020001","030007","040002","050008","060003","070009","080004","090000","100005","110001","120006","130001","140007","150002","160008","170003","180009","190004","200000","210005","220001",
    "230006","240001","250007","260002","270008","280003","290009","300004","310000","320005","330001","340006","350001","360007","370002","380008","390003","400009","410004","420000","430005","440001","450006","460001","470007"];

  async function callSearchRequirement() {
    const sampleSaveSearchData: SearchData = {
      savedAt: null,
      userName: "",
      industry: "農業，林業>農業;農業，林業>林業>管理，補助的経済活動を行う事業所（02林業）;鉱業，採石業，砂利採取業>鉱業，採石業，砂利採取業>管理，補助的経済活動を行う事業所（05鉱業，採石業，砂利採取業）>その他の管理，補助的経済活動を行う事業所",
      industryCode: "A,00,000,0000>A,01,000,0000;A,00,000,0000>A,02,000,0000>A,02,020,0000;C,00,000,0000>C,05,000,0000>C,05,050,0000>C,05,050,0509",
      address: "北海道>札幌市>北区;北海道>札幌市>東区;北海道>函館市;岩手県>大船渡市",
      addressCode: "010006>011002>011029;010006>011002>011037;010006>012025;030007>032034",
      businessSummary: "",
      corporateName: "",
      Keyword: "",
      detailCondition: "",
      flag: "",
      comments: ""
    }

    mappingNamesToCodes(sampleSaveSearchData);
    inputDataBasedOnCallSearchRequirment(sampleSaveSearchData);
  }

  const [isEnteredBusinessKeywordsNeedCheck, setIsEnteredBusinessKeywordsNeedCheck] = React.useState<boolean>(false);
  const [isEnteredFreeWordNeedCheck, setIsEnteredFreeWordNeedCheck] = React.useState<boolean>(false);
  const [isEnteredDetailConditionsNeedCheck, setIsEnteredDetailConditionsNeedCheck] = React.useState<boolean>(false);
  const [isEnteredFlagNeedCheck, setIsEnteredFlagNeedCheck] = React.useState<boolean>(false);
  // 検索条件リセット
  React.useEffect(() => {
    if (returnedCallSearchData) {
      clearSearchRequirements();
      inputDataBasedOnCallSearchRequirment(returnedCallSearchData);
      setCorporateNameRefValue(returnedCallSearchData.corporateName);

      setIsEnteredBusinessKeywordsNeedCheck(true);
      setIsEnteredFreeWordNeedCheck(true);
      setIsEnteredDetailConditionsNeedCheck(true);
      setIsEnteredFlagNeedCheck(true);
    }
  }, [returnedCallSearchData]);
  // 事業内容
  React.useEffect(() => {
    if (returnedCallSearchData && isEnteredBusinessKeywordsNeedCheck) {
      setBusinessKeywordsRefValue(returnedCallSearchData.businessSummary);
      confirmBusinessKeywordsIsEnterd(false);
      setIsEnteredBusinessKeywordsNeedCheck(false);
    }
  }, [isEnteredBusinessKeywords, isEnteredBusinessKeywordsNeedCheck]);
  // キーワード
  React.useEffect(() => {
    if (returnedCallSearchData && isEnteredFreeWordNeedCheck) {
      setFreeWordRefValue(returnedCallSearchData.Keyword);
      confirmFreeWordIsEnterd(false);
      setIsEnteredFreeWordNeedCheck(false);
    }
  }, [isEnteredFreeWord, isEnteredFreeWordNeedCheck]);
  // 詳細条件
  React.useEffect(() => {
    if (returnedCallSearchData && isEnteredDetailConditionsNeedCheck) {
      distributeDetailRequirementsForSaveSearchData(returnedCallSearchData.detailCondition);
      confirmDetailConditionsIsEnterd(false);
      setIsEnteredDetailConditionsNeedCheck(false);
    }
  }, [isEnteredDetailConditions, isEnteredDetailConditionsNeedCheck]);
  // フラグ
  React.useEffect(() => {
    if (returnedCallSearchData && isEnteredFlagNeedCheck) {
      mappingNamesToCodes(returnedCallSearchData);
      setIsEnteredFlagNeedCheck(false);
    }
  }, [isEnteredFlag, isEnteredFlagNeedCheck]);

  function inputDataBasedOnCallSearchRequirment(selectedSearchRequirement: SearchData) {
    const newCheckedIndustryItems: {[key: string]: boolean} = {};
    const newCheckedRegionItems: {[key: string]: boolean} = {};

    if (selectedSearchRequirement.industryCode) {
      selectedSearchRequirement.industryCode.split(";").forEach((industryCodeConcatString) => {
        industryCodeConcatString.split(">").forEach((industryCode:string) => {
          newCheckedIndustryItems[industryCode] = true;
        })
      })
    }

    if (selectedSearchRequirement.addressCode) {
      selectedSearchRequirement.addressCode.split(";").forEach((regionCodeConcatString) => {
        regionCodeConcatString.split(">").forEach((regionCode) => {
          newCheckedRegionItems[regionCode] = true;
        })
      })
    }

    setCheckedIndustryItems(newCheckedIndustryItems);
    setCheckedRegionItems(newCheckedRegionItems);
  }

  function clearSearchRequirements() {
    // 検索条件リセット時すべてのエラーメッセージ、成功メッセージをリセットする
    setSuccessMessage("");
    setErrorMessage1("");
    setErrorMessage2("");
    setErrorMessage3("");

    if (industryDataRef.current) {
      industryDataRef.current.value = "";
      handleIndustryFilter("");
    }
    setCheckedIndustryItems({});
    setCheckedRegionItems({});
    setForNotationIndustryItems({});
    setForNotationRegionItems({});
    setOpenRegionClassificationItems({});
    if (corporateNameRef.current) {
      corporateNameRef.current.value = "";
    }

    if (freeWordFirstRef.current) {
      freeWordFirstRef.current.value = "";
      setFreeWordFirst("");
    }
    if (freeWordSecondRef.current) {
      freeWordSecondRef.current.value = "";
      setFreeWordSecond("");
    }
    if (freeWordThirdRef.current) {
      freeWordThirdRef.current.value = "";
      setFreeWordThird("");
    }
    if (freeWordFourthRef.current) {
      freeWordFourthRef.current.value = "";
      setFreeWordFourth("");
    }
    if (freeWordFifthRef.current) {
      freeWordFifthRef.current.value = "";
      setFreeWordFifth("");
    }
    if (freeWordSixthRef.current) {
      freeWordSixthRef.current.value = "";
      setFreeWordSixth("");
    }
    setIsFreeWordPushed(false);

    if (businessContentsFirstRef.current) {
      businessContentsFirstRef.current.value = "";
      setBusinessContentsFirst("");
    }
    if (businessContentsSecondRef.current) {
      businessContentsSecondRef.current.value = "";
      setBusinessContentsSecond("");
    }
    if (businessContentsThirdRef.current) {
      businessContentsThirdRef.current.value = "";
      setBusinessContentsThird("");
    }
    if (businessContentsFourthRef.current) {
      businessContentsFourthRef.current.value = "";
      setBusinessContentsFourth("");
    }
    if (businessContentsFifthRef.current) {
      businessContentsFifthRef.current.value = "";
      setBusinessContentsFifth("");
    }
    if (businessContentsSixthRef.current) {
      businessContentsSixthRef.current.value = "";
      setBusinessContentsSixth("");
    }
    setIsBusinessContentsPushed(false);

    if (salesFromRef.current) {
      salesFromRef.current.value = "";
      setSalesFrom("");
    }
    if (salesToRef.current) {
      salesToRef.current.value = "";
      setSalesTo("");
    }

    if (employeesNumFromRef.current) {
      employeesNumFromRef.current.value = "";
      setEmployeesNumFrom("");
    }
    if (employeesNumToRef.current) {
      employeesNumToRef.current.value = "";
      setEmployeesNumTo("");
    }

    if (establishedFromRef.current) {
      establishedFromRef.current.value = "";
      setEstablishedFrom("");
    }
    if (establishedToRef.current) {
      establishedToRef.current.value = "";
      setEstablishedTo("");
    }

    if (capitalFromRef.current) {
      capitalFromRef.current.value = "";
      setCapitalFrom("");
    }
    if (capitalToRef.current) {
      capitalToRef.current.value = "";
      setCapitalTo("");
    }

    if (shareholdersRef.current) {
      shareholdersRef.current.value = "";
    }

    if (partnersRef.current) {
      partnersRef.current.value = "";
    }

    setBusinessContentsSearchMethod("AND");
    setFreeWordSearchMethod("AND");

    setCheckedHaveOrNotHaveHomePage([true,false]);
    setCheckedHaveOrNotHaveContactPage([true,true]);
    setCheckedListedOrUnListedCompany([true,true]);
    setCheckedCloseOrOpenCompany([false,true]);
    setCheckedNotificationCertification([false,false]);
    setCheckedAwardName([false,false]);
    setCheckedQualificationLevel([false,false]);
    setCheckedProcurementInformation([false,false]);
    setCheckedOutputOrNotOutputCompany([true,true]);

    setCheckedNewlyEstablished(false);
    setCheckedDXCertified(false);
    setCheckedRegionalEconomicLeaders(false);
    setCheckedPromotionWomenSuccess(false);
    setCheckedLifeAndWorkSupport(false);
    setCheckedPromotingYouthDevelopment(false);

    isBusinessKeywordsCheckboxDifferentFromDefaultState.current = false;
    isFreeWordCheckboxDifferentFromDefaultState.current = false;
    isDetailConditionsCheckboxDifferentFromDefaultState.current = false;
    isFlagCheckboxDifferentFromDefaultState.current = false;

    setAccordionOpenManage([]);

    setIsEnteredBusinessKeywords(false);
    setIsEnteredFreeWord(false);
    setIsEnteredDetailConditions(false);
    setIsEnteredFlag(false);

  }

  function clearTagSearchRequirements() {
    setTagSearchList([]);
    setTagSearchCondList([]);
    setIsTagButtonOn({});
  }

  function clearFacetSearchRequirements() {
    setCheckedEndOfFY([]);    // 決算月
    setCheckedGroup([false]); // 企業グループ
    setCheckedOffice([]);     // 事業所
  }

  function resetTagList() {
    setTagList([]);
  }

  function mappingNamesToCodes(saveSearchData:SearchData) {
    if (saveSearchData.industryCode) {
      const newForNotationIndustryItems:{[key:string]:string} = {};
      const industryCodeList = saveSearchData.industryCode.split(";");
      const industryNameList = saveSearchData.industry.split(";");

      if (industryCodeList.length > 0 && industryCodeList.length === industryNameList.length) {
        for(let i = 0; i < industryCodeList.length; i++) {
          newForNotationIndustryItems[industryCodeList[i]] = industryNameList[i];
        }
      }
      setForNotationIndustryItems(newForNotationIndustryItems);
    }


    if (saveSearchData.addressCode) {
      const newForNotationRegionItems:{[key:string]:string} = {};

      const regionCodeList = saveSearchData.addressCode.split(";");
      const regionNameList = saveSearchData.address.split(";");

      if (regionCodeList.length > 0 && regionCodeList.length === regionNameList.length) {
        for(let i = 0; i < regionCodeList.length; i++) {
          newForNotationRegionItems[regionCodeList[i]] = regionNameList[i];
        }
      }
      setForNotationRegionItems(newForNotationRegionItems);
    }

    if (saveSearchData.flag) {
      const flagList = saveSearchData.flag.split(",");
      setCheckedNewlyEstablished(flagList.includes("新設"));
      setCheckedDXCertified(flagList.includes("DX認定"));
      setCheckedRegionalEconomicLeaders(flagList.includes("地域経済担い手"));
      setCheckedPromotionWomenSuccess(flagList.includes("女性活躍推進"));
      setCheckedLifeAndWorkSupport(flagList.includes("子育て・家庭と仕事の両立支援"));
      setCheckedPromotingYouthDevelopment(flagList.includes("若者採用・育成推進"));
      if (flagList.includes("新設") || flagList.includes("DX認定") || flagList.includes("地域経済担い手") || flagList.includes("女性活躍推進") || flagList.includes("子育て・家庭と仕事の両立支援") || flagList.includes("若者採用・育成推進")) {
        isFlagCheckboxDifferentFromDefaultState.current = true;
        confirmFlagIsEnterd(false);
      }
    }
  }

  //検索条件呼び出し
  useEffect(() => {
    if (!callSearchModalIsOpen && callSearchData) {
      setReturnedCallSearchData(callSearchData[0]); // 一つだけ返却するケースを想定
    }
  }, [callSearchModalIsOpen]);

  function openCallSearchModal() {
    if (isProcessing) {
        return;
    }
    // 検索条件呼出モーダル表示処理開始時すべてのエラーメッセージ、成功メッセージをリセットする
    setSuccessMessage("");
    setErrorMessage1("");
    setErrorMessage2("");
    setErrorMessage3("");

    // 2重クリック防止
    setIsProcessing(true);

    if(tokenInfo.plan == "basic"){
      setCallSearchModalIsOpen(true);
      // 2重クリック防止解除
      setIsProcessing(false);
    }else{
      setErrorMessage2("現在のプランでは検索条件を保存できないため、呼び出し機能も利用できません。ベーシックプランへのアップグレードが必要です。")
      setIsNeedChangePlan(true);
      // 2重クリック防止解除
      setIsProcessing(false);
    }
  }
  function closeCallSearchModal(calledData: SearchData | null = null) {
    if (calledData) {
      setCallSearchData([calledData]);
    }
    setCallSearchModalIsOpen(false);
  }

  // 検索ボタンクリック時にモダール表示・CSV用の検索条件を取得・セットする関数
  // UI設計書と異なる
  function getSearchFilter(){
    // 選択された検索条件の取得・加工
    const industorialClass = Object.values(forNotationIndustryItems).join(';'); // 業種
    const address = Object.values(forNotationRegionItems).join(';'); // 地域
    const numberOfCorporate = dataCount // 企業数
    // 加工した検索条件をモーダルの引数にセット
    const csvDlSearchFilterRecord : SearchFilter  = {
            corporateName:corporateNameRef.current?.value ? corporateNameRef.current?.value : "",
            freeWord:formatFreeWordRequirementsForSaveSearchData(),
            industorialClass:industorialClass,
            address:address,
            businessKeywords: formatBusinessKeywordsRequirementsForSaveSearchData(),
            detailParameter:formatDetailRequirementsForSaveSearchData(),
            flag:formatFlagRequirementsForSaveSearchData(),
            numberOfCorporate:numberOfCorporate,
            comments:'',
    }
    setSearchFilterRecord(csvDlSearchFilterRecord)
  }

  // CSVダウンロードモーダ表示関数（引数を検索条件保存インターフェースとする）
  function openCsvDlModal() {
    // 2重クリック防止・ダウンロード中ならば表示不能
    if (isProcessing || isDownload) {
      return;
    }
    // チェックした企業をCSVダウンロードモーダル表示処理開始時すべてのエラーメッセージ、成功メッセージをリセットする
    setSuccessMessage("");
    setErrorMessage1("");
    setErrorMessage2("");
    setErrorMessage3("");

    // 検索結果で選択した企業の法人番号リストを作成
    const selectedList = getSelectedCorporateNumberList();

    // 選択件数が0件なら中断してメッセージ表示
    if (selectedList.length == 0){
      setErrorMessage3('ダウンロードを行うには、少なくとも1件選択してください。');
      return;
    }

    // 2重クリック防止
    setIsProcessing(true);

    // 選択した企業数を検索条件レコードに入れる
    searchFilterRecord.numberOfCorporate = selectedList.length

    // モーダルの引数にセット
    setSelectedCorporateNumberList(selectedList);
    setSearchFilterRecord(searchFilterRecord);

    // CSVダウンロードモーダル表示フラグON
    setCsvDLModalIsOpen(true);
    // 2重クリック防止解除
    setIsProcessing(false);
  }

  // CSVダウンロードモーダ非表示関数
  function closeCsvDlModal() {
    setCsvDLModalIsOpen(false);
  }

  // CSVダウンロード関数
  function DownloadCsv(searchFilterRecord : SearchFilter, corporateNumberList:string[]) {
    // モーダルから検索条件・法人番号リストを受け取りセット
    setSearchFilterRecord(searchFilterRecord)
    setSelectedCorporateNumberList(corporateNumberList)
    // ダウンロードフラグON
    setIsDownload(true)
  }

  // CSVダウンロード（ダウンロードフラグONに変化した時実行）
  useEffect(() => {
    const downloadCsv = async () => {
      if(isDownload == true){
        // API実行　CSVファイルのダウンロード（ボタン押）
        // 注意：返り値はCSVデータでなく、CSVを保存したS3の署名付きURL
        const csvUrl = await callEventDownloadCsv(searchFilterRecord, selectedCorporateNumberList);
        // URL先をダウンロードさせる（非表示aタグをクリック）
        const link = document.createElement('a');
        link.href = csvUrl;
        link.download = ''; // ファイル名を指定（空の場合はデフォルトの名前）
        link.style.display = 'none';
        // 2025/10/30 ダウンロード件数再読み込み処理の追加 START
        link.addEventListener('click', () => {
          setTimeout(() => {
            setIsDownloaded(true);
          }, 2000);
        });
        // 2025/10/30 ダウンロード件数再読み込み処理の追加 END
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // 完了メッセージ
        setSuccessMessage('ダウンロードが完了しました。');
        setErrorMessage1("");
        setErrorMessage2("");
        setErrorMessage3("");
        setIsNeedChangePlan(false);
        setIsNeedAddPurchase(false);
        setIsNeedChangePlan2(false);
        alert('ダウンロードが完了しました。');
        // 2025/10/30 ダウンロード件数再読み込み処理の追加 START
        // window.location.reload(); //画面再読込
        // 2025/10/30 ダウンロード件数再読み込み処理の追加 END
      }
    }
    downloadCsv();

  },[isDownload]);// isDownloadがtrueの場合のみ実行

  // 2025/10/30 ダウンロード件数再読み込み処理の追加 START
  // CSVダウンロード後画面再読み込み（ダウンロード完了フラグONに変化した時実行）
  useEffect(() => {
    if (isDownloaded) {
      // 共通ヘッダー／ダウンロード件数再読み込み
      setDoReloadOutputCountFlag(!doReloadOutputCountFlag);
      setIsDownloaded(false);
    }
  }, [isDownloaded]);
  // 2025/10/30 ダウンロード件数再読み込み処理の追加 END

  // API実行　CSVファイルのダウンロード（ボタン押）
  // 注意：実際の返り値はCSVデータでなく、CSVを保存したS3のURL
  const callEventDownloadCsv = async (searchFilterRecord:SearchFilter, corporateNumberList:string[]) => {
    try {
      // idTokenを取得
      const { idToken } = await getTokens();
      // API Gatewayを呼び出す
      const baseUrl:string = process.env.REACT_APP_API_BASE_URL || '';
      const path:string = '/event/csvdl';
      const apipath = baseUrl.concat(path);
      const response = await fetch(apipath,{
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${idToken}`, // IDトークンをヘッダーに設定
          'Content-Type': 'application/json'
        },
        body:JSON.stringify({
          'corporateNumberList':corporateNumberList, // 選択した企業の法人番号リスト
          'searchFilterRecord':searchFilterRecord // 検索条件レコード
        }),
      });
      // ステータスコードの確認
      if (!response.ok) {
        setErrorMessage1(ERROR_MESSAGE_PROCESSING_ERROR); // エラーメッセージを表示
        throw Error(`HTTP error! status: ${response.status}`); // 処理を中断
      }
      // レスポンスのJSONデータをパース
      const responseData = await response.json();

      // レスポンスのメッセージが空でなければ例外扱い
      if (responseData.message != ''){
        setErrorMessage3(responseData.message); // エラーメッセージを表示
        throw Error(responseData.message); // 処理を中断
      }

      // 正常ならばCSVを保存したS3のURLを返す
      // 2重ダウンロード防止解除
      setIsDownload(false);
      return responseData.url

    } catch (error) {
      console.error("callEventDownloadCsvエラー:", error);
      // 2重ダウンロード防止解除
      setIsDownload(false);
      throw error;
    }
  };

  // 検索結果変更の度にチェックボックスの初期化
  useMemo(() => {
    setMasterChecked(true);
    setOtherChecked(new Array(corporateNumList.length).fill(true)); // 検索結果数分のチェックボックスを作成
  }, [corporateNumList]);

  // 全て選択するショートカット
  const handleMasterChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const isChecked = event.target.checked;
    setMasterChecked(isChecked);
    setOtherChecked(otherChecked.map(() => isChecked));
  };

  // 個別のチェックボックス処理
  const handleOtherChange = (index: number) => (event: React.ChangeEvent<HTMLInputElement>) => {
    const newChecked = otherChecked.slice();
    newChecked[index] = event.target.checked;
    setOtherChecked(newChecked);
  };

  // 選択済みの企業の法人番号リスト取得関数
  function getSelectedCorporateNumberList(): string[] {
    const checkedNumber = corporateNumList.filter((_, index) => otherChecked[index]);
    return checkedNumber;
  }

  // ■■ G-Search連携呼び出し
  const callGsearchService = async (record:GsearchServiceType) => {
    const newWindow = window.open('', '_blank');
    try {
      // idTokenを取得
      const { idToken } = await getTokens();

      // API Gatewayを呼び出す
      const baseUrl:string = process.env.REACT_APP_API_BASE_URL || '';
      const path:string = '/common/gsearch';
      const apipath = baseUrl.concat(path);
      const response = await fetch(apipath,{
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${idToken}`, // IDトークンをヘッダーに設定
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(record)
      });
      if (response.ok) {
        const result = await response.json();
        if (newWindow) newWindow.location.href = result.headers.Location
        return;
      } else {
        newWindow?.close();
        setErrorMessage3(ERROR_MESSAGE_PROCESSING_ERROR);
      }
    } catch (error) {
      newWindow?.close();
      console.error("callGsearchService:", error);
      setErrorMessage3(ERROR_MESSAGE_PROCESSING_ERROR);
      throw Error;
    }
  };

  //企業横断ボタン押下時
  function callKigyoOdan(corporateName:string) {
    // 企業横断ボタン押下時すべてのエラーメッセージ、成功メッセージをリセットする
    setSuccessMessage("");
    setErrorMessage1("");
    setErrorMessage2("");
    setErrorMessage3("");

    const dbid = "RXCC"
    const now = getCurrentTimestamp()

    const Args: GsearchServiceType = {
      corporateName: corporateName,
      dbid: dbid,
      T: now,
    };
    if(tokenInfo.plan == "free"){
      navigate("/planchange");
    }else{
      if(tokenInfo.available_features == "disabled"){
        //エラーメッセージを表示して中断
        setErrorMessage3("ただいまお客様のアカウントではG-Searchコンテンツをご利用いただけません。詳細については、メールをご確認ください。");
        return
      }
      callGsearchService(Args)
    }
  };
  //新聞横断ボタン押下時
  function callShinbunOdan(corporateName:string) {
    // 新聞横断ボタン押下時すべてのエラーメッセージ、成功メッセージをリセットする
    setSuccessMessage("");
    setErrorMessage1("");
    setErrorMessage2("");
    setErrorMessage3("");
    const dbid = "RXCN"
    const now = getCurrentTimestamp()

    const Args: GsearchServiceType = {
      corporateName: corporateName,
      dbid: dbid,
      T: now,
    };
    if(tokenInfo.plan == "free"){
      navigate("/planchange");
    }else{
      if(tokenInfo.available_features == "disabled"){
        //エラーメッセージを表示して中断
        setErrorMessage3("ただいまお客様のアカウントではG-Searchコンテンツをご利用いただけません。詳細については、メールをご確認ください。");
        return
      }
      callGsearchService(Args)
    }
  };
  //コンプラチェックボタン押下時
  function callComplianceCheck(corporateName:string) {
    // 新聞横断ボタン押下時すべてのエラーメッセージ、成功メッセージをリセットする
    setSuccessMessage("");
    setErrorMessage1("");
    setErrorMessage2("");
    setErrorMessage3("");
    const dbid = "QNBT";
    const now = getCurrentTimestamp();

    const Args: GsearchServiceType = {
      corporateName: corporateName,
      dbid: dbid,
      T: now,
    };
    if(tokenInfo.plan == "free"){
      navigate("/planchange");
    }else{
      if(tokenInfo.available_features == "disabled"){
        //エラーメッセージを表示して中断
        setErrorMessage3("ただいまお客様のアカウントではG-Searchコンテンツをご利用いただけません。詳細については、メールをご確認ください。");
        return
      }
      callGsearchService(Args);
    }
  };

  //現在時刻取得(YYYYmmddhhmmddに整形)
  function getCurrentTimestamp() {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0'); // 月は0始まりなので+1します
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');

    return `${year}${month}${day}${hours}${minutes}${seconds}`;
  }

  //現在時刻取得(YYYY/mmに変形)
  function getFormattedTimeShort() {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');  // 月は0から始まるので+1する
    return `${year}/${month}`;
  }

  //現在時刻取得(yyyy-MM-dd hh:mm:ssに変形)
  function getFormattedTimeLong() {
    const now = new Date();
    const year = now.getFullYear();
    const month = ('0' + (now.getMonth() + 1)).slice(-2);
    const day = ('0' + now.getDate()).slice(-2);
    const hours = ('0' + now.getHours()).slice(-2);
    const minutes = ('0' + now.getMinutes()).slice(-2);
    const seconds = ('0' + now.getSeconds()).slice(-2);

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

  //企業名リンク押下時処理
  async function callCompanyDetail(corporateNumber:string) {
    // 企業名リンク押下時すべてのエラーメッセージ、成功メッセージをリセットする
    setSuccessMessage("");
    setErrorMessage1("");
    setErrorMessage2("");
    setErrorMessage3("");
    const nowShort = getFormattedTimeShort(); //YYYY/mm
    const nowLong = getFormattedTimeLong(); //yyyy-MM-dd hh:mm:ss
    try {
      //残数上限チェック
      //isNotDownloadableがTrueの時ダウンロードできない。
      const isNotDownloadable =await callCheckLimitoutput(nowShort,corporateNumber);
      if(isNotDownloadable && tokenInfo.plan == 'basic'){
        setErrorMessage3("ダウンロード/表示件数が不足しています。")
        setIsNeedAddPurchase(true)
        return
      }else if(isNotDownloadable && (tokenInfo.plan == 'free' || tokenInfo.plan == 'freePlus')){
        setErrorMessage3("ダウンロード/表示件数が不足しています。出力数追加には、ベーシックプランへのアップグレードが必要です。")
        setIsNeedChangePlan2(true)
        return
      }
      //企業詳細画面へ遷移
      navigate(`corporatedetail?corporateNumber=${corporateNumber}`);

    } catch (error) {
      setErrorMessage1(ERROR_MESSAGE_PROCESSING_ERROR);
      }
  }

  // ■■ 残数上限チェックAPI呼び出し
  const callCheckLimitoutput = async (now:string, corporateNumber:string) => {
    try {
      // idTokenを取得
      const { idToken } = await getTokens();

      // API Gatewayを呼び出す
      const baseUrl:string = process.env.REACT_APP_API_BASE_URL || '';
      const path:string = '/common/checklimitoutput';
      const apipath = baseUrl.concat(path);
      const response = await fetch(apipath,{
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${idToken}`, // IDトークンをヘッダーに設定
          'Content-Type': 'application/json'
        },
        body:JSON.stringify({
          'outputDate':now,
          'corporateNumber':[corporateNumber],
          'numberOfCorporate':'1',
          'targetDate':now
        }),
      });
      // レスポンスのJSONデータをパース
      const responseData = await response.json();
      // レスポンスのbodyから必要なデータを取得
      const { isNotDownloadable } = responseData;
      return isNotDownloadable;
    } catch (error) {
      console.error("callCheckLimitoutput:", error);
      throw Error;
    }
  };

  // ■■ 企業詳細への遷移API呼び出し
  const callEventLnkcompanydetail = async (nowShort:string, corporateNumber:string, outputCount_use:string, nowLong:string) => {
    try {
      // idTokenを取得
      const { idToken } = await getTokens();

      // API Gatewayを呼び出す
      const baseUrl:string = process.env.REACT_APP_API_BASE_URL || '';
      const path:string = '/event/link';
      const apipath = baseUrl.concat(path);
      const response = await fetch(apipath,{
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${idToken}`, // IDトークンをヘッダーに設定
          'Content-Type': 'application/json'
        },
        body:JSON.stringify({
          'outputCorporates': [{
                               'corporateNumber': corporateNumber,
                               'outputDate': nowShort,
                               'created_at': nowLong,
                               'updated_at': nowLong
                              }],
          'outputCount_use': outputCount_use,
          'updatedAt': nowLong,
          'outputDate': nowShort,
          'targetDate': nowShort
        }),
      });
    } catch (error) {
      console.error("callEventLnkcompanydetail:", error);
      throw Error;
    }
  };

  // ■■ 残数レコード取得API呼び出し
  const callGetRecordOutputmanage = async (targetDate:string) => {
    try {
      // idTokenを取得
      const { idToken } = await getTokens();

      // API Gatewayを呼び出す
      const baseUrl:string = process.env.REACT_APP_API_BASE_URL || '';
      const path:string = '/postgres/getoutputmanage';
      const apipath = `${baseUrl}${path}?targetDate=${encodeURIComponent(targetDate)}`;
      const response = await fetch(apipath,{
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${idToken}`, // IDトークンをヘッダーに設定
          'Content-Type': 'application/json'
        },
      });
      // レスポンスのJSONデータをパース
      const responseData = await response.json();
      // レスポンスのbodyから必要なデータを取得
      const { outputCount_use } = responseData;
      return outputCount_use;
    } catch (error) {
      console.error("callGetRecordOutputmanage:", error);
      throw Error;
    }
  };

  useEffect(() => {
    saveState();
  }, [rowsPerPage, sortKey, currentPage, ascDesc, dataCount, tableData, tagList]);

  //検索条件セット処理
  const handleConditionSet = () => {
    //企業名
    if(corporateNameRef.current){
      setCorporateName(corporateNameRef.current.value);
    }
    //キーワード１
    if(freeWordFirstRef.current){
      setFreeWordFirst(freeWordFirstRef.current.value);
    }
    //キーワード２
    if(freeWordSecondRef.current){
      setFreeWordSecond(freeWordSecondRef.current.value);
    }
    //キーワード３
    if(freeWordThirdRef.current){
      setFreeWordThird(freeWordThirdRef.current.value);
    }
    //キーワード４
    if(freeWordFourthRef.current){
      setFreeWordFourth(freeWordFourthRef.current.value);
    }
    //キーワード５
    if(freeWordFifthRef.current){
      setFreeWordFifth(freeWordFifthRef.current.value);
    }
    //キーワード６
    if(freeWordSixthRef.current){
      setFreeWordSixth(freeWordSixthRef.current.value);
    }
    //事業内容１
    if(businessContentsFirstRef.current){
      setBusinessContentsFirst(businessContentsFirstRef.current.value);
    }
    //事業内容２
    if(businessContentsSecondRef.current){
      setBusinessContentsSecond(businessContentsSecondRef.current.value);
    }
    //事業内容３
    if(businessContentsThirdRef.current){
      setBusinessContentsThird(businessContentsThirdRef.current.value);
    }
    //事業内容４
    if(businessContentsFourthRef.current){
      setBusinessContentsFourth(businessContentsFourthRef.current.value);
    }
    //事業内容５
    if(businessContentsFifthRef.current){
      setBusinessContentsFifth(businessContentsFifthRef.current.value);
    }
    //事業内容６
    if(businessContentsSixthRef.current){
      setBusinessContentsSixth(businessContentsSixthRef.current.value);
    }
    //売上From
    if(salesFromRef.current){
      setSalesFrom(salesFromRef.current.value);
    }
    //売上To
    if(salesToRef.current){
      setSalesTo(salesToRef.current.value);
    }
    //従業員数From
    if(employeesNumFromRef.current){
      setEmployeesNumFrom(employeesNumFromRef.current.value);
    }
    //従業員数To
    if(employeesNumToRef.current){
      setEmployeesNumTo(employeesNumToRef.current.value);
    }
    //設立年From
    if(establishedFromRef.current){
      setEstablishedFrom(establishedFromRef.current.value);
    }
    //設立年To
    if(establishedToRef.current){
      setEstablishedTo(establishedToRef.current.value);
    }
    //資本金From
    if(capitalFromRef.current){
      setCapitalFrom(capitalFromRef.current.value);
    }
    //資本金To
    if(capitalFromRef.current){
      setCapitalFrom(capitalFromRef.current.value);
    }
    // 株主
    if (shareholdersRef.current) {
      setShareholders(shareholdersRef.current.value);
    }
    // 取引先
    if (partnersRef.current) {
      setPartners(partnersRef.current.value);
    }
  };

  //検索時に保存
  //awaitを付けないとsessionStorageからデータが消えてしまう。
  //最初にセットするItemがロード時、空で取得されてしまうため(dummy)で対応
  const saveState = async () => {
    await sessionStorage.setItem('dummy', dummy);
    await sessionStorage.setItem('forNotationIndustryItems', JSON.stringify(forNotationIndustryItems));
    await sessionStorage.setItem('checkedIndustryItems', JSON.stringify(checkedIndustryItems));
    await sessionStorage.setItem('forNotationRegionItems', JSON.stringify(forNotationRegionItems));
    await sessionStorage.setItem('checkedRegionItems', JSON.stringify(checkedRegionItems));
    await sessionStorage.setItem('corporateName', corporateName);

    // キーワード
    await sessionStorage.setItem('freeWordSearchMethod',freeWordSearchMethod);
    await sessionStorage.setItem('freeWordFirst',freeWordFirst);
    await sessionStorage.setItem('freeWordSecond',freeWordSecond);
    await sessionStorage.setItem('freeWordThird',freeWordThird);
    await sessionStorage.setItem('freeWordFourth',freeWordFourth);
    await sessionStorage.setItem('freeWordFifth',freeWordFifth);
    await sessionStorage.setItem('freeWordSixth',freeWordSixth);
    // 業務内容
    await sessionStorage.setItem('businessContentsSearchMethod',businessContentsSearchMethod);
    await sessionStorage.setItem('businessContentsFirst',businessContentsFirst);
    await sessionStorage.setItem('businessContentsSecond',businessContentsSecond);
    await sessionStorage.setItem('businessContentsThird',businessContentsThird);
    await sessionStorage.setItem('businessContentsFourth',businessContentsFourth);
    await sessionStorage.setItem('businessContentsFifth',businessContentsFifth);
    await sessionStorage.setItem('businessContentsSixth',businessContentsSixth);
    // 検索条件
    await sessionStorage.setItem('salesFrom',salesFrom);
    await sessionStorage.setItem('salesTo',salesTo);
    await sessionStorage.setItem('employeesNumFrom',employeesNumFrom);
    await sessionStorage.setItem('employeesNumTo',employeesNumTo);
    await sessionStorage.setItem('establishedFrom',establishedFrom);
    await sessionStorage.setItem('establishedTo',establishedTo);
    await sessionStorage.setItem('capitalFrom',capitalFrom);
    await sessionStorage.setItem('capitalTo',capitalTo);
    await sessionStorage.setItem('shareholders',shareholders);
    await sessionStorage.setItem('partners',partners);

    await sessionStorage.setItem('checkedHaveOrNotHaveHomePage', JSON.stringify(checkedHaveOrNotHaveHomePage));
    await sessionStorage.setItem('checkedHaveOrNotHaveContactPage', JSON.stringify(checkedHaveOrNotHaveContactPage));
    await sessionStorage.setItem('checkedListedOrUnListedCompany', JSON.stringify(checkedListedOrUnListedCompany));
    await sessionStorage.setItem('checkedCloseOrOpenCompany', JSON.stringify(checkedCloseOrOpenCompany));
    await sessionStorage.setItem('checkedNotificationCertification', JSON.stringify(checkedNotificationCertification));
    await sessionStorage.setItem('checkedAwardName', JSON.stringify(checkedAwardName));
    await sessionStorage.setItem('checkedQualificationLevel', JSON.stringify(checkedQualificationLevel));
    await sessionStorage.setItem('checkedProcurementInformation', JSON.stringify(checkedProcurementInformation));
    await sessionStorage.setItem('checkedOutputOrNotOutputCompany', JSON.stringify(checkedOutputOrNotOutputCompany));

    await sessionStorage.setItem('checkedNewlyEstablished', JSON.stringify(checkedNewlyEstablished));
    await sessionStorage.setItem('checkedDXCertified', JSON.stringify(checkedDXCertified));
    await sessionStorage.setItem('checkedRegionalEconomicLeaders', JSON.stringify(checkedRegionalEconomicLeaders));
    await sessionStorage.setItem('checkedPromotionWomenSuccess', JSON.stringify(checkedPromotionWomenSuccess));
    await sessionStorage.setItem('checkedLifeAndWorkSupport', JSON.stringify(checkedLifeAndWorkSupport));
    await sessionStorage.setItem('checkedPromotingYouthDevelopment', JSON.stringify(checkedPromotingYouthDevelopment));

    await sessionStorage.setItem('currentResultSearchConditions', JSON.stringify(currentResultSearchConditions));

    // ページネーション・並び替え情報
    await sessionStorage.setItem('currentPage', JSON.stringify(currentPage));
    await sessionStorage.setItem('rowsPerPage', JSON.stringify(rowsPerPage));
    await sessionStorage.setItem('sortKey', sortKey);
    await sessionStorage.setItem('ascDesc', ascDesc);
    await sessionStorage.setItem('isAscendingPush', JSON.stringify(isAscendingPush));

    // 検索結果の表示内容
    await sessionStorage.setItem('dataCount', JSON.stringify(dataCount));
    await sessionStorage.setItem('facetCount', JSON.stringify(facetCount));
    await sessionStorage.setItem('isViewFacet', JSON.stringify(isViewFacet));
    await sessionStorage.setItem('tableData', JSON.stringify(tableData));
    await sessionStorage.setItem('tagList', JSON.stringify(tagList));
    await sessionStorage.setItem('tagSearchList', JSON.stringify(tagSearchList));
    await sessionStorage.setItem('tagSearchCondList', JSON.stringify(tagSearchCondList));
    await sessionStorage.setItem('isTagButtonOn', JSON.stringify(isTagButtonOn));
    await sessionStorage.setItem('isSearchClicked', JSON.stringify(isSearchClicked));
    await sessionStorage.setItem('isSearchFacetClicked', JSON.stringify(isSearchFacetClicked));
    await sessionStorage.setItem('isSearchTagFilterClicked', JSON.stringify(isSearchTagFilterClicked));
    await sessionStorage.setItem('isSearchTagNewClicked', JSON.stringify(isSearchTagNewClicked));
    await sessionStorage.setItem('corporateNumList', JSON.stringify(corporateNumList));
    // フィルタファセットの項目
    await sessionStorage.setItem('filterIndustryFacetsData', JSON.stringify(filterIndustryFacetsData));
    await sessionStorage.setItem('filterFinancialEndofFYFacetList', JSON.stringify(filterFinancialEndofFYFacetList));
    await sessionStorage.setItem('filterCorpGroupFacetsHitcount', JSON.stringify(filterCorpGroupFacetsHitcount));
    await sessionStorage.setItem('filterLocalGovernmentFacetList', JSON.stringify(filterLocalGovernmentFacetList));
    await sessionStorage.setItem('filterOfficeIsExistFacetHitcount', JSON.stringify(filterOfficeIsExistFacetHitcount));
    await sessionStorage.setItem('filterCorporateUrlFacetHitCount', JSON.stringify(filterCorporateUrlFacetHitCount));
    // フィルタファセットの条件
    await sessionStorage.setItem('checkedEndOfFY', JSON.stringify(checkedEndOfFY));
    await sessionStorage.setItem('checkedGroup', JSON.stringify(checkedGroup));
    await sessionStorage.setItem('checkedOffice', JSON.stringify(checkedOffice));

    // CSVDL条件　チェックボックス
    await sessionStorage.setItem('searchFilterRecord', JSON.stringify(searchFilterRecord));
    await sessionStorage.setItem('masterChecked', JSON.stringify(masterChecked));
    await sessionStorage.setItem('otherChecked', JSON.stringify(otherChecked));

  };

  useEffect(() => {
    if (errorMessage1 && error1Ref.current) {
      error1Ref.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    else if (errorMessage2 && error2Ref.current) {
      error2Ref.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    else if (errorMessage3 && error3Ref.current) {
      error3Ref.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    else if (successMessage && successRef.current) {
      successRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, [errorMessage1,errorMessage2,errorMessage3,successMessage]);

  // プラン変更画面へ遷移
  const handleNavigatePlanChange = () => {
      navigate("/planchange");
  };

  // 追加購入画面へ遷移
  const handleNavigateAddPurchase = () => {
      navigate("/addpurchase");
  };

  // 並び替えプルダウン項目
  const [options, setOptions] = useState<JSX.Element[]>([]);
  const breakpoint = useBreakpointValue({ base: 'base', large: 'large' });
  useEffect(() => {
    if (breakpoint === 'base') {
      setOptions([
        <option value="20">20件</option>
      ]);
    } else {
      setOptions([
        <option value="20">20件</option>,
        <option value="50">50件</option>,
        <option value="100">100件</option>,
        <option value="200">200件</option>
      ]);
    }
  }, [breakpoint]);

  const [windowDimensions, setWindowDimensions] = useState({
    width: window.innerWidth,
    height: window.innerHeight
  });

  useEffect(() => {
  const handleResize = () => {
    setWindowDimensions({
      width: window.innerWidth,
      height: window.innerHeight
    });
  };

  window.addEventListener('resize', handleResize);

  return () => {
    window.removeEventListener('resize', handleResize);
  };
  }, []);

  //省略時の文字数設定
  useEffect(() => {
    if (windowDimensions.width < 1100) {
      setMinWidth('1450px');
    } else {
      setMinWidth('900px');
    }
  }, [windowDimensions]);

  //テーブルの横幅設定
  const [minWidth, setMinWidth] = useState('1150px');

  // infomationボタンを別タブで開く
  const handleOpenCreditNews = () => {
    window.open(`${process.env.REACT_APP_OPENSITE_BASE_URL}/download/guide/cnavi-guide-credit-news.pdf`, "_blank", "noreferrer");
  };

  // タグのセット
  const [tagSearchList, setTagSearchList] = useState<string[]>([]);
  const [tagSearchCondList, setTagSearchCondList] = useState<string[]>([]);
  const [isTagButtonOn, setIsTagButtonOn] = useState<{[key: string]: boolean}>({});
  const handleSetTagList = (tag:string, num:number) => {
    setTagSearchList(prev => 
      prev.includes(tag) ? prev.filter(item => item !== tag) : [...prev, tag]
    );
    setIsTagButtonOn(prev => ({
      ...prev,
      [num]: !prev[num],
    }));
  };

  // ■■フィルタ・ファセットのスクロール追従
  const mainAreaRef = useRef<HTMLDivElement | null>(null);
  const filterFacetsWrapRef = useRef<HTMLDivElement | null>(null);
  const filterFacetsRef = useRef<HTMLDivElement | null>(null);
  const [isElementInView, setIsElementInView] = useState<boolean>(true);
  const [mainAreaHeight, setmMainAreaHeight] = useState(0);
  const [filterFacetsWrapHeight, setFilterFacetsWrapHeight] = useState(0);
  const [filterFacetsHeight, setFilterFacetsHeight] = useState(0);
  const [filterFacetsWidth, setfilterFacetsWidth] = useState(0);
  const prevScrollPosition = useRef(0);
	const [filterFacetsStyles, setFilterFacetsStyles] = useState<React.CSSProperties>({});
	const [styleType, setStyleType] = useState<string>("elementInView");
	const [fixedPosition, setFixedPosition] = useState<string>("");

  // mainAreaの高さ取得
  React.useEffect(() => {
    if (!mainAreaRef.current) return;
    const observer = new ResizeObserver((entries) => {
      for (const entry of entries) {
        setmMainAreaHeight(entry.contentRect.height);
      }
    });
    observer.observe(mainAreaRef.current);
    return () => observer.disconnect();
  }, [mainAreaRef.current]);

  // フィルタファセット内部の高さ取得
  React.useEffect(() => {
    if (!filterFacetsRef.current) return;

    const updateState = () => {
      if (!filterFacetsRef.current || !filterFacetsWrapRef.current) return;

      const filterFacetsHeight = filterFacetsRef.current.getBoundingClientRect().height;
      setFilterFacetsHeight(filterFacetsHeight);

      // フィルタファセット内部の高さが画面内に収まっているか判別
      const scrollPosition = window.scrollY;
      const windowHeight = window.innerHeight - 130;
      const filterFacetsWrapRect = filterFacetsWrapRef.current.getBoundingClientRect();
      const filterFacetsRect = filterFacetsRef.current.getBoundingClientRect();

      if (filterFacetsHeight <= windowHeight) {
        setIsElementInView(true);
        setStyleType("elementInView");
      } else {
        setIsElementInView(false);
        if (styleType === "elementInView") {
          if (scrollPosition === 0) {
            setStyleType("relative");
          } else {
            setStyleType("topAbsolute");
            const newFixedPositionTop = filterFacetsRect.top - filterFacetsWrapRect.top;
            setFixedPosition(`${newFixedPositionTop}px`);
          }
        }
      }
    };

    const handleScroll = () => {
      if (!filterFacetsRef.current) return;
      if (!filterFacetsWrapRef.current) return;
      if (isElementInView) return;

      const scrollPosition = window.scrollY;
      const windowHeight = window.innerHeight + 50;
      const filterFacetsWrapRect = filterFacetsWrapRef.current.getBoundingClientRect();
      const filterFacetsRect = filterFacetsRef.current.getBoundingClientRect();

      if (prevScrollPosition.current < scrollPosition) { // 下向きスクロール
        if (styleType == "topFixed") {
          setStyleType("topAbsolute");
          const newFixedPositionTop = filterFacetsRect.top - filterFacetsWrapRect.top;
          setFixedPosition(newFixedPositionTop + "px");
        }
        if (filterFacetsRect.bottom <= windowHeight) {          
          setStyleType("bottomFixed");
        }
        if (filterFacetsWrapRect.bottom <= filterFacetsRect.bottom) {
          setStyleType("bottomAbsolute");
        }
      } else { // 上向きスクロール
        if (styleType == "bottomFixed") {
          setStyleType("topAbsolute");
          const newFixedPositionTop = filterFacetsRect.top - filterFacetsWrapRect.top;
          setFixedPosition(newFixedPositionTop + "px");
        }
        if (filterFacetsRect.bottom >= filterFacetsWrapRect.bottom) {
          setStyleType("bottomAbsolute");
        }
        if (filterFacetsRect.top >= 100) {
          setStyleType("topFixed");
        }
        if (scrollPosition == 0) {
          setStyleType("relative");
        }
      }
      prevScrollPosition.current = scrollPosition;
    };

    // 初回とリサイズ時に実行
    updateState();
    const observer = new ResizeObserver(updateState);
    observer.observe(filterFacetsRef.current);
    window.addEventListener("scroll", updateState);
    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", updateState);

    return () => {
      observer.disconnect();
      window.removeEventListener("scroll", updateState);
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", updateState);
    };
  }, [filterFacetsRef.current, styleType]);

  // フィルタファセット外側の高さ設定
  useEffect(() => {
    if (filterFacetsHeight < mainAreaHeight) {
      setFilterFacetsWrapHeight(mainAreaHeight);
    } else {
      setFilterFacetsWrapHeight(filterFacetsHeight);
    }
  }, [mainAreaHeight, filterFacetsHeight]);

  // フィルタファセット内部の幅設定
  useEffect(() => {
    if (!filterFacetsWrapRef.current) return;

    const filterFacetsWidth = filterFacetsWrapRef.current.getBoundingClientRect().width - 10;
    setfilterFacetsWidth(filterFacetsWidth);
  }, [filterFacetsWrapRef.current]);

  // フィルタファセットのスタイル
  React.useEffect(() => {
    switch (styleType) {
      case "elementInView":
        return (
          setFilterFacetsStyles({
            position: "sticky",
            top: "120px",
            bottom: "auto",
          })
        )
      case "relative":
        return (
          setFilterFacetsStyles({
            position: "relative",
          })
        )
      case "topFixed":
        return (
          setFilterFacetsStyles({
            position: "fixed",
            top: "114px",
            bottom: "auto",
          })
        )
      case "topAbsolute":
        return (
          setFilterFacetsStyles({
            position: "absolute",
            top: fixedPosition,
            bottom: "auto",
          })
        )
      case "bottomFixed":
        return (
          setFilterFacetsStyles({
            position: "fixed",
            top: "auto",
            bottom: "20px",
          })
        )
      case "bottomAbsolute":
        return (
          setFilterFacetsStyles({
            position: "absolute",
            top: "auto",
            bottom: "0px",
          })
        )
      default:
        return (
          setFilterFacetsStyles({
            position: "relative",
          })
        )
    }
  }, [styleType]);

  const [limit, setLimit] = useState<number>(5);
  const [isShowMore, setIsShowMore] = useState<boolean>(false);
  const handleShowMore = () => {
    if (filterIndustryFacetsData) {
      setIsShowMore(true);
      setLimit(Object.keys(filterIndustryFacetsData).length);
    }
  }

  const [isDisplayFilterFacets, setIsDisplayFilterFacets] = useState<boolean>(false);
  function filterFacetsButton() {
    if (isDisplayFilterFacets) {
      setIsDisplayFilterFacets(false);
    } else {
      setIsDisplayFilterFacets(true);
    }
  }

  // ハンドラー関数 (フィルタ・ファセット／条件変更時)
  const onChangeFacetCond = async () => {
    // 検索中は多重検索・クリックを防止
    if (isSearching) {
        return;
    }
    // setIsSearching(true); // 検索中フラグON
    await handleGetFacetCount(true);
  };
  function callOnChangeFacetCond() {
    // フィルタ・ファセットの表示中のみ有効
    if (isViewFacet && !isSessionLoading) {
      onChangeFacetCond();
    }
  };
  useEffect(() => {
    // フィルタ・ファセットの表示中のみ有効
    if (isViewFacet && !isSessionLoading) {
      onChangeFacetCond();
    }
  }, [
    forNotationIndustryItems,     // 業種
    forNotationRegionItems,       // 地域
    businessContentsSearchMethod, // 事業内容
    freeWordSearchMethod,         // キーワード
    checkedEndOfFY,               // 決算月
    checkedGroup,                 // 企業グループ
    checkedOffice,                // 事業所
    checkedHaveOrNotHaveHomePage, // 企業URL
  ]);


  // ■フィルタ・ファセットの該当社数更新処理
  const handleGetFacetCount = async (isFromButtonClick: boolean) => {
    // 該当社数更新処理中である場合、キューに処理中フラグを追加
    pushQueueCountFacet();

    const industrialClass_code = Object.keys(forNotationIndustryItems).join(";");

    const newForNotationregionItems:string[] = [];
    const regionItems = Object.keys(forNotationRegionItems);
    regionItems.map((item:string) => {
      if (item.endsWith("tokyoSpecialWards")) {
        regionHierarchyMap["tokyoSpecialWards"].map((code:string)=> {
          newForNotationregionItems.push(item + ">" + code);
        });
      } else if (item.endsWith("tokyoNonSpecialWards")) {
        regionHierarchyMap["tokyoNonSpecialWards"].map((code:string)=> {
          newForNotationregionItems.push(item + ">" + code);
        });
      } else {
        newForNotationregionItems.push(item);
      }
    });
    const address_code = Array.from(new Set(newForNotationregionItems)).join(";");

    const getCurrentDateFormatted = (): string => {
      const date = new Date();
      const year = date.getFullYear();
      const month = ('0' + (date.getMonth() + 1)).slice(-2); // 月は0が1月なので+1
      return `${year}/${month}`;
    };
    let searchConditions:SearchConditions;

    if (isFromButtonClick || !currentResultSearchConditions) {
      searchConditions = {
        outputDate:getCurrentDateFormatted(),
        corporateName:corporateNameRef.current?.value ? corporateNameRef.current?.value : "",
        freeWord: formatFreeWordRequirementsForSaveSearchData(),
        freeWord1:freeWordFirstRef.current?.value ? freeWordFirstRef.current?.value: "",
        freeWord2:freeWordSecondRef.current?.value ? freeWordSecondRef.current?.value: "",
        freeWord3:freeWordThirdRef.current?.value ? freeWordThirdRef.current?.value: "",
        freeWord4:freeWordFourthRef.current?.value ? freeWordFourthRef.current?.value: "",
        freeWord5:freeWordFifthRef.current?.value ? freeWordFifthRef.current?.value: "",
        freeWord6:freeWordSixthRef.current?.value ? freeWordSixthRef.current?.value: "",
        industorialClass_code:industrialClass_code,
        address_code:address_code,
        detailParameter:formatDetailRequirementsForSaveSearchData(),
        flag:formatFlagRequirementsForSaveSearchData(),
        sortOrder: sortKey,
        ascending_DescendingOrder: ascDesc,
        displayCount: rowsPerPage.toString(),
        currentPageNumber: "1",
        businessKeywords:formatBusinessKeywordsRequirementsForSaveSearchData(),
        businessKeyword1:businessContentsFirstRef.current?.value ? businessContentsFirstRef.current?.value: "",
        businessKeyword2:businessContentsSecondRef.current?.value ? businessContentsSecondRef.current?.value: "",
        businessKeyword3:businessContentsThirdRef.current?.value ? businessContentsThirdRef.current?.value: "",
        businessKeyword4:businessContentsFourthRef.current?.value ? businessContentsFourthRef.current?.value: "",
        businessKeyword5:businessContentsFifthRef.current?.value ? businessContentsFifthRef.current?.value: "",
        businessKeyword6:businessContentsSixthRef.current?.value ? businessContentsSixthRef.current?.value: "",
        salesFrom:salesFromRef.current?.value ? salesFromRef.current?.value : "",
        salesTo:salesToRef.current?.value ? salesToRef.current?.value : "",
        numberOfEmployeesFrom:employeesNumFromRef.current?.value ? employeesNumFromRef.current?.value : "",
        numberOfEmployeesTo:employeesNumToRef.current?.value ? employeesNumToRef.current?.value : "",
        establishmentDateFrom:establishedFromRef.current?.value ? establishedFromRef.current?.value : "",
        establishmentDateTo:establishedToRef.current?.value ? establishedToRef.current?.value : "",
        captalStockFrom:capitalFromRef.current?.value ? capitalFromRef.current?.value : "",
        captalStockTo:capitalToRef.current?.value ? capitalToRef.current?.value : "",
        shareholders:shareholdersRef.current?.value ? shareholdersRef.current?.value : "",
        partners:partnersRef.current?.value ? partnersRef.current?.value : "",
        endOfFY:checkedEndOfFY.join(","),
        corporateGroupIsBelong:checkedGroup[0] ? "有" : "",
        officeIsExist:checkedOffice.join(","),
        tags: tagSearchCondList.length > 0 ? tagSearchCondList.join(",") : "",
      };
    } else {
      searchConditions = {
        outputDate:currentResultSearchConditions.outputDate,
        corporateName:currentResultSearchConditions.corporateName,
        freeWord:currentResultSearchConditions.freeWord,
        freeWord1:currentResultSearchConditions.freeWord1,
        freeWord2:currentResultSearchConditions.freeWord2,
        freeWord3:currentResultSearchConditions.freeWord3,
        freeWord4:currentResultSearchConditions.freeWord4,
        freeWord5:currentResultSearchConditions.freeWord5,
        freeWord6:currentResultSearchConditions.freeWord6,
        industorialClass_code:currentResultSearchConditions.industorialClass_code,
        address_code:currentResultSearchConditions.address_code,
        detailParameter:currentResultSearchConditions.detailParameter,
        flag:currentResultSearchConditions.flag,
        sortOrder: sortKey,
        ascending_DescendingOrder: ascDesc,
        displayCount: rowsPerPage.toString(),
        currentPageNumber: currentPage.toString(),
        businessKeywords:currentResultSearchConditions.businessKeywords,
        businessKeyword1:currentResultSearchConditions.businessKeyword1,
        businessKeyword2:currentResultSearchConditions.businessKeyword2,
        businessKeyword3:currentResultSearchConditions.businessKeyword3,
        businessKeyword4:currentResultSearchConditions.businessKeyword4,
        businessKeyword5:currentResultSearchConditions.businessKeyword5,
        businessKeyword6:currentResultSearchConditions.businessKeyword6,
        salesFrom:currentResultSearchConditions.salesFrom,
        salesTo:currentResultSearchConditions.salesTo,
        numberOfEmployeesFrom:currentResultSearchConditions.numberOfEmployeesFrom,
        numberOfEmployeesTo:currentResultSearchConditions.numberOfEmployeesTo,
        establishmentDateFrom:currentResultSearchConditions.establishmentDateFrom,
        establishmentDateTo:currentResultSearchConditions.establishmentDateTo,
        captalStockFrom:currentResultSearchConditions.captalStockFrom,
        captalStockTo:currentResultSearchConditions.captalStockTo,
        shareholders:currentResultSearchConditions.shareholders,
        partners:currentResultSearchConditions.partners,
        endOfFY:currentResultSearchConditions.endOfFY,
        corporateGroupIsBelong:currentResultSearchConditions.corporateGroupIsBelong,
        officeIsExist:currentResultSearchConditions.officeIsExist,
        tags: currentResultSearchConditions.tags,
      };
    }

    // トークンが読み込めていない時は処理を中断
    if (!tokenInfo) {
      // 該当社数更新処理中キューの制御
      shiftQueueCountFacet();
      return;
    }

    // 検索処理開始時すべてのエラーメッセージ、成功メッセージをリセットする
    setSuccessMessage("");
    setErrorMessage1("");
    setErrorMessage2("");
    setErrorMessage3("");

    // 桁数チェックのための整形
    const  inputInfo: CheckDegitRecordType = {
      inputInfo: [
        { itemName: "corporateName", inputText: searchConditions.corporateName, limitNumberOfDigit: 150 },
        { itemName: "freeWord1", inputText: searchConditions.freeWord1, limitNumberOfDigit: 200 },
        { itemName: "freeWord2", inputText: searchConditions.freeWord2, limitNumberOfDigit: 200 },
        { itemName: "freeWord3", inputText: searchConditions.freeWord3, limitNumberOfDigit: 200 },
        { itemName: "freeWord4", inputText: searchConditions.freeWord4, limitNumberOfDigit: 200 },
        { itemName: "freeWord5", inputText: searchConditions.freeWord5, limitNumberOfDigit: 200 },
        { itemName: "freeWord6", inputText: searchConditions.freeWord6, limitNumberOfDigit: 200 },
        { itemName: "businessKeyword1", inputText: searchConditions.businessKeyword1, limitNumberOfDigit: 200 },
        { itemName: "businessKeyword2", inputText: searchConditions.businessKeyword2, limitNumberOfDigit: 200 },
        { itemName: "businessKeyword3", inputText: searchConditions.businessKeyword3, limitNumberOfDigit: 200 },
        { itemName: "businessKeyword4", inputText: searchConditions.businessKeyword4, limitNumberOfDigit: 200 },
        { itemName: "businessKeyword5", inputText: searchConditions.businessKeyword5, limitNumberOfDigit: 200 },
        { itemName: "businessKeyword6", inputText: searchConditions.businessKeyword6, limitNumberOfDigit: 200 },
        { itemName: "salesFrom", inputText: searchConditions.salesFrom.toString(), limitNumberOfDigit: 150 },
        { itemName: "salesTo", inputText: searchConditions.salesTo.toString(), limitNumberOfDigit: 150 },
        { itemName: "numberOfEmployeesFrom", inputText: searchConditions.numberOfEmployeesFrom.toString(), limitNumberOfDigit: 8 },
        { itemName: "numberOfEmployeesTo", inputText: searchConditions.numberOfEmployeesTo.toString(), limitNumberOfDigit: 8 },
        { itemName: "establishmentDateFrom", inputText: searchConditions.establishmentDateFrom.toString(), limitNumberOfDigit: 4 },
        { itemName: "establishmentDateTo", inputText: searchConditions.establishmentDateTo.toString(), limitNumberOfDigit: 4 },
        { itemName: "captalStockFrom", inputText: searchConditions.captalStockFrom.toString(), limitNumberOfDigit: 15 },
        { itemName: "captalStockTo", inputText: searchConditions.captalStockTo.toString(), limitNumberOfDigit: 15 },
        { itemName: "shareholders", inputText: searchConditions.shareholders.toString(), limitNumberOfDigit: 150 },
        { itemName: "partners", inputText: searchConditions.partners.toString(), limitNumberOfDigit: 150 },
      ]
    };
    // 入力桁数チェック
    const degitResult: CheckDegitResult[] = await callCheckDegit(inputInfo);
    const errorMessages = degitResult
    .filter(result => !result.checkResult)
    .map(result => result.message);
    if (errorMessages.length > 0) {
      // 該当社数更新処理中キューの制御
      shiftQueueCountFacet();
      // 一番目のエラーメッセージを表示
      setErrorMessage2(errorMessages[0]);
      return;
    }

    // 属性(数値)チェック
    if (!validateSearchConditions(searchConditions)) {
      // 該当社数更新処理中キューの制御
      shiftQueueCountFacet();
      // エラーメッセージを設定し、処理を中断
      return;
    }

    //範囲チェックFROM,TO
    const sales = validateRange(searchConditions.salesFrom, searchConditions.salesTo);
    if (!sales) {
      // 該当社数更新処理中キューの制御
      shiftQueueCountFacet();
      return;
    }
    const employees = validateRange(searchConditions.numberOfEmployeesFrom, searchConditions.numberOfEmployeesTo);
    if (!employees) {
      // 該当社数更新処理中キューの制御
      shiftQueueCountFacet();
      return;
    }
    const establishment = validateRange(searchConditions.establishmentDateFrom, searchConditions.establishmentDateTo);
    if (!establishment) {
      // 該当社数更新処理中キューの制御
      shiftQueueCountFacet();
      return;
    }
    const captalStock = validateRange(searchConditions.captalStockFrom, searchConditions.captalStockTo);
    if (!captalStock) {
      // 該当社数更新処理中キューの制御
      shiftQueueCountFacet();
      return;
    }
    // エラーがある場合はここで処理を中断
    await callGetFacetCount(searchConditions);

    if (isFromButtonClick || !currentResultSearchConditions) {
      setCurrentResultSearchConditions(searchConditions);
    }
    // 該当社数更新処理中キューの制御
    shiftQueueCountFacet();
  };
  const pushQueueCountFacet = () => {
    // 該当社数更新処理中である場合、キューに処理中フラグを追加
    queueCountFacet.push(true);
    setIsGetFacetCountSearching(true);
  };
  const shiftQueueCountFacet = () => {
    // 該当社数更新処理中キューの制御
    queueCountFacet.shift();
    if (queueCountFacet.length === 0) {
      setIsGetFacetCountSearching(false);
    }
  };

  const callGetFacetCount = async (record: SearchHomeType) => {
    try {
      const { idToken } = await getTokens();
      const baseUrl = process.env.REACT_APP_API_BASE_URL || '';
      const path = '/event/getfacetcount';
      const apipath = baseUrl.concat(path);
      const response = await fetch(apipath, {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${idToken}`, // IDトークンをヘッダーに設定
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(record)
      });

      if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
      }
      const responseData = await response.json();
      // レスポンスから該当社数を取得
      const hitCount = responseData['bodyHitcount'];
      // 該当社数に反映
      setFacetCount(hitCount);

      // 検索が成功すればエラーメッセージは非表示にする
      setErrorMessage1("");
      setErrorMessage2("");
      setErrorMessage3("");

    } catch (error) {
      // setIsSearching(false); // 検索中フラグOFF
      console.error("エラー:", error);
      setErrorMessage3("処理中にエラーが発生しました。もう一度お試し下さい。");
    }
    // // 多重検索・クリックを防止解除
    // setIsSearching(false); // 検索中フラグOFF
  };


  const [isTagButtonClick, setIsTagButtonClick] = useState<boolean>(false);
  // ハンドラー関数 (タグ検索／新たに探すボタン押下時)
  const handleSearchTagNewWithClick = async () => {
    // 検索中は多重検索・クリックを防止
    if (isSearching) {
        return;
    }
    setIsSearching(true); // 検索中フラグON
    setIsSearchTagNewSearching(true); // タグ検索中フラグON
    setCurrentPage(1);
    setIsTagButtonClick(true);
    // 選択中のタグを検索条件として確定させる
    setTagSearchCondList(tagSearchList);
    // await handleSearchTagNew(true);
  };
  // 条件としてタグを確定後、非同期で検索実行
  useEffect(() => {
    // タグ検索中のみ有効
    if (isSearchTagNewSearching) {
      setIsSearchTagNewSearching(false); // タグ検索中フラグOFF

      const executeHandleSearchTagNew = async () => {
        await handleSearchTagNew(true);

        // 検索条件をキャッシュに保存
        handleConditionSet();
        saveState();
      };
      executeHandleSearchTagNew();
      setIsTagButtonClick(false);
    }
  }, [tagSearchCondList, isTagButtonClick]);

  // ■タグ検索／新たに探すボタン検索処理
  const handleSearchTagNew = async (isFromButtonClick: boolean) => {

    // 通常の検索条件をクリアする
    clearSearchRequirements();
    // フィルタ・ファセット検索条件をクリアする
    clearFacetSearchRequirements();

    const getCurrentDateFormatted = (): string => {
      const date = new Date();
      const year = date.getFullYear();
      const month = ('0' + (date.getMonth() + 1)).slice(-2); // 月は0が1月なので+1
      return `${year}/${month}`;
    };

    let searchConditions:SearchConditions;
    if (isFromButtonClick || !currentResultSearchConditions) {
      searchConditions = {
        outputDate: getCurrentDateFormatted(),
        corporateName: "",
        freeWord: "",
        freeWord1: "",
        freeWord2: "",
        freeWord3: "",
        freeWord4: "",
        freeWord5: "",
        freeWord6: "",
        industorialClass_code: "",
        address_code: "",
        detailParameter: formatDetailRequirementsForSaveSearchData(),
        flag: formatFlagRequirementsForSaveSearchData(),
        sortOrder: sortKey,
        ascending_DescendingOrder: ascDesc,
        displayCount: rowsPerPage.toString(),
        currentPageNumber: "1",
        businessKeywords: "",
        businessKeyword1: "",
        businessKeyword2: "",
        businessKeyword3: "",
        businessKeyword4: "",
        businessKeyword5: "",
        businessKeyword6: "",
        salesFrom: "",
        salesTo: "",
        numberOfEmployeesFrom: "",
        numberOfEmployeesTo: "",
        establishmentDateFrom: "",
        establishmentDateTo: "",
        captalStockFrom: "",
        captalStockTo: "",
        shareholders: "",
        partners: "",
        endOfFY: "",
        corporateGroupIsBelong: "",
        officeIsExist: "",
        tags: tagSearchCondList.length > 0 ? tagSearchCondList.join(",") : "",
      };
    } else {
      searchConditions = {
        outputDate:currentResultSearchConditions.outputDate,
        corporateName:currentResultSearchConditions.corporateName,
        freeWord:currentResultSearchConditions.freeWord,
        freeWord1:currentResultSearchConditions.freeWord1,
        freeWord2:currentResultSearchConditions.freeWord2,
        freeWord3:currentResultSearchConditions.freeWord3,
        freeWord4:currentResultSearchConditions.freeWord4,
        freeWord5:currentResultSearchConditions.freeWord5,
        freeWord6:currentResultSearchConditions.freeWord6,
        industorialClass_code:currentResultSearchConditions.industorialClass_code,
        address_code:currentResultSearchConditions.address_code,
        detailParameter:currentResultSearchConditions.detailParameter,
        flag:currentResultSearchConditions.flag,
        sortOrder: sortKey,
        ascending_DescendingOrder: ascDesc,
        displayCount: rowsPerPage.toString(),
        currentPageNumber: currentPage.toString(),
        businessKeywords:currentResultSearchConditions.businessKeywords,
        businessKeyword1:currentResultSearchConditions.businessKeyword1,
        businessKeyword2:currentResultSearchConditions.businessKeyword2,
        businessKeyword3:currentResultSearchConditions.businessKeyword3,
        businessKeyword4:currentResultSearchConditions.businessKeyword4,
        businessKeyword5:currentResultSearchConditions.businessKeyword5,
        businessKeyword6:currentResultSearchConditions.businessKeyword6,
        salesFrom:currentResultSearchConditions.salesFrom,
        salesTo:currentResultSearchConditions.salesTo,
        numberOfEmployeesFrom:currentResultSearchConditions.numberOfEmployeesFrom,
        numberOfEmployeesTo:currentResultSearchConditions.numberOfEmployeesTo,
        establishmentDateFrom:currentResultSearchConditions.establishmentDateFrom,
        establishmentDateTo:currentResultSearchConditions.establishmentDateTo,
        captalStockFrom:currentResultSearchConditions.captalStockFrom,
        captalStockTo:currentResultSearchConditions.captalStockTo,
        shareholders:currentResultSearchConditions.shareholders,
        partners:currentResultSearchConditions.partners,
        endOfFY:currentResultSearchConditions.endOfFY,
        corporateGroupIsBelong:currentResultSearchConditions.corporateGroupIsBelong,
        officeIsExist:currentResultSearchConditions.officeIsExist,
        tags: currentResultSearchConditions.tags,
      };
    }

    // トークンが読み込めていない時は処理を中断
    if (!tokenInfo) {
      setIsSearching(false); // 検索中フラグOFF
      return;
    }

    // 検索処理開始時すべてのエラーメッセージ、成功メッセージをリセットする
    setSuccessMessage("");
    setErrorMessage1("");
    setErrorMessage2("");
    setErrorMessage3("");

    // バックエンド処理を呼び出す
    await callSearchTagNew(searchConditions, isFromButtonClick);
    // CSVダウンロード用検索条件保存（即時反映させるためgetSearchFilterは使用しない）
    const csvDlSearchFilterRecord : SearchFilter  = {
      corporateName: "",
      freeWord: "",
      industorialClass: "",
      address: "",
      businessKeywords: "",
      detailParameter: searchConditions.detailParameter,
      flag: "",
      numberOfCorporate: dataCount,
      comments: "",
    };
    setSearchFilterRecord(csvDlSearchFilterRecord);

    if (isFromButtonClick || !currentResultSearchConditions) {
      setCurrentResultSearchConditions(searchConditions);
    }

    // 検索条件をキャッシュに保存
    handleConditionSet();
    saveState();

    // 検索結果へスクロール
    if (searchConditionRef.current) {
      const top = searchConditionRef.current.getBoundingClientRect().top + window.scrollY - 120;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  const callSearchTagNew = async (record:SearchHomeType, isFromButtonClick:boolean) => {
    try {
      const { idToken } = await getTokens();
      const baseUrl = process.env.REACT_APP_API_BASE_URL || '';
      const path = '/event/searchtagnew';
      const apipath = baseUrl.concat(path);
      const response = await fetch(apipath, {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${idToken}`, // IDトークンをヘッダーに設定
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(record)
      });

      if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
      }
      const responseData = await response.json();
      // レスポンスから表示用データと企業番号一覧を取得
      const searchedData = responseData['bodyVsearch'];
      const corporateNumData = responseData['corporateNumberList'];
      if (searchedData.length === 0) {
        setErrorMessage3("指定された検索条件に一致する結果がありませんでした。");
        // 検索結果に空のリストをセット
        setTableData([]);
        // 検索結果数は0件をセット
        setDataCount(0);
        setFacetCount(0);
        setIsViewFacet(false);

        setCorporateNumList([]);
      } else {

        const formattedData = searchedData.map((item:ResponseDataItem) => ({
            max_search_data_limit: item.max_search_data_limit,
            cnt_corporateNumber: item.cnt_corporateNumber,
            cnt_corporateNumber_limitplus1: item.cnt_corporateNumber_limitplus1,
            corporateName: item.corporateName,
            corporateNumber: item.corporateNumber,
            headquarterAddress: item.headquarterAddress,
            industorialClass_large: item.industorialClass_large,
            captalStock: item.captalStock,
            numberOfEmployees: item.numberOfEmployees,
            flag1: item.flag1,
            flag2: item.flag2,
            flag3: item.flag3,
            flag4: item.flag4,
            flag5: item.flag5,
            flag6: item.flag6,
        }));

        // 検索結果の表示範囲のセット
        setTableData(formattedData);
        setDataCount(formattedData[0].cnt_corporateNumber);
        setFacetCount(formattedData[0].cnt_corporateNumber);
        setIsViewFacet(formattedData[0].cnt_corporateNumber > 0);
        // 検索結果の企業番号一覧のセット
        if(!isEqualArray(corporateNumData, corporateNumList)){
          setCorporateNumList(corporateNumData);
        }
        // // タグ生成APIの呼び出し
        // callGenerateTags(searchedData);
        // setIsGeneratingTags(true); // タグ生成中フラグON
        // 検索が成功すればエラーメッセージは非表示にする
        setErrorMessage1("");
        setErrorMessage2("");
        setErrorMessage3("");
        // 件数が3000件の場合はメッセージを表示(中断はしない)
        const maxSearchDataLimit = formattedData[0].max_search_data_limit;
        if(formattedData[0].cnt_corporateNumber_limitplus1 > maxSearchDataLimit){
          setErrorMessage3(`検索結果が${maxSearchDataLimit}件を超えました。先頭の${maxSearchDataLimit}件までを表示します。`);
        }
      }
      if (isFromButtonClick) {
          setIsSearchClicked(false);
          setIsSearchFacetClicked(false);
          setIsSearchTagFilterClicked(false);
          setIsSearchTagNewClicked(true);
      }

      // フィルタファセット用項目データ
      const facetConditionsData = responseData['facetConditions'];
      settingFilterFacetData(facetConditionsData);
    } catch (error) {
      setIsSearching(false); // 検索中フラグOFF
      console.error("エラー:", error);
      setErrorMessage3("処理中にエラーが発生しました。もう一度お試し下さい。");
    }
    // 多重検索・クリックを防止解除
    setIsSearching(false); // 検索中フラグOFF
  };


  // ハンドラー関数 (タグ検索／絞込みボタン押下時)
  const handleSearchTagFilterWithClick = async () => {
    // 検索中は多重検索・クリックを防止
    if (isSearching) {
        return;
    }
    setIsSearching(true); // 検索中フラグON
    setIsSearchTagFilterSearching(true); // タグ検索中フラグON
    setCurrentPage(1);
    setIsTagButtonClick(true);
    // 選択中のタグを検索条件として確定させる
    setTagSearchCondList(tagSearchList);
    // await handleSearchTagFilter(true);
  };
  // 条件としてタグを確定後、非同期で検索実行
  useEffect(() => {
    // タグ検索中のみ有効
    if (isSearchTagFilterSearching) {
      setIsSearchTagFilterSearching(false); // タグ検索中フラグOFF

      const executeHandleSearchTagFilter = async () => {
        await handleSearchTagFilter(true);

        // 検索条件をキャッシュに保存
        handleConditionSet();
        saveState();
      };
      executeHandleSearchTagFilter();
      setIsTagButtonClick(false);
    }
  }, [tagSearchCondList, isTagButtonClick]);

  // ■タグ検索／絞込みボタン検索処理
  const handleSearchTagFilter = async (isFromButtonClick: boolean) => {

    const industrialClass_code = Object.keys(forNotationIndustryItems).join(";");

    const newForNotationregionItems:string[] = [];
    const regionItems = Object.keys(forNotationRegionItems);
    regionItems.map((item:string) => {
      if (item.endsWith("tokyoSpecialWards")) {
        regionHierarchyMap["tokyoSpecialWards"].map((code:string)=> {
          newForNotationregionItems.push(item + ">" + code);
        });
      } else if (item.endsWith("tokyoNonSpecialWards")) {
        regionHierarchyMap["tokyoNonSpecialWards"].map((code:string)=> {
          newForNotationregionItems.push(item + ">" + code);
        });
      } else {
        newForNotationregionItems.push(item);
      }
    });
    const address_code = Array.from(new Set(newForNotationregionItems)).join(";");

    const getCurrentDateFormatted = (): string => {
      const date = new Date();
      const year = date.getFullYear();
      const month = ('0' + (date.getMonth() + 1)).slice(-2); // 月は0が1月なので+1
      return `${year}/${month}`;
    };

    let searchConditions:SearchConditions;
    if (isFromButtonClick || !currentResultSearchConditions) {
      searchConditions = {
        outputDate:getCurrentDateFormatted(),
        corporateName:corporateNameRef.current?.value ? corporateNameRef.current?.value : "",
        freeWord: formatFreeWordRequirementsForSaveSearchData(),
        freeWord1:freeWordFirstRef.current?.value ? freeWordFirstRef.current?.value: "",
        freeWord2:freeWordSecondRef.current?.value ? freeWordSecondRef.current?.value: "",
        freeWord3:freeWordThirdRef.current?.value ? freeWordThirdRef.current?.value: "",
        freeWord4:freeWordFourthRef.current?.value ? freeWordFourthRef.current?.value: "",
        freeWord5:freeWordFifthRef.current?.value ? freeWordFifthRef.current?.value: "",
        freeWord6:freeWordSixthRef.current?.value ? freeWordSixthRef.current?.value: "",
        industorialClass_code:industrialClass_code,
        address_code:address_code,
        detailParameter:formatDetailRequirementsForSaveSearchData(),
        flag:formatFlagRequirementsForSaveSearchData(),
        sortOrder: sortKey,
        ascending_DescendingOrder: ascDesc,
        displayCount: rowsPerPage.toString(),
        currentPageNumber: "1",
        businessKeywords:formatBusinessKeywordsRequirementsForSaveSearchData(),
        businessKeyword1:businessContentsFirstRef.current?.value ? businessContentsFirstRef.current?.value: "",
        businessKeyword2:businessContentsSecondRef.current?.value ? businessContentsSecondRef.current?.value: "",
        businessKeyword3:businessContentsThirdRef.current?.value ? businessContentsThirdRef.current?.value: "",
        businessKeyword4:businessContentsFourthRef.current?.value ? businessContentsFourthRef.current?.value: "",
        businessKeyword5:businessContentsFifthRef.current?.value ? businessContentsFifthRef.current?.value: "",
        businessKeyword6:businessContentsSixthRef.current?.value ? businessContentsSixthRef.current?.value: "",
        salesFrom:salesFromRef.current?.value ? salesFromRef.current?.value : "",
        salesTo:salesToRef.current?.value ? salesToRef.current?.value : "",
        numberOfEmployeesFrom:employeesNumFromRef.current?.value ? employeesNumFromRef.current?.value : "",
        numberOfEmployeesTo:employeesNumToRef.current?.value ? employeesNumToRef.current?.value : "",
        establishmentDateFrom:establishedFromRef.current?.value ? establishedFromRef.current?.value : "",
        establishmentDateTo:establishedToRef.current?.value ? establishedToRef.current?.value : "",
        captalStockFrom:capitalFromRef.current?.value ? capitalFromRef.current?.value : "",
        captalStockTo:capitalToRef.current?.value ? capitalToRef.current?.value : "",
        shareholders:shareholdersRef.current?.value ? shareholdersRef.current?.value : "",
        partners:partnersRef.current?.value ? partnersRef.current?.value : "",
        endOfFY:checkedEndOfFY.join(","),
        corporateGroupIsBelong:checkedGroup[0] ? "有" : "",
        officeIsExist:checkedOffice.join(","),
        tags: tagSearchCondList.length > 0 ? tagSearchCondList.join(",") : "",
      };
    } else {
      searchConditions = {
        outputDate:currentResultSearchConditions.outputDate,
        corporateName:currentResultSearchConditions.corporateName,
        freeWord:currentResultSearchConditions.freeWord,
        freeWord1:currentResultSearchConditions.freeWord1,
        freeWord2:currentResultSearchConditions.freeWord2,
        freeWord3:currentResultSearchConditions.freeWord3,
        freeWord4:currentResultSearchConditions.freeWord4,
        freeWord5:currentResultSearchConditions.freeWord5,
        freeWord6:currentResultSearchConditions.freeWord6,
        industorialClass_code:currentResultSearchConditions.industorialClass_code,
        address_code:currentResultSearchConditions.address_code,
        detailParameter:currentResultSearchConditions.detailParameter,
        flag:currentResultSearchConditions.flag,
        sortOrder: sortKey,
        ascending_DescendingOrder: ascDesc,
        displayCount: rowsPerPage.toString(),
        currentPageNumber: currentPage.toString(),
        businessKeywords:currentResultSearchConditions.businessKeywords,
        businessKeyword1:currentResultSearchConditions.businessKeyword1,
        businessKeyword2:currentResultSearchConditions.businessKeyword2,
        businessKeyword3:currentResultSearchConditions.businessKeyword3,
        businessKeyword4:currentResultSearchConditions.businessKeyword4,
        businessKeyword5:currentResultSearchConditions.businessKeyword5,
        businessKeyword6:currentResultSearchConditions.businessKeyword6,
        salesFrom:currentResultSearchConditions.salesFrom,
        salesTo:currentResultSearchConditions.salesTo,
        numberOfEmployeesFrom:currentResultSearchConditions.numberOfEmployeesFrom,
        numberOfEmployeesTo:currentResultSearchConditions.numberOfEmployeesTo,
        establishmentDateFrom:currentResultSearchConditions.establishmentDateFrom,
        establishmentDateTo:currentResultSearchConditions.establishmentDateTo,
        captalStockFrom:currentResultSearchConditions.captalStockFrom,
        captalStockTo:currentResultSearchConditions.captalStockTo,
        shareholders:currentResultSearchConditions.shareholders,
        partners:currentResultSearchConditions.partners,
        endOfFY:currentResultSearchConditions.endOfFY,
        corporateGroupIsBelong:currentResultSearchConditions.corporateGroupIsBelong,
        officeIsExist:currentResultSearchConditions.officeIsExist,
        tags: currentResultSearchConditions.tags,
      };
    }

    // トークンが読み込めていない時は処理を中断
    if (!tokenInfo) {
      setIsSearching(false); // 検索中フラグOFF
      return;
    }

    // 検索処理開始時すべてのエラーメッセージ、成功メッセージをリセットする
    setSuccessMessage("");
    setErrorMessage1("");
    setErrorMessage2("");
    setErrorMessage3("");

    // 桁数チェックのための整形
    const  inputInfo: CheckDegitRecordType = {
      inputInfo: [
        { itemName: "corporateName", inputText: searchConditions.corporateName, limitNumberOfDigit: 150 },
        { itemName: "freeWord1", inputText: searchConditions.freeWord1, limitNumberOfDigit: 200 },
        { itemName: "freeWord2", inputText: searchConditions.freeWord2, limitNumberOfDigit: 200 },
        { itemName: "freeWord3", inputText: searchConditions.freeWord3, limitNumberOfDigit: 200 },
        { itemName: "freeWord4", inputText: searchConditions.freeWord4, limitNumberOfDigit: 200 },
        { itemName: "freeWord5", inputText: searchConditions.freeWord5, limitNumberOfDigit: 200 },
        { itemName: "freeWord6", inputText: searchConditions.freeWord6, limitNumberOfDigit: 200 },
        { itemName: "businessKeyword1", inputText: searchConditions.businessKeyword1, limitNumberOfDigit: 200 },
        { itemName: "businessKeyword2", inputText: searchConditions.businessKeyword2, limitNumberOfDigit: 200 },
        { itemName: "businessKeyword3", inputText: searchConditions.businessKeyword3, limitNumberOfDigit: 200 },
        { itemName: "businessKeyword4", inputText: searchConditions.businessKeyword4, limitNumberOfDigit: 200 },
        { itemName: "businessKeyword5", inputText: searchConditions.businessKeyword5, limitNumberOfDigit: 200 },
        { itemName: "businessKeyword6", inputText: searchConditions.businessKeyword6, limitNumberOfDigit: 200 },
        { itemName: "salesFrom", inputText: searchConditions.salesFrom.toString(), limitNumberOfDigit: 150 },
        { itemName: "salesTo", inputText: searchConditions.salesTo.toString(), limitNumberOfDigit: 150 },
        { itemName: "numberOfEmployeesFrom", inputText: searchConditions.numberOfEmployeesFrom.toString(), limitNumberOfDigit: 8 },
        { itemName: "numberOfEmployeesTo", inputText: searchConditions.numberOfEmployeesTo.toString(), limitNumberOfDigit: 8 },
        { itemName: "establishmentDateFrom", inputText: searchConditions.establishmentDateFrom.toString(), limitNumberOfDigit: 4 },
        { itemName: "establishmentDateTo", inputText: searchConditions.establishmentDateTo.toString(), limitNumberOfDigit: 4 },
        { itemName: "captalStockFrom", inputText: searchConditions.captalStockFrom.toString(), limitNumberOfDigit: 15 },
        { itemName: "captalStockTo", inputText: searchConditions.captalStockTo.toString(), limitNumberOfDigit: 15 },
        { itemName: "shareholders", inputText: searchConditions.shareholders.toString(), limitNumberOfDigit: 150 },
        { itemName: "partners", inputText: searchConditions.partners.toString(), limitNumberOfDigit: 150 },
      ]
    };
    // 入力桁数チェック
    const degitResult: CheckDegitResult[] = await callCheckDegit(inputInfo);
    const errorMessages = degitResult
    .filter(result => !result.checkResult)
    .map(result => result.message);
    if (errorMessages.length > 0) {
      setIsSearching(false); // 検索中フラグOFF
      // 一番目のエラーメッセージを表示
      setErrorMessage2(errorMessages[0]);
      return;
    }

    // 属性(数値)チェック
    if (!validateSearchConditions(searchConditions)) {
      setIsSearching(false); // 検索中フラグOFF
      // エラーメッセージを設定し、処理を中断
      return;
    }

    //範囲チェックFROM,TO
    const sales = validateRange(searchConditions.salesFrom, searchConditions.salesTo);
    if (!sales) {
      setIsSearching(false); // 検索中フラグOFF
      return;
    }
    const employees = validateRange(searchConditions.numberOfEmployeesFrom, searchConditions.numberOfEmployeesTo);
    if (!employees) {
      setIsSearching(false); // 検索中フラグOFF
      return;
    }
    const establishment = validateRange(searchConditions.establishmentDateFrom, searchConditions.establishmentDateTo);
    if (!establishment) {
      setIsSearching(false); // 検索中フラグOFF
      return;
    }
    const captalStock = validateRange(searchConditions.captalStockFrom, searchConditions.captalStockTo);
    if (!captalStock) {
      setIsSearching(false); // 検索中フラグOFF
      return;
    }
    // エラーがある場合はここで処理を中断
    await callSearchTagFilter(searchConditions, isFromButtonClick);
    // CSVダウンロード用検索条件保存
    getSearchFilter()

    if (isFromButtonClick || !currentResultSearchConditions) {
      setCurrentResultSearchConditions(searchConditions);
    }

    // 検索条件をキャッシュに保存
    handleConditionSet();
    saveState();

    // 検索結果へスクロール
    if (searchConditionRef.current) {
      const top = searchConditionRef.current.getBoundingClientRect().top + window.scrollY - 120;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  const callSearchTagFilter = async (record:SearchHomeType, isFromButtonClick:boolean) => {
    try {
      const { idToken } = await getTokens();
      const baseUrl = process.env.REACT_APP_API_BASE_URL || '';
      const path = '/event/searchtagfilter';
      const apipath = baseUrl.concat(path);
      const response = await fetch(apipath, {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${idToken}`, // IDトークンをヘッダーに設定
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(record)
      });

      if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
      }
      const responseData = await response.json();
      // レスポンスから表示用データと企業番号一覧を取得
      const searchedData = responseData['bodyVsearch'];
      const corporateNumData = responseData['corporateNumberList'];
      if (searchedData.length === 0) {
        setErrorMessage3("指定された検索条件に一致する結果がありませんでした。");
        // 検索結果に空のリストをセット
        setTableData([]);
        // 検索結果数は0件をセット
        setDataCount(0);
        setFacetCount(0);
        setIsViewFacet(false);

        setCorporateNumList([]);
      } else {

        const formattedData = searchedData.map((item:ResponseDataItem) => ({
            max_search_data_limit: item.max_search_data_limit,
            cnt_corporateNumber: item.cnt_corporateNumber,
            cnt_corporateNumber_limitplus1: item.cnt_corporateNumber_limitplus1,
            corporateName: item.corporateName,
            corporateNumber: item.corporateNumber,
            headquarterAddress: item.headquarterAddress,
            industorialClass_large: item.industorialClass_large,
            captalStock: item.captalStock,
            numberOfEmployees: item.numberOfEmployees,
            flag1: item.flag1,
            flag2: item.flag2,
            flag3: item.flag3,
            flag4: item.flag4,
            flag5: item.flag5,
            flag6: item.flag6,
        }));

        // 検索結果の表示範囲のセット
        setTableData(formattedData);
        setDataCount(formattedData[0].cnt_corporateNumber);
        setFacetCount(formattedData[0].cnt_corporateNumber);
        setIsViewFacet(formattedData[0].cnt_corporateNumber > 0);
        // 検索結果の企業番号一覧のセット
        if(!isEqualArray(corporateNumData, corporateNumList)){
          setCorporateNumList(corporateNumData);
        }
        // // タグ生成APIの呼び出し
        // callGenerateTags(searchedData);
        // setIsGeneratingTags(true); // タグ生成中フラグON
        // 検索が成功すればエラーメッセージは非表示にする
        setErrorMessage1("");
        setErrorMessage2("");
        setErrorMessage3("");
        // 件数が3000件の場合はメッセージを表示(中断はしない)
        const maxSearchDataLimit = formattedData[0].max_search_data_limit;
        if(formattedData[0].cnt_corporateNumber_limitplus1 > maxSearchDataLimit){
          setErrorMessage3(`検索結果が${maxSearchDataLimit}件を超えました。先頭の${maxSearchDataLimit}件までを表示します。`);
        }
      }
      if (isFromButtonClick) {
          setIsSearchClicked(false);
          setIsSearchFacetClicked(false);
          setIsSearchTagFilterClicked(true);
          setIsSearchTagNewClicked(false);
      }

      // フィルタファセット用項目データ
      const facetConditionsData = responseData['facetConditions'];
      settingFilterFacetData(facetConditionsData, true);
    } catch (error) {
      setIsSearching(false); // 検索中フラグOFF
      console.error("エラー:", error);
      setErrorMessage3("処理中にエラーが発生しました。もう一度お試し下さい。");
    }
    // 多重検索・クリックを防止解除
    setIsSearching(false); // 検索中フラグOFF
  };

  // ハンドラー関数 (フィルタ・ファセット検索ボタン押下時)
  const handleSearchFacetWithClick = async () => {
    // 検索中は多重検索・クリックを防止
    if (isSearching) {
        return;
    }
    setIsSearching(true); // 検索中フラグON
    setIsSearchFacetSearching(true); // ファセット検索中フラグON
    setCurrentPage(1);
    // 選択中のタグを検索条件として確定させる
    setTagSearchCondList(tagSearchList);
    // await handleSearchTagFilter(true);
  };
  // 条件としてタグを確定後、非同期で検索実行
  useEffect(() => {
    // フィルタファセット検索中のみ有効
    if (isSearchFacetSearching) {
      setIsSearchFacetSearching(false); // ファセット検索中フラグOFF

      const executeHandleSearchFacet = async () => {
        await handleSearchFacet(true);

        // 検索条件をキャッシュに保存
        handleConditionSet();
        saveState();
      };
      executeHandleSearchFacet();
    }
  }, [tagSearchCondList, isSearchFacetSearching]);

  // ■フィルタ・ファセット検索処理
  const handleSearchFacet = async (isFromButtonClick: boolean) => {

    const industrialClass_code = Object.keys(forNotationIndustryItems).join(";");

    const newForNotationregionItems:string[] = [];
    const regionItems = Object.keys(forNotationRegionItems);
    regionItems.map((item:string) => {
      if (item.endsWith("tokyoSpecialWards")) {
        regionHierarchyMap["tokyoSpecialWards"].map((code:string)=> {
          newForNotationregionItems.push(item + ">" + code);
        });
      } else if (item.endsWith("tokyoNonSpecialWards")) {
        regionHierarchyMap["tokyoNonSpecialWards"].map((code:string)=> {
          newForNotationregionItems.push(item + ">" + code);
        });
      } else {
        newForNotationregionItems.push(item);
      }
    });
    const address_code = Array.from(new Set(newForNotationregionItems)).join(";");

    const getCurrentDateFormatted = (): string => {
      const date = new Date();
      const year = date.getFullYear();
      const month = ('0' + (date.getMonth() + 1)).slice(-2); // 月は0が1月なので+1
      return `${year}/${month}`;
    };

    let searchConditions:SearchConditions;
    if (isFromButtonClick || !currentResultSearchConditions) {
      searchConditions = {
        outputDate:getCurrentDateFormatted(),
        corporateName:corporateNameRef.current?.value ? corporateNameRef.current?.value : "",
        freeWord: formatFreeWordRequirementsForSaveSearchData(),
        freeWord1:freeWordFirstRef.current?.value ? freeWordFirstRef.current?.value: "",
        freeWord2:freeWordSecondRef.current?.value ? freeWordSecondRef.current?.value: "",
        freeWord3:freeWordThirdRef.current?.value ? freeWordThirdRef.current?.value: "",
        freeWord4:freeWordFourthRef.current?.value ? freeWordFourthRef.current?.value: "",
        freeWord5:freeWordFifthRef.current?.value ? freeWordFifthRef.current?.value: "",
        freeWord6:freeWordSixthRef.current?.value ? freeWordSixthRef.current?.value: "",
        industorialClass_code:industrialClass_code,
        address_code:address_code,
        detailParameter:formatDetailRequirementsForSaveSearchData(),
        flag:formatFlagRequirementsForSaveSearchData(),
        sortOrder: sortKey,
        ascending_DescendingOrder: ascDesc,
        displayCount: rowsPerPage.toString(),
        currentPageNumber: "1",
        businessKeywords:formatBusinessKeywordsRequirementsForSaveSearchData(),
        businessKeyword1:businessContentsFirstRef.current?.value ? businessContentsFirstRef.current?.value: "",
        businessKeyword2:businessContentsSecondRef.current?.value ? businessContentsSecondRef.current?.value: "",
        businessKeyword3:businessContentsThirdRef.current?.value ? businessContentsThirdRef.current?.value: "",
        businessKeyword4:businessContentsFourthRef.current?.value ? businessContentsFourthRef.current?.value: "",
        businessKeyword5:businessContentsFifthRef.current?.value ? businessContentsFifthRef.current?.value: "",
        businessKeyword6:businessContentsSixthRef.current?.value ? businessContentsSixthRef.current?.value: "",
        salesFrom:salesFromRef.current?.value ? salesFromRef.current?.value : "",
        salesTo:salesToRef.current?.value ? salesToRef.current?.value : "",
        numberOfEmployeesFrom:employeesNumFromRef.current?.value ? employeesNumFromRef.current?.value : "",
        numberOfEmployeesTo:employeesNumToRef.current?.value ? employeesNumToRef.current?.value : "",
        establishmentDateFrom:establishedFromRef.current?.value ? establishedFromRef.current?.value : "",
        establishmentDateTo:establishedToRef.current?.value ? establishedToRef.current?.value : "",
        captalStockFrom:capitalFromRef.current?.value ? capitalFromRef.current?.value : "",
        captalStockTo:capitalToRef.current?.value ? capitalToRef.current?.value : "",
        shareholders:shareholdersRef.current?.value ? shareholdersRef.current?.value : "",
        partners:partnersRef.current?.value ? partnersRef.current?.value : "",
        endOfFY:checkedEndOfFY.join(","),
        corporateGroupIsBelong:checkedGroup[0] ? "有" : "",
        officeIsExist:checkedOffice.join(","),
        tags: tagSearchCondList.length > 0 ? tagSearchCondList.join(",") : "",
      };
    } else {
      searchConditions = {
        outputDate:currentResultSearchConditions.outputDate,
        corporateName:currentResultSearchConditions.corporateName,
        freeWord:currentResultSearchConditions.freeWord,
        freeWord1:currentResultSearchConditions.freeWord1,
        freeWord2:currentResultSearchConditions.freeWord2,
        freeWord3:currentResultSearchConditions.freeWord3,
        freeWord4:currentResultSearchConditions.freeWord4,
        freeWord5:currentResultSearchConditions.freeWord5,
        freeWord6:currentResultSearchConditions.freeWord6,
        industorialClass_code:currentResultSearchConditions.industorialClass_code,
        address_code:currentResultSearchConditions.address_code,
        detailParameter:currentResultSearchConditions.detailParameter,
        flag:currentResultSearchConditions.flag,
        sortOrder: sortKey,
        ascending_DescendingOrder: ascDesc,
        displayCount: rowsPerPage.toString(),
        currentPageNumber: currentPage.toString(),
        businessKeywords:currentResultSearchConditions.businessKeywords,
        businessKeyword1:currentResultSearchConditions.businessKeyword1,
        businessKeyword2:currentResultSearchConditions.businessKeyword2,
        businessKeyword3:currentResultSearchConditions.businessKeyword3,
        businessKeyword4:currentResultSearchConditions.businessKeyword4,
        businessKeyword5:currentResultSearchConditions.businessKeyword5,
        businessKeyword6:currentResultSearchConditions.businessKeyword6,
        salesFrom:currentResultSearchConditions.salesFrom,
        salesTo:currentResultSearchConditions.salesTo,
        numberOfEmployeesFrom:currentResultSearchConditions.numberOfEmployeesFrom,
        numberOfEmployeesTo:currentResultSearchConditions.numberOfEmployeesTo,
        establishmentDateFrom:currentResultSearchConditions.establishmentDateFrom,
        establishmentDateTo:currentResultSearchConditions.establishmentDateTo,
        captalStockFrom:currentResultSearchConditions.captalStockFrom,
        captalStockTo:currentResultSearchConditions.captalStockTo,
        shareholders:currentResultSearchConditions.shareholders,
        partners:currentResultSearchConditions.partners,
        endOfFY:currentResultSearchConditions.endOfFY,
        corporateGroupIsBelong:currentResultSearchConditions.corporateGroupIsBelong,
        officeIsExist:currentResultSearchConditions.officeIsExist,
        tags: currentResultSearchConditions.tags,
      };
    }

    // トークンが読み込めていない時は処理を中断
    if (!tokenInfo) {
      setIsSearching(false); // 検索中フラグOFF
      return;
    }

    // 検索処理開始時すべてのエラーメッセージ、成功メッセージをリセットする
    setSuccessMessage("");
    setErrorMessage1("");
    setErrorMessage2("");
    setErrorMessage3("");

    // 桁数チェックのための整形
    const  inputInfo: CheckDegitRecordType = {
      inputInfo: [
        { itemName: "corporateName", inputText: searchConditions.corporateName, limitNumberOfDigit: 150 },
        { itemName: "freeWord1", inputText: searchConditions.freeWord1, limitNumberOfDigit: 200 },
        { itemName: "freeWord2", inputText: searchConditions.freeWord2, limitNumberOfDigit: 200 },
        { itemName: "freeWord3", inputText: searchConditions.freeWord3, limitNumberOfDigit: 200 },
        { itemName: "freeWord4", inputText: searchConditions.freeWord4, limitNumberOfDigit: 200 },
        { itemName: "freeWord5", inputText: searchConditions.freeWord5, limitNumberOfDigit: 200 },
        { itemName: "freeWord6", inputText: searchConditions.freeWord6, limitNumberOfDigit: 200 },
        { itemName: "businessKeyword1", inputText: searchConditions.businessKeyword1, limitNumberOfDigit: 200 },
        { itemName: "businessKeyword2", inputText: searchConditions.businessKeyword2, limitNumberOfDigit: 200 },
        { itemName: "businessKeyword3", inputText: searchConditions.businessKeyword3, limitNumberOfDigit: 200 },
        { itemName: "businessKeyword4", inputText: searchConditions.businessKeyword4, limitNumberOfDigit: 200 },
        { itemName: "businessKeyword5", inputText: searchConditions.businessKeyword5, limitNumberOfDigit: 200 },
        { itemName: "businessKeyword6", inputText: searchConditions.businessKeyword6, limitNumberOfDigit: 200 },
        { itemName: "salesFrom", inputText: searchConditions.salesFrom.toString(), limitNumberOfDigit: 150 },
        { itemName: "salesTo", inputText: searchConditions.salesTo.toString(), limitNumberOfDigit: 150 },
        { itemName: "numberOfEmployeesFrom", inputText: searchConditions.numberOfEmployeesFrom.toString(), limitNumberOfDigit: 8 },
        { itemName: "numberOfEmployeesTo", inputText: searchConditions.numberOfEmployeesTo.toString(), limitNumberOfDigit: 8 },
        { itemName: "establishmentDateFrom", inputText: searchConditions.establishmentDateFrom.toString(), limitNumberOfDigit: 4 },
        { itemName: "establishmentDateTo", inputText: searchConditions.establishmentDateTo.toString(), limitNumberOfDigit: 4 },
        { itemName: "captalStockFrom", inputText: searchConditions.captalStockFrom.toString(), limitNumberOfDigit: 15 },
        { itemName: "captalStockTo", inputText: searchConditions.captalStockTo.toString(), limitNumberOfDigit: 15 },
        { itemName: "shareholders", inputText: searchConditions.shareholders.toString(), limitNumberOfDigit: 150 },
        { itemName: "partners", inputText: searchConditions.partners.toString(), limitNumberOfDigit: 150 },
      ]
    };
    // 入力桁数チェック
    const degitResult: CheckDegitResult[] = await callCheckDegit(inputInfo);
    const errorMessages = degitResult
    .filter(result => !result.checkResult)
    .map(result => result.message);
    if (errorMessages.length > 0) {
      setIsSearching(false); // 検索中フラグOFF
      // 一番目のエラーメッセージを表示
      setErrorMessage2(errorMessages[0]);
      return;
    }

    // 属性(数値)チェック
    if (!validateSearchConditions(searchConditions)) {
      setIsSearching(false); // 検索中フラグOFF
      // エラーメッセージを設定し、処理を中断
      return;
    }

    //範囲チェックFROM,TO
    const sales = validateRange(searchConditions.salesFrom, searchConditions.salesTo);
    if (!sales) {
      setIsSearching(false); // 検索中フラグOFF
      return;
    }
    const employees = validateRange(searchConditions.numberOfEmployeesFrom, searchConditions.numberOfEmployeesTo);
    if (!employees) {
      setIsSearching(false); // 検索中フラグOFF
      return;
    }
    const establishment = validateRange(searchConditions.establishmentDateFrom, searchConditions.establishmentDateTo);
    if (!establishment) {
      setIsSearching(false); // 検索中フラグOFF
      return;
    }
    const captalStock = validateRange(searchConditions.captalStockFrom, searchConditions.captalStockTo);
    if (!captalStock) {
      setIsSearching(false); // 検索中フラグOFF
      return;
    }
    // エラーがある場合はここで処理を中断
    await callSearchFacet(searchConditions, isFromButtonClick);
    // CSVダウンロード用検索条件保存
    getSearchFilter()

    if (isFromButtonClick || !currentResultSearchConditions) {
      setCurrentResultSearchConditions(searchConditions);
    }

    // 検索条件をキャッシュに保存
    handleConditionSet();
    saveState();

    // 検索結果へスクロール
    if (searchConditionRef.current) {
      const top = searchConditionRef.current.getBoundingClientRect().top + window.scrollY - 120;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  const callSearchFacet = async (record:SearchHomeType, isFromButtonClick:boolean) => {
    try {
      const { idToken } = await getTokens();
      const baseUrl = process.env.REACT_APP_API_BASE_URL || '';
      const path = '/event/searchfacet';
      const apipath = baseUrl.concat(path);
      const response = await fetch(apipath, {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${idToken}`, // IDトークンをヘッダーに設定
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(record)
      });

      if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
      }
      const responseData = await response.json();
      // レスポンスから表示用データと企業番号一覧を取得
      const searchedData = responseData['bodyVsearch'];
      const corporateNumData = responseData['corporateNumberList'];
      if (searchedData.length === 0) {
        setErrorMessage3("指定された検索条件に一致する結果がありませんでした。");
        // 検索結果に空のリストをセット
        setTableData([]);
        // 検索結果数は0件をセット
        setDataCount(0);
        setFacetCount(0);
        // setIsViewFacet(false);

        setCorporateNumList([]);
      } else {

        const formattedData = searchedData.map((item:ResponseDataItem) => ({
            max_search_data_limit: item.max_search_data_limit,
            cnt_corporateNumber: item.cnt_corporateNumber,
            cnt_corporateNumber_limitplus1: item.cnt_corporateNumber_limitplus1,
            corporateName: item.corporateName,
            corporateNumber: item.corporateNumber,
            headquarterAddress: item.headquarterAddress,
            industorialClass_large: item.industorialClass_large,
            captalStock: item.captalStock,
            numberOfEmployees: item.numberOfEmployees,
            flag1: item.flag1,
            flag2: item.flag2,
            flag3: item.flag3,
            flag4: item.flag4,
            flag5: item.flag5,
            flag6: item.flag6,
        }));

        // 検索結果の表示範囲のセット
        setTableData(formattedData);
        setDataCount(formattedData[0].cnt_corporateNumber);
        setFacetCount(formattedData[0].cnt_corporateNumber);
        setIsViewFacet(formattedData[0].cnt_corporateNumber > 0);
        // 検索結果の企業番号一覧のセット
        if(!isEqualArray(corporateNumData, corporateNumList)){
          setCorporateNumList(corporateNumData);
        }
        // // タグ生成APIの呼び出し
        // callGenerateTags(searchedData);
        // setIsGeneratingTags(true); // タグ生成中フラグON
        // 検索が成功すればエラーメッセージは非表示にする
        setErrorMessage1("");
        setErrorMessage2("");
        setErrorMessage3("");
        // 件数が3000件の場合はメッセージを表示(中断はしない)
        const maxSearchDataLimit = formattedData[0].max_search_data_limit;
        if(formattedData[0].cnt_corporateNumber_limitplus1 > maxSearchDataLimit){
          setErrorMessage3(`検索結果が${maxSearchDataLimit}件を超えました。先頭の${maxSearchDataLimit}件までを表示します。`);
        }
      }
      if (isFromButtonClick) {
          setIsSearchClicked(false);
          setIsSearchFacetClicked(false);
          setIsSearchTagFilterClicked(true);
          setIsSearchTagNewClicked(false);
      }

      // フィルタファセット用項目データ
      const facetConditionsData = responseData['facetConditions'];
      settingFilterFacetData(facetConditionsData, true);
    } catch (error) {
      setIsSearching(false); // 検索中フラグOFF
      console.error("エラー:", error);
      setErrorMessage3("処理中にエラーが発生しました。もう一度お試し下さい。");
    }
    // 多重検索・クリックを防止解除
    setIsSearching(false); // 検索中フラグOFF
  };


  return (
    <>
      <Helmet>
        <title>企業INDEXナビ</title>
      </Helmet>
      <View className="appContainer">
        <Header setIsLoadedHeader={setIsLoadedHeader} doReloadOutputCountFlag={doReloadOutputCountFlag}/>
        {/* フィルタ・ファセット-SP用フロートボタン */}
        { isViewFacet && (
          <Flex
            className="filterFacetsSP"
            position="fixed"
            width="80px"
            height="80px"
            backgroundColor={tokens.colors.blue[60]}
            borderRadius="50vh"
            boxShadow="2px 2px 6px rgba(60, 60, 60, 0.7)"
            overflow="hidden"
            display={{base:"flex", large:"none"}}
            bottom="20px"
            left="10px"
            style={{
              zIndex:"100",
              cursor:"pointer",
            }}
            onClick={() => filterFacetsButton()}
          >
            <img src={IcoFilterFacets} height="100%" width="100%"/>
          </Flex>
        )}

        {/* フィルタ・ファセット-SP */}
        <Flex
          display={isDisplayFilterFacets ? "flex" : "none"}
          position="fixed"
          top="1"
          bottom="1"
          left="1"
          right="1"
          width="100%"
          height="100%"
          backgroundColor={tokens.colors.blue[10]}
          style={{zIndex:"200"}}
          direction="column"
        >
          <Flex
            width="100%"
            height="100%"
            backgroundColor={tokens.colors.blue[10]}
            direction="column"
            padding="30px"
            flex="1"
            style={{overflowY:"auto"}}
            justifyContent="space-between"
          >
            <Flex
              width="100%"
              backgroundColor={tokens.colors.blue[60]}
              border="2px solid var(--amplify-colors-blue-60)"
              direction="column"
              gap="2px"
            >
              <Flex direction="row" gap="0px">
                <Button width="80px" color={tokens.colors.white} fontSize={tokens.fontSizes.xxxl} fontWeight={tokens.fontWeights.bold} borderStyle="none" onClick={() => filterFacetsButton()}>←</Button>
                <Text paddingTop="20px" paddingBottom="20px" paddingRight="80px" width="calc(100% - 80px)" textAlign="center" color={tokens.colors.white} fontSize={tokens.fontSizes.xxl} fontWeight={tokens.fontWeights.bold}>
                  該当社数
                  <View as="span" fontSize={tokens.fontSizes.xxxl} marginLeft="10px" marginRight="10px">{facetCount.toLocaleString()}</View>
                  件 {isGetFacetCountSearching && (<LoadingSpinner />)}
                </Text>
              </Flex>
              <Text textAlign="center" paddingTop="15px" paddingBottom="15px" fontSize="1.8rem" fontWeight={tokens.fontWeights.bold} backgroundColor={tokens.colors.white}>
                条件で絞り込む
              </Text>
              {/* フィルタ・ファセット-企業検索セクション */}
              <Flex direction="column" gap="2px">
                {/* 業種 */}
                <Accordion.Container value={accordionOpenManage} onValueChange={(value: string[] | undefined) => setAccordionOpenManage(value)} >
                  <Accordion.Item value="industryFilterFacets">
                    <Accordion.Trigger className="filterFacetsAccordion" height="50px" lineHeight="50px" paddingLeft={{base:"15px",large:"20px"}} paddingRight={{base:"5px",large:"15px"}}>
                      <Flex width="100%" justifyContent="space-between">
                        <Text marginRight="2px" fontSize="1.8rem" fontWeight={tokens.fontWeights.bold}>業種</Text>
                        <View as="div" className="notAllowDetailConditionInputIndication tooltipWrapper">
                          <View className="tooltipTriggerArea" tabIndex={-1}>
                            <img data-tooltip-id="industryFilterFacetsTooltip" src={IcoInfo} height={"20px"} width={"20px"}/>
                          </View>
                        </View>
                      </Flex>
                      <IoMdArrowDropdown size="40px" className="amplify-accordion__item__icon"/>
                    </Accordion.Trigger>
                    <Accordion.Content backgroundColor={tokens.colors.white} paddingBottom="20px" style={{overflowX:"hidden"}}>
                      <FilterFacetsCheckboxInput
                        dataDict={filterIndustryFacetsData}
                        checkedItems={checkedIndustryItems}
                        setCheckedItems={setCheckedIndustryItems}
                        forNotationItems={forNotationIndustryItems}
                        setForNotationItems={setForNotationIndustryItems}
                        sortingList={industryFacetsSortDataDict}
                        upperLevelItemCodeConcatString={undefined}
                        upperLevelItemNameConcatString={undefined}
                        eachItemNum={eachIndustrialCompanyNum}
                        regionItemNum={undefined}
                        isTopLevelComponent={true}
                        isRegionClassification={false}
                        limit={limit}
                        isTopClass={true}
                      />
                      <Flex width="100%" justifyContent="flex-end">
                        <Button tabIndex={0} border="none" marginTop="10px" paddingRight="20px" style={{cursor:"pointer"}} display={!isShowMore ? "flex" : "none"} onClick={() => handleShowMore()}>
                          <Text fontSize="14px" fontWeight="bold">すべて表示</Text>
                        </Button>
                      </Flex>
                    </Accordion.Content>
                  </Accordion.Item>
                </Accordion.Container>

                {/* 地域 */}
                <Accordion.Container value={accordionOpenManage} onValueChange={(value: string[] | undefined) => setAccordionOpenManage(value)} >
                  <Accordion.Item value="regionFilterFacets">
                    <Accordion.Trigger className="filterFacetsAccordion" height="50px" lineHeight="50px" paddingLeft={{base:"15px",large:"20px"}} paddingRight={{base:"5px",large:"15px"}}>
                      <Flex width="100%" justifyContent="space-between">
                        <Text marginRight="2px" fontSize="1.8rem" fontWeight={tokens.fontWeights.bold}>地域</Text>
                        <View as="div" className="notAllowDetailConditionInputIndication tooltipWrapper">
                          <View className="tooltipTriggerArea" tabIndex={-1}>
                            <img data-tooltip-id="regionFilterFacetsTooltip" src={IcoInfo} height={"20px"} width={"20px"}/>
                          </View>
                        </View>
                      </Flex>
                      <IoMdArrowDropdown size="40px" className="amplify-accordion__item__icon"/>
                    </Accordion.Trigger>
                    <Accordion.Content backgroundColor={tokens.colors.white} paddingBottom="20px" style={{overflowX:"hidden"}}>
                      <Flex direction="row" wrap="wrap" marginLeft="20px" gap="0" width="auto">
                        {Object.entries(regionClassificationDataDict).map(([key,value]) =>
                          <>
                            <Flex direction="column" width="100%">
                              <Flex marginTop="20px" width="100%" minWidth={{base:"150px",large:"200px"}} backgroundColor="transparent" justifyContent="space-between" alignItems="center" gap="0px">
                                <Flex flex="1">
                                  <CheckboxField
                                    size="large"
                                    label={key}
                                    name={key}
                                    // value={key}
                                    checked={topRegionCheckbox[key] !== undefined && topRegionCheckbox[key]}
                                    onChange={() => handleTopRegionCheckbox(key)}
                                    gap="15px"
                                    paddingRight={{base:"0" ,large:"5px"}}
                                    marginRight={{base:"0",large:"0"}}
                                  />
                                </Flex>
                                <Flex as="button" className="plusMinusDisplaySwitchButton" marginTop="5px" marginLeft={{base:"5px", large:"10px"}} marginRight="15px" style={{cursor:"pointer"}} onClick={() => handleClassificationCheck(key,regionData)}>
                                  {openRegionClassificationItems[key] !== undefined && openRegionClassificationItems[key] ?
                                    <img src={IcoMinus} height={"20px"} width={"20px"}/>
                                    :
                                    <img src={IcoPlus} height={"20px"} width={"20px"}/>
                                  }
                                </Flex>
                              </Flex>
                            </Flex>
                            {openRegionClassificationItems[key] && (
                              <FilterFacetsCheckboxInput
                                dataDict={filterRegionFacetsData}
                                checkedItems={checkedRegionItems}
                                setCheckedItems={setCheckedRegionItems}
                                forNotationItems={forNotationRegionItems}
                                setForNotationItems={setForNotationRegionItems}
                                sortingList={value}
                                upperLevelItemCodeConcatString = {undefined}
                                upperLevelItemNameConcatString = {undefined}
                                eachItemNum={eachRegionCompanyNum}
                                regionItemNum={filterLocalGovernmentFacetList}
                                isTopLevelComponent={false}
                                isRegionClassification={true}
                                limit={null}
                                isTopClass={false}
                              />
                            )}
                          </>
                        )}
                      </Flex>
                    </Accordion.Content>
                  </Accordion.Item>
                </Accordion.Container>

                {/* 事業内容 */}
                <Accordion.Container value={accordionOpenManage} onValueChange={(value: string[] | undefined) => setAccordionOpenManage(value)} >
                  <Accordion.Item value="businessKeywordsFilterFacets">
                    <Accordion.Trigger className="filterFacetsAccordion" height="50px" lineHeight="50px" paddingLeft={{base:"15px",large:"20px"}} paddingRight={{base:"5px",large:"15px"}}>
                      <Flex width="100%" justifyContent="space-between">
                        <Text marginRight="2px" fontSize="1.8rem" fontWeight={tokens.fontWeights.bold}>事業内容</Text>
                        <View as="div" className="notAllowDetailConditionInputIndication tooltipWrapper">
                          <View className="tooltipTriggerArea" tabIndex={-1}>
                            <img data-tooltip-id="businessKeywordsFilterFacetsTooltip" src={IcoInfo} height={"20px"} width={"20px"}/>
                          </View>
                        </View>
                      </Flex>
                      <IoMdArrowDropdown size="40px" className="amplify-accordion__item__icon"/>
                    </Accordion.Trigger>
                    <Accordion.Content backgroundColor={tokens.colors.white} paddingTop="15px" paddingBottom="20px" paddingLeft={{base:"5px",large:"15px"}} style={{overflowX:"hidden"}}>
                      <Flex direction="column" gap="0" paddingRight={{base:"5px",large:"10px"}}>
                        <Flex direction="row" gap={{base:"0",large:"10px"}} justifyContent="flex-start">
                          <View as="div" width="170px" marginLeft={{base:"5px",large:"10px"}}>
                            <RadioGroupField
                              legend=""
                              name=""
                              value={businessContentsSearchMethod}
                              onChange={(e) => {
                                setBusinessContentsSearchMethod(e.target.value);
                                }
                              }
                              direction="row"
                              size="large"
                              className="detailConditionRadioButton"
                            >
                              <Radio tabIndex={0} className="detailConditionRadioChoices" value="AND" width="20px" height="20px"><View as="span" marginRight={{base:"40px",large:"30px"}}>AND</View></Radio>
                              <Radio tabIndex={0} className="detailConditionRadioChoices" value="OR" width="20px">OR</Radio>
                            </RadioGroupField>
                          </View>
                        </Flex>
                        <Grid gap={{base:"5px",large:"10px"}} width="100%" justifyContent="flex-start" marginTop="8px" templateColumns="1fr 50px" templateRows={{base:"repeat(3, auto)", large:"auto"}}>
                          <View as="button" className="plusMinusDisplaySwitchButton" row="3" column="2" marginTop="5px" marginLeft={{base:"5px", large:"10px"}} style={{cursor:"pointer"}} onClick={() => handleBusinessContentsTextFieldChange()}>
                            <img src={IcoPlus} height="35px" width="35px" style={{display: !isBusinessContentsPushed ? "block" : "none"}}/>
                          </View>
                          <TextField row="1" column="1" inputStyles={{backgroundColor:`${tokens.colors.white}`,height:"40px",fontSize:`${tokens.fontSizes.large}`}} label="" placeholder="" name="businessKeywords" value={businessContentsFirst} onChange={(e) => {setBusinessContentsFirst(e.target.value);}} onBlur={() => {confirmBusinessKeywordsIsEnterd(false); callOnChangeFacetCond();}}/>
                          <TextField row="2" column="1" inputStyles={{backgroundColor:`${tokens.colors.white}`,height:"40px",fontSize:`${tokens.fontSizes.large}`}} label="" placeholder="" name="businessKeywords" value={businessContentsSecond} onChange={(e) => {setBusinessContentsSecond(e.target.value);}} onBlur={() => {confirmBusinessKeywordsIsEnterd(false); callOnChangeFacetCond();}}/>
                          <TextField row="3" column="1" inputStyles={{backgroundColor:`${tokens.colors.white}`,height:"40px",fontSize:`${tokens.fontSizes.large}`}} label="" placeholder="" name="businessKeywords" value={businessContentsThird} onChange={(e) => {setBusinessContentsThird(e.target.value);}} onBlur={() => {confirmBusinessKeywordsIsEnterd(false); callOnChangeFacetCond();}}/>
                        </Grid>
                        <Grid gap={{base:"5px",large:"10px"}} width="100%" justifyContent="flex-start" marginTop="8px" templateColumns="1fr 50px" templateRows={{base:"repeat(3, auto)", large:"auto"}} style={{display: isBusinessContentsPushed ? "grid" : "none"}}>
                          <View as="button" className="plusMinusDisplaySwitchButton" row="3" column="2" marginTop="5px" marginLeft={{base:"5px", large:"10px"}} style={{cursor:"pointer"}} onClick={() => handleBusinessContentsTextFieldChange()}>
                            <img src={IcoMinus} height="35px" width="35px"/>
                          </View>
                          <TextField row="1" column="1" inputStyles={{backgroundColor:`${tokens.colors.white}`,height:"40px",fontSize:`${tokens.fontSizes.large}`}} label="" placeholder="" name="businessKeywords" value={businessContentsFourth} onChange={(e) => {setBusinessContentsFourth(e.target.value);}} onBlur={() => {confirmBusinessKeywordsIsEnterd(false); callOnChangeFacetCond();}}/>
                          <TextField row="2" column="1" inputStyles={{backgroundColor:`${tokens.colors.white}`,height:"40px",fontSize:`${tokens.fontSizes.large}`}} label="" placeholder="" name="businessKeywords" value={businessContentsFifth} onChange={(e) => {setBusinessContentsFifth(e.target.value);}} onBlur={() => {confirmBusinessKeywordsIsEnterd(false); callOnChangeFacetCond();}}/>
                          <TextField row="3" column="1" inputStyles={{backgroundColor:`${tokens.colors.white}`,height:"40px",fontSize:`${tokens.fontSizes.large}`}} label="" placeholder="" name="businessKeywords" value={businessContentsSixth} onChange={(e) => {setBusinessContentsSixth(e.target.value);}} onBlur={() => {confirmBusinessKeywordsIsEnterd(false); callOnChangeFacetCond();}}/>
                        </Grid>
                      </Flex>
                    </Accordion.Content>
                  </Accordion.Item>
                </Accordion.Container>

                {/* キーワード */}
                <Accordion.Container value={accordionOpenManage} onValueChange={(value: string[] | undefined) => setAccordionOpenManage(value)} >
                  <Accordion.Item value="freeWordFilterFacets">
                    <Accordion.Trigger className="filterFacetsAccordion" height="50px" lineHeight="50px" paddingLeft={{base:"15px",large:"20px"}} paddingRight={{base:"5px",large:"15px"}}>
                      <Flex width="100%" justifyContent="space-between">
                        <Text marginRight="2px" fontSize="1.8rem" fontWeight={tokens.fontWeights.bold}>キーワード</Text>
                        <View as="div" className="notAllowDetailConditionInputIndication tooltipWrapper">
                          <View className="tooltipTriggerArea" tabIndex={-1}>
                            <img data-tooltip-id="freeWordsFilterFacetsTooltip" src={IcoInfo} height={"20px"} width={"20px"}/>
                          </View>
                        </View>
                      </Flex>
                      <IoMdArrowDropdown size="40px" className="amplify-accordion__item__icon"/>
                    </Accordion.Trigger>
                    <Accordion.Content backgroundColor={tokens.colors.white} paddingTop="15px" paddingBottom="20px" paddingLeft={{base:"5px",large:"15px"}} style={{overflowX:"hidden"}}>
                      <Flex direction="column" gap="0" paddingRight={{base:"5px",large:"10px"}}>
                        <Flex direction="row" gap={{base:"0",large:"10px"}} justifyContent="flex-start">
                          <View as="div" width="170px" marginLeft={{base:"5px",large:"10px"}}>
                            <RadioGroupField
                              legend=""
                              name=""
                              value={freeWordSearchMethod}
                              onChange={(e) => {
                                setFreeWordSearchMethod(e.target.value);
                                }
                              }
                              direction="row"
                              size="large"
                              className="freeWordRadioButton"
                            >
                              <Radio tabIndex={0} className="freeWordRadioChoices" value="AND" width="20px" height="20px"><View as="span" marginRight={{base:"40px",large:"30px"}}>AND</View></Radio>
                              <Radio tabIndex={0} className="freeWordRadioChoices" value="OR" width="20px">OR</Radio>
                            </RadioGroupField>
                          </View>
                        </Flex>
                        <Grid gap={{base:"5px",large:"10px"}} width="100%" justifyContent="flex-start" marginTop="8px" templateColumns="1fr 50px" templateRows={{base:"repeat(3, auto)", large:"auto"}}>
                          <View as="button" className="plusMinusDisplaySwitchButton" row="3" column="2" marginTop="5px" marginLeft={{base:"5px", large:"10px"}} style={{cursor:"pointer"}} onClick={() => handleFreeWordTextFieldChange()}>
                            <img src={IcoPlus} height="35px" width="35px" style={{display: !isFreeWordPushed ? "block" : "none"}}/>
                          </View>
                          <TextField row="1" column="1" inputStyles={{backgroundColor:`${tokens.colors.white}`,height:"40px",fontSize:`${tokens.fontSizes.large}`}} label="" placeholder="" name="freeWord" value={freeWordFirst} onChange={(e) => {setFreeWordFirst(e.target.value);}} onBlur={() => {confirmFreeWordIsEnterd(false); callOnChangeFacetCond();}}/>
                          <TextField row="2" column="1" inputStyles={{backgroundColor:`${tokens.colors.white}`,height:"40px",fontSize:`${tokens.fontSizes.large}`}} label="" placeholder="" name="freeWord" value={freeWordSecond} onChange={(e) => {setFreeWordSecond(e.target.value);}} onBlur={() => {confirmFreeWordIsEnterd(false); callOnChangeFacetCond();}}/>
                          <TextField row="3" column="1" inputStyles={{backgroundColor:`${tokens.colors.white}`,height:"40px",fontSize:`${tokens.fontSizes.large}`}} label="" placeholder="" name="freeWord" value={freeWordThird} onChange={(e) => {setFreeWordThird(e.target.value);}} onBlur={() => {confirmFreeWordIsEnterd(false); callOnChangeFacetCond();}}/>
                        </Grid>
                        <Grid gap={{base:"5px",large:"10px"}} width="100%" justifyContent="flex-start" marginTop="8px" templateColumns="1fr 50px" templateRows={{base:"repeat(3, auto)", large:"auto"}} style={{display: isFreeWordPushed ? "grid" : "none"}}>
                          <View as="button" className="plusMinusDisplaySwitchButton" row="3" column="2" marginTop="5px" marginLeft={{base:"5px", large:"10px"}} style={{cursor:"pointer"}} onClick={() => handleFreeWordTextFieldChange()}>
                            <img src={IcoMinus} height="35px" width="35px"/>
                          </View>
                          <TextField row="1" column="1" inputStyles={{backgroundColor:`${tokens.colors.white}`,height:"40px",fontSize:`${tokens.fontSizes.large}`}} label="" placeholder="" name="freeWord" value={freeWordFourth} onChange={(e) => {setFreeWordFourth(e.target.value);}} onBlur={() => {confirmFreeWordIsEnterd(false); callOnChangeFacetCond();}}/>
                          <TextField row="2" column="1" inputStyles={{backgroundColor:`${tokens.colors.white}`,height:"40px",fontSize:`${tokens.fontSizes.large}`}} label="" placeholder="" name="freeWord" value={freeWordFifth} onChange={(e) => {setFreeWordFifth(e.target.value);}} onBlur={() => {confirmFreeWordIsEnterd(false); callOnChangeFacetCond();}}/>
                          <TextField row="3" column="1" inputStyles={{backgroundColor:`${tokens.colors.white}`,height:"40px",fontSize:`${tokens.fontSizes.large}`}} label="" placeholder="" name="freeWord" value={freeWordSixth} onChange={(e) => {setFreeWordSixth(e.target.value);}} onBlur={() => {confirmFreeWordIsEnterd(false); callOnChangeFacetCond();}}/>
                        </Grid>
                      </Flex>
                    </Accordion.Content>
                  </Accordion.Item>
                </Accordion.Container>

                {/* 売上 */}
                <Accordion.Container value={accordionOpenManage} onValueChange={(value: string[] | undefined) => setAccordionOpenManage(value)} >
                  <Accordion.Item value="salesFilterFacets">
                    <Accordion.Trigger className="filterFacetsAccordion" height="50px" lineHeight="50px" paddingLeft={{base:"15px",large:"20px"}} paddingRight={{base:"5px",large:"15px"}}>
                      <Flex width="100%" justifyContent="space-between">
                        <Text marginRight="2px" fontSize="1.8rem" fontWeight={tokens.fontWeights.bold}>売上</Text>
                        <View as="div" className="notAllowDetailConditionInputIndication tooltipWrapper">
                          <View className="tooltipTriggerArea" tabIndex={-1}>
                            <img data-tooltip-id="salesTooltip" src={IcoInfo} height={"20px"} width={"20px"}/>
                          </View>
                        </View>
                      </Flex>
                      <IoMdArrowDropdown size="40px" className="amplify-accordion__item__icon"/>
                    </Accordion.Trigger>
                    <Accordion.Content backgroundColor={tokens.colors.white} paddingTop="15px" paddingBottom="20px" paddingLeft={{base:"15px",large:"50px"}} style={{overflowX:"hidden"}}>
                      <Flex direction="column" gap={{base:"0.5rem",large:"1rem"}} lineHeight="40px">
                        <Flex direction="row" gap={{base:"0.5rem",large:"1rem"}} lineHeight="40px">
                          <TextField inputStyles={{backgroundColor:`${tokens.colors.white}`,fontSize:`${tokens.fontSizes.large}`,width:"100%",height:"40px"}} label="" placeholder="" value={salesFrom} onChange={(e) => {setSalesFrom(e.target.value);}} width="85%" fontSize={tokens.fontSizes.medium} gap="0" onBlur={() => {confirmDetailConditionsIsEnterd(false); callOnChangeFacetCond();}}/>
                          <Text>万円</Text>
                          <Text textAlign="center">～</Text>
                        </Flex>
                        <Flex direction="row" gap={{base:"0.5rem",large:"1rem"}} lineHeight="40px" >
                          <TextField inputStyles={{backgroundColor:`${tokens.colors.white}`,fontSize:`${tokens.fontSizes.large}`,width:"100%",height:"40px"}} label="" placeholder="" value={salesTo} onChange={(e) => {setSalesTo(e.target.value);}} width="85%" fontSize={tokens.fontSizes.medium} gap="0" onBlur={() => {confirmDetailConditionsIsEnterd(false); callOnChangeFacetCond();}}/>
                          <Text>万円</Text>
                        </Flex>
                      </Flex>
                    </Accordion.Content>
                  </Accordion.Item>
                </Accordion.Container>

                {/* 従業員数 */}
                <Accordion.Container value={accordionOpenManage} onValueChange={(value: string[] | undefined) => setAccordionOpenManage(value)} >
                  <Accordion.Item value="employeesNumFilterFacets">
                    <Accordion.Trigger className="filterFacetsAccordion" height="50px" lineHeight="50px" paddingLeft={{base:"15px",large:"20px"}} paddingRight={{base:"5px",large:"15px"}}>
                      <Flex width="100%" justifyContent="space-between">
                        <Text marginRight="2px" fontSize="1.8rem" fontWeight={tokens.fontWeights.bold}>従業員数</Text>
                        <View as="div" className="notAllowDetailConditionInputIndication tooltipWrapper">
                          <View className="tooltipTriggerArea" tabIndex={-1}>
                            <img data-tooltip-id="employeesNumTooltip" src={IcoInfo} height={"20px"} width={"20px"}/>
                          </View>
                        </View>
                      </Flex>
                      <IoMdArrowDropdown size="40px" className="amplify-accordion__item__icon"/>
                    </Accordion.Trigger>
                    <Accordion.Content backgroundColor={tokens.colors.white} paddingTop="15px" paddingBottom="20px" paddingLeft={{base:"15px",large:"50px"}} style={{overflowX:"hidden"}}>
                      <Flex direction="column" gap={{base:"0.5rem",large:"1rem"}} lineHeight="40px" >
                        <Flex direction="row" gap={{base:"0.5rem",large:"1rem"}} lineHeight="40px" >
                          <TextField inputStyles={{backgroundColor:`${tokens.colors.white}`,fontSize:`${tokens.fontSizes.large}`,width:"100%",height:"40px"}} label="" placeholder="" value={employeesNumFrom} onChange={(e) => {setEmployeesNumFrom(e.target.value);}} width="85%" fontSize={tokens.fontSizes.medium} gap="0" onBlur={() => {confirmDetailConditionsIsEnterd(false); callOnChangeFacetCond();}}/>
                          <Text>人</Text>
                          <Text textAlign="center">～</Text>
                        </Flex>
                        <Flex direction="row" gap={{base:"0.5rem",large:"1rem"}} lineHeight="40px" >
                          <TextField inputStyles={{backgroundColor:`${tokens.colors.white}`,fontSize:`${tokens.fontSizes.large}`,width:"100%",height:"40px"}} label="" placeholder="" value={employeesNumTo} onChange={(e) => {setEmployeesNumTo(e.target.value);}} width="85%" fontSize={tokens.fontSizes.medium} gap="0" onBlur={() => {confirmDetailConditionsIsEnterd(false); callOnChangeFacetCond();}}/>
                          <Text>人</Text>
                        </Flex>
                      </Flex>
                    </Accordion.Content>
                  </Accordion.Item>
                </Accordion.Container>

                {/* 設立年 */}
                <Accordion.Container value={accordionOpenManage} onValueChange={(value: string[] | undefined) => setAccordionOpenManage(value)} >
                  <Accordion.Item value="establishedFilterFacets">
                    <Accordion.Trigger className="filterFacetsAccordion" height="50px" lineHeight="50px" paddingLeft={{base:"15px",large:"20px"}} paddingRight={{base:"5px",large:"15px"}}>
                      <Flex width="100%" justifyContent="space-between">
                        <Text marginRight="2px" fontSize="1.8rem" fontWeight={tokens.fontWeights.bold}>設立年</Text>
                        <View as="div" className="notAllowDetailConditionInputIndication tooltipWrapper">
                          <View className="tooltipTriggerArea" tabIndex={-1}>
                            <img data-tooltip-id="establishedTooltip" src={IcoInfo} height={"20px"} width={"20px"}/>
                          </View>
                        </View>
                      </Flex>
                      <IoMdArrowDropdown size="40px" className="amplify-accordion__item__icon"/>
                    </Accordion.Trigger>
                    <Accordion.Content backgroundColor={tokens.colors.white} paddingTop="15px" paddingBottom="20px" paddingLeft={{base:"15px",large:"50px"}} style={{overflowX:"hidden"}}>
                      <Flex direction="column" gap={{base:"0.5rem",large:"1rem"}} lineHeight="40px" >
                        <Flex direction="row" gap={{base:"0.5rem",large:"1rem"}} lineHeight="40px" >
                          <TextField inputStyles={{backgroundColor:`${tokens.colors.white}`,fontSize:`${tokens.fontSizes.large}`,width:"100%",height:"40px"}} label="" placeholder="" width="85%" value={establishedFrom} onChange={(e) => {setEstablishedFrom(e.target.value);}} fontSize={tokens.fontSizes.medium} gap="0" onBlur={() => {confirmDetailConditionsIsEnterd(false); callOnChangeFacetCond();}}/>
                          <Text>年</Text>
                          <Text textAlign="center">～</Text>
                        </Flex>
                        <Flex direction="row" gap={{base:"0.5rem",large:"1rem"}} lineHeight="40px" >
                          <TextField inputStyles={{backgroundColor:`${tokens.colors.white}`,fontSize:`${tokens.fontSizes.large}`,width:"100%",height:"40px"}} label="" placeholder="" width="85%" value={establishedTo} onChange={(e) => {setEstablishedTo(e.target.value);}} fontSize={tokens.fontSizes.medium} gap="0" onBlur={() => {confirmDetailConditionsIsEnterd(false); callOnChangeFacetCond();}}/>
                          <Text>年</Text>
                        </Flex>
                      </Flex>
                    </Accordion.Content>
                  </Accordion.Item>
                </Accordion.Container>

                {/* 資本金 */}
                <Accordion.Container value={accordionOpenManage} onValueChange={(value: string[] | undefined) => setAccordionOpenManage(value)} >
                  <Accordion.Item value="capitalFilterFacets">
                    <Accordion.Trigger className="filterFacetsAccordion" height="50px" lineHeight="50px" paddingLeft={{base:"15px",large:"20px"}} paddingRight={{base:"5px",large:"15px"}}>
                      <Flex width="100%" justifyContent="space-between">
                        <Text marginRight="2px" fontSize="1.8rem" fontWeight={tokens.fontWeights.bold}>資本金</Text>
                        <View as="div" className="notAllowDetailConditionInputIndication tooltipWrapper">
                          <View className="tooltipTriggerArea" tabIndex={-1}>
                            <img data-tooltip-id="capitalTooltip" src={IcoInfo} height={"20px"} width={"20px"}/>
                          </View>
                        </View>
                      </Flex>
                      <IoMdArrowDropdown size="40px" className="amplify-accordion__item__icon"/>
                    </Accordion.Trigger>
                    <Accordion.Content backgroundColor={tokens.colors.white} paddingTop="15px" paddingBottom="20px" paddingLeft={{base:"15px",large:"50px"}} style={{overflowX:"hidden"}}>
                      <Flex direction="column" gap={{base:"0.5rem",large:"1rem"}} lineHeight="40px" >
                        <Flex direction="row" gap={{base:"0.5rem",large:"1rem"}} lineHeight="40px" >
                          <TextField inputStyles={{backgroundColor:`${tokens.colors.white}`,fontSize:`${tokens.fontSizes.large}`,width:"100%",height:"40px"}} label="" placeholder="" value={capitalFrom} onChange={(e) => {setCapitalFrom(e.target.value);}} width="85%" fontSize={tokens.fontSizes.medium} gap="0" onBlur={() => {confirmDetailConditionsIsEnterd(false); callOnChangeFacetCond();}}/>
                          <Text>万円</Text>
                          <Text textAlign="center">～</Text>
                        </Flex>
                        <Flex direction="row" gap={{base:"0.5rem",large:"1rem"}} lineHeight="40px" >
                          <TextField inputStyles={{backgroundColor:`${tokens.colors.white}`,fontSize:`${tokens.fontSizes.large}`,width:"100%",height:"40px"}} label="" placeholder="" value={capitalTo} onChange={(e) => {setCapitalTo(e.target.value);}} width="85%" fontSize={tokens.fontSizes.medium} gap="0" onBlur={() => {confirmDetailConditionsIsEnterd(false); callOnChangeFacetCond();}}/>
                          <Text>万円</Text>
                        </Flex>
                      </Flex>
                    </Accordion.Content>
                  </Accordion.Item>
                </Accordion.Container>

                {/* その他 */}
                <Accordion.Container value={accordionOpenManage} onValueChange={(value: string[] | undefined) => setAccordionOpenManage(value)} >
                  <Accordion.Item value="othersFilterFacets">
                    <Accordion.Trigger className="filterFacetsAccordion" height="50px" lineHeight="50px" paddingLeft={{base:"15px",large:"20px"}} paddingRight={{base:"5px",large:"15px"}}>
                      <Flex width="100%" justifyContent="space-between">
                        <Text marginRight="2px" fontSize="1.8rem" fontWeight={tokens.fontWeights.bold}>その他</Text>
                        <View as="div" className="notAllowDetailConditionInputIndication tooltipWrapper">
                          <View className="tooltipTriggerArea" tabIndex={-1}>
                            <img data-tooltip-id="othersTooltip" src={IcoInfo} height={"20px"} width={"20px"}/>
                          </View>
                        </View>
                      </Flex>
                      <IoMdArrowDropdown size="40px" className="amplify-accordion__item__icon"/>
                    </Accordion.Trigger>
                    <Accordion.Content backgroundColor={tokens.colors.white} style={{overflowX:"hidden"}}>
                      {/* 決算月 */}
                      <Flex direction="column" gap={{base:"0.5rem",large:"1rem"}} fontSize={tokens.fontSizes.large} lineHeight="40px" marginBottom="1rem">
                        <Flex direction="row" backgroundColor={tokens.colors.overlay[5]} paddingLeft={{base:"10px",large:"30px"}}>
                          <Text fontSize={tokens.fontSizes.xl} fontWeight={tokens.fontWeights.bold}>決算月</Text>
                          <View className="tooltipTriggerArea" tabIndex={-1}>
                            <img data-tooltip-id="closingMonthTooltip" src={IcoInfo} height={"20px"} width={"20px"}/>
                          </View>
                        </Flex>
                        <Flex direction="column" paddingLeft={{base:"20px",large:"30px"}}>
                          {Array.isArray(filterFinancialEndofFYFacetList) && filterFinancialEndofFYFacetList.filter((item: filterFinancialEndofFYFacetListType) => item.endOfFY != null).slice(0, monthLimit).map((item: filterFinancialEndofFYFacetListType, index: number) => (
                            <Flex direction="row">
                              <CheckboxField label={item.endOfFY + "月"} name="month" value={item.endOfFY ?? undefined} gap="15px" size="large" checked={item.endOfFY ? checkedEndOfFY.includes(item.endOfFY) : false}
                                onChange={() => {
                                  handleEndOfFYChecked(item.endOfFY);
                              }}
                              />
                              <Text>({item.hitcount})</Text>
                            </Flex>
                          ))}
                          <Flex width="100%" justifyContent="flex-end">
                            <Button tabIndex={0} border="none" paddingRight="20px" display={(hasShowMoreMonthList) ? "flex" : "none"} style={{cursor:"pointer"}} onClick={() => changeMonthLimit()}>
                              <Text fontSize="14px" fontWeight="bold">すべて表示</Text>
                            </Button>
                          </Flex>
                        </Flex>
                      </Flex>
                      {/* 企業グループ */}
                      <Flex direction="column" gap={{base:"0.5rem",large:"1rem"}} fontSize={tokens.fontSizes.large} lineHeight="40px" marginBottom="1rem">
                        <Flex direction="row" backgroundColor={tokens.colors.overlay[5]} paddingLeft={{base:"10px",large:"30px"}}>
                          <Text fontSize={tokens.fontSizes.xl} fontWeight={tokens.fontWeights.bold}>企業グループ</Text>
                          <View className="tooltipTriggerArea" tabIndex={-1}>
                            <img data-tooltip-id="groupTooltip" src={IcoInfo} height={"20px"} width={"20px"}/>
                          </View>
                        </Flex>
                        <Flex direction="column" paddingLeft={{base:"20px",large:"30px"}}>
                          <Flex direction="row">
                            <CheckboxField label="企業グループに所属" name="group" value="yes" gap="15px" size="large" checked={checkedGroup[0]}
                              onChange={() => {
                                handleDetailRequirementsChecked(checkedGroup,setCheckedGroup,0);
                              }}
                            />
                            <Text>({(filterCorpGroupFacetsHitcount && filterCorpGroupFacetsHitcount > 0) ? filterCorpGroupFacetsHitcount : "0"})</Text>
                          </Flex>
                        </Flex>
                      </Flex>
                      {/* 事業所 */}
                      <Flex direction="column" gap={{base:"0.5rem",large:"1rem"}} fontSize={tokens.fontSizes.large} lineHeight="40px" marginBottom="1rem">
                        <Flex direction="row" backgroundColor={tokens.colors.overlay[5]} paddingLeft={{base:"10px",large:"30px"}}>
                          <Text fontSize={tokens.fontSizes.xl} fontWeight={tokens.fontWeights.bold}>事業所</Text>
                          <View className="tooltipTriggerArea" tabIndex={-1}>
                            <img data-tooltip-id="officeTooltip" src={IcoInfo} height={"20px"} width={"20px"}/>
                          </View>
                        </Flex>
                        <Flex direction="column" paddingLeft={{base:"20px",large:"30px"}}>
                          <Flex direction="row">
                            <CheckboxField label="国内のみ有り" name="office" value="1" gap="15px" size="large" checked={checkedOffice.includes("1")}
                              onChange={() => {
                                handleOfficeChecked("1");
                              }}
                              />
                            <Text>({(filterOfficeIsExistFacetHitcount && filterOfficeIsExistFacetHitcount["1"] )? filterOfficeIsExistFacetHitcount["1"] : "0"})</Text>
                          </Flex>
                          <Flex direction="row">
                            <CheckboxField label="海外のみ有り" name="office" value="2" gap="15px" size="large" checked={checkedOffice.includes("2")}
                              onChange={() => {
                                handleOfficeChecked("2");
                              }}
                              />
                            <Text>({(filterOfficeIsExistFacetHitcount && filterOfficeIsExistFacetHitcount["2"] )? filterOfficeIsExistFacetHitcount["2"] : "0"})</Text>
                          </Flex>
                          <Flex direction="row">
                            <CheckboxField label="国内・海外ともに有り" name="office" value="3" gap="15px" size="large" checked={checkedOffice.includes("3")}
                              onChange={() => {
                                handleOfficeChecked("3");
                              }}
                              />
                            <Text>({(filterOfficeIsExistFacetHitcount && filterOfficeIsExistFacetHitcount["3"] )? filterOfficeIsExistFacetHitcount["3"] : "0"})</Text>
                          </Flex>
                          <Flex direction="row">
                            <CheckboxField label="無し" name="office" value="0" gap="15px" size="large" checked={checkedOffice.includes("0")}
                              onChange={() => {
                                handleOfficeChecked("0");
                              }}
                              />
                            <Text>({(filterOfficeIsExistFacetHitcount && filterOfficeIsExistFacetHitcount["0"] )? filterOfficeIsExistFacetHitcount["0"] : "0"})</Text>
                          </Flex>
                        </Flex>
                      </Flex>
                      {/* 企業URL */}
                      <Flex direction="column" gap={{base:"0.5rem",large:"1rem"}} fontSize={tokens.fontSizes.large} lineHeight="40px" marginBottom="1rem">
                        <Flex direction="row" backgroundColor={tokens.colors.overlay[5]} paddingLeft={{base:"10px",large:"30px"}}>
                          <Text fontSize={tokens.fontSizes.xl} fontWeight={tokens.fontWeights.bold}>企業URL</Text>
                          <View className="tooltipTriggerArea" tabIndex={-1}>
                            <img data-tooltip-id="homepageTooltip" src={IcoInfo} height={"20px"} width={"20px"}/>
                          </View>
                        </Flex>
                        <Flex direction="column" paddingLeft={{base:"20px",large:"30px"}}>
                          <Flex direction="row">
                            <CheckboxField label="有" name="homepage" value="yes" gap="15px" size="large" checked={checkedHaveOrNotHaveHomePage[0]}
                              onChange={() => {
                                handleDetailRequirementsChecked(checkedHaveOrNotHaveHomePage,setCheckedHaveOrNotHaveHomePage,0);
                                confirmDetailConditionsIsEnterd(true); 
                              }}
                              />
                            <Text>({(filterCorporateUrlFacetHitCount && filterCorporateUrlFacetHitCount["true"] )? filterCorporateUrlFacetHitCount["true"] : "0"})</Text>
                          </Flex>
                          <Flex direction="row">
                            <CheckboxField label="無" name="homepage" value="yes" gap="15px" size="large" checked={checkedHaveOrNotHaveHomePage[1]}
                              onChange={() => {
                                handleDetailRequirementsChecked(checkedHaveOrNotHaveHomePage,setCheckedHaveOrNotHaveHomePage,1);
                                confirmDetailConditionsIsEnterd(true); 
                              }}
                              />
                            <Text>({(filterCorporateUrlFacetHitCount && filterCorporateUrlFacetHitCount["false"] )? filterCorporateUrlFacetHitCount["false"] : "0"})</Text>
                          </Flex>
                        </Flex>
                      </Flex>
                    </Accordion.Content>
                  </Accordion.Item>
                </Accordion.Container>
              </Flex>
            </Flex>
            {/* フィルタ・ファセット-ボタンセクション */}
            <Flex direction="column" alignItems="center" backgroundColor={tokens.colors.blue[10]} gap="0.5rem" width="100%">
              <Button className="greenHoverButton" variation="primary" color="white" margin={{base:"0 auto",large:"0"}} width="90%" height="45px" borderRadius="25px" onClick={() => {handleSearchFacetWithClick(); filterFacetsButton();}}>
                <MdSearch style={{fontSize: `${tokens.fontSizes.xxl}`, marginRight: "5px"}}/>
                <View as="span" marginBottom="2px" fontSize={tokens.fontSizes.xxl}>この条件で検索</View>
              </Button>
              {/* <Button className="whiteHoverButton" variation="primary" backgroundColor={tokens.colors.white} borderColor={tokens.colors.blue[80]} color={tokens.colors.blue[80]} fontSize={tokens.fontSizes.large} width="60%" height="35px" borderRadius="18px" marginTop="2.5px" onClick={() => clearSearchRequirements()}>
                <View as="span" marginTop="2px">検索条件をリセット</View>
              </Button> */}
            </Flex>
          </Flex>
        </Flex>

        <Flex direction="row" alignItems="flex-start" justifyContent="center" width="100%" paddingRight="5px" flex="1">
          {/* フィルタ・ファセット-PC */}
          { isViewFacet && (
            <Flex
              className="filterFacetsPC"
              ref={filterFacetsWrapRef}
              position="relative"
              justifyContent="flex-end"
              width="284px"
              height={filterFacetsWrapHeight}
              display={{base:"none", large:"flex"}}
              style={{zIndex:"10"}}
              marginLeft="10px"
            >
              <Flex
                className="filterFacets"
                ref={filterFacetsRef}
                style={filterFacetsStyles}
                minWidth="280px"
                width="280px"
                height="fit-content"
                backgroundColor={tokens.colors.blue[60]}
                border="2px solid var(--amplify-colors-blue-60)"
                marginTop="1rem"
                direction="column"
                gap="2px"
              >
                <Text paddingTop="20px" paddingLeft="20px" paddingBottom="20px" color={tokens.colors.white} fontSize={tokens.fontSizes.xxl} fontWeight={tokens.fontWeights.bold}>
                  該当社数
                  <View as="span" fontSize={tokens.fontSizes.xxxl} marginLeft="10px" marginRight="10px">{facetCount.toLocaleString()}</View>
                  件 {isGetFacetCountSearching && (<LoadingSpinner />)}
                </Text>
                <Text textAlign="center" paddingTop="15px" paddingBottom="15px" fontSize="1.8rem" fontWeight={tokens.fontWeights.bold} backgroundColor={tokens.colors.white}>
                  条件で絞り込む
                </Text>
                {/* フィルタ・ファセット-企業検索セクション */}
                <Flex direction="column" gap="2px">
                  {/* 業種 */}
                  <Accordion.Container value={accordionOpenManage} onValueChange={(value: string[] | undefined) => setAccordionOpenManage(value)} >
                    <Accordion.Item value="industryFilterFacets">
                      <Accordion.Trigger className="filterFacetsAccordion" height="50px" lineHeight="50px" paddingLeft={{base:"15px",large:"20px"}} paddingRight={{base:"5px",large:"15px"}}>
                        <Flex width="100%" justifyContent="space-between">
                          <Text marginRight="2px" fontSize="1.8rem"  fontWeight={tokens.fontWeights.bold}>業種</Text>
                          <View as="div" className="notAllowDetailConditionInputIndication tooltipWrapper">
                            <View className="tooltipTriggerArea" tabIndex={-1}>
                              <img data-tooltip-id="industryFilterFacetsTooltip" src={IcoInfo} height={"20px"} width={"20px"}/>
                            </View>
                          </View>
                        </Flex>
                        <IoMdArrowDropdown size="40px" className="amplify-accordion__item__icon"/>
                      </Accordion.Trigger>
                      <Accordion.Content backgroundColor={tokens.colors.white} paddingBottom="20px" style={{overflowX:"hidden"}} width="100%">
                        <FilterFacetsCheckboxInput
                          dataDict={filterIndustryFacetsData}
                          checkedItems={checkedIndustryItems}
                          setCheckedItems={setCheckedIndustryItems}
                          forNotationItems={forNotationIndustryItems}
                          setForNotationItems={setForNotationIndustryItems}
                          sortingList={industryFacetsSortDataDict}
                          upperLevelItemCodeConcatString={undefined}
                          upperLevelItemNameConcatString={undefined}
                          eachItemNum={eachIndustrialCompanyNum}
                          regionItemNum={undefined}
                          isTopLevelComponent={true}
                          isRegionClassification={false}
                          limit={limit}
                          isTopClass={true}
                        />
                        <Flex width="100%" justifyContent="flex-end">
                          <Button border="none" tabIndex={0} marginTop="10px" paddingRight="20px" style={{cursor:"pointer"}} display={!isShowMore ? "flex" : "none"} onClick={() => handleShowMore()}>
                            <Text tabIndex={0} fontSize="14px" fontWeight="bold">すべて表示</Text>
                          </Button>
                        </Flex>
                      </Accordion.Content>
                    </Accordion.Item>
                  </Accordion.Container>

                  {/* 地域 */}
                  <Accordion.Container value={accordionOpenManage} onValueChange={(value: string[] | undefined) => setAccordionOpenManage(value)} >
                    <Accordion.Item value="regionFilterFacets">
                      <Accordion.Trigger className="filterFacetsAccordion" height="50px" lineHeight="50px" paddingLeft={{base:"15px",large:"20px"}} paddingRight={{base:"5px",large:"15px"}}>
                        <Flex width="100%" justifyContent="space-between">
                          <Text marginRight="2px" fontSize="1.8rem"  fontWeight={tokens.fontWeights.bold}>地域</Text>
                          <View as="div" className="notAllowDetailConditionInputIndication tooltipWrapper">
                            <View className="tooltipTriggerArea" tabIndex={-1}>
                              <img data-tooltip-id="regionFilterFacetsTooltip" src={IcoInfo} height={"20px"} width={"20px"}/>
                            </View>
                          </View>
                        </Flex>
                        <IoMdArrowDropdown size="40px" className="amplify-accordion__item__icon"/>
                      </Accordion.Trigger>
                      <Accordion.Content backgroundColor={tokens.colors.white} paddingBottom="20px" style={{overflowX:"hidden"}}>
                        <Flex direction="row" wrap="wrap" marginLeft="20px" gap="0" width="auto">
                          {Object.entries(regionClassificationDataDict).map(([key,value]) =>
                            <>
                              <Flex direction="column" width="100%">
                                <Flex marginTop="20px" width="100%" minWidth={{base:"150px",large:"200px"}} backgroundColor="transparent" justifyContent="space-between" alignItems="center" gap="0px">
                                  <Flex flex="1">
                                    <CheckboxField
                                      size="large"
                                      label={key}
                                      name={key}
                                      // value={key}
                                      checked={topRegionCheckbox[key] !== undefined && topRegionCheckbox[key]}
                                      onChange={() => handleTopRegionCheckbox(key)}
                                      gap="15px"
                                      paddingRight={{base:"0" ,large:"5px"}}
                                      marginRight={{base:"0",large:"0"}}
                                    />
                                  </Flex>
                                  <Flex as="button" className="plusMinusDisplaySwitchButton" marginTop="5px" marginLeft={{base:"5px", large:"10px"}} marginRight="15px" style={{cursor:"pointer"}} onClick={() => handleClassificationCheck(key,regionData)}>
                                    {openRegionClassificationItems[key] !== undefined && openRegionClassificationItems[key] ?
                                      <img src={IcoMinus} height={"20px"} width={"20px"}/>
                                      :
                                      <img src={IcoPlus} height={"20px"} width={"20px"}/>
                                    }
                                  </Flex>
                                </Flex>
                              </Flex>
                              {openRegionClassificationItems[key] && (
                                <FilterFacetsCheckboxInput
                                  dataDict={filterRegionFacetsData}
                                  checkedItems={checkedRegionItems}
                                  setCheckedItems={setCheckedRegionItems}
                                  forNotationItems={forNotationRegionItems}
                                  setForNotationItems={setForNotationRegionItems}
                                  sortingList={value}
                                  upperLevelItemCodeConcatString = {undefined}
                                  upperLevelItemNameConcatString = {undefined}
                                  eachItemNum={eachRegionCompanyNum}
                                  regionItemNum={filterLocalGovernmentFacetList}
                                  isTopLevelComponent={false}
                                  isRegionClassification={true}
                                  limit={null}
                                  isTopClass={false}
                                />
                              )}
                            </>
                          )}
                        </Flex>
                      </Accordion.Content>
                    </Accordion.Item>
                  </Accordion.Container>

                  {/* 事業内容 */}
                  <Accordion.Container value={accordionOpenManage} onValueChange={(value: string[] | undefined) => setAccordionOpenManage(value)} >
                    <Accordion.Item value="businessKeywordsFilterFacets">
                      <Accordion.Trigger className="filterFacetsAccordion" height="50px" lineHeight="50px" paddingLeft={{base:"15px",large:"20px"}} paddingRight={{base:"5px",large:"15px"}}>
                        <Flex width="100%" justifyContent="space-between">
                          <Text marginRight="2px" fontSize="1.8rem"  fontWeight={tokens.fontWeights.bold}>事業内容</Text>
                          <View as="div" className="notAllowDetailConditionInputIndication tooltipWrapper">
                            <View className="tooltipTriggerArea" tabIndex={-1}>
                              <img data-tooltip-id="businessKeywordsFilterFacetsTooltip" src={IcoInfo} height={"20px"} width={"20px"}/>
                            </View>
                          </View>
                        </Flex>
                        <IoMdArrowDropdown size="40px" className="amplify-accordion__item__icon"/>
                      </Accordion.Trigger>
                      <Accordion.Content backgroundColor={tokens.colors.white} paddingTop="15px" paddingBottom="20px" paddingLeft={{base:"5px",large:"15px"}} style={{overflowX:"hidden"}}>
                        <Flex direction="column" gap="0" paddingRight={{base:"5px",large:"10px"}}>
                          <Flex direction="row" gap={{base:"0",large:"10px"}} justifyContent="flex-start">
                            <View as="div" width="170px" marginLeft={{base:"5px",large:"10px"}}>
                              <RadioGroupField
                                legend=""
                                name=""
                                value={businessContentsSearchMethod}
                                onChange={(e) => {
                                  setBusinessContentsSearchMethod(e.target.value);
                                  }
                                }
                                direction="row"
                                size="large"
                                className="detailConditionRadioButton"
                              >
                                <Radio tabIndex={0} className="detailConditionRadioChoices" value="AND" width="20px" height="20px"><View as="span" marginRight={{base:"40px",large:"30px"}}>AND</View></Radio>
                                <Radio tabIndex={0} className="detailConditionRadioChoices" value="OR" width="20px">OR</Radio>
                              </RadioGroupField>
                            </View>
                          </Flex>
                          <Grid gap={{base:"5px",large:"10px"}} width="100%" justifyContent="flex-start" marginTop="8px" templateColumns="1fr 50px" templateRows={{base:"repeat(3, auto)", large:"auto"}}>
                            <View as="button" className="plusMinusDisplaySwitchButton" row="3" column="2" marginTop="5px" marginLeft={{base:"5px", large:"10px"}} style={{cursor:"pointer"}} onClick={() => handleBusinessContentsTextFieldChange()}>
                              <img src={IcoPlus} height="35px" width="35px" style={{display: !isBusinessContentsPushed ? "block" : "none"}}/>
                            </View>
                            <TextField row="1" column="1" inputStyles={{backgroundColor:`${tokens.colors.white}`,height:"40px",fontSize:`${tokens.fontSizes.large}`}} label="" placeholder="" name="businessKeywords" value={businessContentsFirst} onChange={(e) => {setBusinessContentsFirst(e.target.value);}} onBlur={() => {confirmBusinessKeywordsIsEnterd(false); callOnChangeFacetCond();}}/>
                            <TextField row="2" column="1" inputStyles={{backgroundColor:`${tokens.colors.white}`,height:"40px",fontSize:`${tokens.fontSizes.large}`}} label="" placeholder="" name="businessKeywords" value={businessContentsSecond} onChange={(e) => {setBusinessContentsSecond(e.target.value);}} onBlur={() => {confirmBusinessKeywordsIsEnterd(false); callOnChangeFacetCond();}}/>
                            <TextField row="3" column="1" inputStyles={{backgroundColor:`${tokens.colors.white}`,height:"40px",fontSize:`${tokens.fontSizes.large}`}} label="" placeholder="" name="businessKeywords" value={businessContentsThird} onChange={(e) => {setBusinessContentsThird(e.target.value);}} onBlur={() => {confirmBusinessKeywordsIsEnterd(false); callOnChangeFacetCond();}}/>
                          </Grid>
                          <Grid gap={{base:"5px",large:"10px"}} width="100%" justifyContent="flex-start" marginTop="8px" templateColumns="1fr 50px" templateRows={{base:"repeat(3, auto)", large:"auto"}} style={{display: isBusinessContentsPushed ? "grid" : "none"}}>
                            <View as="button" className="plusMinusDisplaySwitchButton" row="3" column="2" marginTop="5px" marginLeft={{base:"5px", large:"10px"}} style={{cursor:"pointer"}} onClick={() => handleBusinessContentsTextFieldChange()}>
                              <img src={IcoMinus} height="35px" width="35px"/>
                            </View>
                            <TextField row="1" column="1" inputStyles={{backgroundColor:`${tokens.colors.white}`,height:"40px",fontSize:`${tokens.fontSizes.large}`}} label="" placeholder="" name="businessKeywords" value={businessContentsFourth} onChange={(e) => {setBusinessContentsFourth(e.target.value);}} onBlur={() => {confirmBusinessKeywordsIsEnterd(false); callOnChangeFacetCond();}}/>
                            <TextField row="2" column="1" inputStyles={{backgroundColor:`${tokens.colors.white}`,height:"40px",fontSize:`${tokens.fontSizes.large}`}} label="" placeholder="" name="businessKeywords" value={businessContentsFifth} onChange={(e) => {setBusinessContentsFifth(e.target.value);}} onBlur={() => {confirmBusinessKeywordsIsEnterd(false); callOnChangeFacetCond();}}/>
                            <TextField row="3" column="1" inputStyles={{backgroundColor:`${tokens.colors.white}`,height:"40px",fontSize:`${tokens.fontSizes.large}`}} label="" placeholder="" name="businessKeywords" value={businessContentsSixth} onChange={(e) => {setBusinessContentsSixth(e.target.value);}} onBlur={() => {confirmBusinessKeywordsIsEnterd(false); callOnChangeFacetCond();}}/>
                          </Grid>
                        </Flex>
                      </Accordion.Content>
                    </Accordion.Item>
                  </Accordion.Container>

                  {/* キーワード */}
                  <Accordion.Container value={accordionOpenManage} onValueChange={(value: string[] | undefined) => setAccordionOpenManage(value)} >
                    <Accordion.Item value="freeWordFilterFacets">
                      <Accordion.Trigger className="filterFacetsAccordion" height="50px" lineHeight="50px" paddingLeft={{base:"15px",large:"20px"}} paddingRight={{base:"5px",large:"15px"}}>
                        <Flex width="100%" justifyContent="space-between">
                          <Text marginRight="2px" fontSize="1.8rem"  fontWeight={tokens.fontWeights.bold}>キーワード</Text>
                          <View as="div" className="notAllowDetailConditionInputIndication tooltipWrapper">
                            <View className="tooltipTriggerArea" tabIndex={-1}>
                              <img data-tooltip-id="freeWordsFilterFacetsTooltip" src={IcoInfo} height={"20px"} width={"20px"}/>
                            </View>
                          </View>
                        </Flex>
                        <IoMdArrowDropdown size="40px" className="amplify-accordion__item__icon"/>
                      </Accordion.Trigger>
                      <Accordion.Content backgroundColor={tokens.colors.white} paddingTop="15px" paddingBottom="20px" paddingLeft={{base:"5px",large:"15px"}} style={{overflowX:"hidden"}}>
                        <Flex direction="column" gap="0" paddingRight={{base:"5px",large:"10px"}}>
                          <Flex direction="row" gap={{base:"0",large:"10px"}} justifyContent="flex-start">
                            <View as="div" width="170px" marginLeft={{base:"5px",large:"10px"}}>
                              <RadioGroupField
                                legend=""
                                name=""
                                value={freeWordSearchMethod}
                                onChange={(e) => {
                                  setFreeWordSearchMethod(e.target.value);
                                  }
                                }
                                direction="row"
                                size="large"
                                className="freeWordRadioButton"
                              >
                                <Radio tabIndex={0} className="freeWordRadioChoices" value="AND" width="20px" height="20px"><View as="span" marginRight={{base:"40px",large:"30px"}}>AND</View></Radio>
                                <Radio tabIndex={0} className="freeWordRadioChoices" value="OR" width="20px">OR</Radio>
                              </RadioGroupField>
                            </View>
                          </Flex>
                          <Grid gap={{base:"5px",large:"10px"}} width="100%" justifyContent="flex-start" marginTop="8px" templateColumns="1fr 50px" templateRows={{base:"repeat(3, auto)", large:"auto"}}>
                            <View as="button" className="plusMinusDisplaySwitchButton" row="3" column="2" marginTop="5px" marginLeft={{base:"5px", large:"10px"}} style={{cursor:"pointer"}} onClick={() => handleFreeWordTextFieldChange()}>
                              <img src={IcoPlus} height="35px" width="35px" style={{display: !isFreeWordPushed ? "block" : "none"}}/>
                            </View>
                            <TextField row="1" column="1" inputStyles={{backgroundColor:`${tokens.colors.white}`,height:"40px",fontSize:`${tokens.fontSizes.large}`}} label="" placeholder="" name="freeWord" value={freeWordFirst} onChange={(e) => {setFreeWordFirst(e.target.value);}} onBlur={() => {confirmFreeWordIsEnterd(false); callOnChangeFacetCond();}}/>
                            <TextField row="2" column="1" inputStyles={{backgroundColor:`${tokens.colors.white}`,height:"40px",fontSize:`${tokens.fontSizes.large}`}} label="" placeholder="" name="freeWord" value={freeWordSecond} onChange={(e) => {setFreeWordSecond(e.target.value);}} onBlur={() => {confirmFreeWordIsEnterd(false); callOnChangeFacetCond();}}/>
                            <TextField row="3" column="1" inputStyles={{backgroundColor:`${tokens.colors.white}`,height:"40px",fontSize:`${tokens.fontSizes.large}`}} label="" placeholder="" name="freeWord" value={freeWordThird} onChange={(e) => {setFreeWordThird(e.target.value);}} onBlur={() => {confirmFreeWordIsEnterd(false); callOnChangeFacetCond();}}/>
                          </Grid>
                          <Grid gap={{base:"5px",large:"10px"}} width="100%" justifyContent="flex-start" marginTop="8px" templateColumns="1fr 50px" templateRows={{base:"repeat(3, auto)", large:"auto"}} style={{display: isFreeWordPushed ? "grid" : "none"}}>
                            <View as="button" className="plusMinusDisplaySwitchButton" row="3" column="2" marginTop="5px" marginLeft={{base:"5px", large:"10px"}} style={{cursor:"pointer"}} onClick={() => handleFreeWordTextFieldChange()}>
                              <img src={IcoMinus} height="35px" width="35px"/>
                            </View>
                            <TextField row="1" column="1" inputStyles={{backgroundColor:`${tokens.colors.white}`,height:"40px",fontSize:`${tokens.fontSizes.large}`}} label="" placeholder="" name="freeWord" value={freeWordFourth} onChange={(e) => {setFreeWordFourth(e.target.value);}} onBlur={() => {confirmFreeWordIsEnterd(false); callOnChangeFacetCond();}}/>
                            <TextField row="2" column="1" inputStyles={{backgroundColor:`${tokens.colors.white}`,height:"40px",fontSize:`${tokens.fontSizes.large}`}} label="" placeholder="" name="freeWord" value={freeWordFifth} onChange={(e) => {setFreeWordFifth(e.target.value);}} onBlur={() => {confirmFreeWordIsEnterd(false); callOnChangeFacetCond();}}/>
                            <TextField row="3" column="1" inputStyles={{backgroundColor:`${tokens.colors.white}`,height:"40px",fontSize:`${tokens.fontSizes.large}`}} label="" placeholder="" name="freeWord" value={freeWordSixth} onChange={(e) => {setFreeWordSixth(e.target.value);}} onBlur={() => {confirmFreeWordIsEnterd(false); callOnChangeFacetCond();}}/>
                          </Grid>
                        </Flex>
                      </Accordion.Content>
                    </Accordion.Item>
                  </Accordion.Container>

                  {/* 売上 */}
                  <Accordion.Container value={accordionOpenManage} onValueChange={(value: string[] | undefined) => setAccordionOpenManage(value)} >
                    <Accordion.Item value="salesFilterFacets">
                      <Accordion.Trigger className="filterFacetsAccordion" height="50px" lineHeight="50px" paddingLeft={{base:"15px",large:"20px"}} paddingRight={{base:"5px",large:"15px"}}>
                        <Flex width="100%" justifyContent="space-between">
                          <Text marginRight="2px" fontSize="1.8rem"  fontWeight={tokens.fontWeights.bold}>売上</Text>
                          <View as="div" className="notAllowDetailConditionInputIndication tooltipWrapper">
                            <View className="tooltipTriggerArea" tabIndex={-1}>
                              <img data-tooltip-id="salesTooltip" src={IcoInfo} height={"20px"} width={"20px"}/>
                            </View>
                          </View>
                        </Flex>
                        <IoMdArrowDropdown size="40px" className="amplify-accordion__item__icon"/>
                      </Accordion.Trigger>
                      <Accordion.Content backgroundColor={tokens.colors.white} paddingTop="15px" paddingBottom="20px" paddingLeft={{base:"15px",large:"20px"}} style={{overflowX:"hidden"}}>
                        <Flex direction="column" gap={{base:"0.5rem",large:"1rem"}} lineHeight="40px" >
                          <Flex direction="row" gap={{base:"0.5rem",large:"1rem"}} lineHeight="40px">
                            <TextField inputStyles={{backgroundColor:`${tokens.colors.white}`,fontSize:`${tokens.fontSizes.large}`,width:"100%",height:"40px"}} label="" placeholder="" value={salesFrom} onChange={(e) => {setSalesFrom(e.target.value);}} fontSize={tokens.fontSizes.medium} gap="0" onBlur={() => {confirmDetailConditionsIsEnterd(false); callOnChangeFacetCond();}}/>
                            <Text whiteSpace="nowrap">万円</Text>
                            <Text textAlign="center">～</Text>
                          </Flex>
                          <Flex direction="row" gap={{base:"0.5rem",large:"1rem"}} lineHeight="40px" >
                            <TextField inputStyles={{backgroundColor:`${tokens.colors.white}`,fontSize:`${tokens.fontSizes.large}`,width:"100%",height:"40px"}} label="" placeholder="" value={salesTo} onChange={(e) => {setSalesTo(e.target.value);}} fontSize={tokens.fontSizes.medium} gap="0" onBlur={() => {confirmDetailConditionsIsEnterd(false); callOnChangeFacetCond();}}/>
                            <Text whiteSpace="nowrap" marginRight="2.5rem">万円</Text>
                          </Flex>
                        </Flex>
                      </Accordion.Content>
                    </Accordion.Item>
                  </Accordion.Container>

                  {/* 従業員数 */}
                  <Accordion.Container value={accordionOpenManage} onValueChange={(value: string[] | undefined) => setAccordionOpenManage(value)} >
                    <Accordion.Item value="employeesNumFilterFacets">
                      <Accordion.Trigger className="filterFacetsAccordion" height="50px" lineHeight="50px" paddingLeft={{base:"15px",large:"20px"}} paddingRight={{base:"5px",large:"15px"}}>
                        <Flex width="100%" justifyContent="space-between">
                          <Text marginRight="2px" fontSize="1.8rem"  fontWeight={tokens.fontWeights.bold}>従業員数</Text>
                          <View as="div" className="notAllowDetailConditionInputIndication tooltipWrapper">
                            <View className="tooltipTriggerArea" tabIndex={-1}>
                              <img data-tooltip-id="employeesNumTooltip" src={IcoInfo} height={"20px"} width={"20px"}/>
                            </View>
                          </View>
                        </Flex>
                        <IoMdArrowDropdown size="40px" className="amplify-accordion__item__icon"/>
                      </Accordion.Trigger>
                      <Accordion.Content backgroundColor={tokens.colors.white} paddingTop="15px" paddingBottom="20px" paddingLeft={{base:"15px",large:"20px"}} style={{overflowX:"hidden"}}>
                        <Flex direction="column" gap={{base:"0.5rem",large:"1rem"}} lineHeight="40px" >
                          <Flex direction="row" gap={{base:"0.5rem",large:"1rem"}} lineHeight="40px" >
                            <TextField inputStyles={{backgroundColor:`${tokens.colors.white}`,fontSize:`${tokens.fontSizes.large}`,width:"100%",height:"40px"}}  label="" placeholder="" value={employeesNumFrom} onChange={(e) => {setEmployeesNumFrom(e.target.value);}} fontSize={tokens.fontSizes.medium} gap="0" onBlur={() => {confirmDetailConditionsIsEnterd(false); callOnChangeFacetCond();}}/>
                            <Text whiteSpace="nowrap">人</Text>
                            <Text textAlign="center">～</Text>
                          </Flex>
                          <Flex direction="row" gap={{base:"0.5rem",large:"1rem"}} lineHeight="40px" >
                            <TextField inputStyles={{backgroundColor:`${tokens.colors.white}`,fontSize:`${tokens.fontSizes.large}`,width:"100%",height:"40px"}} label="" placeholder="" value={employeesNumTo} onChange={(e) => {setEmployeesNumTo(e.target.value);}}  fontSize={tokens.fontSizes.medium} gap="0" onBlur={() => {confirmDetailConditionsIsEnterd(false); callOnChangeFacetCond();}}/>
                            <Text whiteSpace="nowrap" marginRight="2.5rem">人</Text>
                          </Flex>
                        </Flex>
                      </Accordion.Content>
                    </Accordion.Item>
                  </Accordion.Container>

                  {/* 設立年 */}
                  <Accordion.Container value={accordionOpenManage} onValueChange={(value: string[] | undefined) => setAccordionOpenManage(value)} >
                    <Accordion.Item value="establishedFilterFacets">
                      <Accordion.Trigger className="filterFacetsAccordion" height="50px" lineHeight="50px" paddingLeft={{base:"15px",large:"20px"}} paddingRight={{base:"5px",large:"15px"}}>
                        <Flex width="100%" justifyContent="space-between">
                          <Text marginRight="2px" fontSize="1.8rem"  fontWeight={tokens.fontWeights.bold}>設立年</Text>
                          <View as="div" className="notAllowDetailConditionInputIndication tooltipWrapper">
                            <View className="tooltipTriggerArea" tabIndex={-1}>
                              <img data-tooltip-id="establishedTooltip" src={IcoInfo} height={"20px"} width={"20px"}/>
                            </View>
                          </View>
                        </Flex>
                        <IoMdArrowDropdown size="40px" className="amplify-accordion__item__icon"/>
                      </Accordion.Trigger>
                      <Accordion.Content backgroundColor={tokens.colors.white} paddingTop="15px" paddingBottom="20px" paddingLeft={{base:"15px",large:"20px"}} style={{overflowX:"hidden"}}>
                        <Flex direction="column" gap={{base:"0.5rem",large:"1rem"}} lineHeight="40px" >
                          <Flex direction="row" gap={{base:"0.5rem",large:"1rem"}} lineHeight="40px" >
                            <TextField inputStyles={{backgroundColor:`${tokens.colors.white}`,fontSize:`${tokens.fontSizes.large}`,width:"100%",height:"40px"}}  label="" placeholder="" value={establishedFrom} onChange={(e) => {setEstablishedFrom(e.target.value);}} fontSize={tokens.fontSizes.medium} gap="0" onBlur={() => {confirmDetailConditionsIsEnterd(false); callOnChangeFacetCond();}}/>
                            <Text whiteSpace="nowrap">年</Text>
                            <Text textAlign="center">～</Text>
                          </Flex>
                          <Flex direction="row" gap={{base:"0.5rem",large:"1rem"}} lineHeight="40px" >
                            <TextField inputStyles={{backgroundColor:`${tokens.colors.white}`,fontSize:`${tokens.fontSizes.large}`,width:"100%",height:"40px"}} label="" placeholder="" value={establishedTo} onChange={(e) => {setEstablishedTo(e.target.value);}} fontSize={tokens.fontSizes.medium} gap="0" onBlur={() => {confirmDetailConditionsIsEnterd(false); callOnChangeFacetCond();}}/>
                            <Text whiteSpace="nowrap" marginRight="2.5rem">年</Text>
                          </Flex>
                        </Flex>
                      </Accordion.Content>
                    </Accordion.Item>
                  </Accordion.Container>

                  {/* 資本金 */}
                  <Accordion.Container value={accordionOpenManage} onValueChange={(value: string[] | undefined) => setAccordionOpenManage(value)} >
                    <Accordion.Item value="capitalFilterFacets">
                      <Accordion.Trigger className="filterFacetsAccordion" height="50px" lineHeight="50px" paddingLeft={{base:"15px",large:"20px"}} paddingRight={{base:"5px",large:"15px"}}>
                        <Flex width="100%" justifyContent="space-between">
                          <Text marginRight="2px" fontSize="1.8rem"  fontWeight={tokens.fontWeights.bold}>資本金</Text>
                          <View as="div" className="notAllowDetailConditionInputIndication tooltipWrapper">
                            <View className="tooltipTriggerArea" tabIndex={-1}>
                              <img data-tooltip-id="capitalTooltip" src={IcoInfo} height={"20px"} width={"20px"}/>
                            </View>
                          </View>
                        </Flex>
                        <IoMdArrowDropdown size="40px" className="amplify-accordion__item__icon"/>
                      </Accordion.Trigger>
                      <Accordion.Content backgroundColor={tokens.colors.white} paddingTop="15px" paddingBottom="20px" paddingLeft={{base:"15px",large:"20px"}} style={{overflowX:"hidden"}}>
                        <Flex direction="column" gap={{base:"0.5rem",large:"1rem"}} lineHeight="40px" >
                          <Flex direction="row" gap={{base:"0.5rem",large:"1rem"}} lineHeight="40px" >
                            <TextField inputStyles={{backgroundColor:`${tokens.colors.white}`,fontSize:`${tokens.fontSizes.large}`,width:"100%",height:"40px"}}  label="" placeholder="" value={capitalFrom} onChange={(e) => {setCapitalFrom(e.target.value);}} fontSize={tokens.fontSizes.medium} gap="0" onBlur={() => {confirmDetailConditionsIsEnterd(false); callOnChangeFacetCond();}}/>
                            <Text whiteSpace="nowrap">万円</Text>
                            <Text textAlign="center">～</Text>
                          </Flex>
                          <Flex direction="row" gap={{base:"0.5rem",large:"1rem"}} lineHeight="40px" >
                            <TextField inputStyles={{backgroundColor:`${tokens.colors.white}`,fontSize:`${tokens.fontSizes.large}`,width:"100%",height:"40px"}} label="" placeholder="" value={capitalTo} onChange={(e) => {setCapitalTo(e.target.value);}} fontSize={tokens.fontSizes.medium} gap="0" onBlur={() => {confirmDetailConditionsIsEnterd(false); callOnChangeFacetCond();}}/>
                            <Text whiteSpace="nowrap" marginRight="2.5rem">万円</Text>
                          </Flex>
                        </Flex>
                      </Accordion.Content>
                    </Accordion.Item>
                  </Accordion.Container>

                  {/* その他 */}
                  <Accordion.Container value={accordionOpenManage} onValueChange={(value: string[] | undefined) => setAccordionOpenManage(value)} >
                    <Accordion.Item value="othersFilterFacets">
                      <Accordion.Trigger className="filterFacetsAccordion" height="50px" lineHeight="50px" paddingLeft={{base:"15px",large:"20px"}} paddingRight={{base:"5px",large:"15px"}}>
                        <Flex width="100%" justifyContent="space-between">
                          <Text marginRight="2px" fontSize="1.8rem"  fontWeight={tokens.fontWeights.bold}>その他</Text>
                          <View as="div" className="notAllowDetailConditionInputIndication tooltipWrapper">
                            <View className="tooltipTriggerArea" tabIndex={-1}>
                              <img data-tooltip-id="othersTooltip" src={IcoInfo} height={"20px"} width={"20px"}/>
                            </View>
                          </View>
                        </Flex>
                        <IoMdArrowDropdown size="40px" className="amplify-accordion__item__icon"/>
                      </Accordion.Trigger>
                      <Accordion.Content backgroundColor={tokens.colors.white} style={{overflowX:"hidden"}}>
                        {/* 決算月 */}
                        <Flex direction="column" gap={{base:"0.5rem",large:"1rem"}} fontSize={tokens.fontSizes.large} lineHeight="40px" marginBottom="1rem">
                          <Flex direction="row" backgroundColor={tokens.colors.overlay[5]} paddingLeft={{base:"10px",large:"30px"}}>
                            <Text fontSize={tokens.fontSizes.xl} fontWeight={tokens.fontWeights.bold}>決算月</Text>
                            <View className="tooltipTriggerArea" tabIndex={-1}>
                              <img data-tooltip-id="closingMonthTooltip" src={IcoInfo} height={"20px"} width={"20px"}/>
                            </View>
                          </Flex>
                          <Flex direction="column" paddingLeft={{base:"10px",large:"30px"}}>
                            {Array.isArray(filterFinancialEndofFYFacetList) && filterFinancialEndofFYFacetList.filter((item: filterFinancialEndofFYFacetListType) => item.endOfFY != null).slice(0, monthLimit).map((item: filterFinancialEndofFYFacetListType, index: number) => (
                              <Flex direction="row">
                                <CheckboxField label={item.endOfFY ? parseInt(item.endOfFY, 10) + "月" : ""} name="month" value={item.endOfFY ?? undefined} gap="15px" size="large" checked={item.endOfFY ? checkedEndOfFY.includes(item.endOfFY) : false}
                                  onChange={() => {
                                    handleEndOfFYChecked(item.endOfFY);
                                }}
                                />
                                <Text>({item.hitcount})</Text>
                              </Flex>
                            ))}
                            <Flex width="100%" justifyContent="flex-end">
                              <Button tabIndex={0} border="none" paddingRight="20px" display={(hasShowMoreMonthList) ? "flex" : "none"} style={{cursor:"pointer"}} onClick={() => changeMonthLimit()}>
                                <Text fontSize="14px" fontWeight="bold">すべて表示</Text>
                              </Button>
                            </Flex>
                          </Flex>
                        </Flex>
                        {/* 企業グループ */}
                        <Flex direction="column" gap={{base:"0.5rem",large:"1rem"}} fontSize={tokens.fontSizes.large} lineHeight="40px" marginBottom="1rem">
                          <Flex direction="row" backgroundColor={tokens.colors.overlay[5]} paddingLeft={{base:"10px",large:"30px"}}>
                            <Text fontSize={tokens.fontSizes.xl} fontWeight={tokens.fontWeights.bold}>企業グループ</Text>
                            <View className="tooltipTriggerArea" tabIndex={-1}>
                              <img data-tooltip-id="groupTooltip" src={IcoInfo} height={"20px"} width={"20px"}/>
                            </View>
                          </Flex>
                          <Flex direction="column" paddingLeft={{base:"10px",large:"30px"}}>
                            <Flex direction="row">
                              <CheckboxField label="企業グループに所属" name="group" value="yes" gap="15px" size="large" checked={checkedGroup[0]}
                                onChange={() => {
                                  handleDetailRequirementsChecked(checkedGroup,setCheckedGroup,0);
                                }}
                                />
                              <Text>({(filterCorpGroupFacetsHitcount && filterCorpGroupFacetsHitcount > 0) ? filterCorpGroupFacetsHitcount : "0"})</Text>
                            </Flex>
                          </Flex>
                        </Flex>
                        {/* 事業所 */}
                        <Flex direction="column" gap={{base:"0.5rem",large:"1rem"}} fontSize={tokens.fontSizes.large} lineHeight="40px" marginBottom="1rem">
                          <Flex direction="row" backgroundColor={tokens.colors.overlay[5]} paddingLeft={{base:"10px",large:"30px"}}>
                            <Text fontSize={tokens.fontSizes.xl} fontWeight={tokens.fontWeights.bold}>事業所</Text>
                            <View className="tooltipTriggerArea" tabIndex={-1}>
                              <img data-tooltip-id="officeTooltip" src={IcoInfo} height={"20px"} width={"20px"}/>
                            </View>
                          </Flex>
                          <Flex direction="column" paddingLeft={{base:"10px",large:"30px"}}>
                            <Flex direction="row">
                              <CheckboxField label="国内のみ有り" name="office" value="1" gap="15px" size="large" checked={checkedOffice.includes("1")}
                                onChange={() => {
                                  handleOfficeChecked("1");
                                }}
                                />
                              <Text>({(filterOfficeIsExistFacetHitcount && filterOfficeIsExistFacetHitcount["1"] )? filterOfficeIsExistFacetHitcount["1"] : "0"})</Text>
                            </Flex>
                            <Flex direction="row">
                              <CheckboxField label="海外のみ有り" name="office" value="2" gap="15px" size="large" checked={checkedOffice.includes("2")}
                                onChange={() => {
                                  handleOfficeChecked("2");
                                }}
                                />
                              <Text>({(filterOfficeIsExistFacetHitcount && filterOfficeIsExistFacetHitcount["2"] )? filterOfficeIsExistFacetHitcount["2"] : "0"})</Text>
                            </Flex>
                            <Flex direction="row">
                              <CheckboxField label="国内・海外ともに有り" name="office" value="3" gap="15px" size="large" checked={checkedOffice.includes("3")}
                                onChange={() => {
                                  handleOfficeChecked("3");
                                }}
                                />
                              <Text>({(filterOfficeIsExistFacetHitcount && filterOfficeIsExistFacetHitcount["3"] )? filterOfficeIsExistFacetHitcount["3"] : "0"})</Text>
                            </Flex>
                            <Flex direction="row">
                              <CheckboxField label="無し" name="office" value="0" gap="15px" size="large" checked={checkedOffice.includes("0")}
                                onChange={() => {
                                  handleOfficeChecked("0");
                                }}
                                />
                              <Text>({(filterOfficeIsExistFacetHitcount && filterOfficeIsExistFacetHitcount["0"] )? filterOfficeIsExistFacetHitcount["0"] : "0"})</Text>
                            </Flex>
                          </Flex>
                        </Flex>
                        {/* 企業URL */}
                        <Flex direction="column" gap={{base:"0.5rem",large:"1rem"}} fontSize={tokens.fontSizes.large} lineHeight="40px" marginBottom="1rem">
                          <Flex direction="row" backgroundColor={tokens.colors.overlay[5]} paddingLeft={{base:"10px",large:"30px"}}>
                            <Text fontSize={tokens.fontSizes.xl} fontWeight={tokens.fontWeights.bold}>企業URL</Text>
                            <View className="tooltipTriggerArea" tabIndex={-1}>
                              <img data-tooltip-id="homepageTooltip" src={IcoInfo} height={"20px"} width={"20px"}/>
                            </View>
                          </Flex>
                          <Flex direction="column" paddingLeft={{base:"10px",large:"30px"}}>
                            <Flex direction="row">
                              <CheckboxField label="有" name="homepage" value="yes" gap="15px" size="large" checked={checkedHaveOrNotHaveHomePage[0]}
                                onChange={() => {
                                  handleDetailRequirementsChecked(checkedHaveOrNotHaveHomePage,setCheckedHaveOrNotHaveHomePage,0);
                                  confirmDetailConditionsIsEnterd(true); 
                                }}
                                />
                              <Text>({(filterCorporateUrlFacetHitCount && filterCorporateUrlFacetHitCount["true"] )? filterCorporateUrlFacetHitCount["true"] : "0"})</Text>
                            </Flex>
                            <Flex direction="row">
                              <CheckboxField label="無" name="homepage" value="no" gap="15px" size="large" checked={checkedHaveOrNotHaveHomePage[1]}
                                onChange={() => {
                                  handleDetailRequirementsChecked(checkedHaveOrNotHaveHomePage,setCheckedHaveOrNotHaveHomePage,1);
                                  confirmDetailConditionsIsEnterd(true); 
                                }}
                                />
                              <Text>({(filterCorporateUrlFacetHitCount && filterCorporateUrlFacetHitCount["false"] )? filterCorporateUrlFacetHitCount["false"] : "0"})</Text>
                            </Flex>
                          </Flex>
                        </Flex>
                      </Accordion.Content>
                    </Accordion.Item>
                  </Accordion.Container>
                </Flex>

                {/* フィルタ・ファセット-ボタンセクション */}
                <Flex direction="column" alignItems="center" backgroundColor={tokens.colors.white} gap="0.5rem" width="100%" paddingTop="10px" paddingBottom="10px">
                  <Button className="greenHoverButton" variation="primary" color="white" margin={{base:"0 auto",large:"0"}} width={{base:"90%",large:"180px"}} height="40px" borderRadius="20px" onClick={() => handleSearchFacetWithClick()}>
                    <MdSearch style={{fontSize: `${tokens.fontSizes.xxl}`, marginRight: "5px"}}/>
                    <View as="span" marginBottom="2px" fontSize="18px">この条件で検索</View>
                  </Button>
                  {/* <Button className="whiteHoverButton" variation="primary" backgroundColor={tokens.colors.white} borderColor={tokens.colors.blue[80]} color={tokens.colors.blue[80]} fontSize={tokens.fontSizes.large} width="150px" height="35px" borderRadius="18px" marginTop="2.5px" onClick={() => clearSearchRequirements()}>
                    <View as="span" marginTop="2px">検索条件をリセット</View>
                  </Button> */}
                </Flex>
              </Flex>
            </Flex>
          )}
          {/* フィルタ・ファセット-インフォメーションツールチップ */}
          <View as="div">
            {/* 業種 */}
            <Tooltip id="industryFilterFacetsTooltip" noArrow={true} clickable={true} opacity="1" positionStrategy="absolute" place="top-start" delayShow={20}
              style={{maxWidth:"90vw", zIndex:"999", padding:"0.5rem", whiteSpace:"normal", fontSize:"1.2rem", lineHeight:"2.5rem", backgroundColor:"var(--color-blue-d)", color:"white", borderRadius:"3px", boxShadow:"0 0.2rem 0.2rem gray"}}
            >
              <p>業種（大分類、中分類）を選択して絞り込みができます。</p>
            </Tooltip>
            {/* 地域 */}
            <Tooltip id="regionFilterFacetsTooltip" noArrow={true} clickable={true} opacity="1" positionStrategy="absolute" place="top-start" delayShow={20}
              style={{maxWidth:"90vw", zIndex:"999", padding:"0.5rem", whiteSpace:"normal", fontSize:"1.2rem", lineHeight:"2.5rem", backgroundColor:"var(--color-blue-d)", color:"white", borderRadius:"3px", boxShadow:"0 0.2rem 0.2rem gray"}}
            >
              <p>地域（都道府県）を選択して絞り込みができます。</p>
            </Tooltip>
            {/* 事業内容 */}
            <Tooltip id="businessKeywordsFilterFacetsTooltip" noArrow={true} clickable={true} opacity="1" positionStrategy="absolute" place="top-start" delayShow={20}
              style={{maxWidth:"90vw", zIndex:"999", padding:"0.5rem", whiteSpace:"normal", fontSize:"1.2rem", lineHeight:"2.5rem", backgroundColor:"var(--color-blue-d)", color:"white", borderRadius:"3px", boxShadow:"0 0.2rem 0.2rem gray"}}
            >
              <p>収録情報の事業内容から当てはまるキーワードで絞り込みができます。</p>
            </Tooltip>
            {/* キーワード */}
            <Tooltip id="freeWordsFilterFacetsTooltip" noArrow={true} clickable={true} opacity="1" positionStrategy="absolute" place="top-start" delayShow={20}
              style={{maxWidth:"90vw", zIndex:"999", padding:"0.5rem", whiteSpace:"normal", fontSize:"1.2rem", lineHeight:"2.5rem", backgroundColor:"var(--color-blue-d)", color:"white", borderRadius:"3px", boxShadow:"0 0.2rem 0.2rem gray"}}
            >
              <p>収録情報のすべてのデータから当てはまるキーワードで絞り込みができます。</p>
            </Tooltip>
            {/* 売上 */}
            <Tooltip id="salesTooltip" noArrow={true} clickable={true} opacity="1" positionStrategy="absolute" place="top-start" delayShow={20}
              style={{maxWidth:"90vw", zIndex:"999", padding:"0.5rem", whiteSpace:"normal", fontSize:"1.2rem", lineHeight:"2.5rem", backgroundColor:"var(--color-blue-d)", color:"white", borderRadius:"3px", boxShadow:"0 0.2rem 0.2rem gray"}}
            >
              <p>売上の範囲指定で絞り込みができます。<br/>※空欄は上限・下限無しとして扱います。</p>
            </Tooltip>
            {/* 従業員数 */}
            <Tooltip id="employeesNumTooltip" noArrow={true} clickable={true} opacity="1" positionStrategy="absolute" place="top-start" delayShow={20}
              style={{maxWidth:"90vw", zIndex:"999", padding:"0.5rem", whiteSpace:"normal", fontSize:"1.2rem", lineHeight:"2.5rem", backgroundColor:"var(--color-blue-d)", color:"white", borderRadius:"3px", boxShadow:"0 0.2rem 0.2rem gray"}}
            >
              <p>従業員数の範囲指定で絞り込みができます。<br/>※空欄は上限・下限無しとして扱います。</p>
            </Tooltip>
            {/* 設立年 */}
            <Tooltip id="establishedTooltip" noArrow={true} clickable={true} opacity="1" positionStrategy="absolute" place="top-start" delayShow={20}
              style={{maxWidth:"90vw", zIndex:"999", padding:"0.5rem", whiteSpace:"normal", fontSize:"1.2rem", lineHeight:"2.5rem", backgroundColor:"var(--color-blue-d)", color:"white", borderRadius:"3px", boxShadow:"0 0.2rem 0.2rem gray"}}
            >
              <p>設立年の範囲指定で絞り込みができます。<br/>※空欄は上限・下限無しとして扱います。</p>
            </Tooltip>
            {/* 資本金 */}
            <Tooltip id="capitalTooltip" noArrow={true} clickable={true} opacity="1" positionStrategy="absolute" place="top-start" delayShow={20}
              style={{maxWidth:"90vw", zIndex:"999", padding:"0.5rem", whiteSpace:"normal", fontSize:"1.2rem", lineHeight:"2.5rem", backgroundColor:"var(--color-blue-d)", color:"white", borderRadius:"3px", boxShadow:"0 0.2rem 0.2rem gray"}}
            >
              <p>資本金の範囲指定で絞り込みができます。<br/>※空欄は上限・下限無しとして扱います。</p>
            </Tooltip>
            {/* その他 */}
            <Tooltip id="othersTooltip" noArrow={true} clickable={true} opacity="1" positionStrategy="absolute" place="top-start" delayShow={20}
              style={{maxWidth:"90vw", zIndex:"999", padding:"0.5rem", whiteSpace:"normal", fontSize:"1.2rem", lineHeight:"2.5rem", backgroundColor:"var(--color-blue-d)", color:"white", borderRadius:"3px", boxShadow:"0 0.2rem 0.2rem gray"}}
            >
              <p>決算月、企業グループ、事業所、企業URLの区分指定により絞り込みができます。</p>
            </Tooltip>
            {/* 決算月 */}
            <Tooltip id="closingMonthTooltip" noArrow={true} clickable={true} opacity="1" positionStrategy="absolute" place="top-start" delayShow={20}
              style={{maxWidth:"90vw", zIndex:"999", padding:"0.5rem", whiteSpace:"normal", fontSize:"1.2rem", lineHeight:"2.5rem", backgroundColor:"var(--color-blue-d)", color:"white", borderRadius:"3px", boxShadow:"0 0.2rem 0.2rem gray"}}
            >
              <p>決算月を選択して絞り込みができます。</p>
            </Tooltip>
            {/* 企業グループ */}
            <Tooltip id="groupTooltip" noArrow={true} clickable={true} opacity="1" positionStrategy="absolute" place="top-start" delayShow={20}
              style={{maxWidth:"90vw", zIndex:"999", padding:"0.5rem", whiteSpace:"normal", fontSize:"1.2rem", lineHeight:"2.5rem", backgroundColor:"var(--color-blue-d)", color:"white", borderRadius:"3px", boxShadow:"0 0.2rem 0.2rem gray"}}
            >
              <p>企業グループに所属している企業を絞り込みができます。</p>
            </Tooltip>
            {/* 事業所 */}
            <Tooltip id="officeTooltip" noArrow={true} clickable={true} opacity="1" positionStrategy="absolute" place="top-start" delayShow={20}
              style={{maxWidth:"90vw", zIndex:"999", padding:"0.5rem", whiteSpace:"normal", fontSize:"1.2rem", lineHeight:"2.5rem", backgroundColor:"var(--color-blue-d)", color:"white", borderRadius:"3px", boxShadow:"0 0.2rem 0.2rem gray"}}
            >
              <p>事業所の有無を選択して絞り込みができます。</p>
            </Tooltip>
            {/* URL */}
            <Tooltip id="homepageTooltip" noArrow={true} clickable={true} opacity="1" positionStrategy="absolute" place="top-start" delayShow={20}
              style={{maxWidth:"90vw", zIndex:"999", padding:"0.5rem", whiteSpace:"normal", fontSize:"1.2rem", lineHeight:"2.5rem", backgroundColor:"var(--color-blue-d)", color:"white", borderRadius:"3px", boxShadow:"0 0.2rem 0.2rem gray"}}
            >
              <p>企業URLの有無を選択して絞り込みができます。</p>
            </Tooltip>
          </View>

          {/* 検索ボックス部分 */}
          <Flex className={isViewFacet ? "mainArea maxWidth80" : "mainArea"} ref={mainAreaRef} direction="column" alignItems="center" padding="1rem" backgroundColor={tokens.colors.blue[10]} height="100%" maxWidth="100%">
            {/*PC版*/}
            <View width="100%" paddingRight={isViewFacet ? "15px" : "0px"}>
              <Flex direction="column" alignItems="center" width="100%" maxWidth={{base:"640px", large:"1455px"}} margin="0 auto">

                {/* エラーメッセージの表示 */}
                {errorMessage1 && (
                <div ref={error1Ref} className="alertHome">
                  <Alert
                    isDismissible={false}
                    variation="error"
                    color="red"
                    hasIcon={true}
                    heading=""
                    padding="1rem"
                  >
                    {errorMessage1}
                  </Alert>
                </div>
                )}

                {/* 企業検索セクション */}
                <Flex direction="column" width="100%" gap="0">
                  <Card width="100%" marginBottom="0" padding={{ base: "1rem 2rem", large: "0 3rem" }} backgroundColor={tokens.colors.blue[60]} borderRadius="1rem 1rem 0 0">
                    <Flex direction="row" alignItems="center" justifyContent="space-between" backgroundColor={tokens.colors.blue[60]}>
                      <Flex direction={{ base: "column-reverse", large: "row" }} alignItems="center" gap={{ base: "0.2rem", large: "1rem" }}>
                        <Image src={IcoSearchTitle} alt="企業検索ロゴ" width={{ base: "50px", large: "80px" }} height={{ base: "50px", large: "80px" }} />
                        <Text fontWeight="bold" fontSize={{ base: tokens.fontSizes.xxl, large: tokens.fontSizes.xxxl }} color="white">企業検索</Text>
                      </Flex>
                      <Flex direction={{ base: "column", large: "row" }} gap="1rem">
                        <Button className="whiteToBlueHoverButton" width="160px" height="40px" borderRadius="20px" backgroundColor={tokens.colors.white} color={tokens.colors.blue[90]} borderColor={tokens.colors.blue[90]} onClick={() => openSaveSearchModal()} isDisabled={isLoadingToken}>
                          <img src={IcoSearchSave} height={"15px"} width={"15px"}/>
                          <View as="span" fontSize={tokens.fontSizes.large} marginLeft="10px" marginTop="2px">検索条件を保存</View>
                        </Button>
                        <Button className="whiteToBlueHoverButton" width="160px" height="40px" borderRadius="20px" backgroundColor={tokens.colors.white} color={tokens.colors.blue[90]} borderColor={tokens.colors.blue[90]}  onClick={() => openCallSearchModal()} isDisabled={isLoadingToken}>
                          <img src={IcoSearchLoad} height={"15px"} width={"15px"}/>
                          <View as="span" fontSize={tokens.fontSizes.large} marginLeft="7.5px" marginTop="2px">検索条件の呼び出し</View>
                        </Button>
                      </Flex>
                    </Flex>
                  </Card>

                  <Card width="100%" marginTop="0" padding="0" backgroundColor={tokens.colors.white} borderRadius="0 0 1rem 1rem">
                    <Flex direction="row" justifyContent="space-between" >

                      {/* 業種・地域・企業名・詳細条件の入力エリア */}

                      <Flex direction="column" width="100%" gap="0">
                        {/* 業種 */}
                        <Accordion.Container value={accordionOpenManage} onValueChange={(value: string[] | undefined) => setAccordionOpenManage(value)} >
                          <Accordion.Item value="industry" borderColor={tokens.colors.blue[60]} borderWidth="2px" borderRadius="0" >
                            <Accordion.Trigger className="SearchFilterAccordion" backgroundColor={tokens.colors.white} padding="0" height="50px" lineHeight="50px" paddingLeft={{base:"15px",large:"20px"}} boxShadow="none" paddingRight={{base:"5px",large:"15px"}}>
                              <Flex width="100%">
                                <Text fontSize={tokens.fontSizes.large} fontWeight={tokens.fontWeights.bold} width={{base:"115px", large:"150px"}}><View as="span" fontSize={{base:tokens.fontSizes.xl,large:tokens.fontSizes.xxl}} style={{marginRight:"2px"}}>業種</View>で探す</Text>
                                {Object.keys(checkedIndustryItems).length > 0 ? <img src={IcoFilterOn} height={"25px"} width={"25px"} data-tooltip-id="industryTooltip"/> : <img src={IcoFilterOff} height={"25px"} width={"25px"}/>}
                                <Tooltip id="industryTooltip" place="top-start" style={{maxWidth:"90%", whiteSpace:"normal", backgroundColor:"#d2e0ff", color:"#222", lineHeight:1}}>{Object.values(forNotationIndustryItems).join(";")}</Tooltip>
                                <View as="div" className="notAllowDetailConditionInputIndication tooltipWrapper">
                                  <View className="tooltipTriggerArea" tabIndex={-1}>
                                  <img src={IcoInfo} height={"20px"} width={"20px"}/>
                                  <View as="span" className="notAllowDetailConditionInputIndication__tooltip">
                                    業種（大分類、中分類、小分類）を選択して絞り込みができます。
                                  </View>
                                  </View>
                                </View>
                                <TextField id="industryFilter" label="" placeholder="産業分類の名称から検索できます（例：食料→食料品製造業、食料・飲料卸売業  等ヒット）" ref={industryDataRef} width={{base:"40%", large:"82%"}} marginLeft={{base:"5px",large:"10px"}} lineHeight="40px" inputStyles={{backgroundColor:`${tokens.colors.blue[10]}`,height:"40px",fontSize:`${tokens.fontSizes.xl}`}} onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleIndustryFilter(e.target.value)} />
                              </Flex>
                              <IoMdArrowDropdown size="40px" className="amplify-accordion__item__icon"/>
                            </Accordion.Trigger>
                            <Accordion.Content backgroundColor={tokens.colors.blue[10]} maxHeight="350px" paddingBottom="20px" style={{overflowX:"hidden",overflowY:"scroll"}}>
                                <SearchFilterCheckboxInput
                                  dataDict={filterIndustryData}
                                  checkedItems={checkedIndustryItems}
                                  setCheckedItems={setCheckedIndustryItems}
                                  forNotationItems={forNotationIndustryItems}
                                  setForNotationItems={setForNotationIndustryItems}
                                  sortingList={[]}
                                  upperLevelItemCodeConcatString={undefined}
                                  upperLevelItemNameConcatString={undefined}
                                  eachItemNum={eachIndustrialCompanyNum}
                                  isTopLevelComponent={true}
                                  isRegionClassification={false}
                                />
                            </Accordion.Content>
                          </Accordion.Item>
                        </Accordion.Container>

                        {/* 地域 */}
                        <Accordion.Container value={accordionOpenManage} onValueChange={(value: string[] | undefined) => setAccordionOpenManage(value)} >
                          <Accordion.Item value="region" borderColor={tokens.colors.blue[60]} borderRadius="0" borderWidth="2px" style={{borderTop:"none"}}>
                            <Accordion.Trigger className="SearchFilterAccordion" backgroundColor={tokens.colors.white} padding="0" height="50px" lineHeight="50px" paddingLeft={{base:"15px",large:"20px"}} boxShadow="none" paddingRight={{base:"5px",large:"15px"}}>
                              <Flex >
                                <Text fontSize={tokens.fontSizes.large} fontWeight={tokens.fontWeights.bold} width={{base:"115px", large:"150px"}}><View as="span" fontSize={{base:tokens.fontSizes.xl,large:tokens.fontSizes.xxl}} style={{marginRight:"2px"}}>地域</View>で探す</Text>
                                {Object.keys(checkedRegionItems).length > 0 ? <img src={IcoFilterOn} height={"25px"} width={"25px"} data-tooltip-id="regionTooltip"/> : <img src={IcoFilterOff} height={"25px"} width={"25px"} />}
                                <Tooltip id="regionTooltip" place="top-start" style={{maxWidth:"90%", whiteSpace:"normal", backgroundColor:"#d2e0ff", color:"#222", lineHeight:1}}>{Object.values(forNotationRegionItems).join(';')}</Tooltip>
                                <View as="div" className="notAllowDetailConditionInputIndication tooltipWrapper">
                                  <View className="tooltipTriggerArea" tabIndex={-1}>
                                    <img src={IcoInfo} height={"20px"} width={"20px"}/>
                                    <View as="span" className="notAllowDetailConditionInputIndication__tooltip">
                                      地域（都道府県、市区町村）を選択して絞り込みができます。
                                    </View>
                                  </View>
                                </View>
                              </Flex>
                              <IoMdArrowDropdown size="40px" className="amplify-accordion__item__icon"/>
                            </Accordion.Trigger>
                            <Accordion.Content backgroundColor={tokens.colors.blue[10]} maxHeight="350px" paddingBottom="20px" style={{overflowX:"hidden",overflowY:"scroll"}}>
                              <Flex marginLeft={{base:"16px",large:"32.5px"}} direction="column" gap="0">
                                {Object.entries(regionClassificationDataDict).map(([key,value]) =>
                                  <>
                                    <Flex as="button" className="plusMinusDisplaySwitchButton" tabIndex={0} direction="row" marginTop="15px" gap="8px" onClick={() => handleClassificationCheck(key,regionData)} style={{cursor:"pointer"}}>
                                      {openRegionClassificationItems[key] !== undefined && openRegionClassificationItems[key] ?
                                        <img src={IcoMinus} height={"25px"} width={"25px"}/>
                                        :
                                        <img src={IcoPlus} height={"25px"} width={"25px"}/>
                                      }
                                      <Text fontSize={tokens.fontSizes.large} marginTop="4px">{key}</Text>
                                    </Flex>
                                    {openRegionClassificationItems[key] &&(
                                      <SearchFilterCheckboxInput
                                        dataDict={regionData}
                                        checkedItems={checkedRegionItems}
                                        setCheckedItems={setCheckedRegionItems}
                                        forNotationItems={forNotationRegionItems}
                                        setForNotationItems={setForNotationRegionItems}
                                        sortingList={value}
                                        upperLevelItemCodeConcatString = {undefined}
                                        upperLevelItemNameConcatString = {undefined}
                                        eachItemNum={eachRegionCompanyNum}
                                        isTopLevelComponent={false}
                                        isRegionClassification={true}
                                      />
                                    )}
                                  </>
                                )}
                              </Flex>
                            </Accordion.Content>
                          </Accordion.Item>
                        </Accordion.Container>

                        {/* 事業内容 */}
                        <Accordion.Container value={accordionOpenManage} onValueChange={(value: string[] | undefined) => setAccordionOpenManage(value)} >
                          <Accordion.Item value="businessKeywords" borderColor={tokens.colors.blue[60]} borderRadius="0" borderWidth="2px" style={{borderTop:"none"}}>
                            <Accordion.Trigger className="SearchFilterAccordion" backgroundColor={tokens.colors.white} padding="0" height="50px" lineHeight="50px" paddingLeft={{base:"15px",large:"20px"}} boxShadow="none" paddingRight={{base:"5px",large:"15px"}}>
                              <Flex>
                                <Text fontSize={tokens.fontSizes.large} fontWeight={tokens.fontWeights.bold} width={{base:"115px", large:"150px"}}><View as="span" fontSize={{base:tokens.fontSizes.xl,large:tokens.fontSizes.xxl}} style={{marginRight:"2px"}}>事業内容</View>で探す</Text>
                                {isEnteredBusinessKeywords ? <img src={IcoFilterOn} height={"25px"} width={"25px"} data-tooltip-id="businessKeywordsTooltip"/> : <img src={IcoFilterOff} height={"25px"} width={"25px"} />}
                                <Tooltip id="businessKeywordsTooltip" place="top-start" style={{maxWidth:"90%", whiteSpace:"normal", backgroundColor:"#d2e0ff", color:"#222", lineHeight:1}}>{formatBusinessKeywordsRequirementsForSearchFilter()}</Tooltip>
                                <View as="div" className="notAllowDetailConditionInputIndication tooltipWrapper">
                                  <View className="tooltipTriggerArea" tabIndex={-1}>
                                    <img src={IcoInfo} height={"20px"} width={"20px"}/>
                                    <View as="span" className="notAllowDetailConditionInputIndication__tooltip">
                                      収録情報の事業内容から当てはまるキーワードで絞り込みができます。
                                    </View>
                                  </View>
                                </View>
                              </Flex>
                              <IoMdArrowDropdown size="40px" className="amplify-accordion__item__icon"/>
                            </Accordion.Trigger>
                            <Accordion.Content backgroundColor={tokens.colors.blue[10]} maxHeight="350px" paddingTop="15px" paddingBottom="20px" paddingLeft={{base:"15px",large:"50px"}} style={{overflowX:"hidden",overflowY:"scroll"}}>
                              <Flex direction="column" gap="0" paddingRight={{base:"10px",large:"20px"}}>
                                <Flex direction="row" gap={{base:"0",large:"10px"}} justifyContent="flex-start">
                                  <View as="div" width="170px" marginLeft={{base:"0",large:"60px"}}>
                                    <RadioGroupField
                                      legend=""
                                      name=""
                                      value={businessContentsSearchMethod}
                                      onChange={(e) => {
                                        setBusinessContentsSearchMethod(e.target.value);
                                        }
                                      }
                                      direction="row"
                                      size="large"
                                      className="detailConditionRadioButton"
                                    >
                                      <Radio tabIndex={0} className="detailConditionRadioChoices" value="AND" width="20px" height="20px"><View as="span" marginRight={{base:"40px",large:"30px"}}>AND</View></Radio>
                                      <Radio tabIndex={0} className="detailConditionRadioChoices" value="OR" width="20px">OR</Radio>
                                    </RadioGroupField>
                                  </View>
                                </Flex>
                                <Grid gap={{base:"5px",large:"20px"}} width="100%" justifyContent="flex-start" marginTop="8px" templateColumns={{base:"1fr 50px",large:"60px 1fr 1fr 1fr"}} templateRows={{base:"repeat(3, auto)", large:"auto"}}>
                                  <View as="button" className="plusMinusDisplaySwitchButton" row={{base:"3", large:"1"}} column={{base:"2", large:"1"}} marginTop="5px" marginLeft={{base:"5px", large:"10px"}} style={{cursor:"pointer"}} onClick={() => handleBusinessContentsTextFieldChange()}>
                                    <img src={IcoPlus} height="35px" width="35px" style={{display: !isBusinessContentsPushed ? "block" : "none"}}/>
                                  </View>
                                  <TextField row={{base:"1", large:"1"}} column={{base:"1", large:"2"}} inputStyles={{backgroundColor:`${tokens.colors.white}`,height:"40px",fontSize:`${tokens.fontSizes.large}`}} label="" placeholder="" name="businessKeywords" value={businessContentsFirst} ref={businessContentsFirstRef} onChange={(e) => setBusinessContentsFirst(e.target.value)} onBlur={() => confirmBusinessKeywordsIsEnterd(false)}/>
                                  <TextField row={{base:"2", large:"1"}} column={{base:"1", large:"3"}} inputStyles={{backgroundColor:`${tokens.colors.white}`,height:"40px",fontSize:`${tokens.fontSizes.large}`}} label="" placeholder="" name="businessKeywords" value={businessContentsSecond} ref={businessContentsSecondRef} onChange={(e) => setBusinessContentsSecond(e.target.value)} onBlur={() => confirmBusinessKeywordsIsEnterd(false)}/>
                                  <TextField row={{base:"3", large:"1"}} column={{base:"1", large:"4"}} inputStyles={{backgroundColor:`${tokens.colors.white}`,height:"40px",fontSize:`${tokens.fontSizes.large}`}} label="" placeholder="" name="businessKeywords" value={businessContentsThird} ref={businessContentsThirdRef} onChange={(e) => setBusinessContentsThird(e.target.value)} onBlur={() => confirmBusinessKeywordsIsEnterd(false)}/>
                                </Grid>
                                <Grid gap={{base:"5px",large:"20px"}} width="100%" justifyContent="flex-start" marginTop="8px" templateColumns={{base:"1fr 50px",large:"60px 1fr 1fr 1fr"}} templateRows={{base:"repeat(3, auto)", large:"auto"}} style={{display: isBusinessContentsPushed ? "grid" : "none"}}>
                                  <View as="button" className="plusMinusDisplaySwitchButton" row={{base:"3", large:"1"}} column={{base:"2", large:"1"}} marginTop="5px" marginLeft={{base:"5px", large:"10px"}} style={{cursor:"pointer"}} onClick={() => handleBusinessContentsTextFieldChange()}>
                                    <img src={IcoMinus} height="35px" width="35px"/>
                                  </View>
                                  <TextField row={{base:"1", large:"1"}} column={{base:"1", large:"2"}} inputStyles={{backgroundColor:`${tokens.colors.white}`,height:"40px",fontSize:`${tokens.fontSizes.large}`}} label="" placeholder="" name="businessKeywords" value={businessContentsFourth} ref={businessContentsFourthRef} onChange={(e) => setBusinessContentsFourth(e.target.value)} onBlur={() => confirmBusinessKeywordsIsEnterd(false)}/>
                                  <TextField row={{base:"2", large:"1"}} column={{base:"1", large:"3"}} inputStyles={{backgroundColor:`${tokens.colors.white}`,height:"40px",fontSize:`${tokens.fontSizes.large}`}} label="" placeholder="" name="businessKeywords" value={businessContentsFifth} ref={businessContentsFifthRef} onChange={(e) => setBusinessContentsFifth(e.target.value)} onBlur={() => confirmBusinessKeywordsIsEnterd(false)}/>
                                  <TextField row={{base:"3", large:"1"}} column={{base:"1", large:"4"}} inputStyles={{backgroundColor:`${tokens.colors.white}`,height:"40px",fontSize:`${tokens.fontSizes.large}`}} label="" placeholder="" name="businessKeywords" value={businessContentsSixth} ref={businessContentsSixthRef} onChange={(e) => setBusinessContentsSixth(e.target.value)} onBlur={() => confirmBusinessKeywordsIsEnterd(false)}/>
                                </Grid>
                              </Flex>
                            </Accordion.Content>
                          </Accordion.Item>
                        </Accordion.Container>

                        {/* 企業名 */}
                        <Flex id="corporateNameInput" justifyContent="space-between" backgroundColor={tokens.colors.white} borderColor={tokens.colors.blue[60]} borderWidth="2px" height="50px" lineHeight="50px" paddingLeft={{base:"15px",large:"20px"}} paddingRight={{base:"10px",large:"20px"}} style={{borderBottom:"solid",borderRight:"solid",borderLeft:"solid",borderTop:"none"}}>
                          <Flex width="100%">
                            <Text fontSize={tokens.fontSizes.large} width={{base:"140px", large:"175px"}} fontWeight={tokens.fontWeights.bold}><View as="span" fontSize={{base:tokens.fontSizes.xl,large:tokens.fontSizes.xxl}} style={{marginRight:"2px"}}>企業名</View>で探す</Text>
                            {/* {isEnteredFreeWord ? <img src={IcoFilterOn} height={"25px"} width={"25px"} data-tooltip-id="detailConditionsTooltip"/> : <img src={IcoFilterOff} height={"25px"} width={"25px"} />} */}
                            {/* <Tooltip id="corporateNameTooltip" place="top-start" style={{maxWidth:"90%", whiteSpace:"normal", backgroundColor:"#d2e0ff", color:"#222", lineHeight:1}}>{formatDetailRequirementsForSaveSearchData()}</Tooltip> */}
                            <View as="div" className="notAllowDetailConditionInputIndication tooltipWrapper" marginLeft="1rem">
                              <View className="tooltipTriggerArea" tabIndex={-1}>
                                <img src={IcoInfo} height={"20px"} width={"20px"}/>
                                <View as="span" className="notAllowDetailConditionInputIndication__tooltip">
                                  収録情報の企業名から当てはまるキーワードで検索ができます。
                                </View>
                              </View>
                            </View>
                            <TextField id="first_name" label="" placeholder="法人格の除いた企業名でも検索できます" width={{base:"40%", large:"80%"}} marginLeft={{base:"5px",large:"10px"}} height="40px" lineHeight="40px" inputStyles={{backgroundColor:`${tokens.colors.blue[10]}`,height:"40px",fontSize:`${tokens.fontSizes.xl}`}} ref={corporateNameRef} />
                          </Flex>
                        </Flex>

                        {/* キーワード */}
                        <Accordion.Container value={accordionOpenManage} onValueChange={(value: string[] | undefined) => setAccordionOpenManage(value)} >
                          <Accordion.Item value="freeWord" borderColor={tokens.colors.blue[60]} borderRadius="0" borderWidth="2px" style={{borderTop:"none"}}>
                            <Accordion.Trigger className="SearchFilterAccordion" backgroundColor={tokens.colors.white} padding="0" height="50px" lineHeight="50px" paddingLeft={{base:"15px",large:"20px"}} boxShadow="none" paddingRight={{base:"5px",large:"15px"}}>
                              <Flex>
                                <Text fontSize={tokens.fontSizes.large} fontWeight={tokens.fontWeights.bold} width={{base:"115px", large:"150px"}}><View as="span" fontSize={{base:tokens.fontSizes.xl,large:tokens.fontSizes.xxl}} style={{marginRight:"2px"}}>キーワード</View>で探す</Text>
                                {isEnteredFreeWord ? <img src={IcoFilterOn} height={"25px"} width={"25px"} data-tooltip-id="freeWordsTooltip"/> : <img src={IcoFilterOff} height={"25px"} width={"25px"} />}
                                <Tooltip id="freeWordsTooltip" place="top-start" style={{maxWidth:"90%", whiteSpace:"normal", backgroundColor:"#d2e0ff", color:"#222", lineHeight:1}}>{formatFreeWordRequirementsForSearchFilter()}</Tooltip>
                                <View as="div" className="notAllowDetailConditionInputIndication tooltipWrapper">
                                  <View className="tooltipTriggerArea" tabIndex={-1}>
                                    <img src={IcoInfo} height={"20px"} width={"20px"}/>
                                    <View as="span" className="notAllowDetailConditionInputIndication__tooltip">
                                      収録情報のすべてのデータから当てはまるキーワードで絞り込みができます。
                                    </View>
                                  </View>
                                </View>
                              </Flex>
                              <IoMdArrowDropdown size="40px" className="amplify-accordion__item__icon"/>
                            </Accordion.Trigger>
                            <Accordion.Content backgroundColor={tokens.colors.blue[10]} maxHeight="350px" paddingTop="15px" paddingBottom="20px" paddingLeft={{base:"15px",large:"50px"}} style={{overflowX:"hidden",overflowY:"scroll"}}>
                              <Flex direction="column" gap="0" paddingRight={{base:"10px",large:"20px"}}>
                                <Flex direction="row" gap={{base:"0",large:"10px"}} justifyContent="flex-start">
                                  <View as="div" width="170px" marginLeft={{base:"0",large:"60px"}}>
                                    <RadioGroupField
                                      legend=""
                                      name=""
                                      value={freeWordSearchMethod}
                                      onChange={(e) => {
                                        setFreeWordSearchMethod(e.target.value);
                                        }
                                      }
                                      direction="row"
                                      size="large"
                                      className="freeWordRadioButton"
                                    >
                                      <Radio tabIndex={0} className="freeWordRadioChoices" value="AND" width="20px" height="20px"><View as="span" marginRight={{base:"40px",large:"30px"}}>AND</View></Radio>
                                      <Radio tabIndex={0} className="freeWordRadioChoices" value="OR" width="20px">OR</Radio>
                                    </RadioGroupField>
                                  </View>
                                </Flex>
                                <Grid gap={{base:"5px",large:"20px"}} width="100%" justifyContent="flex-start" marginTop="8px" templateColumns={{base:"1fr 50px",large:"60px 1fr 1fr 1fr"}} templateRows={{base:"repeat(3, auto)", large:"auto"}}>
                                  <View as="button" className="plusMinusDisplaySwitchButton" row={{base:"3", large:"1"}} column={{base:"2", large:"1"}} marginTop="5px" marginLeft={{base:"5px", large:"10px"}} style={{cursor:"pointer"}} onClick={() => handleFreeWordTextFieldChange()}>
                                    <img src={IcoPlus} height="35px" width="35px" style={{display: !isFreeWordPushed ? "block" : "none"}}/>
                                  </View>
                                  <TextField row={{base:"1", large:"1"}} column={{base:"1", large:"2"}} inputStyles={{backgroundColor:`${tokens.colors.white}`,height:"40px",fontSize:`${tokens.fontSizes.large}`}} label="" placeholder="" name="freeWord" value={freeWordFirst} ref={freeWordFirstRef} onChange={(e) => setFreeWordFirst(e.target.value)} onBlur={() => confirmFreeWordIsEnterd(false)}/>
                                  <TextField row={{base:"2", large:"1"}} column={{base:"1", large:"3"}} inputStyles={{backgroundColor:`${tokens.colors.white}`,height:"40px",fontSize:`${tokens.fontSizes.large}`}} label="" placeholder="" name="freeWord" value={freeWordSecond} ref={freeWordSecondRef} onChange={(e) => setFreeWordSecond(e.target.value)} onBlur={() => confirmFreeWordIsEnterd(false)}/>
                                  <TextField row={{base:"3", large:"1"}} column={{base:"1", large:"4"}} inputStyles={{backgroundColor:`${tokens.colors.white}`,height:"40px",fontSize:`${tokens.fontSizes.large}`}} label="" placeholder="" name="freeWord" value={freeWordThird} ref={freeWordThirdRef} onChange={(e) => setFreeWordThird(e.target.value)} onBlur={() => confirmFreeWordIsEnterd(false)}/>
                                </Grid>
                                <Grid gap={{base:"5px",large:"20px"}} width="100%" justifyContent="flex-start" marginTop="8px" templateColumns={{base:"1fr 50px",large:"60px 1fr 1fr 1fr"}} templateRows={{base:"repeat(3, auto)", large:"auto"}} style={{display: isFreeWordPushed ? "grid" : "none"}}>
                                  <View as="button" className="plusMinusDisplaySwitchButton" row={{base:"3", large:"1"}} column={{base:"2", large:"1"}} marginTop="5px" marginLeft={{base:"5px", large:"10px"}} style={{cursor:"pointer"}} onClick={() => handleFreeWordTextFieldChange()}>
                                    <img src={IcoMinus} height="35px" width="35px"/>
                                  </View>
                                  <TextField row={{base:"1", large:"1"}} column={{base:"1", large:"2"}} inputStyles={{backgroundColor:`${tokens.colors.white}`,height:"40px",fontSize:`${tokens.fontSizes.large}`}} label="" placeholder="" name="freeWord" value={freeWordFourth} ref={freeWordFourthRef} onChange={(e) => setFreeWordFourth(e.target.value)} onBlur={() => confirmFreeWordIsEnterd(false)}/>
                                  <TextField row={{base:"2", large:"1"}} column={{base:"1", large:"3"}} inputStyles={{backgroundColor:`${tokens.colors.white}`,height:"40px",fontSize:`${tokens.fontSizes.large}`}} label="" placeholder="" name="freeWord" value={freeWordFifth} ref={freeWordFifthRef} onChange={(e) => setFreeWordFifth(e.target.value)} onBlur={() => confirmFreeWordIsEnterd(false)}/>
                                  <TextField row={{base:"3", large:"1"}} column={{base:"1", large:"4"}} inputStyles={{backgroundColor:`${tokens.colors.white}`,height:"40px",fontSize:`${tokens.fontSizes.large}`}} label="" placeholder="" name="freeWord" value={freeWordSixth} ref={freeWordSixthRef} onChange={(e) => setFreeWordSixth(e.target.value)} onBlur={() => confirmFreeWordIsEnterd(false)}/>
                                </Grid>
                              </Flex>
                            </Accordion.Content>
                          </Accordion.Item>
                        </Accordion.Container>

                        {/* 詳細条件 */}
                        <Accordion.Container value={accordionOpenManage} onValueChange={(value: string[] | undefined) => setAccordionOpenManage(value)} >
                          <Accordion.Item value="details" borderColor={tokens.colors.blue[60]} borderRadius="0" borderWidth="2px" style={{borderTop:"none"}}>
                            <Accordion.Trigger className="SearchFilterAccordion" backgroundColor={tokens.colors.white} padding="0" height="50px" lineHeight="50px" paddingLeft={{base:"15px",large:"20px"}} boxShadow="none" paddingRight={{base:"5px",large:"15px"}}>
                              <Flex>
                                <Text fontSize={tokens.fontSizes.large} fontWeight={tokens.fontWeights.bold} width={{base:"115px", large:"150px"}}><View as="span" fontSize={{base:tokens.fontSizes.xl,large:tokens.fontSizes.xxl}} style={{marginRight:"2px"}}>詳細条件</View>で絞る</Text>
                                {isEnteredDetailConditions ? <img src={IcoFilterOn} height={"25px"} width={"25px"} data-tooltip-id="detailConditionsTooltip"/> : <img src={IcoFilterOff} height={"25px"} width={"25px"} />}
                                <Tooltip id="detailConditionsTooltip" place="top-start" style={{maxWidth:"90%", whiteSpace:"normal", backgroundColor:"#d2e0ff", color:"#222", lineHeight:1}}>{formatDetailRequirementsForSaveSearchData()}</Tooltip>
                                <View as="div" className="notAllowDetailConditionInputIndication tooltipWrapper">
                                  <View className="tooltipTriggerArea" tabIndex={-1}>
                                    <img src={IcoInfo} height={"20px"} width={"20px"}/>
                                    <View as="span" className="notAllowDetailConditionInputIndication__tooltip">
                                      売上、従業員数、設立年、資本金の範囲指定、株主および取引先のキーワード指定、各種区分指定により絞り込みができます。
                                    </View>
                                  </View>
                                </View>
                              </Flex>
                              <IoMdArrowDropdown size="40px" className="amplify-accordion__item__icon"/>
                            </Accordion.Trigger>
                            <Accordion.Content backgroundColor={tokens.colors.blue[10]} maxHeight="350px" paddingTop="15px" paddingBottom="20px" paddingLeft={{base:"15px",large:"50px"}} style={{overflowX:"hidden",overflowY:"scroll"}}>
                              <Flex direction="column" gap="0">
                                {/* 売上 */}
                                <Flex direction={{base:"column",large:"row"}} gap={{base:"0",large:"10px"}} style={{verticalAlign:"center"}} marginTop="15px">
                                  <Flex direction="row">
                                    <View as="div" width={{base:"",large:"120px"}} textAlign="center" lineHeight="40px">
                                      <Text fontSize={tokens.fontSizes.large} fontWeight={tokens.fontWeights.bold} textAlign="left">売上</Text>
                                    </View>
                                    <View as="div" className="notAllowDetailConditionInputIndication tooltipWrapper">
                                      <View className="tooltipTriggerArea" tabIndex={-1}>
                                        <img data-tooltip-id="salesTooltip" src={IcoInfo} height={"20px"} width={"20px"}/>
                                      </View>
                                    </View>
                                  </Flex>
                                  <View as="div" width={{base:"100%",large:"90%"}}>
                                    <Flex direction="row" gap={{base:"0.5rem",large:"1rem"}} lineHeight="40px" >
                                      <TextField inputStyles={{backgroundColor:`${tokens.colors.white}`,fontSize:`${tokens.fontSizes.large}`,width:"120px",height:"40px"}} label="" placeholder="" ref={salesFromRef} value={salesFrom} onChange={(e) => setSalesFrom(e.target.value)} fontSize={tokens.fontSizes.medium} gap="0" onBlur={() => confirmDetailConditionsIsEnterd(false)}/>
                                      <Flex justifyContent="space-between" gap="0" width={{base:"40px",large:"60px"}} fontSize={tokens.fontSizes.large}>
                                        <Text>万円</Text>
                                        <Text>～</Text>
                                      </Flex>
                                      <TextField inputStyles={{backgroundColor:`${tokens.colors.white}`,fontSize:`${tokens.fontSizes.large}`,width:"120px",height:"40px"}} label="" placeholder="" ref={salesToRef} value={salesTo} onChange={(e) => setSalesTo(e.target.value)} fontSize={tokens.fontSizes.medium} gap="0" onBlur={() => confirmDetailConditionsIsEnterd(false)}/>
                                      <Text fontSize={tokens.fontSizes.large}>万円</Text>
                                    </Flex>
                                  </View>
                                </Flex>
                                {/* 従業員数 */}
                                <Flex direction={{base:"column",large:"row"}} gap={{base:"0",large:"10px"}} style={{verticalAlign:"center"}} marginTop="15px">
                                  <Flex direction="row">
                                    <View as="div" width={{base:"",large:"120px"}} textAlign="center" lineHeight="40px">
                                      <Text fontSize={tokens.fontSizes.large} fontWeight={tokens.fontWeights.bold}  textAlign="left">従業員数</Text>
                                    </View>
                                    <View as="div" className="notAllowDetailConditionInputIndication tooltipWrapper">
                                      <View className="tooltipTriggerArea" tabIndex={-1}>
                                        <img data-tooltip-id="employeesNumTooltip" src={IcoInfo} height={"20px"} width={"20px"}/>
                                      </View>
                                    </View>
                                  </Flex>
                                  <View as="div" width={{base:"100%",large:"90%"}}>
                                    <Flex direction="row" gap={{base:"0.5rem",large:"1rem"}} lineHeight="40px" >
                                      <TextField inputStyles={{backgroundColor:`${tokens.colors.white}`,fontSize:`${tokens.fontSizes.large}`,width:"120px",height:"40px"}}  label="" placeholder="" ref={employeesNumFromRef} value={employeesNumFrom} onChange={(e) => setEmployeesNumFrom(e.target.value)} fontSize={tokens.fontSizes.medium} gap="0" onBlur={() => confirmDetailConditionsIsEnterd(false)}/>
                                      <Flex justifyContent="space-between" gap="0" width={{base:"40px",large:"60px"}} fontSize={tokens.fontSizes.large}>
                                        <Text>人</Text>
                                        <Text>～</Text>
                                      </Flex>
                                      <TextField inputStyles={{backgroundColor:`${tokens.colors.white}`,fontSize:`${tokens.fontSizes.large}`,width:"120px",height:"40px"}} label="" placeholder="" ref={employeesNumToRef} value={employeesNumTo} onChange={(e) => setEmployeesNumTo(e.target.value)} fontSize={tokens.fontSizes.medium} gap="0" onBlur={() => confirmDetailConditionsIsEnterd(false)}/>
                                      <Text fontSize={tokens.fontSizes.large}>人</Text>
                                    </Flex>
                                  </View>
                                </Flex>
                                {/* 設立年 */}
                                <Flex direction={{base:"column",large:"row"}} gap={{base:"0",large:"10px"}} style={{verticalAlign:"center"}} marginTop="15px">
                                  <Flex direction="row">
                                    <View as="div" width={{base:"",large:"120px"}} textAlign="center" lineHeight="40px">
                                      <Text fontSize={tokens.fontSizes.large} fontWeight={tokens.fontWeights.bold}  textAlign="left">設立年</Text>
                                    </View>
                                    <View as="div" className="notAllowDetailConditionInputIndication tooltipWrapper">
                                      <View className="tooltipTriggerArea" tabIndex={-1}>
                                        <img data-tooltip-id="establishedTooltip" src={IcoInfo} height={"20px"} width={"20px"}/>
                                      </View>
                                    </View>
                                  </Flex>
                                  <View as="div" width={{base:"100%",large:"90%"}}>
                                    <Flex direction="row" gap={{base:"0.5rem",large:"1rem"}} lineHeight="40px" >
                                      <TextField inputStyles={{backgroundColor:`${tokens.colors.white}`,fontSize:`${tokens.fontSizes.large}`,width:"120px",height:"40px"}}  label="" placeholder=""  ref={establishedFromRef} value={establishedFrom} onChange={(e) => setEstablishedFrom(e.target.value)} fontSize={tokens.fontSizes.medium} gap="0" onBlur={() => confirmDetailConditionsIsEnterd(false)}/>
                                      <Flex justifyContent="space-between" gap="0" width={{base:"40px",large:"60px"}} fontSize={tokens.fontSizes.large}>
                                        <Text>年</Text>
                                        <Text>～</Text>
                                      </Flex>
                                      <TextField inputStyles={{backgroundColor:`${tokens.colors.white}`,fontSize:`${tokens.fontSizes.large}`,width:"120px",height:"40px"}} label="" placeholder="" ref={establishedToRef} value={establishedTo} onChange={(e) => setEstablishedTo(e.target.value)} fontSize={tokens.fontSizes.medium} gap="0" onBlur={() => confirmDetailConditionsIsEnterd(false)}/>
                                      <Text fontSize={tokens.fontSizes.large}>年</Text>
                                    </Flex>
                                  </View>
                                </Flex>
                                {/* 資本金 */}
                                <Flex direction={{base:"column",large:"row"}} gap={{base:"0",large:"10px"}} style={{verticalAlign:"center"}} marginTop="15px">
                                  <Flex direction="row">
                                    <View as="div" width={{base:"",large:"120px"}} textAlign="center" lineHeight="40px">
                                      <Text fontSize={tokens.fontSizes.large} fontWeight={tokens.fontWeights.bold}  textAlign="left">資本金</Text>
                                    </View>
                                    <View as="div" className="notAllowDetailConditionInputIndication tooltipWrapper">
                                      <View className="tooltipTriggerArea" tabIndex={-1}>
                                        <img data-tooltip-id="capitalTooltip" src={IcoInfo} height={"20px"} width={"20px"}/>
                                      </View>
                                    </View>
                                  </Flex>
                                  <View as="div" width={{base:"100%",large:"90%"}}>
                                    <Flex direction="row" gap={{base:"0.5rem",large:"1rem"}} lineHeight="40px" >
                                      <TextField inputStyles={{backgroundColor:`${tokens.colors.white}`,fontSize:`${tokens.fontSizes.large}`,width:"120px",height:"40px"}}  label="" placeholder="" ref={capitalFromRef} value={capitalFrom} onChange={(e) => setCapitalFrom(e.target.value)} fontSize={tokens.fontSizes.medium} gap="0" onBlur={() => confirmDetailConditionsIsEnterd(false)}/>
                                      <Flex justifyContent="space-between" gap="0" width={{base:"40px",large:"60px"}} fontSize={tokens.fontSizes.large}>
                                        <Text>万円</Text>
                                        <Text>～</Text>
                                      </Flex>
                                      <TextField inputStyles={{backgroundColor:`${tokens.colors.white}`,fontSize:`${tokens.fontSizes.large}`,width:"120px",height:"40px"}} label="" placeholder="" ref={capitalToRef} value={capitalTo} onChange={(e) => setCapitalTo(e.target.value)} fontSize={tokens.fontSizes.medium} gap="0" onBlur={() => confirmDetailConditionsIsEnterd(false)}/>
                                      <Text fontSize={tokens.fontSizes.large}>万円</Text>
                                    </Flex>
                                  </View>
                                </Flex>
                                {/* 株主 */}
                                <Flex direction={{base:"column",large:"row"}} gap={{base:"0",large:"10px"}} style={{verticalAlign:"center"}} marginTop="15px">
                                  <Flex direction="row">
                                    <View as="div" width={{base:"",large:"120px"}} textAlign="center" lineHeight="40px">
                                      {!allowDetailConditionInput ?
                                        <Text fontSize={tokens.fontSizes.large} fontWeight={tokens.fontWeights.bold}  textAlign="left" color="lightgray">株主</Text>
                                        :
                                        <Text fontSize={tokens.fontSizes.large} fontWeight={tokens.fontWeights.bold}  textAlign="left">株主</Text>
                                      }
                                    </View>
                                    <View as="div" className="notAllowDetailConditionInputIndication tooltipWrapper">
                                      <View className="tooltipTriggerArea" tabIndex={-1}>
                                        <img data-tooltip-id="shareholdersTooltip" src={IcoInfo} height={"20px"} width={"20px"}/>
                                      </View>
                                    </View>
                                  </Flex>
                                  <View as="div" width={{base:"100%",large:"90%"}}>
                                    <Flex direction="row" gap={{base:"0.5rem",large:"1rem"}} lineHeight="40px" >
                                      <TextField isDisabled={!allowDetailConditionInput} inputStyles={{backgroundColor:`${tokens.colors.white}`,fontSize:`${tokens.fontSizes.large}`,width:"120px",height:"40px"}}  label="" placeholder="" ref={shareholdersRef}  fontSize={tokens.fontSizes.medium} gap="0" onBlur={() => confirmDetailConditionsIsEnterd(false)}/>
                                    </Flex>
                                  </View>
                                </Flex>
                                {/* 取引先 */}
                                <Flex direction={{base:"column",large:"row"}} gap={{base:"0",large:"10px"}} style={{verticalAlign:"center"}} marginTop="15px">
                                  <Flex direction="row">
                                    <View as="div" width={{base:"",large:"120px"}} textAlign="center" lineHeight="40px">
                                      {!allowDetailConditionInput ?
                                        <Text fontSize={tokens.fontSizes.large} fontWeight={tokens.fontWeights.bold}  textAlign="left" color="lightgray">取引先</Text>
                                        :
                                        <Text fontSize={tokens.fontSizes.large} fontWeight={tokens.fontWeights.bold}  textAlign="left">取引先</Text>
                                      }
                                    </View>
                                    <View as="div" className="notAllowDetailConditionInputIndication tooltipWrapper">
                                      <View className="tooltipTriggerArea" tabIndex={-1}>
                                        <img data-tooltip-id="partnersTooltip" src={IcoInfo} height={"20px"} width={"20px"}/>
                                      </View>
                                    </View>
                                  </Flex>
                                  <View as="div" width={{base:"100%",large:"90%"}}>
                                    <Flex direction="row" gap={{base:"0.5rem",large:"1rem"}} lineHeight="40px" >
                                      <TextField isDisabled={!allowDetailConditionInput} inputStyles={{backgroundColor:`${tokens.colors.white}`,fontSize:`${tokens.fontSizes.large}`,width:"120px",height:"40px"}}  label="" placeholder="" ref={partnersRef}  fontSize={tokens.fontSizes.medium} gap="0" onBlur={() => confirmDetailConditionsIsEnterd(false)}/>
                                    </Flex>
                                  </View>
                                </Flex>
                                {/* URL */}
                                <Flex direction={{base:"column",large:"row"}} gap={{base:"0",large:"10px"}} marginTop="10px">
                                  <Flex direction="row">
                                    <View as="div" width={{base:"",large:"120px"}} textAlign="center" lineHeight="40px">
                                      <Text fontSize={tokens.fontSizes.large} fontWeight={tokens.fontWeights.bold}  textAlign="left">URL</Text>
                                    </View>
                                    <View as="div" className="notAllowDetailConditionInputIndication tooltipWrapper">
                                      <View className="tooltipTriggerArea" tabIndex={-1}>
                                        <img data-tooltip-id="homepageTooltip" src={IcoInfo} height={"20px"} width={"20px"}/>
                                      </View>
                                    </View>
                                  </Flex>
                                  <View as="div" width={{base:"100%",large:"90%"}} marginLeft={{base:"10px",large:"5px"}}>
                                    <Flex direction="row" gap="1rem" lineHeight={{base:"25px",large:"40px"}}>
                                      <CheckboxField label="有" name="homepage" value="yes" gap="15px" size="large" marginRight="40px" inputStyles={{backgroundColor:`${tokens.colors.white}`}} checked={checkedHaveOrNotHaveHomePage[0]}
                                      onChange={() => {
                                        handleDetailRequirementsChecked(checkedHaveOrNotHaveHomePage,setCheckedHaveOrNotHaveHomePage,0);
                                        confirmDetailConditionsIsEnterd(true);
                                      }}
                                      />
                                      <CheckboxField label="無" name="homepage" value="no" gap="15px" size="large" checked={checkedHaveOrNotHaveHomePage[1]}
                                      onChange={() => {
                                        handleDetailRequirementsChecked(checkedHaveOrNotHaveHomePage,setCheckedHaveOrNotHaveHomePage,1);
                                        confirmDetailConditionsIsEnterd(true);
                                      }}
                                      />
                                    </Flex>
                                  </View>
                                </Flex>
                                {/* 問合せURL */}
                                <Flex direction={{base:"column",large:"row"}} gap={{base:"0",large:"10px"}} marginTop={{base:"15px",large:"0px"}}>
                                  <Flex direction="row">
                                    <View as="div" width={{base:"",large:"120px"}} textAlign="center" lineHeight="40px">
                                      {!allowDetailConditionInput ?
                                        <Text fontSize={tokens.fontSizes.large} fontWeight={tokens.fontWeights.bold}  textAlign="left" color="lightgray">問合せURL</Text>
                                        :
                                        <Text fontSize={tokens.fontSizes.large} fontWeight={tokens.fontWeights.bold}  textAlign="left">問合せURL</Text>
                                      }
                                    </View>
                                    <View as="div" className="notAllowDetailConditionInputIndication tooltipWrapper">
                                      <View className="tooltipTriggerArea" tabIndex={-1}>
                                        <img data-tooltip-id="inquiryPageTooltip" src={IcoInfo} height={"20px"} width={"20px"}/>
                                      </View>
                                    </View>
                                  </Flex>
                                  <View as="div" width={{base:"100%",large:"90%"}} marginLeft={{base:"10px",large:"5px"}}>
                                    <Flex direction="row" gap="1rem" lineHeight={{base:"25px",large:"40px"}}>
                                      <CheckboxField isDisabled={!allowDetailConditionInput} label="有" name="inquiryPage" value="yes" gap="15px" size="large" marginRight="40px" checked={checkedHaveOrNotHaveContactPage[0]}
                                        onChange={() => {
                                            handleDetailRequirementsChecked(checkedHaveOrNotHaveContactPage,setCheckedHaveOrNotHaveContactPage,0);
                                            confirmDetailConditionsIsEnterd(true);
                                        }}
                                        />
                                      <CheckboxField isDisabled={!allowDetailConditionInput} label="無" name="inquiryPage" value="no" gap="15px" size="large" checked={checkedHaveOrNotHaveContactPage[1]}
                                        onChange={() => {
                                          handleDetailRequirementsChecked(checkedHaveOrNotHaveContactPage,setCheckedHaveOrNotHaveContactPage,1);
                                          confirmDetailConditionsIsEnterd(true);
                                        }}
                                        />
                                    </Flex>
                                  </View>
                                </Flex>
                                {/* 上場・非上場 */}
                                <Flex direction={{base:"column",large:"row"}} gap={{base:"0",large:"10px"}} marginTop={{base:"15px",large:"0px"}}>
                                  <Flex direction="row">
                                    <View as="div" width={{base:"",large:"120px"}} textAlign="center" lineHeight="40px">
                                      {!allowDetailConditionInput ?
                                        <Text fontSize={tokens.fontSizes.large} fontWeight={tokens.fontWeights.bold}  textAlign="left" color="lightgray">上場・非上場</Text>
                                        :
                                        <Text fontSize={tokens.fontSizes.large} fontWeight={tokens.fontWeights.bold}  textAlign="left">上場・非上場</Text>
                                      }
                                    </View>
                                    <View as="div" className="notAllowDetailConditionInputIndication tooltipWrapper">
                                      <View className="tooltipTriggerArea" tabIndex={-1}>
                                        <img data-tooltip-id="listedTooltip" src={IcoInfo} height={"20px"} width={"20px"}/>
                                      </View>
                                    </View>
                                  </Flex>
                                  <View as="div" width={{base:"100%",large:"90%"}} marginLeft={{base:"10px",large:"5px"}}>
                                    <Flex direction="row" gap="1rem" lineHeight={{base:"25px",large:"40px"}}>
                                      <CheckboxField isDisabled={!allowDetailConditionInput} label="上場" name="listed" value="yes" gap="15px" size="large" marginRight="27.5px" checked={checkedListedOrUnListedCompany[0]}
                                        onChange={() => {
                                          handleDetailRequirementsChecked(checkedListedOrUnListedCompany,setCheckedListedOrUnListedCompany,0);
                                          confirmDetailConditionsIsEnterd(true);
                                        }}/>
                                      <CheckboxField isDisabled={!allowDetailConditionInput} label="非上場" name="listed" value="no" gap="15px" size="large" checked={checkedListedOrUnListedCompany[1]}
                                        onChange={() => {
                                          handleDetailRequirementsChecked(checkedListedOrUnListedCompany,setCheckedListedOrUnListedCompany,1);
                                          confirmDetailConditionsIsEnterd(true);
                                        }}/>
                                    </Flex>
                                  </View>
                                </Flex>
                                {/* 閉鎖企業 */}
                                <Flex direction={{base:"column",large:"row"}} gap={{base:"0",large:"10px"}} marginTop={{base:"15px",large:"0px"}}>
                                  <Flex direction="row">
                                    <View as="div" width={{base:"",large:"120px"}} textAlign="center" lineHeight="40px">
                                      {!allowDetailConditionInput ?
                                        <Text fontSize={tokens.fontSizes.large} fontWeight={tokens.fontWeights.bold}  textAlign="left" color="lightgray">閉鎖企業</Text>
                                        :
                                        <Text fontSize={tokens.fontSizes.large} fontWeight={tokens.fontWeights.bold}  textAlign="left">閉鎖企業</Text>
                                      }
                                    </View>
                                    <View as="div" className="notAllowDetailConditionInputIndication tooltipWrapper">
                                      <View className="tooltipTriggerArea" tabIndex={-1}>
                                        <img data-tooltip-id="closedTooltip" src={IcoInfo} height={"20px"} width={"20px"}/>
                                      </View>
                                    </View>
                                  </Flex>
                                  <View as="div" width={{base:"100%",large:"90%"}} marginLeft={{base:"10px",large:"5px"}}>
                                    <Flex direction="row" gap="1rem" lineHeight={{base:"25px",large:"40px"}}>
                                      <CheckboxField isDisabled={!allowDetailConditionInput} label="有" name="closed" value="yes" gap="15px" size="large" marginRight="40px" checked={checkedCloseOrOpenCompany[0]}
                                        onChange={() => {
                                          handleDetailRequirementsChecked(checkedCloseOrOpenCompany,setCheckedCloseOrOpenCompany,0);
                                          confirmDetailConditionsIsEnterd(true);
                                        }}
                                        />
                                      <CheckboxField isDisabled={!allowDetailConditionInput} label="無" name="closed" value="no" gap="15px" size="large" checked={checkedCloseOrOpenCompany[1]}
                                        onChange={() => {
                                          handleDetailRequirementsChecked(checkedCloseOrOpenCompany,setCheckedCloseOrOpenCompany,1)
                                          confirmDetailConditionsIsEnterd(true);
                                        }}/>
                                    </Flex>
                                  </View>
                                </Flex>
                                {/* 届出認定 */}
                                <Flex direction={{base:"column",large:"row"}} gap={{base:"0",large:"10px"}} marginTop={{base:"15px",large:"0px"}}>
                                  <Flex direction="row">
                                    <View as="div" width={{base:"",large:"120px"}} textAlign="center" lineHeight="40px">
                                      {!allowDetailConditionInput ?
                                        <Text fontSize={tokens.fontSizes.large} fontWeight={tokens.fontWeights.bold}  textAlign="left" color="lightgray">届出認定</Text>
                                        :
                                        <Text fontSize={tokens.fontSizes.large} fontWeight={tokens.fontWeights.bold}  textAlign="left">届出認定</Text>
                                      }
                                    </View>
                                    <View as="div" className="notAllowDetailConditionInputIndication tooltipWrapper">
                                      <View className="tooltipTriggerArea" tabIndex={-1}>
                                        <img data-tooltip-id="certificationTooltip" src={IcoInfo} height={"20px"} width={"20px"}/>
                                      </View>
                                    </View>
                                  </Flex>
                                  <View as="div" width={{base:"100%",large:"90%"}} marginLeft={{base:"10px",large:"5px"}}>
                                    <Flex direction="row" gap="1rem" lineHeight={{base:"25px",large:"40px"}}>
                                      <CheckboxField isDisabled={!allowDetailConditionInput} label="有" name="certification" value="yes" gap="15px" size="large" marginRight="40px" checked={checkedNotificationCertification[0]}
                                        onChange={() => {
                                          handleDetailRequirementsChecked(checkedNotificationCertification,setCheckedNotificationCertification,0);
                                          confirmDetailConditionsIsEnterd(true);
                                        }}
                                        />
                                      <CheckboxField isDisabled={!allowDetailConditionInput} label="無" name="certification" value="no" gap="15px" size="large" checked={checkedNotificationCertification[1]}
                                        onChange={() => {
                                          handleDetailRequirementsChecked(checkedNotificationCertification,setCheckedNotificationCertification,1)
                                          confirmDetailConditionsIsEnterd(true);
                                        }}/>
                                    </Flex>
                                  </View>
                                </Flex>
                                {/* 表彰名 */}
                                <Flex direction={{base:"column",large:"row"}} gap={{base:"0",large:"10px"}} marginTop={{base:"15px",large:"0px"}}>
                                  <Flex direction="row">
                                    <View as="div" width={{base:"",large:"120px"}} textAlign="center" lineHeight="40px">
                                      {!allowDetailConditionInput ?
                                        <Text fontSize={tokens.fontSizes.large} fontWeight={tokens.fontWeights.bold}  textAlign="left" color="lightgray">表彰名</Text>
                                        :
                                        <Text fontSize={tokens.fontSizes.large} fontWeight={tokens.fontWeights.bold}  textAlign="left">表彰名</Text>
                                      }
                                    </View>
                                    <View as="div" className="notAllowDetailConditionInputIndication tooltipWrapper">
                                      <View className="tooltipTriggerArea" tabIndex={-1}>
                                        <img data-tooltip-id="awardTooltip" src={IcoInfo} height={"20px"} width={"20px"}/>
                                      </View>
                                    </View>
                                  </Flex>
                                  <View as="div" width={{base:"100%",large:"90%"}} marginLeft={{base:"10px",large:"5px"}}>
                                    <Flex direction="row" gap="1rem" lineHeight={{base:"25px",large:"40px"}}>
                                      <CheckboxField isDisabled={!allowDetailConditionInput} label="有" name="award" value="yes" gap="15px" size="large" marginRight="40px" checked={checkedAwardName[0]}
                                        onChange={() => {
                                          handleDetailRequirementsChecked(checkedAwardName,setCheckedAwardName,0);
                                          confirmDetailConditionsIsEnterd(true);
                                        }}
                                        />
                                      <CheckboxField isDisabled={!allowDetailConditionInput} label="無" name="award" value="no" gap="15px" size="large" checked={checkedAwardName[1]}
                                        onChange={() => {
                                          handleDetailRequirementsChecked(checkedAwardName,setCheckedAwardName,1)
                                          confirmDetailConditionsIsEnterd(true);
                                        }}/>
                                    </Flex>
                                  </View>
                                </Flex>
                                {/* 資格等級 */}
                                <Flex direction={{base:"column",large:"row"}} gap={{base:"0",large:"10px"}} marginTop={{base:"15px",large:"0px"}}>
                                  <Flex direction="row">
                                    <View as="div" width={{base:"",large:"120px"}} textAlign="center" lineHeight="40px">
                                      {!allowDetailConditionInput ?
                                        <Text fontSize={tokens.fontSizes.large} fontWeight={tokens.fontWeights.bold}  textAlign="left" color="lightgray">資格等級</Text>
                                        :
                                        <Text fontSize={tokens.fontSizes.large} fontWeight={tokens.fontWeights.bold}  textAlign="left">資格等級</Text>
                                      }
                                    </View>
                                    <View as="div" className="notAllowDetailConditionInputIndication tooltipWrapper">
                                      <View className="tooltipTriggerArea" tabIndex={-1}>
                                        <img data-tooltip-id="qualificationTooltip" src={IcoInfo} height={"20px"} width={"20px"}/>
                                      </View>
                                    </View>
                                  </Flex>
                                  <View as="div" width={{base:"100%",large:"90%"}} marginLeft={{base:"10px",large:"5px"}}>
                                    <Flex direction="row" gap="1rem" lineHeight={{base:"25px",large:"40px"}}>
                                      <CheckboxField isDisabled={!allowDetailConditionInput} label="有" name="qualification" value="yes" gap="15px" size="large" marginRight="40px" checked={checkedQualificationLevel[0]}
                                        onChange={() => {
                                          handleDetailRequirementsChecked(checkedQualificationLevel,setCheckedQualificationLevel,0);
                                          confirmDetailConditionsIsEnterd(true);
                                        }}
                                        />
                                      <CheckboxField isDisabled={!allowDetailConditionInput} label="無" name="qualification" value="no" gap="15px" size="large" checked={checkedQualificationLevel[1]}
                                        onChange={() => {
                                          handleDetailRequirementsChecked(checkedQualificationLevel,setCheckedQualificationLevel,1)
                                          confirmDetailConditionsIsEnterd(true);
                                        }}/>
                                    </Flex>
                                  </View>
                                </Flex>
                                {/* 調達情報 */}
                                <Flex direction={{base:"column",large:"row"}} gap={{base:"0",large:"10px"}} marginTop={{base:"15px",large:"0px"}}>
                                  <Flex direction="row">
                                    <View as="div" width={{base:"",large:"120px"}} textAlign="center" lineHeight="40px">
                                      {!allowDetailConditionInput ?
                                        <Text fontSize={tokens.fontSizes.large} fontWeight={tokens.fontWeights.bold}  textAlign="left" color="lightgray">調達情報</Text>
                                        :
                                        <Text fontSize={tokens.fontSizes.large} fontWeight={tokens.fontWeights.bold}  textAlign="left">調達情報</Text>
                                      }
                                    </View>
                                    <View as="div" className="notAllowDetailConditionInputIndication tooltipWrapper">
                                      <View className="tooltipTriggerArea" tabIndex={-1}>
                                        <img data-tooltip-id="infoTooltip" src={IcoInfo} height={"20px"} width={"20px"}/>
                                      </View>
                                    </View>
                                  </Flex>
                                  <View as="div" width={{base:"100%",large:"90%"}} marginLeft={{base:"10px",large:"5px"}}>
                                    <Flex direction="row" gap="1rem" lineHeight={{base:"25px",large:"40px"}}>
                                      <CheckboxField isDisabled={!allowDetailConditionInput} label="有" name="info" value="yes" gap="15px" size="large" marginRight="40px" checked={checkedProcurementInformation[0]}
                                        onChange={() => {
                                          handleDetailRequirementsChecked(checkedProcurementInformation,setCheckedProcurementInformation,0);
                                          confirmDetailConditionsIsEnterd(true);
                                        }}
                                        />
                                      <CheckboxField isDisabled={!allowDetailConditionInput} label="無" name="info" value="no" gap="15px" size="large" checked={checkedProcurementInformation[1]}
                                        onChange={() => {
                                          handleDetailRequirementsChecked(checkedProcurementInformation,setCheckedProcurementInformation,1)
                                          confirmDetailConditionsIsEnterd(true);
                                        }}/>
                                    </Flex>
                                  </View>
                                </Flex>
                                {/* 出力済み企業 */}
                                <Flex direction={{base:"column",large:"row"}} gap={{base:"0",large:"10px"}} marginTop={{base:"15px",large:"0px"}}>
                                  <Flex direction="row">
                                    <View as="div" width={{base:"",large:"120px"}} textAlign="center" lineHeight="40px">
                                      {!allowDetailConditionInput ?
                                        <Text fontSize={tokens.fontSizes.large} fontWeight={tokens.fontWeights.bold}  textAlign="left" color="lightgray">出力済み企業</Text>
                                        :
                                        <Text fontSize={tokens.fontSizes.large} fontWeight={tokens.fontWeights.bold}  textAlign="left">出力済み企業</Text>
                                      }
                                    </View>
                                    <View as="div" className="notAllowDetailConditionInputIndication tooltipWrapper">
                                      <View className="tooltipTriggerArea" tabIndex={-1}>
                                        <img data-tooltip-id="outputTooltip" src={IcoInfo} height={"20px"} width={"20px"}/>
                                      </View>
                                    </View>
                                  </Flex>
                                  <View as="div" width={{base:"100%",large:"90%"}} marginLeft={{base:"10px",large:"5px"}}>
                                    <Flex direction="row" gap="1rem" lineHeight={{base:"25px",large:"40px"}}>
                                      <CheckboxField className="customCheckbox" isDisabled={!allowDetailConditionInput} label="有" name="exported" value="yes" gap="15px" size="large" marginRight="40px" checked={checkedOutputOrNotOutputCompany[0]}
                                        onChange={() => {
                                          handleDetailRequirementsChecked(checkedOutputOrNotOutputCompany,setCheckedOutputOrNotOutputCompany,0);
                                          confirmDetailConditionsIsEnterd(true);
                                        }}/>
                                      <CheckboxField className="customCheckbox" isDisabled={!allowDetailConditionInput} label="無" name="exported" value="no" gap="15px" size="large" checked={checkedOutputOrNotOutputCompany[1]}
                                        onChange={() => {
                                          handleDetailRequirementsChecked(checkedOutputOrNotOutputCompany,setCheckedOutputOrNotOutputCompany,1);
                                          confirmDetailConditionsIsEnterd(true);
                                        }}/>
                                    </Flex>
                                  </View>
                                </Flex>
                              </Flex>
                            </Accordion.Content>
                          </Accordion.Item>
                        </Accordion.Container>
                        {/* インフォメーションツールチップ */}
                        <View as="div">
                          {/* 売上 */}
                          <Tooltip id="salesTooltip" noArrow={true} clickable={true} opacity="1" positionStrategy="absolute" place="top-start" delayShow={20}
                            style={{maxWidth:"90vw", zIndex:"10", padding:"0.5rem", whiteSpace:"normal", fontSize:"1.2rem", lineHeight:"2.5rem", backgroundColor:"var(--color-blue-d)", color:"white", borderRadius:"3px", boxShadow:"0 0.2rem 0.2rem gray"}}
                          >
                            <p>売上の範囲指定で絞り込みができます。<br/>※空欄は上限・下限無しとして扱います。</p>
                          </Tooltip>
                          {/* 従業員数 */}
                          <Tooltip id="employeesNumTooltip" noArrow={true} clickable={true} opacity="1" positionStrategy="absolute" place="top-start" delayShow={20}
                            style={{maxWidth:"90vw", zIndex:"10", padding:"0.5rem", whiteSpace:"normal", fontSize:"1.2rem", lineHeight:"2.5rem", backgroundColor:"var(--color-blue-d)", color:"white", borderRadius:"3px", boxShadow:"0 0.2rem 0.2rem gray"}}
                          >
                            <p>従業員数の範囲指定で絞り込みができます。<br/>※空欄は上限・下限無しとして扱います。</p>
                          </Tooltip>
                          {/* 設立年 */}
                          <Tooltip id="establishedTooltip" noArrow={true} clickable={true} opacity="1" positionStrategy="absolute" place="top-start" delayShow={20}
                            style={{maxWidth:"90vw", zIndex:"10", padding:"0.5rem", whiteSpace:"normal", fontSize:"1.2rem", lineHeight:"2.5rem", backgroundColor:"var(--color-blue-d)", color:"white", borderRadius:"3px", boxShadow:"0 0.2rem 0.2rem gray"}}
                          >
                            <p>設立年の範囲指定で絞り込みができます。<br/>※空欄は上限・下限無しとして扱います。</p>
                          </Tooltip>
                          {/* 資本金 */}
                          <Tooltip id="capitalTooltip" noArrow={true} clickable={true} opacity="1" positionStrategy="absolute" place="top-start" delayShow={20}
                            style={{maxWidth:"90vw", zIndex:"10", padding:"0.5rem", whiteSpace:"normal", fontSize:"1.2rem", lineHeight:"2.5rem", backgroundColor:"var(--color-blue-d)", color:"white", borderRadius:"3px", boxShadow:"0 0.2rem 0.2rem gray"}}
                          >
                            <p>資本金の範囲指定で絞り込みができます。<br/>※空欄は上限・下限無しとして扱います。</p>
                          </Tooltip>
                          {/* 株主 */}
                          <Tooltip id="shareholdersTooltip" noArrow={true} clickable={true} opacity="1" positionStrategy="absolute" place="top-start" delayShow={20}
                            style={{maxWidth:"90vw", zIndex:"10", padding:"0.5rem", whiteSpace:"normal", fontSize:"1.2rem", lineHeight:"2.5rem", backgroundColor:"var(--color-blue-d)", color:"white", borderRadius:"3px", boxShadow:"0 0.2rem 0.2rem gray"}}
                          >
                            {!allowDetailConditionInput ?
                              <p>
                                フリーPlusプランおよびベーシックプランでご利用いただけます。<br/>料金プランの詳細や変更のお申込みは
                                <a href="https://cnavi-app.g-search.or.jp/planchange" target="_blank" rel="noopener noreferrer" style={{ color: '#cce5ff', textDecoration: 'underline', marginLeft: '4px' }} onClick={(e) => {e.stopPropagation(); }}>こちらから</a>
                              </p>
                              :
                              <p>収録情報の株主名から当てはまるキーワードで<wbr/>絞り込みができます。</p>
                            }
                          </Tooltip>
                          {/* 取引先 */}
                          <Tooltip id="partnersTooltip" noArrow={true} clickable={true} opacity="1" positionStrategy="absolute" place="top-start" delayShow={20}
                            style={{maxWidth:"80vw", zIndex:"10", padding:"0.5rem", whiteSpace:"normal", fontSize:"1.2rem", lineHeight:"2.5rem", backgroundColor:"var(--color-blue-d)", color:"white", borderRadius:"3px", boxShadow:"0 0.2rem 0.2rem gray"}}
                          >
                            {!allowDetailConditionInput ?
                              <p>
                                フリーPlusプランおよびベーシックプランでご利用いただけます。<br/>料金プランの詳細や変更のお申込みは
                                <a href="https://cnavi-app.g-search.or.jp/planchange" target="_blank" rel="noopener noreferrer" style={{ color: '#cce5ff', textDecoration: 'underline', marginLeft: '4px' }} onClick={(e) => {e.stopPropagation(); }}>こちらから</a>
                              </p>
                              :
                              <p>収録情報の取引先名から当てはまるキーワードで絞り込みができます。</p>
                            }
                          </Tooltip>
                          {/* URL */}
                          <Tooltip id="homepageTooltip" noArrow={true} clickable={true} opacity="1" positionStrategy="absolute" place="top-start" delayShow={20}
                            style={{maxWidth:"90vw", zIndex:"10", padding:"0.5rem", whiteSpace:"normal", fontSize:"1.2rem", lineHeight:"2.5rem", backgroundColor:"var(--color-blue-d)", color:"white", borderRadius:"3px", boxShadow:"0 0.2rem 0.2rem gray"}}
                          >
                            <p>企業URLの有無を選択して絞り込みができます。</p>
                          </Tooltip>
                          {/* 問合せURL */}
                          <Tooltip id="inquiryPageTooltip" noArrow={true} clickable={true} opacity="1" positionStrategy="absolute" place="top-start" delayShow={20}
                            style={{maxWidth:"80vw", zIndex:"10", padding:"0.5rem", whiteSpace:"normal", fontSize:"1.2rem", lineHeight:"2.5rem", backgroundColor:"var(--color-blue-d)", color:"white", borderRadius:"3px", boxShadow:"0 0.2rem 0.2rem gray"}}
                          >
                            {!allowDetailConditionInput ?
                              <p>
                                フリーPlusプランおよびベーシックプランでご利用いただけます。<br/>料金プランの詳細や変更のお申込みは
                                <a href="https://cnavi-app.g-search.or.jp/planchange" target="_blank" rel="noopener noreferrer" style={{ color: '#cce5ff', textDecoration: 'underline', marginLeft: '4px' }} onClick={(e) => {e.stopPropagation(); }}>こちらから</a>
                              </p>
                              :
                              <p>問合わせURLの有無を選択して絞り込みができます。</p>
                            }
                          </Tooltip>
                          {/* 上場・非上場 */}
                          <Tooltip id="listedTooltip" noArrow={true} clickable={true} opacity="1" positionStrategy="absolute" place="top-start" delayShow={20}
                            style={{maxWidth:"80vw", zIndex:"10", padding:"0.5rem", whiteSpace:"normal", fontSize:"1.2rem", lineHeight:"2.5rem", backgroundColor:"var(--color-blue-d)", color:"white", borderRadius:"3px", boxShadow:"0 0.2rem 0.2rem gray"}}
                          >
                            {!allowDetailConditionInput ?
                              <p>
                                フリーPlusプランおよびベーシックプランでご利用いただけます。<br/>料金プランの詳細や変更のお申込みは
                                <a href="https://cnavi-app.g-search.or.jp/planchange" target="_blank" rel="noopener noreferrer" style={{ color: '#cce5ff', textDecoration: 'underline', marginLeft: '4px' }} onClick={(e) => {e.stopPropagation(); }}>こちらから</a>
                              </p>
                              :
                              <p>上場・非上場を選択して絞り込みができます。</p>
                            }
                          </Tooltip>
                          {/* 閉鎖企業 */}
                          <Tooltip id="closedTooltip" noArrow={true} clickable={true} opacity="1" positionStrategy="absolute" place="top-start" delayShow={20}
                            style={{maxWidth:"80vw", zIndex:"10", padding:"0.5rem", whiteSpace:"normal", fontSize:"1.2rem", lineHeight:"2.5rem", backgroundColor:"var(--color-blue-d)", color:"white", borderRadius:"3px", boxShadow:"0 0.2rem 0.2rem gray"}}
                          >
                            {!allowDetailConditionInput ?
                              <p>
                                フリーPlusプランおよびベーシックプランでご利用いただけます。<br/>料金プランの詳細や変更のお申込みは
                                <a href="https://cnavi-app.g-search.or.jp/planchange" target="_blank" rel="noopener noreferrer" style={{ color: '#cce5ff', textDecoration: 'underline', marginLeft: '4px' }} onClick={(e) => {e.stopPropagation(); }}>こちらから</a>
                              </p>
                              :
                              <p>閉鎖企業かどうかを選択して絞り込みができます。</p>
                            }
                          </Tooltip>
                          {/* 届出認定 */}
                          <Tooltip id="certificationTooltip" noArrow={true} clickable={true} opacity="1" positionStrategy="absolute" place="top-start" delayShow={20}
                            style={{maxWidth:"80vw", zIndex:"10", padding:"0.5rem", whiteSpace:"normal", fontSize:"1.2rem", lineHeight:"2.5rem", backgroundColor:"var(--color-blue-d)", color:"white", borderRadius:"3px", boxShadow:"0 0.2rem 0.2rem gray"}}
                          >
                            {!allowDetailConditionInput ?
                              <p>
                                フリーPlusプランおよびベーシックプランでご利用いただけます。<br/>料金プランの詳細や変更のお申込みは
                                <a href="https://cnavi-app.g-search.or.jp/planchange" target="_blank" rel="noopener noreferrer" style={{ color: '#cce5ff', textDecoration: 'underline', marginLeft: '4px' }} onClick={(e) => {e.stopPropagation(); }}>こちらから</a>
                              </p>
                              :
                              <p>届出認定等の有無を選択して絞り込みができます。</p>
                            }
                          </Tooltip>
                          {/* 表彰名 */}
                          <Tooltip id="awardTooltip" noArrow={true} clickable={true} opacity="1" positionStrategy="absolute" place="top-start" delayShow={20}
                            style={{maxWidth:"80vw", zIndex:"10", padding:"0.5rem", whiteSpace:"normal", fontSize:"1.2rem", lineHeight:"2.5rem", backgroundColor:"var(--color-blue-d)", color:"white", borderRadius:"3px", boxShadow:"0 0.2rem 0.2rem gray"}}
                          >
                            {!allowDetailConditionInput ?
                              <p>
                                フリーPlusプランおよびベーシックプランでご利用いただけます。<br/>料金プランの詳細や変更のお申込みは
                                <a href="https://cnavi-app.g-search.or.jp/planchange" target="_blank" rel="noopener noreferrer" style={{ color: '#cce5ff', textDecoration: 'underline', marginLeft: '4px' }} onClick={(e) => {e.stopPropagation(); }}>こちらから</a>
                              </p>
                              :
                              <p>表彰の有無を選択して絞り込みができます。</p>
                            }
                          </Tooltip>
                          {/* 資格等級 */}
                          <Tooltip id="qualificationTooltip" noArrow={true} clickable={true} opacity="1" positionStrategy="absolute" place="top-start" delayShow={20}
                            style={{maxWidth:"80vw", zIndex:"10", padding:"0.5rem", whiteSpace:"normal", fontSize:"1.2rem", lineHeight:"2.5rem", backgroundColor:"var(--color-blue-d)", color:"white", borderRadius:"3px", boxShadow:"0 0.2rem 0.2rem gray"}}
                          >
                            {!allowDetailConditionInput ?
                              <p>
                                フリーPlusプランおよびベーシックプランでご利用いただけます。<br/>料金プランの詳細や変更のお申込みは
                                <a href="https://cnavi-app.g-search.or.jp/planchange" target="_blank" rel="noopener noreferrer" style={{ color: '#cce5ff', textDecoration: 'underline', marginLeft: '4px' }} onClick={(e) => {e.stopPropagation(); }}>こちらから</a>
                              </p>
                              :
                              <p>資格等級の有無を選択して絞り込みができます。</p>
                            }
                          </Tooltip>
                          {/* 調達情報 */}
                          <Tooltip id="infoTooltip" noArrow={true} clickable={true} opacity="1" positionStrategy="absolute" place="top-start" delayShow={20}
                            style={{maxWidth:"80vw", zIndex:"10", padding:"0.5rem", whiteSpace:"normal", fontSize:"1.2rem", lineHeight:"2.5rem", backgroundColor:"var(--color-blue-d)", color:"white", borderRadius:"3px", boxShadow:"0 0.2rem 0.2rem gray"}}
                          >
                            {!allowDetailConditionInput ?
                              <p>
                                フリーPlusプランおよびベーシックプランでご利用いただけます。<br/>料金プランの詳細や変更のお申込みは
                                <a href="https://cnavi-app.g-search.or.jp/planchange" target="_blank" rel="noopener noreferrer" style={{ color: '#cce5ff', textDecoration: 'underline', marginLeft: '4px' }} onClick={(e) => {e.stopPropagation(); }}>こちらから</a>
                              </p>
                              :
                              <p>調達情報の有無を選択して絞り込みができます。</p>
                            }
                          </Tooltip>
                          {/* 出力済み企業 */}
                          <Tooltip id="outputTooltip" noArrow={true} clickable={true} opacity="1" positionStrategy="absolute" place="top-start" delayShow={20}
                            style={{maxWidth:"80vw", zIndex:"10", padding:"0.5rem", whiteSpace:"normal", fontSize:"1.2rem", lineHeight:"2.5rem", backgroundColor:"var(--color-blue-d)", color:"white", borderRadius:"3px", boxShadow:"0 0.2rem 0.2rem gray"}}
                          >
                            {!allowDetailConditionInput ?
                              <p>
                                フリーPlusプランおよびベーシックプランでご利用いただけます。<br/>料金プランの詳細や変更のお申込みは
                                <a href="https://cnavi-app.g-search.or.jp/planchange" target="_blank" rel="noopener noreferrer" style={{ color: '#cce5ff', textDecoration: 'underline', marginLeft: '4px' }} onClick={(e) => {e.stopPropagation(); }}>こちらから</a>
                              </p>
                              :
                              <p>企業詳細情報を出力した実績がある企業かどうかを選択して絞り込みができます。</p>
                            }
                          </Tooltip>
                        </View>

                        {/* フラグ-PC */}
                        <Flex id="corporateNameInput" className="flagPC" justifyContent="space-between" backgroundColor={tokens.colors.white} borderColor={tokens.colors.blue[60]} borderWidth="2px" height="50px" lineHeight="50px" paddingLeft={{base:"15px",large:"20px"}} paddingRight={{base:"10px",large:"20px"}} style={{borderBottom:"solid",borderRight:"solid",borderLeft:"solid",borderTop:"none"}}>
                          <Flex width="100%">
                            {!allowDetailConditionInput ?
                              <Text fontSize={tokens.fontSizes.large} width="175px"  fontWeight={tokens.fontWeights.bold} color="lightgray"><View as="span" fontSize={{base:tokens.fontSizes.xl,large:tokens.fontSizes.xxl}} style={{marginRight:"2px"}}>フラグ</View>から絞る</Text>
                            :
                              <Text fontSize={tokens.fontSizes.large} width="175px" fontWeight={tokens.fontWeights.bold}><View as="span" fontSize={{base:tokens.fontSizes.xl,large:tokens.fontSizes.xxl}} style={{marginRight:"2px"}}>フラグ</View>から絞る</Text>
                            }
                            {!allowDetailConditionInput ?
                              <View as="div" className="notAllowDetailConditionInputIndication tooltipWrapper" marginLeft="1rem">
                                <View className="tooltipTriggerArea" tabIndex={-1}>
                                  <img src={IcoInfo} height={"20px"} width={"20px"}/>
                                  <View as="span" className="notAllowDetailConditionInputIndication__tooltip">
                                      フリーPlusプランおよびベーシックプランでご利用いただけます。<br />料金プランの詳細や変更のお申込みは
                                    <a href="https://cnavi-app.g-search.or.jp/planchange" target="_blank" rel="noopener noreferrer" style={{ color: '#cce5ff', textDecoration: 'underline', marginLeft: '4px' }} onClick={(e) => {e.stopPropagation(); }}>こちらから</a>
                                  </View>
                                </View>
                              </View>
                              :
                              <View as="div" className="notAllowDetailConditionInputIndication tooltipWrapper" marginLeft="1rem">
                                <View className="tooltipTriggerArea" tabIndex={-1}>
                                  <img src={IcoInfo} height={"20px"} width={"20px"}/>
                                  <View as="span" className="notAllowDetailConditionInputIndication__tooltip">
                                    特徴フラグを指定して絞り込みができます。
                                  </View>
                                </View>
                              </View>
                            }
                            <Flex direction="row" gap="20px" lineHeight={{base:"25px",large:"40px"}} marginLeft="20px">
                              <CheckboxField isDisabled={!allowDetailConditionInput} label="新設" name="newly" value="yes" gap="15px" size="large" checked={checkedNewlyEstablished}
                                onChange={() => {
                                  handleFlagRequirementsChecked(checkedNewlyEstablished,setCheckedNewlyEstablished);
                                  confirmFlagIsEnterd(false);
                                }}/>
                              <CheckboxField isDisabled={!allowDetailConditionInput} label="DX認定" name="dx" value="yes" gap="15px" size="large" checked={checkedDXCertified}
                                onChange={() => {
                                  handleFlagRequirementsChecked(checkedDXCertified,setCheckedDXCertified);
                                  confirmFlagIsEnterd(false);
                                }}/>
                              <CheckboxField isDisabled={!allowDetailConditionInput} label="地域経済担い手" name="leaders" value="yes" gap="15px" size="large" checked={checkedRegionalEconomicLeaders}
                                onChange={() => {
                                  handleFlagRequirementsChecked(checkedRegionalEconomicLeaders,setCheckedRegionalEconomicLeaders);
                                  confirmFlagIsEnterd(false);
                                }}/>
                              <CheckboxField isDisabled={!allowDetailConditionInput} label="女性活躍推進" name="women" value="yes" gap="15px" size="large" checked={checkedPromotionWomenSuccess}
                                onChange={() => {
                                  handleFlagRequirementsChecked(checkedPromotionWomenSuccess,setCheckedPromotionWomenSuccess);
                                  confirmFlagIsEnterd(false);
                                }}/>
                              <CheckboxField isDisabled={!allowDetailConditionInput} label="子育て・家庭と仕事の両立支援" name="support" value="yes" gap="15px" size="large" checked={checkedLifeAndWorkSupport}
                                onChange={() => {
                                  handleFlagRequirementsChecked(checkedLifeAndWorkSupport,setCheckedLifeAndWorkSupport);
                                  confirmFlagIsEnterd(false);
                                }}/>
                              <CheckboxField isDisabled={!allowDetailConditionInput} label="若者採用・育成推進" name="youth" value="yes" gap="15px" size="large" checked={checkedPromotingYouthDevelopment}
                                onChange={() => {
                                  handleFlagRequirementsChecked(checkedPromotingYouthDevelopment,setCheckedPromotingYouthDevelopment);
                                  confirmFlagIsEnterd(false);
                                }}/>
                            </Flex>
                          </Flex>
                        </Flex>
                        {/* フラグ-SP */}
                        <Accordion.Container className="flagSP" value={accordionOpenManage} onValueChange={(value: string[] | undefined) => setAccordionOpenManage(value)}>
                          <Accordion.Item value="flag" borderColor={tokens.colors.blue[60]} borderRadius="0" borderWidth="2px" style={{borderTop:"none"}}>
                            <Accordion.Trigger className="SearchFilterAccordion" backgroundColor={tokens.colors.white} padding="0" height="50px" lineHeight="50px" paddingLeft={{base:"15px",large:"20px"}} boxShadow="none" paddingRight={{base:"5px",large:"15px"}}>
                              <Flex>
                                {!allowDetailConditionInput ?
                                  <Text fontSize={tokens.fontSizes.large} width={{base:"115px", large:"150px"}} fontWeight={tokens.fontWeights.bold} color="lightgray"><View as="span" fontSize={{base:tokens.fontSizes.xl,large:tokens.fontSizes.xxl}} style={{marginRight:"2px"}}>フラグ</View>から絞る</Text>
                                :
                                  <Text fontSize={tokens.fontSizes.large} width={{base:"115px", large:"150px"}} fontWeight={tokens.fontWeights.bold}><View as="span" fontSize={{base:tokens.fontSizes.xl,large:tokens.fontSizes.xxl}} style={{marginRight:"2px"}}>フラグ</View>から絞る</Text>
                                }
                                {isEnteredFlag ? <img src={IcoFilterOn} height={"25px"} width={"25px"} data-tooltip-id="flagTooltip"/> : <img src={IcoFilterOff} height={"25px"} width={"25px"} />}
                                <Tooltip id="flagTooltip" place="top-start" style={{maxWidth:"90%", whiteSpace:"normal", backgroundColor:"#d2e0ff", color:"#222", lineHeight:1}}>{formatFlagRequirementsForSaveSearchData()}</Tooltip>
                                {!allowDetailConditionInput ?
                                  <View as="div" className="notAllowDetailConditionInputIndication tooltipWrapper">
                                    <View className="tooltipTriggerArea" tabIndex={-1}>
                                      <img src={IcoInfo} height={"20px"} width={"20px"}/>
                                      <View as="span" className="notAllowDetailConditionInputIndication__tooltip">
                                          フリーPlusプランおよびベーシックプランでご利用いただけます。<br />料金プランの詳細や変更のお申込みは
                                        <a href="https://cnavi-app.g-search.or.jp/planchange" target="_blank" rel="noopener noreferrer" style={{ color: '#cce5ff', textDecoration: 'underline', marginLeft: '4px' }} onClick={(e) => {e.stopPropagation(); }}>こちらから</a>
                                      </View>
                                    </View>
                                  </View>
                                  :
                                  <View as="div" className="notAllowDetailConditionInputIndication tooltipWrapper">
                                    <View className="tooltipTriggerArea" tabIndex={-1}>
                                      <img src={IcoInfo} height={"20px"} width={"20px"}/>
                                      <View as="span" className="notAllowDetailConditionInputIndication__tooltip">
                                        特徴フラグを指定して絞り込みができます。
                                      </View>
                                    </View>
                                  </View>
                                }
                              </Flex>
                              <IoMdArrowDropdown size="40px" className="amplify-accordion__item__icon"/>
                            </Accordion.Trigger>
                            <Accordion.Content backgroundColor={tokens.colors.blue[10]} maxHeight="350px" paddingTop="15px" paddingBottom="20px" paddingLeft={{base:"15px",large:"50px"}} style={{overflowX:"hidden",overflowY:"scroll"}}>
                            <Flex direction="column" gap="20px" lineHeight={{base:"25px",large:"40px"}} marginLeft="20px">
                              <CheckboxField isDisabled={!allowDetailConditionInput} label="新設" name="newly" value="yes" gap="15px" size="large" ref={newlyEstablishedRef} checked={checkedNewlyEstablished}
                                onChange={() => {
                                  handleFlagRequirementsChecked(checkedNewlyEstablished,setCheckedNewlyEstablished);
                                  confirmFlagIsEnterd(false);
                                }}/>
                              <CheckboxField isDisabled={!allowDetailConditionInput} label="DX認定" name="dx" value="yes" gap="15px" size="large" ref={dxCertifiedRef} checked={checkedDXCertified}
                                onChange={() => {
                                  handleFlagRequirementsChecked(checkedDXCertified,setCheckedDXCertified);
                                  confirmFlagIsEnterd(false);
                                }}/>
                              <CheckboxField isDisabled={!allowDetailConditionInput} label="地域経済担い手" name="leaders" value="yes" gap="15px" size="large" ref={regionalEconomicLeadersRef} checked={checkedRegionalEconomicLeaders}
                                onChange={() => {
                                  handleFlagRequirementsChecked(checkedRegionalEconomicLeaders,setCheckedRegionalEconomicLeaders);
                                  confirmFlagIsEnterd(false);
                                }}/>
                              <CheckboxField isDisabled={!allowDetailConditionInput} label="女性活躍推進" name="women" value="yes" gap="15px" size="large" ref={promotionWomenSuccessRef} checked={checkedPromotionWomenSuccess}
                                onChange={() => {
                                  handleFlagRequirementsChecked(checkedPromotionWomenSuccess,setCheckedPromotionWomenSuccess);
                                  confirmFlagIsEnterd(false);
                                }}/>
                              <CheckboxField isDisabled={!allowDetailConditionInput} label="子育て・家庭と仕事の両立支援" name="support" value="yes" gap="15px" size="large" ref={lifeAndWorkSupportRef} checked={checkedLifeAndWorkSupport}
                                onChange={() => {
                                  handleFlagRequirementsChecked(checkedLifeAndWorkSupport,setCheckedLifeAndWorkSupport);
                                  confirmFlagIsEnterd(false);
                                }}/>
                              <CheckboxField isDisabled={!allowDetailConditionInput} label="若者採用・育成推進" name="youth" value="yes" gap="15px" size="large" ref={promotingYouthDevelopmentRef} checked={checkedPromotingYouthDevelopment}
                                onChange={() => {
                                  handleFlagRequirementsChecked(checkedPromotingYouthDevelopment,setCheckedPromotingYouthDevelopment);
                                  confirmFlagIsEnterd(false);
                                }}/>
                            </Flex>
                            </Accordion.Content>
                          </Accordion.Item>
                        </Accordion.Container>
                      </Flex>
                    </Flex>
                  </Card>
                </Flex>

                {/* ボタンエリア */}
                <Flex direction={{base:"column",large:"row"}} justifyContent="center" gap="1.5rem" width="100%" marginTop={{base:"20px",large:"0"}} marginBottom="30px">
                  <Button className="greenHoverButton" variation="primary" backgroundColor={tokens.colors.green[40]} color="white" margin={{base:"0 auto",large:"0"}} width={{base:"90%",large:"150px"}} height="40px" borderRadius="20px" onClick={() => handleSearchWithClick()}>
                    <MdSearch style={{fontSize: `${tokens.fontSizes.xxxl}`, marginRight: "5px"}}/>
                    <View as="span" marginBottom="2px" fontSize="18px">検索する</View>
                  </Button>
                  <Button className="whiteHoverButton" variation="primary" backgroundColor={tokens.colors.white} borderColor={tokens.colors.blue[80]} color={tokens.colors.blue[80]} fontSize={tokens.fontSizes.large} width={{base:"90%",large:"150px"}} height="35px" borderRadius="18px" margin={{base:"0 auto",large:"2.5px 0 0 0"}} onClick={() => clearSearchRequirements()}>
                    <View as="span" marginTop="2px">検索条件をリセット</View>
                  </Button>
                </Flex>

                {/* セレクトテーマ */}
{/* 2025/10/21 V2.0 セレクトテーマ非表示対応
                <Flex direction={{base:"column",large:"row"}} justifyContent="left" gap="1.5rem" width="100%" lineHeight="50px">
                  <Text fontSize={tokens.fontSizes.large} width="150px" minWidth="120px" fontWeight={tokens.fontWeights.bold}><View as="span" fontSize={{base:tokens.fontSizes.xl,large:tokens.fontSizes.xxl}} style={{marginRight:"2px"}}>セレクト</View>テーマ</Text>
                {isFetchedEachTrendThemeList &&
                  <Collection items={eachTrendThemeList} direction="row" type="list" gap="1.5rem" wrap="wrap" marginTop="0" marginBottom="20px">
                  {((item:any, index:number) => (
                    <Button className="whiteHoverButton" variation="primary" backgroundColor={tokens.colors.white} borderColor={tokens.colors.blue[80]} color={tokens.colors.blue[80]} fontSize={tokens.fontSizes.large} width="150px" height="35px" margin={{base:"0 auto",large:"6px 0 0 0"}} onClick={() => handleTrendThemeWithClick(item) }>
                      <View as="span" marginTop="2px" overflow="hidden" whiteSpace="nowrap" style={{textOverflow:"ellipsis"}}>{item.trendThemeName}</View>          
                    </Button>
                  ))}
                  </Collection>
                }
                </Flex>
*/}

                {/* エラーメッセージの表示 ()*/}
                {errorMessage2 && (
                <div ref={error2Ref} className="alertHome">
                  <Alert
                    isDismissible={false}
                    variation="error"
                    color="red"
                    hasIcon={true}
                    heading=""
                    padding="1rem"
                  >
                    {errorMessage2}
                  </Alert>
                </div>
                )}
                {tokenInfo && (tokenInfo.plan == 'free' || tokenInfo.plan == 'freePlus') && isNeedChangePlan && !isNeedChangePlan2 ? (
                  <Button className="whiteHoverButton" onClick={handleNavigatePlanChange} marginTop="2rem" display="inline-flex" borderColor={tokens.colors.neutral[60]} backgroundColor={tokens.colors.white} color={tokens.colors.black} padding="1rem 3rem 0.5rem" borderRadius="0px">
                      <Flex gap="1rem" justifyContent="center">
                              <Text fontSize="1.5rem" fontWeight="500">プラン変更の案内</Text>
                              <View><MdNavigateNext fontSize="2rem" /></View>
                      </Flex>
                  </Button>
                ):(<></>)}
                {/* 成功メッセージの表示 */}
                {successMessage && (
                <div ref={successRef} className="alertHome">
                  <Message
                    isDismissible={false}
                    variation="outlined"
                    colorTheme="success"
                    hasIcon={true}
                    heading=""
                  >
                    {successMessage}
                  </Message>
                </div>
                )}

                {/* エラーメッセージの表示 */}
                {errorMessage3 && (
                <div ref={error3Ref} className="alertHome">
                  <Alert
                    isDismissible={false}
                    variation="error"
                    color="red"
                    hasIcon={true}
                    heading=""
                    padding="1rem"
                  >
                    {errorMessage3}
                  </Alert>
                </div>
                )}
                {tokenInfo && tokenInfo.plan == 'basic' && isNeedAddPurchase ? (
                    <Button className="whiteHoverButton" onClick={handleNavigateAddPurchase} marginTop="2rem" display="inline-flex" borderColor={tokens.colors.neutral[60]} backgroundColor={tokens.colors.white} color={tokens.colors.black} padding="1rem 3rem 0.5rem" borderRadius="0px" >
                        <Flex gap="1rem" justifyContent="center">
                                <Text fontSize="1.5rem" fontWeight="500">出力数追加の案内</Text>
                                <View><MdNavigateNext fontSize="2rem" /></View>
                        </Flex>
                    </Button>
                ):(<></>)}
                {tokenInfo && (tokenInfo.plan == 'free' || tokenInfo.plan == 'freePlus') && isNeedChangePlan2 ? (
                    <Button className="whiteHoverButton" onClick={handleNavigatePlanChange} marginTop="2rem" display="inline-flex" borderColor={tokens.colors.neutral[60]} backgroundColor={tokens.colors.white} color={tokens.colors.black} padding="1rem 3rem 0.5rem" borderRadius="0px">
                        <Flex gap="1rem" justifyContent="center">
                                <Text fontSize="1.5rem" fontWeight="500">プラン変更の案内</Text>
                                <View><MdNavigateNext fontSize="2rem" /></View>
                        </Flex>
                    </Button>
                ):(<></>)}
                {/* 検索条件表示エリア */}
                {(searchFilterRecord.industorialClass||searchFilterRecord.address||searchFilterRecord.businessKeywords||searchFilterRecord.corporateName||searchFilterRecord.freeWord||searchFilterRecord.detailParameter||searchFilterRecord.flag) &&
                <Card width={{ base: "calc(100% - 50px)", large: "calc(100% - 350px)" }} maxHeight={{base:"90px",large:"180px"}} overflow="hidden" marginBottom="0" padding={{ base:"1rem 1.5rem", medium:"1rem 2rem" }}>
                  <div ref={searchConditionRef}>
                    <Text fontSize={tokens.fontSizes.large} width="150px" minWidth="120px" fontWeight={tokens.fontWeights.bold}>
                      <View as="span" fontSize={{base:tokens.fontSizes.xl,large:tokens.fontSizes.xxl}} style={{marginRight:"2px"}}>現在の検索条件</View>
                    </Text>
                    <Flex  direction="column" justifyContent="center" alignItems="center">
                      <View width="100%" textAlign="right">
                        <Button borderStyle="none" onClick={openSearchConditionModal}><View as="span" color={tokens.colors.neutral[60]} fontSize={tokens.fontSizes.l}>すべてを表示する</View></Button>
                      </View>
                    </Flex>
                    <Flex direction="column">
                      {searchFilterRecord.industorialClass &&
                      <View width="90%" overflow="hidden" whiteSpace="nowrap" style={{textOverflow:"ellipsis"}}><Text as="span" fontSize={tokens.fontSizes.xl} width="5em" fontWeight={tokens.fontWeights.bold}>業種：</Text>{searchFilterRecord.industorialClass}</View>
                      }
                      {searchFilterRecord.address &&
                      <View width="90%" overflow="hidden" whiteSpace="nowrap" style={{textOverflow:"ellipsis"}}><Text as="span" fontSize={tokens.fontSizes.xl} width="5em" fontWeight={tokens.fontWeights.bold}>地域：</Text>{searchFilterRecord.address}</View>
                      }
                      {searchFilterRecord.businessKeywords &&
                      <View width="90%" overflow="hidden" whiteSpace="nowrap" style={{textOverflow:"ellipsis"}}><Text as="span" fontSize={tokens.fontSizes.xl} width="5em" fontWeight={tokens.fontWeights.bold}>事業内容：</Text>{searchFilterRecord.businessKeywords}</View>
                      }
                      {searchFilterRecord.corporateName &&
                      <View width="90%" overflow="hidden" whiteSpace="nowrap" style={{textOverflow:"ellipsis"}}><Text as="span" fontSize={tokens.fontSizes.xl} width="5em" fontWeight={tokens.fontWeights.bold}>企業名：</Text>{searchFilterRecord.corporateName}</View>
                      }
                      {searchFilterRecord.freeWord &&
                      <View width="90%" overflow="hidden" whiteSpace="nowrap" style={{textOverflow:"ellipsis"}}><Text as="span" fontSize={tokens.fontSizes.xl} width="5em" fontWeight={tokens.fontWeights.bold}>キーワード：</Text>{searchFilterRecord.freeWord}</View>
                      }
                      {searchFilterRecord.detailParameter &&
                      <View width="90%" overflow="hidden" whiteSpace="nowrap" style={{textOverflow:"ellipsis"}}><Text as="span" fontSize={tokens.fontSizes.xl} width="5em" fontWeight={tokens.fontWeights.bold}>詳細条件：</Text>{searchFilterRecord.detailParameter}</View>
                      }
                      {searchFilterRecord.flag &&
                      <View width="90%" overflow="hidden" whiteSpace="nowrap" style={{textOverflow:"ellipsis"}}><Text as="span" fontSize={tokens.fontSizes.xl} width="5em" fontWeight={tokens.fontWeights.bold}>フラグ：</Text>{searchFilterRecord.flag}</View>
                      }
                    </Flex>
                  </div>
                </Card>
                }
                {/* 検索結果セクション */}
                <Flex direction="column" width="100%" gap="0">
                  {/* 検索結果セクション */}
                  <Flex direction="row" gap="0">
                    <Card width={{ base: "calc(100% - 170px)", large: "calc(100% - 350px)" }}  marginBottom="0" padding={{ base:"1rem 1.5rem", medium:"1rem 2rem" }} backgroundColor={tokens.colors.blue[60]} borderRadius="1rem 0 0 0">
                      <Flex direction="row" alignItems="center" justifyContent="space-between" backgroundColor={tokens.colors.blue[60]}>
                        <Flex direction={{ base: "column-reverse", large: "row" }} alignItems="center" gap={{ base: "0.2rem", large: "1rem" }} width="100%">
                          <Image src={IcoResultTitle} alt="検索結果ロゴ" width={{ base: "50px", large: "80px" }} height={{ base: "50px", large: "80px" }}/>
                          <Flex direction={{ base: "column", large: "row" }} alignItems="center" gap={{ base: "0.2rem", large: "1rem" }}>
                            <Text fontWeight="bold" fontSize={{ base: tokens.fontSizes.xxl, large: tokens.fontSizes.xxxl }} color="white">検索結果</Text>
                            <Flex direction="row" alignItems="baseline">
                              <Text fontWeight="bold" fontSize={tokens.fontSizes.xxxl} color="white">{dataCount.toLocaleString()}</Text>
                              <Text fontWeight="bold" fontSize={tokens.fontSizes.xl} color="white" marginTop="0.5rem">件</Text>
                            </Flex>
                          </Flex>
                          <Button isDisabled={isSearching || isLoadingToken} className="greenHoverButton" fontSize={{base:"1.1rem", large:"1.75rem"}} variation="primary" borderRadius="5rem" onClick={() => openCsvDlModal()} margin={{base:"0 auto",large:"0"}} width={{base:"90%",large:"420px"}}>
                            <Flex padding="0 0.5rem" alignItems="center" gap="2rem">
                              <View paddingTop="0.25rem" color="inherit" ><IcoCsvTableHover height={"2rem"} width={"2rem"}/></View>
                              <Text color="inherit"><span>チェックした企業を</span><span>CSVダウンロード</span></Text>
                            </Flex>
                          </Button>
                          <Button className="whiteHoverButton" variation="primary" backgroundColor={tokens.colors.white} borderColor={tokens.colors.blue[80]} color={tokens.colors.blue[80]} fontSize={tokens.fontSizes.large} width={{base:"90%",large:"150px"}} height="35px" borderRadius="18px" margin={{base:"0 auto",large:"2.5px 0 0 0"}} onClick={() => clearSearchRequirements()}>
                            <View as="span" marginTop="2px">検索条件をリセット</View>
                          </Button>
                        </Flex>
                      </Flex>
                    </Card>
                    <Flex width={{ base: "170px", large: "350px" }} direction="column" gap="0">
                      <Flex direction="row" alignItems="center" justifyContent={{ base: "center", large: "start" }} gap="1rem" backgroundColor={tokens.colors.blue[40]} borderRadius="0 1rem 0 0" height={{ base: "35%", large: "50%" }}>
                        <Text color="white" fontWeight="bold" fontSize="1.25rem" marginLeft="2%">表示件数</Text>
                        <SelectField label=""  width="10rem" fontWeight="bold" icon={<FaAngleDown size="1.5rem" />} marginBottom="0.5rem" className="numorder-pulldown"
                          value={rowsPerPage.toString()} onChange={handleRowsPerPageChange}  isDisabled={isSearching || isLoadingToken}>
                          {options}
                        </SelectField>
                      </Flex>
                      <Flex direction={{ base: "column", large: "row" }} alignItems="center" justifyContent={{ base: "space-evenly", large: "space-between" }} backgroundColor={tokens.colors.blue[80]} gap="2%" height={{ base: "65%", large: "50%" }}>
                        <Flex alignItems="center" gap="1rem" marginLeft="2%">
                          <Text color="white" fontWeight="bold" fontSize="1.25rem">並び替え</Text>
                          <SelectField label=""  width="10rem" fontWeight="bold" icon={<FaAngleDown size="1.5rem" />} marginBottom="0.5rem" className="kindorder-pulldown"
                            value={sortKey} onChange={handleSortChange} isDisabled={isSearching || isLoadingToken}>
                            <option value="headquarterAddress">住所</option>
                            <option value="industorialClass_large">業種</option>
                            <option value="captalStock">資本金</option>
                            <option value="numberOfEmployees">従業員数</option>
                          </SelectField>
                        </Flex>
                        <Flex alignItems="center" gap="2%" marginRight="2%" justifyContent="flex-end">
                          <Button
                            width="80px"
                            borderRadius="5rem"
                            backgroundColor={!isAscendingPush ? tokens.colors.blue[60] : 'white'}
                            color={!isAscendingPush ? 'white' : tokens.colors.blue[90]}
                            padding="0.5rem 5%"
                            maxWidth="45%"
                            onClick={() => handleOrderChange("DESC",false)}
                            isDisabled={isSearching || isLoadingToken}
                            className="whiteToBlueHoverButton"
                          >
                            <Flex display="inline-flex" alignItems="center" direction="row" gap="0.5rem">
                              <Text color="inherit" fontSize={tokens.fontSizes.xl}>降順</Text>
                              <View paddingTop="0.25rem" color="inherit"><ImArrowDown size="1.3rem" /></View>
                            </Flex>
                          </Button>
                          <Button
                            width="80px"
                            borderRadius="5rem"
                            backgroundColor={isAscendingPush ? tokens.colors.blue[60] : 'white'}
                            color={isAscendingPush ? 'white' : tokens.colors.blue[90]}
                            padding="0.5rem 5%"
                            maxWidth="45%"
                            onClick={() => handleOrderChange("ASC",true)}
                            isDisabled={isSearching || isLoadingToken}
                            className="whiteToBlueHoverButton"
                          >
                            <Flex display="inline-flex" alignItems="center" direction="row" gap="0.5rem">
                              <Text color="inherit" fontSize={tokens.fontSizes.xl}>昇順</Text>
                              <View paddingTop="0.25rem" color="inherit"><ImArrowUp size="1.3rem" /></View>
                            </Flex>
                          </Button>
                        </Flex>
                      </Flex>
                    </Flex>
                  </Flex>
                  {!isGeneratingTags && (isSearchClicked || isSearchFacetClicked || isSearchTagFilterClicked || isSearchTagNewClicked) && tagList.length > 0 ?
                    (<Flex className="tagsContainer" direction={{ base: "column", large: "row" }} width="100%" padding="10px 15px" backgroundColor={tokens.colors.white} alignItems="center" justifyContent="space-between" display={tagList.length > 0 ? "flex" : "none"}>
                      <Flex className="tagsContent" direction={{ base: "column", large: "row" }}>
                        <Flex direction="row" minWidth="180px" textAlign="center" margin="5px" paddingRight="10px" style={{borderRight:"0.5px grey dotted"}} alignItems="center">
                          <img src={IcoTagKey} height={"20px"} width={"20px"}/>
                          <Text color={tokens.colors.black} fontWeight="bold">キーワード</Text>
                          <View color={tokens.colors.blue[60]} border="None" height={"35px"} width={"35px"} backgroundColor="inherit" padding="0.5rem">
                            <img src={IcoInfoTags} data-tooltip-id="tagTooltip" height={"30px"} width={"30px"}/>
                          </View>
                        </Flex>
                        <Flex direction="row" gap={{ base:"5px", large:"15px" }} wrap="wrap">
                          {tagList.map((item, index) => (
                            <Button className="tagsText" tabIndex={0} border="none" isDisabled={!allowDetailConditionInput} alignItems="center" margin="5px" style={{ all:"unset", cursor:"pointer", pointerEvents: allowDetailConditionInput ? "auto" : "none" }} onClick={() => handleSetTagList(item, index)}>
                              <Flex direction="row" gap="3px">
                                {isTagButtonOn[index] ? <img src={IcoTagCheckOn} height={"20px"} width={"20px"}/> : <img src={IcoTagCheckOff} height={"20px"} width={"20px"}/>}
                                <Text color={isTagButtonOn[index] ? tokens.colors.black : "grey"} fontWeight={isTagButtonOn[index] ? "bold" : ""} whiteSpace="nowrap">{item}</Text>
                              </Flex>
                            </Button>
                          ))}
                        </Flex>
                      </Flex>
                      <Flex className="tagsButtonContainer" gap="15px" justifyContent={{base:"center", large:"flex-end"}} alignItems="center">
                        <Button data-tooltip-id="tagFilterButtonTooltip" height="fit-content" className={(allowDetailConditionInput && Object.values(isTagButtonOn).includes(true)) ? "tagsButton" : ""} isDisabled={!allowDetailConditionInput || !(Object.values(isTagButtonOn).includes(true))} borderRadius="5px" variation="primary" alignItems="center" border="None" padding="0.5rem" width={"140px"} style={{ pointerEvents:!allowDetailConditionInput ? 'none' : 'auto', }} onClick={() => handleSearchTagFilterWithClick()}>
                          <Flex direction="row" padding="2px 10px">
                            <img src={IcoFilterTags} height={"25px"} width={"25px"}/>
                            <Text fontSize={tokens.fontSizes.large} color="#ffffff" style={{ wordBreak: 'keep-all' }}>キーワードで<br/>絞り込む</Text>
                          </Flex>
                        </Button>
                        <Button data-tooltip-id="taNewButtonTooltip" height="fit-content" className={(allowDetailConditionInput && Object.values(isTagButtonOn).includes(true)) ? "tagsButton" : ""} isDisabled={!allowDetailConditionInput || !(Object.values(isTagButtonOn).includes(true))} borderRadius="5px" variation="primary" alignItems="center" border="None" padding="0.5rem" width={"140px"} style={{ pointerEvents:!allowDetailConditionInput ? 'none' : 'auto', }} onClick={() => handleSearchTagNewWithClick()}>
                          <Flex direction="row" padding="2px 10px" alignItems="center">
                            <MdSearch style={{fontSize: `${tokens.fontSizes.xxl}`, marginRight: "5px"}}/>
                            <Text fontSize={tokens.fontSizes.large} color="#ffffff" style={{ wordBreak: 'keep-all' }}>キーワード<br/>のみで検索</Text>
                          </Flex>
                        </Button>
                      </Flex>
                    </Flex>)
                    :
                    ("")
                  }
                  { isGeneratingTags &&
                    <View className="searching-dots-wrapper">
                      <div className="generating-tags-dots-container">
                        {[...Array(totalDots)].map((_, i) => {
                        // 円周上の位置を計算
                        const angle = (i * (360 / totalDots)) * (Math.PI / 180);
                        const radius = 30;
                        const x = radius * Math.cos(angle);
                        const y = radius * Math.sin(angle);
                        const isActive = i === activeIndex;
                        return (
                          <div
                            key={i}
                            className={`generating-tags-dot ${isActive ? 'active' : ''}`}
                            style={{
                              left: `${40 + x}px`,
                              top: `${40 + y}px`,
                              transform: 'translate(-50%, -50%)',
                            }}
                          />
                        );
                        })}
                        <div className="generating-tags-center">
                          <div className="generating-tags-core" />
                        </div>
                      </div>
                      <Text fontSize="1.4rem" marginTop="0.5rem" textAlign="center" color="#4B5563">キーワード生成中です</Text>
                    </View>
                  }
                  { !isSearching &&
                  <>
                    {/* テーブル部分 */}
                    {(isSearchClicked || isSearchFacetClicked || isSearchTagFilterClicked || isSearchTagNewClicked) && dataCount > 0 && (
                      <View>
                        <Card width="100%" padding="0" style={{ overflowX: "auto" }}>
                          <Table width="100%" className="result-table" style={{tableLayout: "fixed", minWidth: minWidth, overflowX: "auto"}}>
                            <TableHead border="solid 1px black">
                              <TableRow>
                                {/* チェックボックス */}
                                <TableCell style={{border:"solid 1px lightgray", borderBottomWidth:"0.25rem", borderBottomColor:"blue"}} width="5rem" backgroundColor={tokens.colors.overlay[5]}>
                                  <CheckboxField name="ALL" label="" size="large" alignItems="center" checked={masterChecked} onChange={handleMasterChange} />
                                </TableCell>
                                {/* 企業名 */}
                                <TableCell style={{border:"solid 1px lightgray", borderBottomWidth:"0.25rem", borderBottomColor:"blue"}} width="27rem" backgroundColor={tokens.colors.overlay[5]} fontWeight="bold" fontSize={tokens.fontSizes.xl} whiteSpace="nowrap">企業名（クリックで企業詳細を確認）</TableCell>
                                {/* 住所 */}
                                <TableCell style={{border:"solid 1px lightgray", borderBottomWidth:"0.25rem", borderBottomColor:"blue"}} width="20%" backgroundColor={tokens.colors.overlay[5]} fontWeight="bold" fontSize={tokens.fontSizes.xl} whiteSpace="nowrap">住所</TableCell>
                                {/* 業種 */}
                                <TableCell style={{border:"solid 1px lightgray", borderBottomWidth:"0.25rem", borderBottomColor:"blue"}} width="12%" maxWidth="120px" backgroundColor={tokens.colors.overlay[5]} fontWeight="bold" fontSize={tokens.fontSizes.xl} whiteSpace="nowrap">業種</TableCell>
                                {/* 資本金 */}
                                <TableCell style={{border:"solid 1px lightgray", borderBottomWidth:"0.25rem", borderBottomColor:"blue"}} width="14rem" backgroundColor={tokens.colors.overlay[5]} fontWeight="bold" fontSize={tokens.fontSizes.xl} whiteSpace="nowrap">資本金</TableCell>
                                {/* 従業員 */}
                                <TableCell style={{border:"solid 1px lightgray", borderBottomWidth:"0.25rem", borderBottomColor:"blue"}} width="8rem" maxWidth="100px" backgroundColor={tokens.colors.overlay[5]} fontWeight="bold" fontSize={tokens.fontSizes.xl} whiteSpace="nowrap">従業員</TableCell>
                                {/* 特徴 */}
                                <TableCell style={{border:"solid 1px lightgray", borderBottomWidth:"0.25rem", borderBottomColor:"blue"}} width="15rem" backgroundColor={tokens.colors.overlay[5]} fontWeight="bold" fontSize={tokens.fontSizes.xl}>
                                  <Flex padding="0 0.5rem" display="inline-flex" alignItems="center" gap="0">
                                    <Text color="inherit" whiteSpace="nowrap">特徴</Text>
                                    <View as="div" className="notAllowDetailConditionInputIndication tooltipWrapper">
                                      <View className="tooltipTriggerArea" tabIndex={-1} color={tokens.colors.blue[60]} border="None" backgroundColor="inherit" padding="0.5rem">
                                        <GrCircleInformation data-tooltip-id="faturesTooltip" tabIndex={-1} fontSize="2.5rem"/>
                                      </View>
                                    </View>
                                  </Flex>
                                </TableCell>
                                {/* 与信・ニュース */}
                                <TableCell style={{border:"solid 1px lightgray", borderBottomWidth:"0.25rem", borderBottomColor:"blue"}} width="22rem" backgroundColor={tokens.colors.overlay[5]} fontWeight="bold" fontSize={tokens.fontSizes.xl}>
                                  <Flex padding="0 0.5rem" display="inline-flex" alignItems="center" gap="0">
                                    <Text color="inherit" whiteSpace="nowrap">与信・ニュース</Text>
                                      <Button color={tokens.colors.blue[60]} border="None" backgroundColor="inherit" padding="0.5rem" className="whiteHoverButton" onClick={handleOpenCreditNews}>
                                      <GrCircleInformation fontSize="2.5rem"/>
                                    </Button>
                                  </Flex>
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {tableData.map((item, index) => (
                                <TableRow key={index}>
                                  {/* チェックボックス */}
                                  <TableCell border="solid 1px lightgray" width="5rem">
                                    <CheckboxField name="row" label="" size="large" value={item.corporateNumber}  checked={otherChecked[indexOfFirstItem + index]} onChange={handleOtherChange(indexOfFirstItem + index)} />
                                  </TableCell>
                                  {/* 企業名 */}
                                  <TableCell border="solid 1px lightgray" width="27rem" fontSize={tokens.fontSizes.large} style={{whiteSpace: "normal", wordBreak: "normal"}}>
                                    <Link onClick={() => callCompanyDetail(item.corporateNumber)}
                                          onKeyPress={(e: React.KeyboardEvent<HTMLElement>) => {
                                            if (e.key === 'Enter' || e.key === ' ') {
                                              e.preventDefault();
                                              callCompanyDetail(item.corporateNumber);
                                            }
                                          }}
                                          role="button" tabIndex={0} className="LinkInHomeScreen">
                                      {item.corporateName}
                                    </Link>
                                  </TableCell>
                                  {/* 住所 */}
                                  <TableCell border="solid 1px lightgray" width="20%" fontSize={tokens.fontSizes.large} style={{whiteSpace: "normal", wordBreak: "normal"}}
                                    onMouseEnter={() => handleAddressMouseEnter(index)} onMouseLeave={() => handleAddressMouseLeave(index)}>{item.headquarterAddress}
                                  </TableCell>
                                  {/* 業種 */}
                                  <TableCell border="solid 1px lightgray" width="12%" maxWidth="120px" fontSize={tokens.fontSizes.large} style={{whiteSpace: hoveredIndex[index]?.industryHovered ? "pre-wrap" : "nowrap",
                                      overflow: hoveredIndex[index]?.industryHovered ? "visible" : "hidden",
                                      textOverflow: hoveredIndex[index]?.industryHovered ? "clip" : "ellipsis",
                                      wordBreak: hoveredIndex[index]?.industryHovered ? "break-word" : "normal"}}
                                      onMouseEnter={() => handleIndustryMouseEnter(index)} onMouseLeave={() => handleIndustryMouseLeave(index)}>{item.industorialClass_large ? item.industorialClass_large : "-"}
                                  </TableCell>
                                  {/* 資本金 */}
                                  <TableCell className="right" border="solid 1px lightgray" width="14rem" fontSize={tokens.fontSizes.large} 
                                    style={{whiteSpace: hoveredIndex[index]?.capitalHovered ? "pre-wrap" : "nowrap",
                                      overflow: hoveredIndex[index]?.capitalHovered ? "visible" : "hidden",
                                      textOverflow: hoveredIndex[index]?.capitalHovered ? "clip" : "ellipsis",
                                      wordBreak: hoveredIndex[index]?.capitalHovered ? "break-word" : "normal"}}
                                      onMouseEnter={() => handleCapitalMouseEnter(index)} onMouseLeave={() => handleCapitalMouseLeave(index)}>{item.captalStock === 0 || item.captalStock === null ? "-" : item.captalStock.toLocaleString() + "円"}
                                  </TableCell>
                                  {/* 従業員 */}
                                  <TableCell className="right" border="solid 1px lightgray" width="8rem" maxWidth="100px" fontSize={tokens.fontSizes.large} style={{whiteSpace: hoveredIndex[index]?.membersHovered ? "normal" : "nowrap",
                                    overflow: hoveredIndex[index]?.membersHovered ? "visible" : "hidden",
                                    textOverflow: hoveredIndex[index]?.membersHovered ? "clip" : "ellipsis",
                                    wordBreak: hoveredIndex[index]?.membersHovered ? "break-all" : "normal"}}
                                    onMouseEnter={() => handleMembersMouseEnter(index)} onMouseLeave={() => handleMembersMouseLeave(index)}>{item.numberOfEmployees === 0 || item.numberOfEmployees === null ? "-" : item.numberOfEmployees.toLocaleString() + "人"}
                                  </TableCell>
                                  {/* 特徴 */}
                                  <TableCell className="right" border="solid 1px lightgray" width="15rem" minWidth="150px" fontSize={tokens.fontSizes.large} textAlign="left">
                                    {item.flag1 ? <img src={IcoNewly} width="25%" data-tooltip-id="newlyTooltip"/> : ""}
                                    {item.flag2 ? <img src={IcoDx} width="25%" data-tooltip-id="dxTooltip"/> : ""}
                                    {item.flag3 ? <img src={IcoLeaders} width="25%" data-tooltip-id="leadersTooltip"/> : ""}
                                    {item.flag4 ? <img src={IcoWomen} width="25%" data-tooltip-id="womenTooltip"/> : ""}
                                    {item.flag5 ? <img src={IcoSupport} width="25%" data-tooltip-id="supportTooltip"/> : ""}
                                    {item.flag6 ? <img src={IcoYouth} width="25%" data-tooltip-id="youthTooltip"/> : ""}
                                  </TableCell>
                                  {/* 与信・ニュース */}
                                  <TableCell border="solid 1px lightgray" width="22rem">
                                    <Flex className="table-bottun" direction="row" justifyContent="space-between" gap="0 0.5rem">
                                      <div className="creditNewspaperInvestigation">
                                        <Button className="whiteHoverButton" borderColor={tokens.colors.neutral[60]} backgroundColor={tokens.colors.white} color={tokens.colors.blue[60]} onClick={() => callKigyoOdan(item.corporateName)}
                                        display="flex" direction="column" alignItems="center" padding="0.25rem 1rem" gap="0.25rem" whiteSpace="nowrap">
                                        <IcoKigyou/><span>与信調査</span>
                                        </Button>
                                        <span className="creditNewspaperInvestigation__tooltip">
                                          帝国データバンクや東京商工リサーチから評点や業績がわかる
                                        </span>
                                      </div>
                                      <div className="creditNewspaperInvestigation">
                                        <Button className="whiteHoverButton" borderColor={tokens.colors.neutral[60]} backgroundColor={tokens.colors.white} color={tokens.colors.blue[60]} onClick={() => callShinbunOdan(item.corporateName)}
                                        display="flex" direction="column" alignItems="center" padding="0.25rem 1rem" gap="0.25rem" whiteSpace="nowrap">
                                        <IcoSinbun/><span>新聞調査</span>
                                        </Button>
                                        <span className="creditNewspaperInvestigation__tooltip">
                                          新聞・雑誌記事から企業の活動状況がわかる
                                        </span>
                                      </div>
                                      <div className="creditNewspaperInvestigation">
                                        <Button className="whiteHoverButton" borderColor={tokens.colors.neutral[60]} backgroundColor={tokens.colors.white} color={tokens.colors.blue[60]} onClick={() => callComplianceCheck(item.corporateName)}
                                        display="flex" direction="column" alignItems="center" padding="0.25rem 1rem" gap="0.1rem" whiteSpace="nowrap">
                                        <IcoComplianceCheck height={"1.6rem"}/><span style={{lineHeight:"1.2"}}>コンプラ<br/>チェック</span>
                                        </Button>
                                        <span className="creditNewspaperInvestigation__tooltip">
                                          企業名からコンプライアンスに関する情報がわかります。
                                        </span>
                                      </div>
                                    </Flex>
                                  </TableCell>
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </Card>
                        <Flex direction={{base:"column-reverse", large:"row"}} marginTop="1rem">
                          <Button isDisabled={isSearching || isLoadingToken} className="greenHoverButton" fontSize="1.75rem" variation="primary" borderRadius="5rem" onClick={() => openCsvDlModal()} margin={{base:"0 auto",large:"0"}} width={{base:"260px",medium:"90%",large:"420px"}}>
                            <Flex padding="0 0.5rem" alignItems="center" gap="2rem">
                              <View paddingTop="0.25rem" color="inherit" ><IcoCsvTableHover height={"2rem"} width={"2rem"}/></View>
                              <Text color="inherit"><span>チェックした企業を</span><span>CSVダウンロード</span></Text>
                            </Flex>
                          </Button>
                          <Flex direction={{base:"column", large:"row"}} alignItems="center" gap={{base:"1rem", large:"0.5rem"}} margin={{base:"2rem auto", large:"0 0 0 auto"}}>
                            <Text>
                              {isSearching? '件表示':`${indexOfFirstItem + 1}〜${Math.min(indexOfLastItem, indexOfFirstItem + tableData.length)}件表示`}
                            </Text>
                            {/* Paginationコンポーネントの使用 */}
                            <HomeScreenPagination
                                    currentPage={currentPage}
                                    totalPages={totalPages}
                                    onNext={handleNextPage}
                                    onPrevious={handlePreviousPage}
                                    onChange={handleChangePage}
                            />
                          </Flex>
                        </Flex>
                      </View>
                    )}
                  </>
                  }
                  { isSearching &&
                    <View className="searching-dots-wrapper">
                      <div className="searching-dots-container">
                        {[...Array(totalDots)].map((_, i) => {
                        // 円周上の位置を計算
                        const angle = (i * (360 / totalDots)) * (Math.PI / 180);
                        const radius = 60;
                        const x = radius * Math.cos(angle);
                        const y = radius * Math.sin(angle);
                        const isActive = i === activeIndex;
                        return (
                          <div
                            key={i}
                            className={`searching-dot ${isActive ? 'active' : ''}`}
                            style={{
                              left: `${80 + x}px`,
                              top: `${80 + y}px`,
                              transform: 'translate(-50%, -50%)',
                            }}
                          />
                        );
                        })}
                        <div className="searching-center">
                          <div className="searching-core" />
                        </div>
                      </div>
                      <Text fontSize="1.8rem" marginTop="1rem" textAlign="center" color="#4B5563">検索中です</Text>
                    </View>
                  }
                </Flex>
                {/* ツールチップ */}
                <View as="div">
                  {/* タグ */}
                  <Tooltip id="tagTooltip" noArrow={true} clickable={true} opacity="1" positionStrategy="absolute" place="top" delayShow={20}
                    style={{maxWidth:"90vw", zIndex:"999", padding:"0.5rem", whiteSpace:"normal", fontSize:"1.2rem", lineHeight:"2.5rem", backgroundColor:"var(--color-blue-d)", color:"white", borderRadius:"3px", boxShadow:"0 0.2rem 0.2rem gray"}}
                  >
                    {!allowDetailConditionInput ?
                      <p>
                        フリーPlusプランおよびベーシックプランでご利用いただけます。<br/>料金プランの詳細や変更のお申込みは
                        <a href="https://cnavi-app.g-search.or.jp/planchange" target="_blank" rel="noopener noreferrer" style={{ color: '#cce5ff', textDecoration: 'underline', marginLeft: '4px' }} onClick={(e) => {e.stopPropagation(); }}>こちらから</a>
                      </p>
                      :
                      <p>検索結果の企業情報をテキスト解析して、生成したタグから絞込みができます。</p>
                    }
                  </Tooltip>
                  {/* タグ - キーワードで絞り込む */}
                  <Tooltip id="tagFilterButtonTooltip" noArrow={true} clickable={true} opacity="1" positionStrategy="absolute" place="top" delayShow={20}
                    style={{maxWidth:"90vw", zIndex:"999", padding:"0.5rem", whiteSpace:"normal", fontSize:"1.2rem", lineHeight:"2.5rem", backgroundColor:"var(--color-blue-d)", color:"white", borderRadius:"3px", boxShadow:"0 0.2rem 0.2rem gray"}}
                  >
                    {!allowDetailConditionInput ?
                      ""
                      :
                      <p>検索結果をキーワード（類似語含む）で絞り込みます。</p>
                    }
                  </Tooltip>
                  {/* タグ - キーワードのみで検索ボタン */}
                  <Tooltip id="taNewButtonTooltip" noArrow={true} clickable={true} opacity="1" positionStrategy="absolute" place="top" delayShow={20}
                    style={{maxWidth:"90vw", zIndex:"999", padding:"0.5rem", whiteSpace:"normal", fontSize:"1.2rem", lineHeight:"2.5rem", backgroundColor:"var(--color-blue-d)", color:"white", borderRadius:"3px", boxShadow:"0 0.2rem 0.2rem gray"}}
                  >
                    {!allowDetailConditionInput ?
                      ""
                      :
                      <p>選択したキーワード（類似語含む）で新たに検索します。</p>
                    }
                  </Tooltip>
                  {/* 特徴 */}
                  <Tooltip id="faturesTooltip" noArrow={true} clickable={true} opacity="1" positionStrategy="absolute" place="top" delayShow={20}
                    style={{maxWidth:"90vw", zIndex:"999", padding:"0.5rem", whiteSpace:"normal", fontSize:"1.2rem", lineHeight:"2.5rem", backgroundColor:"var(--color-blue-d)", color:"white", borderRadius:"3px", boxShadow:"0 0.2rem 0.2rem gray"}}
                  >
                    <p>特徴アイコンをマウスオーバーすると、アイコンの説明が表示されます。</p>
                  </Tooltip>
                  {/* 特徴 - 新設 */}
                  <Tooltip id="newlyTooltip" noArrow={true} clickable={true} opacity="1" positionStrategy="absolute" place="top" delayShow={20}
                    style={{maxWidth:"90vw", zIndex:"999", padding:"0.5rem", whiteSpace:"normal", fontSize:"1.2rem", lineHeight:"2.5rem", backgroundColor:"var(--color-blue-d)", color:"white", borderRadius:"3px", boxShadow:"0 0.2rem 0.2rem gray"}}
                  >
                    <p>設立から2年以内の企業</p>
                  </Tooltip>
                  {/* 特徴 - DX認定 */}
                  <Tooltip id="dxTooltip" noArrow={true} clickable={true} opacity="1" positionStrategy="absolute" place="top" delayShow={20}
                    style={{maxWidth:"90vw", zIndex:"999", padding:"0.5rem", whiteSpace:"normal", fontSize:"1.2rem", lineHeight:"2.5rem", backgroundColor:"var(--color-blue-d)", color:"white", borderRadius:"3px", boxShadow:"0 0.2rem 0.2rem gray"}}
                  >
                    <p>DX認定制度の認定を受けた企業</p>
                  </Tooltip>
                  {/* 特徴 - 地域経済担い手 */}
                  <Tooltip id="leadersTooltip" noArrow={true} clickable={true} opacity="1" positionStrategy="absolute" place="top" delayShow={20}
                    style={{maxWidth:"90vw", zIndex:"999", padding:"0.5rem", whiteSpace:"normal", fontSize:"1.2rem", lineHeight:"2.5rem", backgroundColor:"var(--color-blue-d)", color:"white", borderRadius:"3px", boxShadow:"0 0.2rem 0.2rem gray"}}
                  >
                    <p>地域未来牽引企業の認定を受けた企業</p>
                  </Tooltip>
                  {/* 特徴 - 女性活躍推進 */}
                  <Tooltip id="womenTooltip" noArrow={true} clickable={true} opacity="1" positionStrategy="absolute" place="top" delayShow={20}
                    style={{maxWidth:"90vw", zIndex:"999", padding:"0.5rem", whiteSpace:"normal", fontSize:"1.2rem", lineHeight:"2.5rem", backgroundColor:"var(--color-blue-d)", color:"white", borderRadius:"3px", boxShadow:"0 0.2rem 0.2rem gray"}}
                  >
                    <p>女性の活躍推進企業、えるぼし、ポジティブ・アクション、なでしこ銘柄のいずれかの認定を受けた企業</p>
                  </Tooltip>
                  {/* 特徴 - 子育て・家庭と仕事の両立支援 */}
                  <Tooltip id="supportTooltip" noArrow={true} clickable={true} opacity="1" positionStrategy="absolute" place="top" delayShow={20}
                    style={{maxWidth:"90vw", zIndex:"999", padding:"0.5rem", whiteSpace:"normal", fontSize:"1.2rem", lineHeight:"2.5rem", backgroundColor:"var(--color-blue-d)", color:"white", borderRadius:"3px", boxShadow:"0 0.2rem 0.2rem gray"}}
                  >
                    <p>くるみん認定（プラチナくるみん含む）、両立支援ひろばのいずれかの認定を受けた企業</p>
                  </Tooltip>
                  {/* 特徴 - 若者採用・育成推進 */}
                  <Tooltip id="youthTooltip" noArrow={true} clickable={true} opacity="1" positionStrategy="absolute" place="top" delayShow={20}
                    style={{maxWidth:"90vw", zIndex:"999", padding:"0.5rem", whiteSpace:"normal", fontSize:"1.2rem", lineHeight:"2.5rem", backgroundColor:"var(--color-blue-d)", color:"white", borderRadius:"3px", boxShadow:"0 0.2rem 0.2rem gray"}}
                  >
                    <p>育成などが優良な中小企業として、ユースエールの認定を受けた企業</p>
                  </Tooltip>
                </View>
              </Flex>
              <SearchConditionModal modalIsOpen={searchConditionModalIsOpen} onRequestClose={closeSearchConditionModal} modalData={searchFilterRecord} />
              <SaveSearchFilter modalIsOpen={saveSearchModalIsOpen} onRequestClose={closeSaveSearchModal} modalData={saveSearchData} onSave={handleSaveSearchData} />
              <CallSearchFilter modalIsOpen={callSearchModalIsOpen} onRequestClose={closeCallSearchModal} modalData={callSearchData} onCall={closeCallSearchModal} />
              <CsvDLConfirm isOpen={csvDLModalIsOpen} seachFilterRecord={searchFilterRecord} corporateNumberList={selectedCorporateNumberList} onDownload={DownloadCsv} onClose={closeCsvDlModal} />
            </View>
          </Flex>
        </Flex>
        <Footer />
      </View>
    </>

  );
}
